/* eslint-disable max-len */
import {calculateSum} from '../../../../../pages/esgManager/constants/commonFunctions';
import {
  conditionType,
  inputType
} from '../../../../../pages/esgManager/interface/inputType';

export const CDP_SME_INTRO_FIELD_NAMES = {
  SME_INTRO_Q1_VALUE: 'smeIntroQ1_value',

  SME_INTRO_Q2_VALUE: 'smeIntroQ2_value',

  SME_INTRO_Q3_VALUE: 'smeIntroQ3_value',
  SME_INTRO_Q3_1_VALUE: 'smeIntroQ3_1_value',
  SME_INTRO_Q3_2_VALUE: 'smeIntroQ3_2_value',

  SME_INTRO_Q4_VALUE: 'smeIntroQ4_value',
  SME_INTRO_Q4_1_VALUE: 'smeIntroQ4_1_value',
  SME_INTRO_Q4_2_VALUE: 'smeIntroQ4_2_value',

  SME_INTRO_Q5_VALUE: 'smeIntroQ5_value',

  SME_INTRO_Q6_VALUE: 'smeIntroQ6_value',
  SME_INTRO_Q6_1_VALUE: 'smeIntroQ6_1_value',
  SME_INTRO_Q6_2_VALUE: 'smeIntroQ6_2_value',

  SME_INTRO_Q7_VALUE: 'smeIntroQ7_value',
  SME_INTRO_Q7_1_VALUE: 'smeIntroQ7_1_value',
  SME_INTRO_Q7_2_VALUE: 'smeIntroQ7_2_value',
  SME_INTRO_Q7_3_VALUE: 'smeIntroQ7_3_value',

  SME_INTRO_Q8_VALUE: 'smeIntroQ8_value'
} as const;

export const CDP_SME_MANAGEMENT_FIELD_NAMES = {
  SME_MANAGEMENT_Q1_VALUE: 'smeManagementQ1_value',
  SME_MANAGEMENT_Q1_1_VALUE: 'smeManagementQ1_1_value',
  SME_MANAGEMENT_Q1_2_VALUE: 'smeManagementQ1_2_value',
  SME_MANAGEMENT_Q1_3_VALUE: 'smeManagementQ1_3_value',
  SME_MANAGEMENT_Q1_4_VALUE: 'smeManagementQ1_4_value'
} as const;

export const CDP_SME_DISCLOSURE_FIELD_NAMES = {
  SME_DISCLOSURE_Q1_VALUE: 'smeDisclosureQ1_value',
  SME_DISCLOSURE_Q1_1_VALUE: 'smeDisclosureQ1_1_value',
  SME_DISCLOSURE_Q1_2_VALUE: 'smeDisclosureQ1_2_value',
  SME_DISCLOSURE_Q1_3_VALUE: 'smeDisclosureQ1_3_value',

  SME_DISCLOSURE_Q2_VALUE: 'smeDisclosureQ2_value',
  SME_DISCLOSURE_Q2_1_VALUE: 'smeDisclosureQ2_1_value',
  SME_DISCLOSURE_Q2_2_VALUE: 'smeDisclosureQ2_2_value',
  SME_DISCLOSURE_Q2_3_VALUE: 'smeDisclosureQ2_3_value',
  SME_DISCLOSURE_Q2_4_VALUE: 'smeDisclosureQ2_4_value',
  SME_DISCLOSURE_Q2_5_VALUE: 'smeDisclosureQ2_5_value',
  SME_DISCLOSURE_Q2_6_VALUE: 'smeDisclosureQ2_6_value',
  SME_DISCLOSURE_Q2_7_VALUE: 'smeDisclosureQ2_7_value',
  SME_DISCLOSURE_Q2_8_VALUE: 'smeDisclosureQ2_8_value',
  SME_DISCLOSURE_Q2_9_VALUE: 'smeDisclosureQ2_9_value',
  SME_DISCLOSURE_Q2_10_VALUE: 'smeDisclosureQ2_10_value',
  SME_DISCLOSURE_Q2_11_VALUE: 'smeDisclosureQ2_11_value',
  SME_DISCLOSURE_Q2_12_VALUE: 'smeDisclosureQ2_12_value',
  SME_DISCLOSURE_Q2_13_VALUE: 'smeDisclosureQ2_13_value',
  SME_DISCLOSURE_Q2_14_VALUE: 'smeDisclosureQ2_14_value',
  SME_DISCLOSURE_Q2_15_VALUE: 'smeDisclosureQ2_15_value',
  SME_DISCLOSURE_Q2_16_VALUE: 'smeDisclosureQ2_16_value',
  SME_DISCLOSURE_Q2_17_VALUE: 'smeDisclosureQ2_17_value',
  SME_DISCLOSURE_Q2_18_VALUE: 'smeDisclosureQ2_18_value',
  SME_DISCLOSURE_Q2_19_VALUE: 'smeDisclosureQ2_19_value',
  SME_DISCLOSURE_Q2_20_VALUE: 'smeDisclosureQ2_20_value',

  SME_DISCLOSURE_Q3_VALUE: 'smeDisclosureQ3_value',
  SME_DISCLOSURE_Q3_1_VALUE: 'smeDisclosureQ3_1_value',
  SME_DISCLOSURE_Q3_2_VALUE: 'smeDisclosureQ3_2_value',
  SME_DISCLOSURE_Q3_3_VALUE: 'smeDisclosureQ3_3_value',

  SME_DISCLOSURE_Q4_VALUE: 'smeDisclosureQ4_value',
  SME_DISCLOSURE_Q4_1_VALUE: 'smeDisclosureQ4_1_value',
  SME_DISCLOSURE_Q4_2_VALUE: 'smeDisclosureQ4_2_value',
  SME_DISCLOSURE_Q4_3_VALUE: 'smeDisclosureQ4_3_value',

  SME_DISCLOSURE_Q5_VALUE: 'smeDisclosureQ5_value',
  SME_DISCLOSURE_Q5_1_VALUE: 'smeDisclosureQ5_1_value',
  SME_DISCLOSURE_Q5_2_VALUE: 'smeDisclosureQ5_2_value',
  SME_DISCLOSURE_Q5_3_VALUE: 'smeDisclosureQ5_3_value',
  SME_DISCLOSURE_Q5_4_VALUE: 'smeDisclosureQ5_4_value',
  SME_DISCLOSURE_Q5_5_VALUE: 'smeDisclosureQ5_5_value',
  SME_DISCLOSURE_Q5_6_VALUE: 'smeDisclosureQ5_6_value',
  SME_DISCLOSURE_Q5_7_VALUE: 'smeDisclosureQ5_7_value',
  SME_DISCLOSURE_Q5_8_VALUE: 'smeDisclosureQ5_8_value',
  SME_DISCLOSURE_Q5_9_VALUE: 'smeDisclosureQ5_9_value',
  SME_DISCLOSURE_Q5_10_VALUE: 'smeDisclosureQ5_10_value',
  SME_DISCLOSURE_Q5_11_VALUE: 'smeDisclosureQ5_11_value',
  SME_DISCLOSURE_Q5_12_VALUE: 'smeDisclosureQ5_12_value'
} as const;

export const CDP_SME_GOVERNANCE_FIELD_NAMES = {
  SME_GOVERNANCE_Q1_VALUE: 'smeGovernanceQ1_value',
  SME_GOVERNANCE_Q1_1_VALUE: 'smeGovernanceQ1_1_value',
  SME_GOVERNANCE_Q1_2_VALUE: 'smeGovernanceQ1_2_value',

  SME_GOVERNANCE_Q2_VALUE: 'smeGovernanceQ2_value',
  SME_GOVERNANCE_Q2_1_VALUE: 'smeGovernanceQ2_1_value',
  SME_GOVERNANCE_Q2_2_VALUE: 'smeGovernanceQ2_2_value',
  SME_GOVERNANCE_Q2_3_VALUE: 'smeGovernanceQ2_3_value',
  SME_GOVERNANCE_Q2_4_VALUE: 'smeGovernanceQ2_4_value',
  SME_GOVERNANCE_Q2_5_VALUE: 'smeGovernanceQ2_5_value',
  SME_GOVERNANCE_Q2_6_VALUE: 'smeGovernanceQ2_6_value',

  SME_GOVERNANCE_Q3_VALUE: 'smeGovernanceQ3_value',
  SME_GOVERNANCE_Q3_1_VALUE: 'smeGovernanceQ3_1_value',
  SME_GOVERNANCE_Q3_2_VALUE: 'smeGovernanceQ3_2_value',

  SME_GOVERNANCE_Q4_VALUE: 'smeGovernanceQ4_value',
  SME_GOVERNANCE_Q4_1_VALUE: 'smeGovernanceQ4_1_value',
  SME_GOVERNANCE_Q4_2_VALUE: 'smeGovernanceQ4_2_value',
  SME_GOVERNANCE_Q4_3_VALUE: 'smeGovernanceQ4_3_value',
  SME_GOVERNANCE_Q4_4_VALUE: 'smeGovernanceQ4_4_value',
  SME_GOVERNANCE_Q4_5_VALUE: 'smeGovernanceQ4_5_value'
} as const;

export const CDP_SME_BUSINESS_STRATEGY_FIELD_NAMES = {
  SME_BUSINESS_STRATEGY_Q1_VALUE: 'smeBusinessStrategyQ1_value',
  SME_BUSINESS_STRATEGY_Q1_1_VALUE: 'smeBusinessStrategyQ1_1_value',
  SME_BUSINESS_STRATEGY_Q1_2_VALUE: 'smeBusinessStrategyQ1_2_value',
  SME_BUSINESS_STRATEGY_Q1_3_VALUE: 'smeBusinessStrategyQ1_3_value',

  SME_BUSINESS_STRATEGY_Q2_VALUE: 'smeBusinessStrategyQ2_value',
  SME_BUSINESS_STRATEGY_Q2_1_VALUE: 'smeBusinessStrategyQ2_1_value',
  SME_BUSINESS_STRATEGY_Q2_2_VALUE: 'smeBusinessStrategyQ2_2_value',
  SME_BUSINESS_STRATEGY_Q2_3_VALUE: 'smeBusinessStrategyQ2_3_value',
  SME_BUSINESS_STRATEGY_Q2_4_VALUE: 'smeBusinessStrategyQ2_4_value',
  SME_BUSINESS_STRATEGY_Q2_5_VALUE: 'smeBusinessStrategyQ2_5_value',
  SME_BUSINESS_STRATEGY_Q2_6_VALUE: 'smeBusinessStrategyQ2_6_value',

  SME_BUSINESS_STRATEGY_Q3_VALUE: 'smeBusinessStrategyQ3_value',
  SME_BUSINESS_STRATEGY_Q3_1_VALUE: 'smeBusinessStrategyQ3_1_value',
  SME_BUSINESS_STRATEGY_Q3_2_VALUE: 'smeBusinessStrategyQ3_2_value',
  SME_BUSINESS_STRATEGY_Q3_3_VALUE: 'smeBusinessStrategyQ3_3_value',
  SME_BUSINESS_STRATEGY_Q3_4_VALUE: 'smeBusinessStrategyQ3_4_value',
  SME_BUSINESS_STRATEGY_Q3_5_VALUE: 'smeBusinessStrategyQ3_5_value',
  SME_BUSINESS_STRATEGY_Q3_6_VALUE: 'smeBusinessStrategyQ3_6_value',
  SME_BUSINESS_STRATEGY_Q3_7_VALUE: 'smeBusinessStrategyQ3_7_value',
  SME_BUSINESS_STRATEGY_Q3_8_VALUE: 'smeBusinessStrategyQ3_8_value',

  SME_BUSINESS_STRATEGY_Q4_VALUE: 'smeBusinessStrategyQ4_value',
  SME_BUSINESS_STRATEGY_Q4_1_VALUE: 'smeBusinessStrategyQ4_1_value',
  SME_BUSINESS_STRATEGY_Q4_2_VALUE: 'smeBusinessStrategyQ4_2_value',
  SME_BUSINESS_STRATEGY_Q4_3_VALUE: 'smeBusinessStrategyQ4_3_value',
  SME_BUSINESS_STRATEGY_Q4_4_VALUE: 'smeBusinessStrategyQ4_4_value',
  SME_BUSINESS_STRATEGY_Q4_5_VALUE: 'smeBusinessStrategyQ4_5_value',
  SME_BUSINESS_STRATEGY_Q4_6_VALUE: 'smeBusinessStrategyQ4_6_value',

  SME_BUSINESS_STRATEGY_Q5_VALUE: 'smeBusinessStrategyQ5_value',
  SME_BUSINESS_STRATEGY_Q5_1_VALUE: 'smeBusinessStrategyQ5_1_value',
  SME_BUSINESS_STRATEGY_Q5_2_VALUE: 'smeBusinessStrategyQ5_2_value',
  SME_BUSINESS_STRATEGY_Q5_3_VALUE: 'smeBusinessStrategyQ5_3_value',
  SME_BUSINESS_STRATEGY_Q5_4_VALUE: 'smeBusinessStrategyQ5_4_value',
  SME_BUSINESS_STRATEGY_Q5_5_VALUE: 'smeBusinessStrategyQ5_5_value',
  SME_BUSINESS_STRATEGY_Q5_6_VALUE: 'smeBusinessStrategyQ5_6_value',
  SME_BUSINESS_STRATEGY_Q5_7_VALUE: 'smeBusinessStrategyQ5_7_value',
  SME_BUSINESS_STRATEGY_Q5_8_VALUE: 'smeBusinessStrategyQ5_8_value',
  SME_BUSINESS_STRATEGY_Q5_9_VALUE: 'smeBusinessStrategyQ5_9_value',
  SME_BUSINESS_STRATEGY_Q5_10_VALUE: 'smeBusinessStrategyQ5_10_value',
  SME_BUSINESS_STRATEGY_Q5_11_VALUE: 'smeBusinessStrategyQ5_11_value',

  SME_BUSINESS_STRATEGY_Q6_VALUE: 'smeBusinessStrategyQ6_value',
  SME_BUSINESS_STRATEGY_Q6_1_VALUE: 'smeBusinessStrategyQ6_1_value',
  SME_BUSINESS_STRATEGY_Q6_2_VALUE: 'smeBusinessStrategyQ6_2_value',
  SME_BUSINESS_STRATEGY_Q6_3_VALUE: 'smeBusinessStrategyQ6_3_value',

  SME_BUSINESS_STRATEGY_Q7_VALUE: 'smeBusinessStrategyQ7_value',
  SME_BUSINESS_STRATEGY_Q7_1_VALUE: 'smeBusinessStrategyQ7_1_value',
  SME_BUSINESS_STRATEGY_Q7_2_VALUE: 'smeBusinessStrategyQ7_2_value',
  SME_BUSINESS_STRATEGY_Q7_3_VALUE: 'smeBusinessStrategyQ7_3_value',
  SME_BUSINESS_STRATEGY_Q7_4_VALUE: 'smeBusinessStrategyQ7_4_value',
  SME_BUSINESS_STRATEGY_Q7_5_VALUE: 'smeBusinessStrategyQ7_5_value',
  SME_BUSINESS_STRATEGY_Q7_6_VALUE: 'smeBusinessStrategyQ7_6_value',
  SME_BUSINESS_STRATEGY_Q7_7_VALUE: 'smeBusinessStrategyQ7_7_value',
  SME_BUSINESS_STRATEGY_Q7_8_VALUE: 'smeBusinessStrategyQ7_8_value',
  SME_BUSINESS_STRATEGY_Q7_9_VALUE: 'smeBusinessStrategyQ7_9_value',
  SME_BUSINESS_STRATEGY_Q7_10_VALUE: 'smeBusinessStrategyQ7_10_value',
  SME_BUSINESS_STRATEGY_Q7_11_VALUE: 'smeBusinessStrategyQ7_11_value',
  SME_BUSINESS_STRATEGY_Q7_12_VALUE: 'smeBusinessStrategyQ7_12_value'
} as const;

export const CDP_SME_PER_APPROACH_FIELD_NAMES = {
  SME_PER_APPROACH_Q1_VALUE: 'smePerApproachQ1_value',
  SME_PER_APPROACH_Q1_1_VALUE: 'smePerApproachQ1_1_value',
  SME_PER_APPROACH_Q1_2_VALUE: 'smePerApproachQ1_2_value'
} as const;

export const CDP_SME_PER_CLIMATE_CHANGE_FIELD_NAMES = {
  SME_PER_CLIMATE_CHANGE_Q1_VALUE: 'smePerClimateChangeQ1_value',
  SME_PER_CLIMATE_CHANGE_Q1_1_VALUE: 'smePerClimateChangeQ1_1_value',
  SME_PER_CLIMATE_CHANGE_Q1_2_VALUE: 'smePerClimateChangeQ1_2_value',
  SME_PER_CLIMATE_CHANGE_Q1_3_VALUE: 'smePerClimateChangeQ1_3_value',
  SME_PER_CLIMATE_CHANGE_Q1_4_VALUE: 'smePerClimateChangeQ1_4_value',
  SME_PER_CLIMATE_CHANGE_Q1_5_VALUE: 'smePerClimateChangeQ1_5_value',
  SME_PER_CLIMATE_CHANGE_Q1_6_VALUE: 'smePerClimateChangeQ1_6_value',
  SME_PER_CLIMATE_CHANGE_Q1_7_VALUE: 'smePerClimateChangeQ1_7_value',
  SME_PER_CLIMATE_CHANGE_Q1_8_VALUE: 'smePerClimateChangeQ1_8_value',
  SME_PER_CLIMATE_CHANGE_Q1_9_VALUE: 'smePerClimateChangeQ1_9_value',
  SME_PER_CLIMATE_CHANGE_Q1_10_VALUE: 'smePerClimateChangeQ1_10_value',
  SME_PER_CLIMATE_CHANGE_Q1_11_VALUE: 'smePerClimateChangeQ1_11_value',
  SME_PER_CLIMATE_CHANGE_Q1_12_VALUE: 'smePerClimateChangeQ1_12_value',
  SME_PER_CLIMATE_CHANGE_Q1_13_VALUE: 'smePerClimateChangeQ1_13_value',
  SME_PER_CLIMATE_CHANGE_Q1_14_VALUE: 'smePerClimateChangeQ1_14_value',
  SME_PER_CLIMATE_CHANGE_Q1_15_VALUE: 'smePerClimateChangeQ1_15_value',
  SME_PER_CLIMATE_CHANGE_Q1_16_VALUE: 'smePerClimateChangeQ1_16_value',
  SME_PER_CLIMATE_CHANGE_Q1_17_VALUE: 'smePerClimateChangeQ1_17_value',
  SME_PER_CLIMATE_CHANGE_Q1_18_VALUE: 'smePerClimateChangeQ1_18_value',
  SME_PER_CLIMATE_CHANGE_Q1_19_VALUE: 'smePerClimateChangeQ1_19_value',
  SME_PER_CLIMATE_CHANGE_Q1_20_VALUE: 'smePerClimateChangeQ1_20_value',

  SME_PER_CLIMATE_CHANGE_Q2_1_VALUE: 'smePerClimateChangeQ2_1_value',

  SME_PER_CLIMATE_CHANGE_Q3_1_VALUE: 'smePerClimateChangeQ3_1_value',

  SME_PER_CLIMATE_CHANGE_Q4_VALUE: 'smePerClimateChangeQ4_value',
  SME_PER_CLIMATE_CHANGE_Q4_1_VALUE: 'smePerClimateChangeQ4_1_value',
  SME_PER_CLIMATE_CHANGE_Q4_2_VALUE: 'smePerClimateChangeQ4_2_value',
  SME_PER_CLIMATE_CHANGE_Q4_3_VALUE: 'smePerClimateChangeQ4_3_value',
  SME_PER_CLIMATE_CHANGE_Q4_4_VALUE: 'smePerClimateChangeQ4_4_value',
  SME_PER_CLIMATE_CHANGE_Q4_5_VALUE: 'smePerClimateChangeQ4_5_value',
  SME_PER_CLIMATE_CHANGE_Q4_6_VALUE: 'smePerClimateChangeQ4_6_value',
  SME_PER_CLIMATE_CHANGE_Q4_7_VALUE: 'smePerClimateChangeQ4_7_value',
  SME_PER_CLIMATE_CHANGE_Q4_8_VALUE: 'smePerClimateChangeQ4_8_value',
  SME_PER_CLIMATE_CHANGE_Q4_9_VALUE: 'smePerClimateChangeQ4_9_value',
  SME_PER_CLIMATE_CHANGE_Q4_10_VALUE: 'smePerClimateChangeQ4_10_value',
  SME_PER_CLIMATE_CHANGE_Q4_11_VALUE: 'smePerClimateChangeQ4_11_value',
  SME_PER_CLIMATE_CHANGE_Q4_12_VALUE: 'smePerClimateChangeQ4_12_value',

  SME_PER_CLIMATE_CHANGE_Q5_VALUE: 'smePerClimateChangeQ5_value',
  SME_PER_CLIMATE_CHANGE_Q5_1_VALUE: 'smePerClimateChangeQ5_1_value',
  SME_PER_CLIMATE_CHANGE_Q5_2_VALUE: 'smePerClimateChangeQ5_2_value',
  SME_PER_CLIMATE_CHANGE_Q5_3_VALUE: 'smePerClimateChangeQ5_3_value',
  SME_PER_CLIMATE_CHANGE_Q5_4_VALUE: 'smePerClimateChangeQ5_4_value',

  SME_PER_CLIMATE_CHANGE_Q6_VALUE: 'smePerClimateChangeQ6_value',
  SME_PER_CLIMATE_CHANGE_Q6_1_VALUE: 'smePerClimateChangeQ6_1_value',
  SME_PER_CLIMATE_CHANGE_Q6_2_VALUE: 'smePerClimateChangeQ6_2_value',
  SME_PER_CLIMATE_CHANGE_Q6_3_VALUE: 'smePerClimateChangeQ6_3_value',
  SME_PER_CLIMATE_CHANGE_Q6_4_VALUE: 'smePerClimateChangeQ6_4_value',
  SME_PER_CLIMATE_CHANGE_Q6_5_VALUE: 'smePerClimateChangeQ6_5_value',
  SME_PER_CLIMATE_CHANGE_Q6_6_VALUE: 'smePerClimateChangeQ6_6_value',

  SME_PER_CLIMATE_CHANGE_Q7_VALUE: 'smePerClimateChangeQ7_value',
  SME_PER_CLIMATE_CHANGE_Q7_1_VALUE: 'smePerClimateChangeQ7_1_value',
  SME_PER_CLIMATE_CHANGE_Q7_2_VALUE: 'smePerClimateChangeQ7_2_value',

  SME_PER_CLIMATE_CHANGE_Q8_VALUE: 'smePerClimateChangeQ8_value',
  SME_PER_CLIMATE_CHANGE_Q8_1_VALUE: 'smePerClimateChangeQ8_1_value',
  SME_PER_CLIMATE_CHANGE_Q8_2_VALUE: 'smePerClimateChangeQ8_2_value',
  SME_PER_CLIMATE_CHANGE_Q8_3_VALUE: 'smePerClimateChangeQ8_3_value',
  SME_PER_CLIMATE_CHANGE_Q8_4_VALUE: 'smePerClimateChangeQ8_4_value',

  SME_PER_CLIMATE_CHANGE_Q9_VALUE: 'smePerClimateChangeQ9_value',
  SME_PER_CLIMATE_CHANGE_Q9_1_VALUE: 'smePerClimateChangeQ9_1_value',
  SME_PER_CLIMATE_CHANGE_Q9_2_VALUE: 'smePerClimateChangeQ9_2_value',
  SME_PER_CLIMATE_CHANGE_Q9_3_VALUE: 'smePerClimateChangeQ9_3_value',
  SME_PER_CLIMATE_CHANGE_Q9_4_VALUE: 'smePerClimateChangeQ9_4_value',
  SME_PER_CLIMATE_CHANGE_Q9_5_VALUE: 'smePerClimateChangeQ9_5_value',
  SME_PER_CLIMATE_CHANGE_Q9_6_VALUE: 'smePerClimateChangeQ9_6_value',
  SME_PER_CLIMATE_CHANGE_Q9_7_VALUE: 'smePerClimateChangeQ9_7_value',
  SME_PER_CLIMATE_CHANGE_Q9_8_VALUE: 'smePerClimateChangeQ9_8_value',
  SME_PER_CLIMATE_CHANGE_Q9_9_VALUE: 'smePerClimateChangeQ9_9_value',
  SME_PER_CLIMATE_CHANGE_Q9_10_VALUE: 'smePerClimateChangeQ9_10_value',
  SME_PER_CLIMATE_CHANGE_Q9_11_VALUE: 'smePerClimateChangeQ9_11_value',
  SME_PER_CLIMATE_CHANGE_Q9_12_VALUE: 'smePerClimateChangeQ9_12_value',
  SME_PER_CLIMATE_CHANGE_Q9_13_VALUE: 'smePerClimateChangeQ9_13_value',
  SME_PER_CLIMATE_CHANGE_Q9_14_VALUE: 'smePerClimateChangeQ9_14_value',
  SME_PER_CLIMATE_CHANGE_Q9_15_VALUE: 'smePerClimateChangeQ9_15_value',
  SME_PER_CLIMATE_CHANGE_Q9_16_VALUE: 'smePerClimateChangeQ9_16_value',
  SME_PER_CLIMATE_CHANGE_Q9_17_VALUE: 'smePerClimateChangeQ9_17_value',
  SME_PER_CLIMATE_CHANGE_Q9_18_VALUE: 'smePerClimateChangeQ9_18_value',
  SME_PER_CLIMATE_CHANGE_Q9_19_VALUE: 'smePerClimateChangeQ9_19_value',
  SME_PER_CLIMATE_CHANGE_Q9_20_VALUE: 'smePerClimateChangeQ9_20_value',

  SME_PER_CLIMATE_CHANGE_Q10_VALUE: 'smePerClimateChangeQ10_value',
  SME_PER_CLIMATE_CHANGE_Q10_1_VALUE: 'smePerClimateChangeQ10_1_value',
  SME_PER_CLIMATE_CHANGE_Q10_2_VALUE: 'smePerClimateChangeQ10_2_value',

  SME_PER_CLIMATE_CHANGE_Q11_VALUE: 'smePerClimateChangeQ11_value',
  SME_PER_CLIMATE_CHANGE_Q11_1_VALUE: 'smePerClimateChangeQ11_1_value',
  SME_PER_CLIMATE_CHANGE_Q11_2_VALUE: 'smePerClimateChangeQ11_2_value',
  SME_PER_CLIMATE_CHANGE_Q11_3_VALUE: 'smePerClimateChangeQ11_3_value',

  SME_PER_CLIMATE_CHANGE_Q12_VALUE: 'smePerClimateChangeQ12_value',
  SME_PER_CLIMATE_CHANGE_Q12_1_VALUE: 'smePerClimateChangeQ12_1_value',
  SME_PER_CLIMATE_CHANGE_Q12_2_VALUE: 'smePerClimateChangeQ12_2_value',

  SME_PER_CLIMATE_CHANGE_Q13_VALUE: 'smePerClimateChangeQ13_value',
  SME_PER_CLIMATE_CHANGE_Q13_1_VALUE: 'smePerClimateChangeQ13_1_value',
  SME_PER_CLIMATE_CHANGE_Q13_2_VALUE: 'smePerClimateChangeQ13_2_value',
  SME_PER_CLIMATE_CHANGE_Q13_3_VALUE: 'smePerClimateChangeQ13_3_value',

  SME_PER_CLIMATE_CHANGE_Q14_VALUE: 'smePerClimateChangeQ14_value',
  SME_PER_CLIMATE_CHANGE_Q14_1_VALUE: 'smePerClimateChangeQ14_1_value',
  SME_PER_CLIMATE_CHANGE_Q14_2_VALUE: 'smePerClimateChangeQ14_2_value',
  SME_PER_CLIMATE_CHANGE_Q14_3_VALUE: 'smePerClimateChangeQ14_3_value',
  SME_PER_CLIMATE_CHANGE_Q14_4_VALUE: 'smePerClimateChangeQ14_4_value',
  SME_PER_CLIMATE_CHANGE_Q14_5_VALUE: 'smePerClimateChangeQ14_5_value',
  SME_PER_CLIMATE_CHANGE_Q14_6_VALUE: 'smePerClimateChangeQ14_6_value',
  SME_PER_CLIMATE_CHANGE_Q14_7_VALUE: 'smePerClimateChangeQ14_7_value',
  SME_PER_CLIMATE_CHANGE_Q14_8_VALUE: 'smePerClimateChangeQ14_8_value',
  SME_PER_CLIMATE_CHANGE_Q14_9_VALUE: 'smePerClimateChangeQ14_9_value',
  SME_PER_CLIMATE_CHANGE_Q14_10_VALUE: 'smePerClimateChangeQ14_10_value',
  SME_PER_CLIMATE_CHANGE_Q14_11_VALUE: 'smePerClimateChangeQ14_11_value',
  SME_PER_CLIMATE_CHANGE_Q14_12_VALUE: 'smePerClimateChangeQ14_12_value',
  SME_PER_CLIMATE_CHANGE_Q14_13_VALUE: 'smePerClimateChangeQ14_13_value',
  SME_PER_CLIMATE_CHANGE_Q14_14_VALUE: 'smePerClimateChangeQ14_14_value',
  SME_PER_CLIMATE_CHANGE_Q14_15_VALUE: 'smePerClimateChangeQ14_15_value',
  SME_PER_CLIMATE_CHANGE_Q14_16_VALUE: 'smePerClimateChangeQ14_16_value',
  SME_PER_CLIMATE_CHANGE_Q14_17_VALUE: 'smePerClimateChangeQ14_17_value',
  SME_PER_CLIMATE_CHANGE_Q14_18_VALUE: 'smePerClimateChangeQ14_18_value',
  SME_PER_CLIMATE_CHANGE_Q14_19_VALUE: 'smePerClimateChangeQ14_19_value',
  SME_PER_CLIMATE_CHANGE_Q14_20_VALUE: 'smePerClimateChangeQ14_20_value',

  SME_PER_CLIMATE_CHANGE_Q15_VALUE: 'smePerClimateChangeQ15_value',
  SME_PER_CLIMATE_CHANGE_Q15_1_VALUE: 'smePerClimateChangeQ15_1_value',
  SME_PER_CLIMATE_CHANGE_Q15_2_VALUE: 'smePerClimateChangeQ15_2_value',

  SME_PER_CLIMATE_CHANGE_Q16_VALUE: 'smePerClimateChangeQ16_value',
  SME_PER_CLIMATE_CHANGE_Q16_1_VALUE: 'smePerClimateChangeQ16_1_value',
  SME_PER_CLIMATE_CHANGE_Q16_2_VALUE: 'smePerClimateChangeQ16_2_value',
  SME_PER_CLIMATE_CHANGE_Q16_3_VALUE: 'smePerClimateChangeQ16_3_value',
  SME_PER_CLIMATE_CHANGE_Q16_4_VALUE: 'smePerClimateChangeQ16_4_value',

  SME_PER_CLIMATE_CHANGE_Q17_VALUE: 'smePerClimateChangeQ17_value',

  SME_PER_CLIMATE_CHANGE_Q18_VALUE: 'smePerClimateChangeQ18_value',
  SME_PER_CLIMATE_CHANGE_Q18_1_VALUE: 'smePerClimateChangeQ18_1_value',
  SME_PER_CLIMATE_CHANGE_Q18_2_VALUE: 'smePerClimateChangeQ18_2_value',
  SME_PER_CLIMATE_CHANGE_Q18_3_VALUE: 'smePerClimateChangeQ18_3_value',
  SME_PER_CLIMATE_CHANGE_Q18_4_VALUE: 'smePerClimateChangeQ18_4_value',
  SME_PER_CLIMATE_CHANGE_Q18_5_VALUE: 'smePerClimateChangeQ18_5_value',

  SME_PER_CLIMATE_CHANGE_Q19_VALUE: 'smePerClimateChangeQ19_value',
  SME_PER_CLIMATE_CHANGE_Q19_1_VALUE: 'smePerClimateChangeQ19_1_value',
  SME_PER_CLIMATE_CHANGE_Q19_2_VALUE: 'smePerClimateChangeQ19_2_value',
  SME_PER_CLIMATE_CHANGE_Q19_3_VALUE: 'smePerClimateChangeQ19_3_value',
  SME_PER_CLIMATE_CHANGE_Q19_4_VALUE: 'smePerClimateChangeQ19_4_value',

  SME_PER_CLIMATE_CHANGE_Q20_VALUE: 'smePerClimateChangeQ20_value',
  SME_PER_CLIMATE_CHANGE_Q20_1_VALUE: 'smePerClimateChangeQ20_1_value',
  SME_PER_CLIMATE_CHANGE_Q20_2_VALUE: 'smePerClimateChangeQ20_2_value',
  SME_PER_CLIMATE_CHANGE_Q20_3_VALUE: 'smePerClimateChangeQ20_3_value',

  SME_PER_CLIMATE_CHANGE_Q21_VALUE: 'smePerClimateChangeQ21_value',
  SME_PER_CLIMATE_CHANGE_Q21_1_VALUE: 'smePerClimateChangeQ21_1_value',
  SME_PER_CLIMATE_CHANGE_Q21_2_VALUE: 'smePerClimateChangeQ21_2_value',
  SME_PER_CLIMATE_CHANGE_Q21_3_VALUE: 'smePerClimateChangeQ21_3_value',
  SME_PER_CLIMATE_CHANGE_Q21_4_VALUE: 'smePerClimateChangeQ21_4_value',
  SME_PER_CLIMATE_CHANGE_Q21_5_VALUE: 'smePerClimateChangeQ21_5_value',
  SME_PER_CLIMATE_CHANGE_Q21_6_VALUE: 'smePerClimateChangeQ21_6_value',
  SME_PER_CLIMATE_CHANGE_Q21_7_VALUE: 'smePerClimateChangeQ21_7_value',
  SME_PER_CLIMATE_CHANGE_Q21_8_VALUE: 'smePerClimateChangeQ21_8_value',
  SME_PER_CLIMATE_CHANGE_Q21_9_VALUE: 'smePerClimateChangeQ21_9_value',
  SME_PER_CLIMATE_CHANGE_Q21_10_VALUE: 'smePerClimateChangeQ21_10_value',
  SME_PER_CLIMATE_CHANGE_Q21_11_VALUE: 'smePerClimateChangeQ21_11_value',
  SME_PER_CLIMATE_CHANGE_Q21_12_VALUE: 'smePerClimateChangeQ21_12_value',
  SME_PER_CLIMATE_CHANGE_Q21_13_VALUE: 'smePerClimateChangeQ21_13_value',
  SME_PER_CLIMATE_CHANGE_Q21_14_VALUE: 'smePerClimateChangeQ21_14_value',
  SME_PER_CLIMATE_CHANGE_Q21_15_VALUE: 'smePerClimateChangeQ21_15_value',
  SME_PER_CLIMATE_CHANGE_Q21_16_VALUE: 'smePerClimateChangeQ21_16_value',
  SME_PER_CLIMATE_CHANGE_Q21_17_VALUE: 'smePerClimateChangeQ21_17_value',

  SME_PER_CLIMATE_CHANGE_Q22_VALUE: 'smePerClimateChangeQ22_value',
  SME_PER_CLIMATE_CHANGE_Q22_1_VALUE: 'smePerClimateChangeQ22_1_value',
  SME_PER_CLIMATE_CHANGE_Q22_2_VALUE: 'smePerClimateChangeQ22_2_value',
  SME_PER_CLIMATE_CHANGE_Q22_3_VALUE: 'smePerClimateChangeQ22_3_value',
  SME_PER_CLIMATE_CHANGE_Q22_4_VALUE: 'smePerClimateChangeQ22_4_value',
  SME_PER_CLIMATE_CHANGE_Q22_5_VALUE: 'smePerClimateChangeQ22_5_value',
  SME_PER_CLIMATE_CHANGE_Q22_6_VALUE: 'smePerClimateChangeQ22_6_value',
  SME_PER_CLIMATE_CHANGE_Q22_7_VALUE: 'smePerClimateChangeQ22_7_value',
  SME_PER_CLIMATE_CHANGE_Q22_8_VALUE: 'smePerClimateChangeQ22_8_value',
  SME_PER_CLIMATE_CHANGE_Q22_9_VALUE: 'smePerClimateChangeQ22_9_value',
  SME_PER_CLIMATE_CHANGE_Q22_10_VALUE: 'smePerClimateChangeQ22_10_value',
  SME_PER_CLIMATE_CHANGE_Q22_11_VALUE: 'smePerClimateChangeQ22_11_value',
  SME_PER_CLIMATE_CHANGE_Q22_12_VALUE: 'smePerClimateChangeQ22_12_value',
  SME_PER_CLIMATE_CHANGE_Q22_13_VALUE: 'smePerClimateChangeQ22_13_value',
  SME_PER_CLIMATE_CHANGE_Q22_14_VALUE: 'smePerClimateChangeQ22_14_value',
  SME_PER_CLIMATE_CHANGE_Q22_15_VALUE: 'smePerClimateChangeQ22_15_value',
  SME_PER_CLIMATE_CHANGE_Q22_16_VALUE: 'smePerClimateChangeQ22_16_value',
  SME_PER_CLIMATE_CHANGE_Q22_17_VALUE: 'smePerClimateChangeQ22_17_value',
  SME_PER_CLIMATE_CHANGE_Q22_18_VALUE: 'smePerClimateChangeQ22_18_value',

  SME_PER_CLIMATE_CHANGE_Q23_VALUE: 'smePerClimateChangeQ23_value',
  SME_PER_CLIMATE_CHANGE_Q23_1_VALUE: 'smePerClimateChangeQ23_1_value',
  SME_PER_CLIMATE_CHANGE_Q23_2_VALUE: 'smePerClimateChangeQ23_2_value',
  SME_PER_CLIMATE_CHANGE_Q23_3_VALUE: 'smePerClimateChangeQ23_3_value',
  SME_PER_CLIMATE_CHANGE_Q23_4_VALUE: 'smePerClimateChangeQ23_4_value',
  SME_PER_CLIMATE_CHANGE_Q23_5_VALUE: 'smePerClimateChangeQ23_5_value',
  SME_PER_CLIMATE_CHANGE_Q23_6_VALUE: 'smePerClimateChangeQ23_6_value',
  SME_PER_CLIMATE_CHANGE_Q23_7_VALUE: 'smePerClimateChangeQ23_7_value',
  SME_PER_CLIMATE_CHANGE_Q23_8_VALUE: 'smePerClimateChangeQ23_8_value',
  SME_PER_CLIMATE_CHANGE_Q23_9_VALUE: 'smePerClimateChangeQ23_9_value',
  SME_PER_CLIMATE_CHANGE_Q23_10_VALUE: 'smePerClimateChangeQ23_10_value',
  SME_PER_CLIMATE_CHANGE_Q23_11_VALUE: 'smePerClimateChangeQ23_11_value',

  SME_PER_CLIMATE_CHANGE_Q24_VALUE: 'smePerClimateChangeQ24_value',
  SME_PER_CLIMATE_CHANGE_Q24_1_VALUE: 'smePerClimateChangeQ24_1_value',
  SME_PER_CLIMATE_CHANGE_Q24_2_VALUE: 'smePerClimateChangeQ24_2_value',

  SME_PER_CLIMATE_CHANGE_Q25_VALUE: 'smePerClimateChangeQ25_value',
  SME_PER_CLIMATE_CHANGE_Q25_1_VALUE: 'smePerClimateChangeQ25_1_value',
  SME_PER_CLIMATE_CHANGE_Q25_2_VALUE: 'smePerClimateChangeQ25_2_value',
  SME_PER_CLIMATE_CHANGE_Q25_3_VALUE: 'smePerClimateChangeQ25_3_value',
  SME_PER_CLIMATE_CHANGE_Q25_4_VALUE: 'smePerClimateChangeQ25_4_value',
  SME_PER_CLIMATE_CHANGE_Q25_5_VALUE: 'smePerClimateChangeQ25_5_value',
  SME_PER_CLIMATE_CHANGE_Q25_6_VALUE: 'smePerClimateChangeQ25_6_value',
  SME_PER_CLIMATE_CHANGE_Q25_7_VALUE: 'smePerClimateChangeQ25_7_value',
  SME_PER_CLIMATE_CHANGE_Q25_8_VALUE: 'smePerClimateChangeQ25_8_value',
  SME_PER_CLIMATE_CHANGE_Q25_9_VALUE: 'smePerClimateChangeQ25_9_value',
  SME_PER_CLIMATE_CHANGE_Q25_10_VALUE: 'smePerClimateChangeQ25_10_value'
} as const;

export const SCOPE_FIELD_NAMES = {
  SME_PER_CLIMATE_CHANGE_Q1_1_VALUE_SCOPE1:
    'smePerClimateChangeQ1_1_value_Scope1',
  SME_PER_CLIMATE_CHANGE_Q1_1_VALUE_SCOPE2:
    'smePerClimateChangeQ1_1_value_Scope2',
  SME_PER_CLIMATE_CHANGE_Q1_1_VALUE_SCOPE3:
    'smePerClimateChangeQ1_1_value_Scope3',
  SME_PER_CLIMATE_CHANGE_Q1_8_VALUE_SCOPE3:
    'smePerClimateChangeQ1_8_value_Scope3'
} as const;

export const CDP_SME_SIGN_OFF_FIELD_NAMES = {
  SME_SIGN_OFF_Q1_1_VALUE: 'smeSignOffRequestQ1_1_value',

  SME_SIGN_OFF_Q2_VALUE: 'smeSignOffRequestQ2_value',
  SME_SIGN_OFF_Q2_1_VALUE: 'smeSignOffRequestQ2_1_value',
  SME_SIGN_OFF_Q2_2_VALUE: 'smeSignOffRequestQ2_2_value',
  SME_SIGN_OFF_Q2_3_VALUE: 'smeSignOffRequestQ2_3_value',
  SME_SIGN_OFF_Q2_4_VALUE: 'smeSignOffRequestQ2_4_value',
  SME_SIGN_OFF_Q2_5_VALUE: 'smeSignOffRequestQ2_5_value',

  SME_SIGN_OFF_Q3_VALUE: 'smeSignOffRequestQ3_value',
  SME_SIGN_OFF_Q3_1_VALUE: 'smeSignOffRequestQ3_1_value',
  SME_SIGN_OFF_Q3_2_VALUE: 'smeSignOffRequestQ3_2_value',

  SME_SIGN_OFF_Q4_1_VALUE: 'smeSignOffRequestQ4_1_value'
} as const;

export const EMISSION_EVALUATION_OPTIONS = [
  {
    label:
      'Yes, we use tailored in-house or paid-for resources to calculate them',
    value:
      'Yes, we use tailored in-house or paid-for resources to calculate them'
  },
  {
    label: 'Yes, we use a generic tool to estimate them, please specify',
    value: 'Yes, we use a generic tool to estimate them, please specify'
  },
  {
    label: 'No, but we plan to within the next two years',
    value: 'No, but we plan to within the next two years'
  },
  {
    label: 'No, and do not plan to in the next two years',
    value: 'No, and do not plan to in the next two years'
  }
];

export const SCOPE_2_APPROACH_OPTIONS = [
  {
    label: 'We are reporting a Scope 2 location-based figure',
    value: 'We are reporting a Scope 2 location-based figure'
  },
  {
    label: 'We are reporting a Scope 2 market-based figure',
    value: 'We are reporting a Scope 2 market-based figure'
  },
  {
    label:
      'We are reporting both a Scope 2 location-based and market-based figure',
    value:
      'We are reporting both a Scope 2 location-based and market-based figure'
  },
  {
    label:
      'We are reporting a Scope 2 figure but do not know which approach was used',
    value:
      'We are reporting a Scope 2 figure but do not know which approach was used'
  }
];

export const PRIMARY_REASON_FOR_NOT_REPORTING_A_MARKET_BASED_FIGURE_OPTIONS = [
  {
    label:
      'We have no operations where we are able to access electricity supplier emission factors or residual emission factors, and are unable to report a Scope 2, market-based figure',
    value:
      'We have no operations where we are able to access electricity supplier emission factors or residual emission factors, and are unable to report a Scope 2, market-based figure'
  },
  {
    label:
      'We have operations where we are able to access electricity supplier emission factors or residual emissions factors, but are unable to report a Scope 2, market-based figure',
    value:
      'We have operations where we are able to access electricity supplier emission factors or residual emissions factors, but are unable to report a Scope 2, market-based figure'
  }
];

export const MAIN_MEASURES_WHICH_HAVE_HELPED_OR_WOULD_HELP_TO_MANAGE_OR_RESOLVE_THE_CHALLENGES_OPTIONS =
  [
    {
      label: 'Use of free tools and resources',
      value: 'Use of free tools and resources'
    },
    {
      label: 'Investment in paid-for tools and resources',
      value: 'Investment in paid-for tools and resources'
    },
    {
      label: 'External partnership',
      value: 'External partnership'
    },
    {
      label: 'Stakeholder or peer support',
      value: 'Stakeholder or peer support'
    },
    {
      label: 'Involvement in external partnerships and collaboration',
      value: 'Involvement in external partnerships and collaboration'
    },
    {
      label: 'Other, please specify',
      value: 'Other, please specify'
    }
  ];

export const PRIMARY_REASON_FOR_NOT_EVALUATING_EMISSIONS_OPTIONS = [
  {
    label:
      'Lack of internal resources, capabilities, or expertise (e.g., due to organization size)',
    value:
      'Lack of internal resources, capabilities, or expertise (e.g., due to organization size)'
  },
  {
    label: 'No standardized procedure',
    value: 'No standardized procedure'
  },
  {
    label: 'Not an immediate strategic priority',
    value: 'Not an immediate strategic priority'
  },
  {
    label: 'Judged to be unimportant or not relevant',
    value: 'Judged to be unimportant or not relevant'
  },
  {
    label: 'Other, please specify',
    value: 'Other, please specify'
  }
];

export const LANGUAGE_OPTIONS = [
  {value: 'English', label: 'English'},
  {value: 'Latin', label: 'Latin'},
  {value: 'American', label: 'American'},
  {value: 'Spanish', label: 'Spanish'},
  {value: 'Brazilian', label: 'Brazilian'},
  {value: 'Portuguese', label: 'Portuguese'},
  {value: 'Japanes', label: 'Japanes'},
  {value: 'Chinese', label: 'Chinese'},
  {value: 'Other Please Specify', label: 'Other Please Specify'}
];

export const CURRENCY_OPTIONS = [
  {value: 'AED', label: 'AED'},
  {value: 'AFN', label: 'AFN'},
  {value: 'ALL', label: 'ALL'},
  {value: 'AMD', label: 'AMD'},
  {value: 'ANG', label: 'ANG'},
  {value: 'AOA', label: 'AOA'},
  {value: 'ARS', label: 'ARS'},
  {value: 'AUD', label: 'AUD'},
  {value: 'AWG', label: 'AWG'},
  {value: 'AZN', label: 'AZN'},
  {value: 'BAM', label: 'BAM'},
  {value: 'BBD', label: 'BBD'},
  {value: 'BDT', label: 'BDT'},
  {value: 'BGN', label: 'BGN'},
  {value: 'BHD', label: 'BHD'},
  {value: 'BIF', label: 'BIF'},
  {value: 'BMD', label: 'BMD'},
  {value: 'BND', label: 'BND'},
  {value: 'BOB', label: 'BOB'},
  {value: 'BRL', label: 'BRL'},
  {value: 'BSD', label: 'BSD'},
  {value: 'BTN', label: 'BTN'},
  {value: 'BWP', label: 'BWP'},
  {value: 'BYN', label: 'BYN'},
  {value: 'BZD', label: 'BZD'},
  {value: 'CAD', label: 'CAD'},
  {value: 'CDF', label: 'CDF'},
  {value: 'CHF', label: 'CHF'},
  {value: 'CLP', label: 'CLP'},
  {value: 'CNY', label: 'CNY'},
  {value: 'COP', label: 'COP'},
  {value: 'CRC', label: 'CRC'},
  {value: 'CUP', label: 'CUP'},
  {value: 'CVE', label: 'CVE'},
  {value: 'CZK', label: 'CZK'},
  {value: 'DJF', label: 'DJF'},
  {value: 'DKK', label: 'DKK'},
  {value: 'DOP', label: 'DOP'},
  {value: 'DZD', label: 'DZD'},
  {value: 'EGP', label: 'EGP'},
  {value: 'ERN', label: 'ERN'},
  {value: 'ETB', label: 'ETB'},
  {value: 'EUR', label: 'EUR'},
  {value: 'FJD', label: 'FJD'},
  {value: 'FKP', label: 'FKP'},
  {value: 'FOK', label: 'FOK'},
  {value: 'GBP', label: 'GBP'},
  {value: 'GEL', label: 'GEL'},
  {value: 'GGP', label: 'GGP'},
  {value: 'GHS', label: 'GHS'},
  {value: 'GIP', label: 'GIP'},
  {value: 'GMD', label: 'GMD'},
  {value: 'GNF', label: 'GNF'},
  {value: 'GTQ', label: 'GTQ'},
  {value: 'GYD', label: 'GYD'},
  {value: 'HKD', label: 'HKD'},
  {value: 'HNL', label: 'HNL'},
  {value: 'HRK', label: 'HRK'},
  {value: 'HTG', label: 'HTG'},
  {value: 'HUF', label: 'HUF'},
  {value: 'IDR', label: 'IDR'},
  {value: 'ILS', label: 'ILS'},
  {value: 'IMP', label: 'IMP'},
  {value: 'INR', label: 'INR'},
  {value: 'IQD', label: 'IQD'},
  {value: 'IRR', label: 'IRR'},
  {value: 'ISK', label: 'ISK'},
  {value: 'JEP', label: 'JEP'},
  {value: 'JMD', label: 'JMD'},
  {value: 'JOD', label: 'JOD'},
  {value: 'JPY', label: 'JPY'},
  {value: 'KES', label: 'KES'},
  {value: 'KGS', label: 'KGS'},
  {value: 'KHR', label: 'KHR'},
  {value: 'KID', label: 'KID'},
  {value: 'KMF', label: 'KMF'},
  {value: 'KRW', label: 'KRW'},
  {value: 'KWD', label: 'KWD'},
  {value: 'KYD', label: 'KYD'},
  {value: 'KZT', label: 'KZT'},
  {value: 'LAK', label: 'LAK'},
  {value: 'LBP', label: 'LBP'},
  {value: 'LKR', label: 'LKR'},
  {value: 'LRD', label: 'LRD'},
  {value: 'LSL', label: 'LSL'},
  {value: 'LYD', label: 'LYD'},
  {value: 'MAD', label: 'MAD'},
  {value: 'MDL', label: 'MDL'},
  {value: 'MGA', label: 'MGA'},
  {value: 'MKD', label: 'MKD'},
  {value: 'MMK', label: 'MMK'},
  {value: 'MNT', label: 'MNT'},
  {value: 'MOP', label: 'MOP'},
  {value: 'MRU', label: 'MRU'},
  {value: 'MUR', label: 'MUR'},
  {value: 'MVR', label: 'MVR'},
  {value: 'MWK', label: 'MWK'},
  {value: 'MXN', label: 'MXN'},
  {value: 'MYR', label: 'MYR'},
  {value: 'MZN', label: 'MZN'},
  {value: 'NAD', label: 'NAD'},
  {value: 'NGN', label: 'NGN'},
  {value: 'NIO', label: 'NIO'},
  {value: 'NOK', label: 'NOK'},
  {value: 'NPR', label: 'NPR'},
  {value: 'NZD', label: 'NZD'},
  {value: 'OMR', label: 'OMR'},
  {value: 'PAB', label: 'PAB'},
  {value: 'PEN', label: 'PEN'},
  {value: 'PGK', label: 'PGK'},
  {value: 'PHP', label: 'PHP'},
  {value: 'PKR', label: 'PKR'},
  {value: 'PLN', label: 'PLN'},
  {value: 'PYG', label: 'PYG'},
  {value: 'QAR', label: 'QAR'},
  {value: 'RON', label: 'RON'},
  {value: 'RSD', label: 'RSD'},
  {value: 'RUB', label: 'RUB'},
  {value: 'RWF', label: 'RWF'},
  {value: 'SAR', label: 'SAR'},
  {value: 'SBD', label: 'SBD'},
  {value: 'SCR', label: 'SCR'},
  {value: 'SDG', label: 'SDG'},
  {value: 'SEK', label: 'SEK'},
  {value: 'SGD', label: 'SGD'},
  {value: 'SHP', label: 'SHP'},
  {value: 'SLE', label: 'SLE'},
  {value: 'SOS', label: 'SOS'},
  {value: 'SRD', label: 'SRD'},
  {value: 'SSP', label: 'SSP'},
  {value: 'STN', label: 'STN'},
  {value: 'SYP', label: 'SYP'},
  {value: 'SZL', label: 'SZL'},
  {value: 'THB', label: 'THB'},
  {value: 'TJS', label: 'TJS'},
  {value: 'TMT', label: 'TMT'},
  {value: 'TND', label: 'TND'},
  {value: 'TOP', label: 'TOP'},
  {value: 'TRY', label: 'TRY'},
  {value: 'TTD', label: 'TTD'},
  {value: 'TVD', label: 'TVD'},
  {value: 'TWD', label: 'TWD'},
  {value: 'TZS', label: 'TZS'},
  {value: 'UAH', label: 'UAH'},
  {value: 'UGX', label: 'UGX'},
  {value: 'USD', label: 'USD'},
  {value: 'UYU', label: 'UYU'},
  {value: 'UZS', label: 'UZS'},
  {value: 'VES', label: 'VES'},
  {value: 'VND', label: 'VND'},
  {value: 'VUV', label: 'VUV'},
  {value: 'WST', label: 'WST'},
  {value: 'XAF', label: 'XAF'},
  {value: 'XCD', label: 'XCD'},
  {value: 'XDR', label: 'XDR'},
  {value: 'XOF', label: 'XOF'},
  {value: 'XPF', label: 'XPF'},
  {value: 'YER', label: 'YER'},
  {value: 'ZAR', label: 'ZAR'},
  {value: 'ZMW', label: 'ZMW'},
  {value: 'ZWL', label: 'ZWL'}
];

export const COUNTRY_OPTIONS = [
  {value: 'Afghanistan', label: 'Afghanistan'},
  {value: 'Albania', label: 'Albania'},
  {value: 'Algeria', label: 'Algeria'},
  {value: 'Andorra', label: 'Andorra'},
  {value: 'Angola', label: 'Angola'},
  {value: 'Antigua and Barbuda', label: 'Antigua and Barbuda'},
  {value: 'Argentina', label: 'Argentina'},
  {value: 'Armenia', label: 'Armenia'},
  {value: 'Australia', label: 'Australia'},
  {value: 'Austria', label: 'Austria'},
  {value: 'Azerbaijan', label: 'Azerbaijan'},
  {value: 'Bahamas', label: 'Bahamas'},
  {value: 'Bahrain', label: 'Bahrain'},
  {value: 'Bangladesh', label: 'Bangladesh'},
  {value: 'Barbados', label: 'Barbados'},
  {value: 'Belarus', label: 'Belarus'},
  {value: 'Belgium', label: 'Belgium'},
  {value: 'Belize', label: 'Belize'},
  {value: 'Benin', label: 'Benin'},
  {value: 'Bhutan', label: 'Bhutan'},
  {value: 'Bolivia', label: 'Bolivia'},
  {value: 'Bosnia and Herzegovina', label: 'Bosnia and Herzegovina'},
  {value: 'Botswana', label: 'Botswana'},
  {value: 'Brazil', label: 'Brazil'},
  {value: 'Brunei', label: 'Brunei'},
  {value: 'Bulgaria', label: 'Bulgaria'},
  {value: 'Burkina Faso', label: 'Burkina Faso'},
  {value: 'Burundi', label: 'Burundi'},
  {value: 'Cabo Verde', label: 'Cabo Verde'},
  {value: 'Cambodia', label: 'Cambodia'},
  {value: 'Cameroon', label: 'Cameroon'},
  {value: 'Canada', label: 'Canada'},
  {value: 'Central African Republic', label: 'Central African Republic'},
  {value: 'Chad', label: 'Chad'},
  {value: 'Chile', label: 'Chile'},
  {value: 'China', label: 'China'},
  {value: 'Colombia', label: 'Colombia'},
  {value: 'Comoros', label: 'Comoros'},
  {value: 'Congo (Congo-Brazzaville)', label: 'Congo (Congo-Brazzaville)'},
  {value: 'Costa Rica', label: 'Costa Rica'},
  {value: 'Croatia', label: 'Croatia'},
  {value: 'Cuba', label: 'Cuba'},
  {value: 'Cyprus', label: 'Cyprus'},
  {value: 'Czechia', label: 'Czechia'},
  {
    value: 'Democratic Republic of the Congo',
    label: 'Democratic Republic of the Congo'
  },
  {value: 'Denmark', label: 'Denmark'},
  {value: 'Djibouti', label: 'Djibouti'},
  {value: 'Dominica', label: 'Dominica'},
  {value: 'Dominican Republic', label: 'Dominican Republic'},
  {value: 'Ecuador', label: 'Ecuador'},
  {value: 'Egypt', label: 'Egypt'},
  {value: 'El Salvador', label: 'El Salvador'},
  {value: 'Equatorial Guinea', label: 'Equatorial Guinea'},
  {value: 'Eritrea', label: 'Eritrea'},
  {value: 'Estonia', label: 'Estonia'},
  {value: 'Eswatini', label: 'Eswatini'},
  {value: 'Ethiopia', label: 'Ethiopia'},
  {value: 'Fiji', label: 'Fiji'},
  {value: 'Finland', label: 'Finland'},
  {value: 'France', label: 'France'},
  {value: 'Gabon', label: 'Gabon'},
  {value: 'Gambia', label: 'Gambia'},
  {value: 'Georgia', label: 'Georgia'},
  {value: 'Germany', label: 'Germany'},
  {value: 'Ghana', label: 'Ghana'},
  {value: 'Greece', label: 'Greece'},
  {value: 'Grenada', label: 'Grenada'},
  {value: 'Guatemala', label: 'Guatemala'},
  {value: 'Guinea', label: 'Guinea'},
  {value: 'Guinea-Bissau', label: 'Guinea-Bissau'},
  {value: 'Guyana', label: 'Guyana'},
  {value: 'Haiti', label: 'Haiti'},
  {value: 'Honduras', label: 'Honduras'},
  {value: 'Hungary', label: 'Hungary'},
  {value: 'Iceland', label: 'Iceland'},
  {value: 'India', label: 'India'},
  {value: 'Indonesia', label: 'Indonesia'},
  {value: 'Iran', label: 'Iran'},
  {value: 'Iraq', label: 'Iraq'},
  {value: 'Ireland', label: 'Ireland'},
  {value: 'Israel', label: 'Israel'},
  {value: 'Italy', label: 'Italy'},
  {value: 'Jamaica', label: 'Jamaica'},
  {value: 'Japan', label: 'Japan'},
  {value: 'Jordan', label: 'Jordan'},
  {value: 'Kazakhstan', label: 'Kazakhstan'},
  {value: 'Kenya', label: 'Kenya'},
  {value: 'Kiribati', label: 'Kiribati'},
  {value: 'Kuwait', label: 'Kuwait'},
  {value: 'Kyrgyzstan', label: 'Kyrgyzstan'},
  {value: 'Laos', label: 'Laos'},
  {value: 'Latvia', label: 'Latvia'},
  {value: 'Lebanon', label: 'Lebanon'},
  {value: 'Lesotho', label: 'Lesotho'},
  {value: 'Liberia', label: 'Liberia'},
  {value: 'Libya', label: 'Libya'},
  {value: 'Liechtenstein', label: 'Liechtenstein'},
  {value: 'Lithuania', label: 'Lithuania'},
  {value: 'Luxembourg', label: 'Luxembourg'},
  {value: 'Madagascar', label: 'Madagascar'},
  {value: 'Malawi', label: 'Malawi'},
  {value: 'Malaysia', label: 'Malaysia'},
  {value: 'Maldives', label: 'Maldives'},
  {value: 'Mali', label: 'Mali'},
  {value: 'Malta', label: 'Malta'},
  {value: 'Marshall Islands', label: 'Marshall Islands'},
  {value: 'Mauritania', label: 'Mauritania'},
  {value: 'Mauritius', label: 'Mauritius'},
  {value: 'Mexico', label: 'Mexico'},
  {value: 'Micronesia', label: 'Micronesia'},
  {value: 'Moldova', label: 'Moldova'},
  {value: 'Monaco', label: 'Monaco'},
  {value: 'Mongolia', label: 'Mongolia'},
  {value: 'Montenegro', label: 'Montenegro'},
  {value: 'Morocco', label: 'Morocco'},
  {value: 'Mozambique', label: 'Mozambique'},
  {value: 'Myanmar', label: 'Myanmar'},
  {value: 'Namibia', label: 'Namibia'},
  {value: 'Nauru', label: 'Nauru'},
  {value: 'Nepal', label: 'Nepal'},
  {value: 'Netherlands', label: 'Netherlands'},
  {value: 'New Zealand', label: 'New Zealand'},
  {value: 'Nicaragua', label: 'Nicaragua'},
  {value: 'Niger', label: 'Niger'},
  {value: 'Nigeria', label: 'Nigeria'},
  {value: 'North Korea', label: 'North Korea'},
  {value: 'North Macedonia', label: 'North Macedonia'},
  {value: 'Norway', label: 'Norway'},
  {value: 'Oman', label: 'Oman'},
  {value: 'Pakistan', label: 'Pakistan'},
  {value: 'Palau', label: 'Palau'},
  {value: 'Palestine State', label: 'Palestine State'},
  {value: 'Panama', label: 'Panama'},
  {value: 'Papua New Guinea', label: 'Papua New Guinea'},
  {value: 'Paraguay', label: 'Paraguay'},
  {value: 'Peru', label: 'Peru'},
  {value: 'Philippines', label: 'Philippines'},
  {value: 'Poland', label: 'Poland'},
  {value: 'Portugal', label: 'Portugal'},
  {value: 'Qatar', label: 'Qatar'},
  {value: 'Romania', label: 'Romania'},
  {value: 'Russia', label: 'Russia'},
  {value: 'Rwanda', label: 'Rwanda'},
  {value: 'Saint Kitts and Nevis', label: 'Saint Kitts and Nevis'},
  {value: 'Saint Lucia', label: 'Saint Lucia'},
  {
    value: 'Saint Vincent and the Grenadines',
    label: 'Saint Vincent and the Grenadines'
  },
  {value: 'Samoa', label: 'Samoa'},
  {value: 'San Marino', label: 'San Marino'},
  {value: 'Sao Tome and Principe', label: 'Sao Tome and Principe'},
  {value: 'Saudi Arabia', label: 'Saudi Arabia'},
  {value: 'Senegal', label: 'Senegal'},
  {value: 'Serbia', label: 'Serbia'},
  {value: 'Seychelles', label: 'Seychelles'},
  {value: 'Sierra Leone', label: 'Sierra Leone'},
  {value: 'Singapore', label: 'Singapore'},
  {value: 'Slovakia', label: 'Slovakia'},
  {value: 'Slovenia', label: 'Slovenia'},
  {value: 'Solomon Islands', label: 'Solomon Islands'},
  {value: 'Somalia', label: 'Somalia'},
  {value: 'South Africa', label: 'South Africa'},
  {value: 'South Korea', label: 'South Korea'},
  {value: 'South Sudan', label: 'South Sudan'},
  {value: 'Spain', label: 'Spain'},
  {value: 'Sri Lanka', label: 'Sri Lanka'},
  {value: 'Sudan', label: 'Sudan'},
  {value: 'Suriname', label: 'Suriname'},
  {value: 'Sweden', label: 'Sweden'},
  {value: 'Switzerland', label: 'Switzerland'},
  {value: 'Syria', label: 'Syria'},
  {value: 'Taiwan', label: 'Taiwan'},
  {value: 'Tajikistan', label: 'Tajikistan'},
  {value: 'Tanzania', label: 'Tanzania'},
  {value: 'Thailand', label: 'Thailand'},
  {value: 'Timor-Leste', label: 'Timor-Leste'},
  {value: 'Togo', label: 'Togo'},
  {value: 'Tonga', label: 'Tonga'},
  {value: 'Trinidad and Tobago', label: 'Trinidad and Tobago'},
  {value: 'Tunisia', label: 'Tunisia'},
  {value: 'Turkey', label: 'Turkey'},
  {value: 'Turkmenistan', label: 'Turkmenistan'},
  {value: 'Tuvalu', label: 'Tuvalu'},
  {value: 'Uganda', label: 'Uganda'},
  {value: 'Ukraine', label: 'Ukraine'},
  {value: 'United Arab Emirates', label: 'United Arab Emirates'},
  {value: 'United Kingdom', label: 'United Kingdom'},
  {value: 'United States of America', label: 'United States of America'},
  {value: 'Uruguay', label: 'Uruguay'},
  {value: 'Uzbekistan', label: 'Uzbekistan'},
  {value: 'Vanuatu', label: 'Vanuatu'},
  {value: 'Vatican City', label: 'Vatican City'},
  {value: 'Venezuela', label: 'Venezuela'},
  {value: 'Vietnam', label: 'Vietnam'},
  {value: 'Yemen', label: 'Yemen'},
  {value: 'Zambia', label: 'Zambia'},
  {value: 'Zimbabwe', label: 'Zimbabwe'}
];

export const ENVIRONMENTAL_ISSUE_OPTIONS = [
  {value: 'Climate change', label: 'Climate change'},
  {value: 'Forests', label: 'Forests'},
  {value: 'Water', label: 'Water'}
];

export const OPPORTUNITY_OPTIONS = [
  {value: 'Opp 1', label: 'Opp 1'},
  {value: 'Opp 2', label: 'Opp 2'},
  {value: 'Opp 3', label: 'Opp 3'},
  {value: 'Opp 4', label: 'Opp 4'},
  {value: 'Opp 5', label: 'Opp 5'},
  {value: 'Opp 6', label: 'Opp 6'},
  {value: 'Opp 7', label: 'Opp 7'},
  {value: 'Opp 8', label: 'Opp 8'},
  {value: 'Opp 9', label: 'Opp 9'},
  {value: 'Opp 10', label: 'Opp 10'},
  {value: 'Opp 11', label: 'Opp 11'},
  {value: 'Opp 12', label: 'Opp 12'},
  {value: 'Opp 13', label: 'Opp 13'},
  {value: 'Opp 14', label: 'Opp 14'},
  {value: 'Opp 15', label: 'Opp 15'},
  {value: 'Opp 16', label: 'Opp 16'},
  {value: 'Opp 17', label: 'Opp 17'},
  {value: 'Opp 18', label: 'Opp 18'},
  {value: 'Opp 19', label: 'Opp 19'},
  {value: 'Opp 20', label: 'Opp 20'},
  {value: 'Opp 21', label: 'Opp 21'},
  {value: 'Opp 22', label: 'Opp 22'},
  {value: 'Opp 23', label: 'Opp 23'},
  {value: 'Opp 24', label: 'Opp 24'},
  {value: 'Opp 25', label: 'Opp 25'},
  {value: 'Opp 26', label: 'Opp 26'},
  {value: 'Opp 27', label: 'Opp 27'},
  {value: 'Opp 28', label: 'Opp 28'},
  {value: 'Opp 29', label: 'Opp 29'},
  {value: 'Opp 30', label: 'Opp 30'},
  {value: 'Opp 31', label: 'Opp 31'},
  {value: 'Opp 32', label: 'Opp 32'},
  {value: 'Opp 33', label: 'Opp 33'},
  {value: 'Opp 34', label: 'Opp 34'},
  {value: 'Opp 35', label: 'Opp 35'},
  {value: 'Opp 36', label: 'Opp 36'},
  {value: 'Opp 37', label: 'Opp 37'},
  {value: 'Opp 38', label: 'Opp 38'},
  {value: 'Opp 39', label: 'Opp 39'},
  {value: 'Opp 40', label: 'Opp 40'},
  {value: 'Opp 41', label: 'Opp 41'},
  {value: 'Opp 42', label: 'Opp 42'},
  {value: 'Opp 43', label: 'Opp 43'},
  {value: 'Opp 44', label: 'Opp 44'},
  {value: 'Opp 45', label: 'Opp 45'},
  {value: 'Opp 46', label: 'Opp 46'},
  {value: 'Opp 47', label: 'Opp 47'},
  {value: 'Opp 48', label: 'Opp 48'},
  {value: 'Opp 49', label: 'Opp 49'},
  {value: 'Opp 50', label: 'Opp 50'},
  {value: 'Opp 51', label: 'Opp 51'},
  {value: 'Opp 52', label: 'Opp 52'},
  {value: 'Opp 53', label: 'Opp 53'},
  {value: 'Opp 54', label: 'Opp 54'},
  {value: 'Opp 55', label: 'Opp 55'},
  {value: 'Opp 56', label: 'Opp 56'},
  {value: 'Opp 57', label: 'Opp 57'},
  {value: 'Opp 58', label: 'Opp 58'},
  {value: 'Opp 59', label: 'Opp 59'},
  {value: 'Opp 60', label: 'Opp 60'},
  {value: 'Opp 61', label: 'Opp 61'},
  {value: 'Opp 62', label: 'Opp 62'},
  {value: 'Opp 63', label: 'Opp 63'},
  {value: 'Opp 64', label: 'Opp 64'},
  {value: 'Opp 65', label: 'Opp 65'},
  {value: 'Opp 66', label: 'Opp 66'},
  {value: 'Opp 67', label: 'Opp 67'},
  {value: 'Opp 68', label: 'Opp 68'},
  {value: 'Opp 69', label: 'Opp 69'},
  {value: 'Opp 70', label: 'Opp 70'},
  {value: 'Opp 71', label: 'Opp 71'},
  {value: 'Opp 72', label: 'Opp 72'},
  {value: 'Opp 73', label: 'Opp 73'},
  {value: 'Opp 74', label: 'Opp 74'},
  {value: 'Opp 75', label: 'Opp 75'},
  {value: 'Opp 76', label: 'Opp 76'},
  {value: 'Opp 77', label: 'Opp 77'},
  {value: 'Opp 78', label: 'Opp 78'},
  {value: 'Opp 79', label: 'Opp 79'},
  {value: 'Opp 80', label: 'Opp 80'},
  {value: 'Opp 81', label: 'Opp 81'},
  {value: 'Opp 82', label: 'Opp 82'},
  {value: 'Opp 83', label: 'Opp 83'},
  {value: 'Opp 84', label: 'Opp 84'},
  {value: 'Opp 85', label: 'Opp 85'},
  {value: 'Opp 86', label: 'Opp 86'},
  {value: 'Opp 87', label: 'Opp 87'},
  {value: 'Opp 88', label: 'Opp 88'},
  {value: 'Opp 89', label: 'Opp 89'},
  {value: 'Opp 90', label: 'Opp 90'},
  {value: 'Opp 91', label: 'Opp 91'},
  {value: 'Opp 92', label: 'Opp 92'},
  {value: 'Opp 93', label: 'Opp 93'},
  {value: 'Opp 94', label: 'Opp 94'},
  {value: 'Opp 95', label: 'Opp 95'},
  {value: 'Opp 96', label: 'Opp 96'},
  {value: 'Opp 97', label: 'Opp 97'},
  {value: 'Opp 98', label: 'Opp 98'},
  {value: 'Opp 99', label: 'Opp 99'},
  {value: 'Opp 100', label: 'Opp 100'}
];

export const COMMODITY_OPTIONS = [
  {label: 'Timber products', value: 'Timber products'},
  {label: 'Palm oil', value: 'Palm oil'},
  {
    label: 'Cattle products',
    value: 'Cattle products'
  },
  {label: 'Cocoa', value: 'Cocoa'},
  {label: 'Coffee', value: 'Coffee'},
  {label: 'Soy', value: 'Soy'},
  {label: 'Rubber', value: 'Rubber'},
  {label: 'Not applicable', value: 'Not applicable'}
];

export const INITIATIVE_ID_OPTIONS = [
  {value: 'Ini 1', label: 'Ini 1'},
  {value: 'Ini 2', label: 'Ini 2'},
  {value: 'Ini 3', label: 'Ini 3'},
  {value: 'Ini 4', label: 'Ini 4'},
  {value: 'Ini 5', label: 'Ini 5'},
  {value: 'Ini 6', label: 'Ini 6'},
  {value: 'Ini 7', label: 'Ini 7'},
  {value: 'Ini 8', label: 'Ini 8'},
  {value: 'Ini 9', label: 'Ini 9'},
  {value: 'Ini 10', label: 'Ini 10'},
  {value: 'Ini 11', label: 'Ini 11'},
  {value: 'Ini 12', label: 'Ini 12'},
  {value: 'Ini 13', label: 'Ini 13'},
  {value: 'Ini 14', label: 'Ini 14'},
  {value: 'Ini 15', label: 'Ini 15'},
  {value: 'Ini 16', label: 'Ini 16'},
  {value: 'Ini 17', label: 'Ini 17'},
  {value: 'Ini 18', label: 'Ini 18'},
  {value: 'Ini 19', label: 'Ini 19'},
  {value: 'Ini 20', label: 'Ini 20'},
  {value: 'Ini 21', label: 'Ini 21'},
  {value: 'Ini 22', label: 'Ini 22'},
  {value: 'Ini 23', label: 'Ini 23'},
  {value: 'Ini 24', label: 'Ini 24'},
  {value: 'Ini 25', label: 'Ini 25'},
  {value: 'Ini 26', label: 'Ini 26'},
  {value: 'Ini 27', label: 'Ini 27'},
  {value: 'Ini 28', label: 'Ini 28'},
  {value: 'Ini 29', label: 'Ini 29'},
  {value: 'Ini 30', label: 'Ini 30'},
  {value: 'Ini 31', label: 'Ini 31'},
  {value: 'Ini 32', label: 'Ini 32'},
  {value: 'Ini 33', label: 'Ini 33'},
  {value: 'Ini 34', label: 'Ini 34'},
  {value: 'Ini 35', label: 'Ini 35'},
  {value: 'Ini 36', label: 'Ini 36'},
  {value: 'Ini 37', label: 'Ini 37'},
  {value: 'Ini 38', label: 'Ini 38'},
  {value: 'Ini 39', label: 'Ini 39'},
  {value: 'Ini 40', label: 'Ini 40'},
  {value: 'Ini 41', label: 'Ini 41'},
  {value: 'Ini 42', label: 'Ini 42'},
  {value: 'Ini 43', label: 'Ini 43'},
  {value: 'Ini 44', label: 'Ini 44'},
  {value: 'Ini 45', label: 'Ini 45'},
  {value: 'Ini 46', label: 'Ini 46'},
  {value: 'Ini 47', label: 'Ini 47'},
  {value: 'Ini 48', label: 'Ini 48'},
  {value: 'Ini 49', label: 'Ini 49'},
  {value: 'Ini 50', label: 'Ini 50'},
  {value: 'Ini 51', label: 'Ini 51'},
  {value: 'Ini 52', label: 'Ini 52'},
  {value: 'Ini 53', label: 'Ini 53'},
  {value: 'Ini 54', label: 'Ini 54'},
  {value: 'Ini 55', label: 'Ini 55'},
  {value: 'Ini 56', label: 'Ini 56'},
  {value: 'Ini 57', label: 'Ini 57'},
  {value: 'Ini 58', label: 'Ini 58'},
  {value: 'Ini 59', label: 'Ini 59'},
  {value: 'Ini 60', label: 'Ini 60'},
  {value: 'Ini 61', label: 'Ini 61'},
  {value: 'Ini 62', label: 'Ini 62'},
  {value: 'Ini 63', label: 'Ini 63'},
  {value: 'Ini 64', label: 'Ini 64'},
  {value: 'Ini 65', label: 'Ini 65'},
  {value: 'Ini 66', label: 'Ini 66'},
  {value: 'Ini 67', label: 'Ini 67'},
  {value: 'Ini 68', label: 'Ini 68'},
  {value: 'Ini 69', label: 'Ini 69'},
  {value: 'Ini 70', label: 'Ini 70'},
  {value: 'Ini 71', label: 'Ini 71'},
  {value: 'Ini 72', label: 'Ini 72'},
  {value: 'Ini 73', label: 'Ini 73'},
  {value: 'Ini 74', label: 'Ini 74'},
  {value: 'Ini 75', label: 'Ini 75'},
  {value: 'Ini 76', label: 'Ini 76'},
  {value: 'Ini 77', label: 'Ini 77'},
  {value: 'Ini 78', label: 'Ini 78'},
  {value: 'Ini 79', label: 'Ini 79'},
  {value: 'Ini 80', label: 'Ini 80'},
  {value: 'Ini 81', label: 'Ini 81'},
  {value: 'Ini 82', label: 'Ini 82'},
  {value: 'Ini 83', label: 'Ini 83'},
  {value: 'Ini 84', label: 'Ini 84'},
  {value: 'Ini 85', label: 'Ini 85'},
  {value: 'Ini 86', label: 'Ini 86'},
  {value: 'Ini 87', label: 'Ini 87'},
  {value: 'Ini 88', label: 'Ini 88'},
  {value: 'Ini 89', label: 'Ini 89'},
  {value: 'Ini 90', label: 'Ini 90'},
  {value: 'Ini 91', label: 'Ini 91'},
  {value: 'Ini 92', label: 'Ini 92'},
  {value: 'Ini 93', label: 'Ini 93'},
  {value: 'Ini 94', label: 'Ini 94'},
  {value: 'Ini 95', label: 'Ini 95'},
  {value: 'Ini 96', label: 'Ini 96'},
  {value: 'Ini 97', label: 'Ini 97'},
  {value: 'Ini 98', label: 'Ini 98'},
  {value: 'Ini 99', label: 'Ini 99'},
  {value: 'Ini 100', label: 'Ini 100'}
];

export const FINANCIAL_EFFECTS_OPTIONS = [
  {
    value: 'Adopt sustainable irrigation practices [W only]',
    label: 'Adopt sustainable irrigation practices [W only]'
  },
  {
    value:
      'Avoid sourcing from jurisdictions with a high risk of deforestation and conversion of other natural ecosystems [F only]',
    label:
      'Avoid sourcing from jurisdictions with a high risk of deforestation and conversion of other natural ecosystems [F only]'
  },
  {
    value: 'Improve soil health [F, W only]',
    label: 'Improve soil health [F, W only]'
  },
  {
    value: 'Species management and/or recovery [F only]',
    label: 'Species management and/or recovery [F only]'
  },
  {
    value: 'Other agricultural practice, please specify',
    label: 'Other agricultural practice, please specify'
  },
  {
    value: 'Develop new products, services and/or markets',
    label: 'Develop new products, services and/or markets'
  },
  {
    value: 'Increase supplier diversification',
    label: 'Increase supplier diversification'
  },
  {value: 'Marketing campaigns', label: 'Marketing campaigns'},
  {value: 'Market expansion', label: 'Market expansion'},
  {
    value: 'Improve emergency response systems in sourcing regions [F only]',
    label: 'Improve emergency response systems in sourcing regions [F only]'
  },
  {
    value: 'Improve fire management systems in sourcing regions [F only]',
    label: 'Improve fire management systems in sourcing regions [F only]'
  },
  {
    value: 'Other diversification, please specify',
    label: 'Other diversification, please specify'
  },
  {
    value:
      'Align organization’s public policy engagement with its environmental strategy',
    label:
      'Align organization’s public policy engagement with its environmental strategy'
  },
  {
    value: 'Engage in multi-stakeholder initiatives',
    label: 'Engage in multi-stakeholder initiatives'
  },
  {value: 'Engage with customers', label: 'Engage with customers'},
  {
    value: 'Engage with local communities',
    label: 'Engage with local communities'
  },
  {
    value: 'Engage with NGOs/special interest groups',
    label: 'Engage with NGOs/special interest groups'
  },
  {
    value: 'Engage with regulators/policy makers',
    label: 'Engage with regulators/policy makers'
  },
  {value: 'Engage with suppliers', label: 'Engage with suppliers'},
  {value: 'Engage with trade unions', label: 'Engage with trade unions'},
  {
    value:
      'Ensure grievance mechanisms are available to relevant stakeholders [FW]',
    label:
      'Ensure grievance mechanisms are available to relevant stakeholders [FW]'
  },
  {
    value: 'Introduce/strengthen environmental incentives',
    label: 'Introduce/strengthen environmental incentives'
  },
  {
    value: 'Other engagement, please specify',
    label: 'Other engagement, please specify'
  },
  {
    value:
      'Ensure no deforestation and no conversion in own operations [F only]',
    label:
      'Ensure no deforestation and no conversion in own operations [F only]'
  },
  {
    value: 'Establish site-specific targets',
    label: 'Establish site-specific targets'
  },
  {
    value: 'Establish company-wide targets',
    label: 'Establish company-wide targets'
  },
  {
    value: 'Greater compliance with regulatory requirements',
    label: 'Greater compliance with regulatory requirements'
  },
  {value: 'Greater due diligence', label: 'Greater due diligence'},
  {
    value: 'Greater traceability of commodities [F only]',
    label: 'Greater traceability of commodities [F only]'
  },
  {
    value:
      'Implementation of environmental best practices in direct operations',
    label: 'Implementation of environmental best practices in direct operations'
  },
  {
    value: 'Improve monitoring of direct operations',
    label: 'Improve monitoring of direct operations'
  },
  {
    value: 'Improve monitoring of upstream and downstream activities',
    label: 'Improve monitoring of upstream and downstream activities'
  },
  {
    value: 'New or tighter supplier performance standards',
    label: 'New or tighter supplier performance standards'
  },
  {
    value: 'Promotion of best practice and awareness in the value chain',
    label: 'Promotion of best practice and awareness in the value chain'
  },
  {
    value: 'Other compliance, monitoring or target, please specify',
    label: 'Other compliance, monitoring or target, please specify'
  },
  {
    value:
      'Adopt water efficiency, water reuse, recycling and conservation practices [W only]',
    label:
      'Adopt water efficiency, water reuse, recycling and conservation practices [W only]'
  },
  {
    value: 'Improve maintenance of infrastructure [C, W only]',
    label: 'Improve maintenance of infrastructure [C, W only]'
  },
  {
    value: 'Increase environment-related capital expenditure',
    label: 'Increase environment-related capital expenditure'
  },
  {
    value: 'Increase geographic diversity of facilities',
    label: 'Increase geographic diversity of facilities'
  },
  {value: 'Increase investment in R&D', label: 'Increase investment in R&D'},
  {
    value:
      'Increase investment in water, sanitation and hygiene [WASH] [W only]',
    label:
      'Increase investment in water, sanitation and hygiene [WASH] [W only]'
  },
  {
    value: 'Secure alternative water supply [W only]',
    label: 'Secure alternative water supply [W only]'
  },
  {
    value: 'Other infrastructure, technology and spending, please specify',
    label: 'Other infrastructure, technology and spending, please specify'
  },
  {
    value: 'Biodiversity offsetting [F only]',
    label: 'Biodiversity offsetting [F only]'
  },
  {
    value:
      'Implement ecosystem restoration and long-term protection [C, F only]',
    label:
      'Implement ecosystem restoration and long-term protection [C, F only]'
  },
  {
    value:
      'Engage and support landscape and jurisdictional initiatives [F only]',
    label:
      'Engage and support landscape and jurisdictional initiatives [F only]'
  },
  {
    value: 'Implement nature-based solutions',
    label: 'Implement nature-based solutions'
  },
  {
    value:
      'Promotion of sustainable forest management, including financial incentives [F only]',
    label:
      'Promotion of sustainable forest management, including financial incentives [F only]'
  },
  {
    value: 'Support catchment and river restoration [W only]',
    label: 'Support catchment and river restoration [W only]'
  },
  {
    value: 'Support river basin restoration [W only]',
    label: 'Support river basin restoration [W only]'
  },
  {
    value:
      'Voluntary engagement in conservation projects (including reforestation, afforestation and ecosystem restoration) [F only]',
    label:
      'Voluntary engagement in conservation projects (including reforestation, afforestation and ecosystem restoration) [F only]'
  },
  {
    value:
      'Other nature-based solution, restoration and conservation, please specify',
    label:
      'Other nature-based solution, restoration and conservation, please specify'
  },
  {
    value: 'Adopt regenerative agriculture policies [F and W only]',
    label: 'Adopt regenerative agriculture policies [F and W only]'
  },
  {
    value: 'Amend the Business Continuity Plan',
    label: 'Amend the Business Continuity Plan'
  },
  {
    value:
      'Consider relevant transboundary water policies and agreements at national, bilateral or regional level [W only]',
    label:
      'Consider relevant transboundary water policies and agreements at national, bilateral or regional level [W only]'
  },
  {
    value: 'Develop a climate transition plan [C only]',
    label: 'Develop a climate transition plan [C only]'
  },
  {
    value: 'Develop drought emergency plans',
    label: 'Develop drought emergency plans'
  },
  {
    value: 'Develop flood emergency plans',
    label: 'Develop flood emergency plans'
  },
  {
    value:
      'Improve alignment of public policy influencing activity with environmental commitments [C, F, W only]',
    label:
      'Improve alignment of public policy influencing activity with environmental commitments [C, F, W only]'
  },
  {value: 'Increase insurance coverage', label: 'Increase insurance coverage'},
  {
    value: 'Increased use of sustainably sourced materials',
    label: 'Increased use of sustainably sourced materials'
  },
  {
    value: 'More ambitious environmental commitments and policies',
    label: 'More ambitious environmental commitments and policies'
  },
  {
    value: 'More ambitious no-conversion commitments and policies [F only]',
    label: 'More ambitious no-conversion commitments and policies [F only]'
  },
  {
    value:
      'More ambitious policies and commitments to protect natural ecosystems [F, W only]',
    label:
      'More ambitious policies and commitments to protect natural ecosystems [F, W only]'
  },
  {
    value:
      'Participation in environmental collaborative industry frameworks, initiatives and/or commitments',
    label:
      'Participation in environmental collaborative industry frameworks, initiatives and/or commitments'
  },
  {
    value: 'Use risk transfer instruments',
    label: 'Use risk transfer instruments'
  },
  {
    value: 'Other policies or plans, please specify',
    label: 'Other policies or plans, please specify'
  },
  {
    value: 'Implement internal price on carbon [C only]',
    label: 'Implement internal price on carbon [C only]'
  },
  {
    value: 'Implement internal price on water [W only]',
    label: 'Implement internal price on water [W only]'
  },
  {
    value: 'Increase internal price on carbon [C only]',
    label: 'Increase internal price on carbon [C only]'
  },
  {
    value: 'Increase internal price on water [W only]',
    label: 'Increase internal price on water [W only]'
  },
  {
    value: 'Purchase water quality credits [W only]',
    label: 'Purchase water quality credits [W only]'
  },
  {
    value: 'Promotion/purchase of carbon credits [C, F only]',
    label: 'Promotion/purchase of carbon credits [C, F only]'
  },
  {
    value: 'Other pricing or credit, please specify',
    label: 'Other pricing or credit, please specify'
  }
];

export const DISCLOSURE_MODULE_OPTIONS = [
  {value: 'Introduction', label: 'Introduction'},
  {
    value: 'All data points in module 14',
    label: 'All data points in module 14'
  },
  {
    value: 'Other data point in module 14, please specify',
    label: 'Other data point in module 14, please specify'
  },
  {
    value:
      'Identification, assessment, and management, risks, and opportunities',
    label:
      'Identification, assessment, and management, risks, and opportunities'
  },
  {
    value: 'Identification, assessment, and management processes',
    label: 'Identification, assessment, and management processes'
  },
  {
    value: 'All data points in module 15',
    label: 'All data points in module 15'
  },
  {
    value: 'Other data point in module 15, please specify',
    label: 'Other data point in module 15, please specify'
  },
  {
    value: 'Disclosure of risks and opportunities',
    label: 'Disclosure of risks and opportunities'
  },
  {
    value: 'Financial effect of environmental risks',
    label: 'Financial effect of environmental risks'
  },
  {
    value: 'All data points in module 16',
    label: 'All data points in module 16'
  },
  {
    value: 'Other data point in module 16, please specify',
    label: 'Other data point in module 16, please specify'
  },
  {value: 'Governance', label: 'Governance'},
  {value: 'Environmental policies', label: 'Environmental policies'},
  {
    value: 'All data points in module 17',
    label: 'All data points in module 17'
  },
  {
    value: 'Other data point in module 17, please specify',
    label: 'Other data point in module 17, please specify'
  },
  {value: 'Business strategy', label: 'Business strategy'},
  {value: 'Transition plans [CC only]', label: 'Transition plans [CC only]'},
  {
    value: 'All data points in module 18',
    label: 'All data points in module 18'
  },
  {
    value: 'Other data point in module 18, please specify',
    label: 'Other data point in module 18, please specify'
  },
  {
    value: 'Environmental performance – Consolidation approach',
    label: 'Environmental performance – Consolidation approach'
  },
  {value: 'Consolidation approach', label: 'Consolidation approach'},
  {
    value: 'All data points in module 19',
    label: 'All data points in module 19'
  },
  {
    value: 'Other data point in module 19, please specify',
    label: 'Other data point in module 19, please specify'
  },
  {
    value: 'Environmental performance – Climate change',
    label: 'Environmental performance – Climate change'
  },
  {
    value: 'Allocation of emissions to customers [SC only]',
    label: 'Allocation of emissions to customers [SC only]'
  },
  {
    value: 'Electricity/Steam/Heat/Cooling consumption',
    label: 'Electricity/Steam/Heat/Cooling consumption'
  },
  {
    value: 'Emissions reduction initiatives/business activities',
    label: 'Emissions reduction initiatives/business activities'
  },
  {value: 'Progress against targets', label: 'Progress against targets'},
  {
    value: 'Renewable Electricity consumption',
    label: 'Renewable Electricity consumption'
  },
  {value: 'Target-setting methodology', label: 'Target-setting methodology'},
  {
    value: 'Year on year change in absolute emissions (Scope 1 and 2)',
    label: 'Year on year change in absolute emissions (Scope 1 and 2)'
  },
  {
    value: 'Year on year change in absolute emissions (Scope 3)',
    label: 'Year on year change in absolute emissions (Scope 3)'
  },
  {
    value: 'Year on year change in emissions intensity (Scope 1 and 2)',
    label: 'Year on year change in emissions intensity (Scope 1 and 2)'
  },
  {
    value: 'Year on year change in emissions intensity (Scope 3)',
    label: 'Year on year change in emissions intensity (Scope 3)'
  },
  {
    value: 'All data points in module 20',
    label: 'All data points in module 20'
  },
  {
    value: 'Other data point in module 20, please specify',
    label: 'Other data point in module 20, please specify'
  },
  {
    value: 'All data points in CDP response',
    label: 'All data points in CDP response'
  }
];

export const VERIFICATION_STANDARD_OPTIONS = [
  {value: 'General', label: 'General'},
  {value: 'AA1000AS', label: 'AA1000AS'},
  {
    value: 'Aluminium Stewardship Initiative (ASW)',
    label: 'Aluminium Stewardship Initiative (ASW)'
  },
  {value: 'ASAE 3000 [CC and W only]', label: 'ASAE 3000 [CC and W only]'},
  {
    value:
      'Attestation Standards (AT-C Section 105 & 210/205) established by the American Institute of Certified Public Accountants (AICPA)',
    label:
      'Attestation Standards (AT-C Section 105 & 210/205) established by the American Institute of Certified Public Accountants (AICPA)'
  },
  {
    value: 'Compagnie Nationale des Commissaires aux Comptes (CNCC)',
    label: 'Compagnie Nationale des Commissaires aux Comptes (CNCC)'
  },
  {
    value:
      'CRevR 6 Bestyrkande av hållbarhetsredovisning (RevR 6 Assurance of Sustainability)',
    label:
      'CRevR 6 Bestyrkande av hållbarhetsredovisning (RevR 6 Assurance of Sustainability)'
  },
  {value: 'CSAE 3000 [CC and W only]', label: 'CSAE 3000 [CC and W only]'},
  {
    value:
      'DNV Verisustain Protocol / Verification Protocol for Sustainability Reporting',
    label:
      'DNV Verisustain Protocol / Verification Protocol for Sustainability Reporting'
  },
  {value: 'Dutch Standard 3000A', label: 'Dutch Standard 3000A'},
  {
    value:
      'IDW AsS 821: IDW Assurance Standard: Generally Accepted Assurance Principles for the Audit or Review of Reports on Sustainability Issues',
    label:
      'IDW AsS 821: IDW Assurance Standard: Generally Accepted Assurance Principles for the Audit or Review of Reports on Sustainability Issues'
  },
  {
    value:
      'International Sustainability and Carbon Certification (ISCC) [CC and F only]',
    label:
      'International Sustainability and Carbon Certification (ISCC) [CC and F only]'
  },
  {value: 'ISAE 3000', label: 'ISAE 3000'},
  {
    value: 'ISAE 3410, Assurance Engagements on Greenhouse Gas Statements',
    label: 'ISAE 3410, Assurance Engagements on Greenhouse Gas Statements'
  },
  {
    value:
      'RevR6 Procedure for assurance of sustainability report from Far, the Swedish auditors professional body',
    label:
      'RevR6 Procedure for assurance of sustainability report from Far, the Swedish auditors professional body'
  },
  {
    value: 'Roundtable on Sustainable Biomaterials (RSB)',
    label: 'Roundtable on Sustainable Biomaterials (RSB)'
  },
  {
    value: 'SGS Sustainability Report Assurance',
    label: 'SGS Sustainability Report Assurance'
  },
  {
    value:
      'Standard 3810N Assurance engagements relating to sustainability reports of the Royal Netherlands Institute of Registered Accountants',
    label:
      'Standard 3810N Assurance engagements relating to sustainability reports of the Royal Netherlands Institute of Registered Accountants'
  },
  {
    value: 'SURE (Sustainable Resources Verification Scheme) [CC and F only]',
    label: 'SURE (Sustainable Resources Verification Scheme) [CC and F only]'
  },
  {
    value: 'Sustainable Biomass Program (SBP)',
    label: 'Sustainable Biomass Program (SBP)'
  },
  {
    value: 'Verified Carbon Standard (VCS) [CC and F only]',
    label: 'Verified Carbon Standard (VCS) [CC and F only]'
  },
  {
    value: 'Other general verification standard, please specify',
    label: 'Other general verification standard, please specify'
  },
  {value: 'Water', label: 'Water'},
  {
    value: 'Other water verification standard, please specify',
    label: 'Other water verification standard, please specify'
  },
  {value: 'Forests', label: 'Forests'},
  {
    value: 'Other forests verification standard, please specify',
    label: 'Other forests verification standard, please specify'
  },
  {value: 'Climate change', label: 'Climate change'},
  {
    value:
      'ABNT NBR ISO 14064-3:2007 (Associação Brasileira de Normas Técnicas)',
    label:
      'ABNT NBR ISO 14064-3:2007 (Associação Brasileira de Normas Técnicas)'
  },
  {
    value:
      'Advanced technologies promotion Subsidy Scheme with Emission reduction Target (ASSET)',
    label:
      'Advanced technologies promotion Subsidy Scheme with Emission reduction Target (ASSET)'
  },
  {
    value:
      'Airport Carbon Accreditation (ACA) des Airports Council International Europe',
    label:
      'Airport Carbon Accreditation (ACA) des Airports Council International Europe'
  },
  {
    value: 'Alberta Specified Gas Emitters Regulation',
    label: 'Alberta Specified Gas Emitters Regulation'
  },
  {value: 'ASAE 3410', label: 'ASAE 3410'},
  {
    value: 'Australia National Greenhouse and Energy Regulations (NGER Act)',
    label: 'Australia National Greenhouse and Energy Regulations (NGER Act)'
  },
  {
    value:
      'California Mandatory GHG Reporting Regulations (Californian Air Resources Board regulations)',
    label:
      'California Mandatory GHG Reporting Regulations (Californian Air Resources Board regulations)'
  },
  {
    value:
      'Canadian Institute of Chartered Accountants (CICA) Handbook: Assurance Section 5025',
    label:
      'Canadian Institute of Chartered Accountants (CICA) Handbook: Assurance Section 5025'
  },
  {value: 'Carbon Trust Standard', label: 'Carbon Trust Standard'},
  {
    value: 'Chicago Climate Exchange verification standard',
    label: 'Chicago Climate Exchange verification standard'
  },
  {value: 'Climate Action Reserve', label: 'Climate Action Reserve'},
  {
    value: 'Corporate GHG Verification Guidelines from ERT',
    label: 'Corporate GHG Verification Guidelines from ERT'
  },
  {value: 'CSAE 3410', label: 'CSAE 3410'},
  {value: 'Earthcheck Certified', label: 'Earthcheck Certified'},
  {
    value: 'ERM GHG Performance Data Assurance Methodology',
    label: 'ERM GHG Performance Data Assurance Methodology'
  },
  {
    value: 'ERT Standard “Corporate Greenhouse Gas Verification”',
    label: 'ERT Standard “Corporate Greenhouse Gas Verification”'
  },
  {
    value:
      'IDW PS 821: IDW IDW Prüfungsstandard: Grundsätze ordnungsmäßiger Prüfung oder prüferischer Durchsicht von Berichtenim Bereich der Nachhaltigkeit',
    label:
      'IDW PS 821: IDW IDW Prüfungsstandard: Grundsätze ordnungsmäßiger Prüfung oder prüferischer Durchsicht von Berichtenim Bereich der Nachhaltigkeit'
  },
  {
    value: 'IRECS (International Renewable Energy Certificate services)',
    label: 'IRECS (International Renewable Energy Certificate services)'
  },
  {value: 'ISO 14064-1', label: 'ISO 14064-1'},
  {value: 'ISO 14064-3', label: 'ISO 14064-3'},
  {
    value:
      'JVETS (Japanese Voluntary Emissions Trading Scheme) Guideline for Verification',
    label:
      'JVETS (Japanese Voluntary Emissions Trading Scheme) Guideline for Verification'
  },
  {
    value: 'Korean GHG and energy target management system',
    label: 'Korean GHG and energy target management system'
  },
  {
    value:
      'NMX-SAA-14064-3-IMNC: Instituto Mexicano de Normalización y Certificación A.C',
    label:
      'NMX-SAA-14064-3-IMNC: Instituto Mexicano de Normalización y Certificación A.C'
  },
  {
    value: 'Saitama Prefecture Target-Setting Emissions Trading Program',
    label: 'Saitama Prefecture Target-Setting Emissions Trading Program'
  },
  {
    value: 'Spanish Institute of Registered Auditors (ICJCE)',
    label: 'Spanish Institute of Registered Auditors (ICJCE)'
  },
  {value: 'SSAE 3000', label: 'SSAE 3000'},
  {
    value:
      'State of Israel Ministry of Environmental Protection, VERIFICATION OF GREENHOUSE GAS EMISSIONS AND EMISSIONS REDUCTION IN ISRAEL GUIDANCE DOCUMENT FOR CONDUCTING VERIFICAITONS, Process A',
    label:
      'State of Israel Ministry of Environmental Protection, VERIFICATION OF GREENHOUSE GAS EMISSIONS AND EMISSIONS REDUCTION IN ISRAEL GUIDANCE DOCUMENT FOR CONDUCTING VERIFICAITONS, Process A'
  },
  {value: 'Swiss Climate CO2 label', label: 'Swiss Climate CO2 label'},
  {
    value: 'Thai Greenhouse Gas Management Organization (TGO)',
    label: 'Thai Greenhouse Gas Management Organization (TGO)'
  },
  {
    value: 'The Climate Registry’s General Verification Protocol (GVP)',
    label: 'The Climate Registry’s General Verification Protocol (GVP)'
  },
  {value: 'Toitū carbon reduce', label: 'Toitū carbon reduce'},
  {value: 'Toitū climate positive', label: 'Toitū climate positive'},
  {value: 'Toitū net carbon zero', label: 'Toitū net carbon zero'},
  {
    value: 'Tokyo Emissions Trading Scheme',
    label: 'Tokyo Emissions Trading Scheme'
  },
  {
    value:
      'Verification under the EU Emissions Trading Scheme (EU ETS) Directive and EU ETS related national implementation laws',
    label:
      'Verification under the EU Emissions Trading Scheme (EU ETS) Directive and EU ETS related national implementation laws'
  },
  {
    value: 'Other climate change verification standard, please specify',
    label: 'Other climate change verification standard, please specify'
  },
  {value: 'Water', label: 'Water'},
  {
    value: 'Other water verification standard, please specify',
    label: 'Other water verification standard, please specify'
  },
  {value: 'Forests', label: 'Forests'},
  {
    value: 'Other forests verification standard, please specify',
    label: 'Other forests verification standard, please specify'
  }
];

export const RELEVANCE_OF_SCOPE_OPTIONS = [
  {
    label: 'Emissions are not relevant',
    value: 'Emissions are not relevant'
  },
  {
    label: 'Emissions are relevant but not yet calculated',
    value: 'Emissions are relevant but not yet calculated'
  },
  {
    label: 'Emissions are relevant and calculated, but not disclosed',
    value: 'Emissions are relevant and calculated, but not disclosed'
  },
  {
    label: 'Emissions excluded due to a recent acquisition or merger',
    value: 'Emissions excluded due to a recent acquisition or merger'
  },
  {
    label: 'Emissions are not evaluated',
    value: 'Emissions are not evaluated'
  }
];

export const ABS_OPTIONS = [
  {value: 'Abs 1', label: 'Abs 1'},
  {value: 'Abs 2', label: 'Abs 2'},
  {value: 'Abs 3', label: 'Abs 3'},
  {value: 'Abs 4', label: 'Abs 4'},
  {value: 'Abs 5', label: 'Abs 5'},
  {value: 'Abs 6', label: 'Abs 6'},
  {value: 'Abs 7', label: 'Abs 7'},
  {value: 'Abs 8', label: 'Abs 8'},
  {value: 'Abs 9', label: 'Abs 9'},
  {value: 'Abs 10', label: 'Abs 10'},
  {value: 'Abs 11', label: 'Abs 11'},
  {value: 'Abs 12', label: 'Abs 12'},
  {value: 'Abs 13', label: 'Abs 13'},
  {value: 'Abs 14', label: 'Abs 14'},
  {value: 'Abs 15', label: 'Abs 15'},
  {value: 'Abs 16', label: 'Abs 16'},
  {value: 'Abs 17', label: 'Abs 17'},
  {value: 'Abs 18', label: 'Abs 18'},
  {value: 'Abs 19', label: 'Abs 19'},
  {value: 'Abs 20', label: 'Abs 20'},
  {value: 'Abs 21', label: 'Abs 21'},
  {value: 'Abs 22', label: 'Abs 22'},
  {value: 'Abs 23', label: 'Abs 23'},
  {value: 'Abs 24', label: 'Abs 24'},
  {value: 'Abs 25', label: 'Abs 25'},
  {value: 'Abs 26', label: 'Abs 26'},
  {value: 'Abs 27', label: 'Abs 27'},
  {value: 'Abs 28', label: 'Abs 28'},
  {value: 'Abs 29', label: 'Abs 29'},
  {value: 'Abs 30', label: 'Abs 30'},
  {value: 'Abs 31', label: 'Abs 31'},
  {value: 'Abs 32', label: 'Abs 32'},
  {value: 'Abs 33', label: 'Abs 33'},
  {value: 'Abs 34', label: 'Abs 34'},
  {value: 'Abs 35', label: 'Abs 35'},
  {value: 'Abs 36', label: 'Abs 36'},
  {value: 'Abs 37', label: 'Abs 37'},
  {value: 'Abs 38', label: 'Abs 38'},
  {value: 'Abs 39', label: 'Abs 39'},
  {value: 'Abs 40', label: 'Abs 40'},
  {value: 'Abs 41', label: 'Abs 41'},
  {value: 'Abs 42', label: 'Abs 42'},
  {value: 'Abs 43', label: 'Abs 43'},
  {value: 'Abs 44', label: 'Abs 44'},
  {value: 'Abs 45', label: 'Abs 45'},
  {value: 'Abs 46', label: 'Abs 46'},
  {value: 'Abs 47', label: 'Abs 47'},
  {value: 'Abs 48', label: 'Abs 48'},
  {value: 'Abs 49', label: 'Abs 49'},
  {value: 'Abs 50', label: 'Abs 50'}
];

export const INT_OPTIONS = [
  {value: 'Int 1', label: 'Int 1'},
  {value: 'Int 2', label: 'Int 2'},
  {value: 'Int 3', label: 'Int 3'},
  {value: 'Int 4', label: 'Int 4'},
  {value: 'Int 5', label: 'Int 5'},
  {value: 'Int 6', label: 'Int 6'},
  {value: 'Int 7', label: 'Int 7'},
  {value: 'Int 8', label: 'Int 8'},
  {value: 'Int 9', label: 'Int 9'},
  {value: 'Int 10', label: 'Int 10'},
  {value: 'Int 11', label: 'Int 11'},
  {value: 'Int 12', label: 'Int 12'},
  {value: 'Int 13', label: 'Int 13'},
  {value: 'Int 14', label: 'Int 14'},
  {value: 'Int 15', label: 'Int 15'},
  {value: 'Int 16', label: 'Int 16'},
  {value: 'Int 17', label: 'Int 17'},
  {value: 'Int 18', label: 'Int 18'},
  {value: 'Int 19', label: 'Int 19'},
  {value: 'Int 20', label: 'Int 20'},
  {value: 'Int 21', label: 'Int 21'},
  {value: 'Int 22', label: 'Int 22'},
  {value: 'Int 23', label: 'Int 23'},
  {value: 'Int 24', label: 'Int 24'},
  {value: 'Int 25', label: 'Int 25'},
  {value: 'Int 26', label: 'Int 26'},
  {value: 'Int 27', label: 'Int 27'},
  {value: 'Int 28', label: 'Int 28'},
  {value: 'Int 29', label: 'Int 29'},
  {value: 'Int 30', label: 'Int 30'},
  {value: 'Int 31', label: 'Int 31'},
  {value: 'Int 32', label: 'Int 32'},
  {value: 'Int 33', label: 'Int 33'},
  {value: 'Int 34', label: 'Int 34'},
  {value: 'Int 35', label: 'Int 35'},
  {value: 'Int 36', label: 'Int 36'},
  {value: 'Int 37', label: 'Int 37'},
  {value: 'Int 38', label: 'Int 38'},
  {value: 'Int 39', label: 'Int 39'},
  {value: 'Int 40', label: 'Int 40'},
  {value: 'Int 41', label: 'Int 41'},
  {value: 'Int 42', label: 'Int 42'},
  {value: 'Int 43', label: 'Int 43'},
  {value: 'Int 44', label: 'Int 44'},
  {value: 'Int 45', label: 'Int 45'},
  {value: 'Int 46', label: 'Int 46'},
  {value: 'Int 47', label: 'Int 47'},
  {value: 'Int 48', label: 'Int 48'},
  {value: 'Int 49', label: 'Int 49'},
  {value: 'Int 50', label: 'Int 50'}
];

export const OTH_OPTIONS = [
  {label: 'Oth 1', value: 'Oth 1'},
  {label: 'Oth 2', value: 'Oth 2'},
  {label: 'Oth 3', value: 'Oth 3'},
  {label: 'Oth 4', value: 'Oth 4'},
  {label: 'Oth 5', value: 'Oth 5'},
  {label: 'Oth 6', value: 'Oth 6'},
  {label: 'Oth 7', value: 'Oth 7'},
  {label: 'Oth 8', value: 'Oth 8'},
  {label: 'Oth 9', value: 'Oth 9'},
  {label: 'Oth 10', value: 'Oth 10'},
  {label: 'Oth 11', value: 'Oth 11'},
  {label: 'Oth 12', value: 'Oth 12'},
  {label: 'Oth 13', value: 'Oth 13'},
  {label: 'Oth 14', value: 'Oth 14'},
  {label: 'Oth 15', value: 'Oth 15'},
  {label: 'Oth 16', value: 'Oth 16'},
  {label: 'Oth 17', value: 'Oth 17'},
  {label: 'Oth 18', value: 'Oth 18'},
  {label: 'Oth 19', value: 'Oth 19'},
  {label: 'Oth 20', value: 'Oth 20'},
  {label: 'Oth 21', value: 'Oth 21'},
  {label: 'Oth 22', value: 'Oth 22'},
  {label: 'Oth 23', value: 'Oth 23'},
  {label: 'Oth 24', value: 'Oth 24'},
  {label: 'Oth 25', value: 'Oth 25'},
  {label: 'Oth 26', value: 'Oth 26'},
  {label: 'Oth 27', value: 'Oth 27'},
  {label: 'Oth 28', value: 'Oth 28'},
  {label: 'Oth 29', value: 'Oth 29'},
  {label: 'Oth 30', value: 'Oth 30'},
  {label: 'Oth 31', value: 'Oth 31'},
  {label: 'Oth 32', value: 'Oth 32'},
  {label: 'Oth 33', value: 'Oth 33'},
  {label: 'Oth 34', value: 'Oth 34'},
  {label: 'Oth 35', value: 'Oth 35'},
  {label: 'Oth 36', value: 'Oth 36'},
  {label: 'Oth 37', value: 'Oth 37'},
  {label: 'Oth 38', value: 'Oth 38'},
  {label: 'Oth 39', value: 'Oth 39'},
  {label: 'Oth 40', value: 'Oth 40'},
  {label: 'Oth 41', value: 'Oth 41'},
  {label: 'Oth 42', value: 'Oth 42'},
  {label: 'Oth 43', value: 'Oth 43'},
  {label: 'Oth 44', value: 'Oth 44'},
  {label: 'Oth 45', value: 'Oth 45'},
  {label: 'Oth 46', value: 'Oth 46'},
  {label: 'Oth 47', value: 'Oth 47'},
  {label: 'Oth 48', value: 'Oth 48'},
  {label: 'Oth 49', value: 'Oth 49'},
  {label: 'Oth 50', value: 'Oth 50'}
];

export const INITIATIVE_TYPE_OPTIONS = [
  {
    value: 'Company policy or behavioral change',
    label: 'Company policy or behavioral change'
  },
  {value: 'Supplier engagement', label: 'Supplier engagement'},
  {value: 'Customer engagement', label: 'Customer engagement'},
  {value: 'Site consolidation/closure', label: 'Site consolidation/closure'},
  {
    value: 'Change in purchasing practices',
    label: 'Change in purchasing practices'
  },
  {value: 'Resource efficiency', label: 'Resource efficiency'},
  {value: 'Waste management', label: 'Waste management'},
  {
    value: 'Other company policy or behavioral change, please specify',
    label: 'Other company policy or behavioral change, please specify'
  },
  {
    value: 'Energy efficiency in buildings',
    label: 'Energy efficiency in buildings'
  },
  {value: 'insulation', label: 'insulation'},
  {value: 'Maintenance program', label: 'Maintenance program'},
  {value: 'Draught proofing', label: 'Draught proofing'},
  {value: 'Solar shading', label: 'Solar shading'},
  {
    value: 'Building Energy Management Systems (BEMS)',
    label: 'Building Energy Management Systems (BEMS)'
  },
  {
    value: 'Heating, ventilation and air conditioning (HVAC)',
    label: 'Heating, ventilation and air conditioning (HVAC)'
  },
  {value: 'Lighting', label: 'Lighting'},
  {value: 'Motors and drives', label: 'Motors and drives'},
  {
    value: 'Combined heat and power (cogeneration)',
    label: 'Combined heat and power (cogeneration)'
  },
  {
    value: 'Other energy efficiency in buildings, please specify',
    label: 'Other energy efficiency in buildings, please specify'
  },
  {
    value: 'Energy efficiency in production processes',
    label: 'Energy efficiency in production processes'
  },
  {value: 'Waste heat recovery', label: 'Waste heat recovery'},
  {value: 'Cooling technology', label: 'Cooling technology'},
  {value: 'Process optimization', label: 'Process optimization'},
  {value: 'Fuel switch', label: 'Fuel switch'},
  {value: 'Compressed air', label: 'Compressed air'},
  {
    value: 'Combined heat and power (cogeneration)',
    label: 'Combined heat and power (cogeneration)'
  },
  {value: 'Wastewater treatment', label: 'Wastewater treatment'},
  {value: 'Reuse of water', label: 'Reuse of water'},
  {value: 'Reuse of steam', label: 'Reuse of steam'},
  {
    value: 'Machine/equipment replacement',
    label: 'Machine/equipment replacement'
  },
  {value: 'Automation', label: 'Automation'},
  {value: 'Electrification', label: 'Electrification'},
  {value: 'Smart control system', label: 'Smart control system'},
  {value: 'Motors and drives', label: 'Motors and drives'},
  {value: 'Product or service design', label: 'Product or service design'},
  {
    value: 'Other energy efficiency in production processes, please specify',
    label: 'Other energy efficiency in production processes, please specify'
  },
  {
    value: 'Fugitive emissions reductions',
    label: 'Fugitive emissions reductions'
  },
  {
    value: 'Agricultural methane capture',
    label: 'Agricultural methane capture'
  },
  {
    value: 'Agricultural nitrous oxide reduction',
    label: 'Agricultural nitrous oxide reduction'
  },
  {value: 'Landfill methane capture', label: 'Landfill methane capture'},
  {
    value: 'Oil/natural gas methane leak capture/prevention',
    label: 'Oil/natural gas methane leak capture/prevention'
  },
  {
    value: 'Refrigerant leakage reduction',
    label: 'Refrigerant leakage reduction'
  },
  {
    value: 'Carbon capture and storage/utilization (CCS/U)',
    label: 'Carbon capture and storage/utilization (CCS/U)'
  },
  {
    value: 'Other fugitive emissions reductions, please specify',
    label: 'Other fugitive emissions reductions, please specify'
  },
  {
    value: 'Low-carbon energy consumption',
    label: 'Low-carbon energy consumption'
  },
  {value: 'Solid biofuels', label: 'Solid biofuels'},
  {value: 'Liquid biofuels', label: 'Liquid biofuels'},
  {value: 'Geothermal', label: 'Geothermal'},
  {value: 'Small hydropower (<25 MW)', label: 'Small hydropower (<25 MW)'},
  {
    value: 'Renewable hydrogen fuel cell',
    label: 'Renewable hydrogen fuel cell'
  },
  {value: 'Solar PV', label: 'Solar PV'},
  {value: 'Nuclear', label: 'Nuclear'},
  {value: 'Tidal', label: 'Tidal'},
  {
    value: 'Fossil fuel plant fitted with CCS',
    label: 'Fossil fuel plant fitted with CCS'
  },
  {
    value: 'Other low-carbon energy consumption, please specify',
    label: 'Other low-carbon energy consumption, please specify'
  },
  {
    value: 'Low-carbon energy generation',
    label: 'Low-carbon energy generation'
  },
  {value: 'Liquid biofuels', label: 'Liquid biofuels'},
  {value: 'Geothermal', label: 'Geothermal'},
  {
    value: 'Renewable hydrogen fuel cell',
    label: 'Renewable hydrogen fuel cell'
  },
  {value: 'Nuclear', label: 'Nuclear'},
  {value: 'Solar PV', label: 'Solar PV'},
  {value: 'Solar CSP', label: 'Solar CSP'},
  {value: 'Wind', label: 'Wind'},
  {value: 'Tidal', label: 'Tidal'},
  {
    value: 'Fossil fuel plant fitted with CCS',
    label: 'Fossil fuel plant fitted with CCS'
  },
  {
    value: 'Other low-carbon energy generation, please specify',
    label: 'Other low-carbon energy generation, please specify'
  },
  {
    value: 'Non-energy industrial process emissions reductions',
    label: 'Non-energy industrial process emissions reductions'
  },
  {value: 'Process material efficiency', label: 'Process material efficiency'},
  {
    value: 'Carbon capture and storage/utilization (CCS/U)',
    label: 'Carbon capture and storage/utilization (CCS/U)'
  },
  {
    value:
      'Other non-energy industrial process emissions reductions, please specify',
    label:
      'Other non-energy industrial process emissions reductions, please specify'
  },
  {value: 'Transportation', label: 'Transportation'},
  {value: 'Business travel policy', label: 'Business travel policy'},
  {value: 'Teleworking', label: 'Teleworking'},
  {
    value: 'Company fleet vehicle replacement',
    label: 'Company fleet vehicle replacement'
  },
  {
    value: 'Company fleet vehicle efficiency',
    label: 'Company fleet vehicle efficiency'
  },
  {
    value: 'Other transportation, please specify',
    label: 'Other transportation, please specify'
  },
  {
    value: 'Waste reduction and material circularity',
    label: 'Waste reduction and material circularity'
  },
  {value: 'Waste reduction', label: 'Waste reduction'},
  {
    value: 'Product/component/material reuse',
    label: 'Product/component/material reuse'
  },
  {
    value: 'Product/component/material recycling',
    label: 'Product/component/material recycling'
  },
  {value: 'Remanufacturing', label: 'Remanufacturing'},
  {
    value: 'Other waste reduction and material circularity, please specify',
    label: 'Other waste reduction and material circularity, please specify'
  },
  {value: 'Other, please specify', label: 'Other, please specify'}
];

export const PROTOCOL_OPTIONS = [
  {value: 'ABI Energia Linee Guida', label: 'ABI Energia Linee Guida'},
  {
    value: 'Act on the Rational Use of Energy',
    label: 'Act on the Rational Use of Energy'
  },
  {
    value:
      'American Petroleum Institute Compendium of Greenhouse Gas Emissions Methodologies for the Oil and Natural Gas Industry, 2009',
    label:
      'American Petroleum Institute Compendium of Greenhouse Gas Emissions Methodologies for the Oil and Natural Gas Industry, 2009'
  },
  {
    value: 'Australia - National Greenhouse and Energy Reporting Act',
    label: 'Australia - National Greenhouse and Energy Reporting Act'
  },
  {value: 'Bilan Carbone, ABC', label: 'Bilan Carbone, ABC'},
  {
    value:
      'Defra Environmental Reporting Guidelines: Including streamlined energy and carbon reporting guidance, 2019',
    label:
      'Defra Environmental Reporting Guidelines: Including streamlined energy and carbon reporting guidance, 2019'
  },
  {
    value: 'ENCORD: Construction CO2e Measurement Protocol',
    label: 'ENCORD: Construction CO2e Measurement Protocol'
  },
  {
    value:
      'Environment Canada, Sulphur hexafluoride (SF6) Emission Estimation and Reporting Protocol for Electric Utilities',
    label:
      'Environment Canada, Sulphur hexafluoride (SF6) Emission Estimation and Reporting Protocol for Electric Utilities'
  },
  {
    value:
      'Environment Canada, Aluminum Production, Guidance Manual for Estimating Greenhouse Gas Emissions',
    label:
      'Environment Canada, Aluminum Production, Guidance Manual for Estimating Greenhouse Gas Emissions'
  },
  {
    value:
      'Environment Canada, Base Metals Smelting/Refining, Guidance Manual for Estimating Greenhouse Gas Emissions',
    label:
      'Environment Canada, Base Metals Smelting/Refining, Guidance Manual for Estimating Greenhouse Gas Emissions'
  },
  {
    value:
      'Environment Canada, Cement Production, Guidance Manual for Estimating Greenhouse Gas Emissions',
    label:
      'Environment Canada, Cement Production, Guidance Manual for Estimating Greenhouse Gas Emissions'
  },
  {
    value:
      'Environment Canada, Primary Iron and Steel Production, Guidance Manual for Estimating Greenhouse Gas Emissions',
    label:
      'Environment Canada, Primary Iron and Steel Production, Guidance Manual for Estimating Greenhouse Gas Emissions'
  },
  {
    value:
      'Environment Canada, Lime Production, Guidance Manual for Estimating Greenhouse Gas Emissions',
    label:
      'Environment Canada, Lime Production, Guidance Manual for Estimating Greenhouse Gas Emissions'
  },
  {
    value:
      'Environment Canada, Primary Magnesium Production and Casting, Guidance Manual for Estimating Greenhouse Gas Emissions',
    label:
      'Environment Canada, Primary Magnesium Production and Casting, Guidance Manual for Estimating Greenhouse Gas Emissions'
  },
  {
    value:
      'Environment Canada, Metal Mining, Guidance Manual for Estimating Greenhouse Gas Emissions',
    label:
      'Environment Canada, Metal Mining, Guidance Manual for Estimating Greenhouse Gas Emissions'
  },
  {
    value: 'EPRA (European Public Real Estate Association) guidelines, 2011',
    label: 'EPRA (European Public Real Estate Association) guidelines, 2011'
  },
  {
    value:
      'EPRA (European Public Real Estate Association) Sustainability Best Practice recommendations Guidelines, 2017',
    label:
      'EPRA (European Public Real Estate Association) Sustainability Best Practice recommendations Guidelines, 2017'
  },
  {
    value: `European Union Emission Trading System (EU ETS): The Monitoring and Reporting
     Regulation (MMR) – General guidance for installations`,
    label: `European Union Emission Trading System (EU ETS): The Monitoring and Reporting
     Regulation (MMR) – General guidance for installations`
  },
  {
    value: `European Union Emissions Trading System (EU ETS): The Monitoring and Reporting
     Regulation (MMR) – General guidance for aircraft operators`,
    label: `European Union Emissions Trading System (EU ETS): The Monitoring and Reporting 
    Regulation (MMR) – General guidance for aircraft operators`
  },
  {
    value:
      'Global GHG Accounting and Reporting Standard for the Financial Industry (PCAF)',
    label:
      'Global GHG Accounting and Reporting Standard for the Financial Industry (PCAF)'
  },
  {
    value: `Hong Kong Environmental Protection Department, Guidelines to Account for and Report 
    on Greenhouse Gas Emissions and Removals for Buildings, 2010`,
    label: `Hong Kong Environmental Protection Department, Guidelines to Account for and Report 
    on Greenhouse Gas Emissions and Removals for Buildings, 2010`
  },
  {
    value: 'ICLEI Local Government GHG Protocol',
    label: 'ICLEI Local Government GHG Protocol'
  },
  {
    value: 'IEA CO2 Emissions from Fuel Combustion',
    label: 'IEA CO2 Emissions from Fuel Combustion'
  },
  {
    value:
      'International Wine Industry Greenhouse Gas Protocol and Accounting Tool',
    label:
      'International Wine Industry Greenhouse Gas Protocol and Accounting Tool'
  },
  {
    value:
      '2019 Refinement to the 2006 IPCC Guidelines for National Greenhouse Gas Inventories,2006',
    label:
      '2019 Refinement to the 2006 IPCC Guidelines for National Greenhouse Gas Inventories,2006'
  },
  {
    value:
      'IPIECA’s Petroleum Industry Guidelines for reporting GHG emissions, 2nd edition, 2011',
    label:
      'IPIECA’s Petroleum Industry Guidelines for reporting GHG emissions, 2nd edition, 2011'
  },
  {value: 'ISO 14064-1', label: 'ISO 14064-1'},
  {
    value: `Japan Ministry of the Environment, Law Concerning the Promotion of the Measures to Cope with Global Warming,
     Superseded by Revision of the Act on Promotion of Global Warming Countermeasures (2005 Amendment)`,
    label: `Japan Ministry of the Environment, Law Concerning the Promotion of the Measures to Cope with Global Warming, 
    Superseded by Revision of the Act on Promotion of Global Warming Countermeasures (2005 Amendment)`
  },
  {
    value: 'Korea GHG and Energy Target Management System Operating Guidelines',
    label: 'Korea GHG and Energy Target Management System Operating Guidelines'
  },
  {
    value:
      'New Zealand - Guidance for Voluntary, Corporate Greenhouse Gas Reporting',
    label:
      'New Zealand - Guidance for Voluntary, Corporate Greenhouse Gas Reporting'
  },
  {
    value: 'Regional Greenhouse Gas Initiative (RGGI) Model Rule',
    label: 'Regional Greenhouse Gas Initiative (RGGI) Model Rule'
  },
  {
    value:
      'Smart Freight Centre: GLEC Framework for Logistics Emissions Methodologies',
    label:
      'Smart Freight Centre: GLEC Framework for Logistics Emissions Methodologies'
  },
  {value: 'Taiwan - GHG Reduction Act', label: 'Taiwan - GHG Reduction Act'},
  {
    value:
      'Thailand Greenhouse Gas Management Organization: The National Guideline Carbon Footprint for organization',
    label:
      'Thailand Greenhouse Gas Management Organization: The National Guideline Carbon Footprint for organization'
  },
  {
    value: 'The Climate Registry: Electric Power Sector (EPS) Protocol',
    label: 'The Climate Registry: Electric Power Sector (EPS) Protocol'
  },
  {
    value: 'The Climate Registry: General Reporting Protocol',
    label: 'The Climate Registry: General Reporting Protocol'
  },
  {
    value: 'The Climate Registry: Local Government Operations (LGO) Protocol',
    label: 'The Climate Registry: Local Government Operations (LGO) Protocol'
  },
  {
    value: 'The Climate Registry: Oil & Gas Protocol',
    label: 'The Climate Registry: Oil & Gas Protocol'
  },
  {
    value: `The GHG Indicator: UNEP Guidelines for Calculating Greenhouse Gas Emissions 
    for Businesses and Non-Commercial Organizations`,
    label: `The GHG Indicator: UNEP Guidelines for Calculating Greenhouse Gas Emissions 
    for Businesses and Non-Commercial Organizations`
  },
  {
    value:
      'The Greenhouse Gas Protocol: A Corporate Accounting and Reporting Standard (Revised Edition)',
    label:
      'The Greenhouse Gas Protocol: A Corporate Accounting and Reporting Standard (Revised Edition)'
  },
  {
    value: `The Greenhouse Gas Protocol Agricultural Guidance: Interpreting the Corporate Accounting 
    and Reporting Standard for the Agricultural Sector`,
    label: `The Greenhouse Gas Protocol Agricultural Guidance: Interpreting the Corporate 
    Accounting and Reporting Standard for the Agricultural Sector`
  },
  {
    value: 'The Greenhouse Gas Protocol: Public Sector Standard',
    label: 'The Greenhouse Gas Protocol: Public Sector Standard'
  },
  {
    value: 'The Greenhouse Gas Protocol: Scope 2 Guidance',
    label: 'The Greenhouse Gas Protocol: Scope 2 Guidance'
  },
  {
    value:
      'The Greenhouse Gas Protocol: Corporate Value Chain (Scope 3) Standard',
    label:
      'The Greenhouse Gas Protocol: Corporate Value Chain (Scope 3) Standard'
  },
  {
    value: 'The Tokyo Cap-and Trade Program',
    label: 'The Tokyo Cap-and Trade Program'
  },
  {
    value: `US EPA Center for Corporate Climate Leadership: Direct Fugitive Emissions from Refrigeration,
     Air Conditioning, Fire Suppression, and Industrial Gases`,
    label: `US EPA Center for Corporate Climate Leadership: Direct Fugitive Emissions from Refrigeration, 
    Air Conditioning, Fire Suppression, and Industrial Gases`
  },
  {
    value:
      'US EPA Center for Corporate Climate Leadership: Indirect Emissions From Events and Conferences',
    label:
      'US EPA Center for Corporate Climate Leadership: Indirect Emissions From Events and Conferences'
  },
  {
    value:
      'US EPA Center for Corporate Climate Leadership: Indirect Emissions From Purchased Electricity',
    label:
      'US EPA Center for Corporate Climate Leadership: Indirect Emissions From Purchased Electricity'
  },
  {
    value:
      'US EPA Center for Corporate Climate Leadership: Direct Emissions from Stationary Combustion Sources',
    label:
      'US EPA Center for Corporate Climate Leadership: Direct Emissions from Stationary Combustion Sources'
  },
  {
    value:
      'US EPA Center for Corporate Climate Leadership: Direct Emissions from Mobile Combustion Sources',
    label:
      'US EPA Center for Corporate Climate Leadership: Direct Emissions from Mobile Combustion Sources'
  },
  {
    value: 'US EPA Mandatory Greenhouse Gas Reporting Rule',
    label: 'US EPA Mandatory Greenhouse Gas Reporting Rule'
  },
  {
    value: 'US EPA Emissions & Generation Resource Integrated Database (eGRID)',
    label: 'US EPA Emissions & Generation Resource Integrated Database (eGRID)'
  },
  {
    value: 'VfU (Verein fur Umweltmanagement) Indicators Standard',
    label: 'VfU (Verein fur Umweltmanagement) Indicators Standard'
  },
  {
    value: 'World Steel Association CO2 emissions data collection guidelines',
    label: 'World Steel Association CO2 emissions data collection guidelines'
  },
  {value: 'Other, please specify', label: 'Other, please specify'}
];

export const smeIntroQuestions = [
  {
    key: '1',
    showIndex: false,
    items: [
      {
        field: [
          {
            fieldType: inputType.HEADING,
            heading: '14.1 In which language are you submitting your response?'
          },
          {
            fieldType: inputType.SELECT,
            fieldName: CDP_SME_INTRO_FIELD_NAMES.SME_INTRO_Q1_VALUE,
            options: LANGUAGE_OPTIONS
          }
        ]
      },
      {
        field: [
          {
            fieldType: inputType.HEADING,
            heading:
              '14.2 Select the currency used for all financial information disclosed throughout your response.'
          },
          {
            fieldType: inputType.SELECT,
            fieldName: CDP_SME_INTRO_FIELD_NAMES.SME_INTRO_Q2_VALUE,
            options: CURRENCY_OPTIONS,
            colSpan: true
          }
        ]
      },
      {
        field: [
          {
            fieldType: inputType.HEADING,
            heading:
              '14.3 Provide an overview and introduction to your organization.'
          },
          {
            fieldType: inputType.ADD_NEW_TO_TABLE,
            fieldName: CDP_SME_INTRO_FIELD_NAMES.SME_INTRO_Q3_VALUE,
            allowMultipleRows: false,
            formList: {
              formFields: [
                {
                  type: inputType.SELECT,
                  fieldName: CDP_SME_INTRO_FIELD_NAMES.SME_INTRO_Q3_1_VALUE,
                  fieldLabel: 'Organization Type',
                  options: [
                    {
                      value: 'Publicly Trade Organization',
                      label: 'Publicly Trade Organization'
                    },
                    {
                      value: 'Privately Owned Organization',
                      label: 'Privately Owned Organization'
                    },
                    {
                      value: 'State Owned Organization',
                      label: 'State Owned Organization'
                    },
                    {
                      value:
                        'Partially Privately Owned and Partially State Owned Organization',
                      label:
                        'Partially Privately Owned and Partially State Owned Organization'
                    }
                  ],
                  colSpan: true
                },
                {
                  type: inputType.WYSIWYG,
                  fieldName: CDP_SME_INTRO_FIELD_NAMES.SME_INTRO_Q3_2_VALUE,
                  fieldLabel: 'Description of Organization',
                  colSpan: true,
                  textLimit: 1000
                }
              ]
            }
          }
        ]
      },
      {
        field: [
          {
            fieldType: inputType.HEADING,
            heading:
              '14.4 State the end date of the year for which you are reporting data.'
          },
          {
            fieldType: inputType.ADD_NEW_TO_TABLE,
            fieldName: CDP_SME_INTRO_FIELD_NAMES.SME_INTRO_Q4_VALUE,
            allowMultipleRows: false,
            overflow: 'visible',
            formList: {
              formFields: [
                {
                  type: inputType.DATEPICKER,
                  fieldName: CDP_SME_INTRO_FIELD_NAMES.SME_INTRO_Q4_1_VALUE,
                  fieldLabel: 'End Date of Reporting Year',
                  dateFormat: 'DD-MM-YYYY'
                },
                {
                  type: inputType.RADIOGROUP,
                  fieldName: CDP_SME_INTRO_FIELD_NAMES.SME_INTRO_Q4_2_VALUE,
                  fieldLabel:
                    'Alignment of This reporting Period with your financial Reporting period',
                  options: ['Yes', 'No']
                }
              ]
            }
          }
        ]
      },
      {
        field: [
          {
            fieldType: inputType.HEADING,
            heading:
              '14.4.1 What is your organization’s annual revenue for the reporting period?'
          },
          {
            fieldType: inputType.WYSIWYG,
            fieldName: CDP_SME_INTRO_FIELD_NAMES.SME_INTRO_Q5_VALUE
          }
        ]
      },
      {
        field: [
          {
            fieldType: inputType.HEADING,
            heading:
              '14.5 How do the entities included in your CDP response compare to those in your financial statements?'
          },
          {
            fieldType: inputType.ADD_NEW_TO_TABLE,
            fieldName: CDP_SME_INTRO_FIELD_NAMES.SME_INTRO_Q6_VALUE,
            allowMultipleRows: false,
            formList: {
              formFields: [
                {
                  type: inputType.SELECT,
                  fieldName: CDP_SME_INTRO_FIELD_NAMES.SME_INTRO_Q6_1_VALUE,
                  fieldLabel:
                    'Are the entities included in your CDP response the same as those included used in your financial statements?',
                  options: [
                    {
                      value:
                        'Yes, the entities included in my CDP disclosure are the same as those included in my financial statements',
                      label:
                        'Yes, the entities included in my CDP disclosure are the same as those included in my financial statements'
                    },
                    {
                      value:
                        'No, the entities included in my CDP disclosure are not the same as those included in my financial statements',
                      label:
                        'No, the entities included in my CDP disclosure are not the same as those included in my financial statements'
                    },
                    {
                      value:
                        'Not applicable - we do not publicly disclose financial statements',
                      label:
                        'Not applicable - we do not publicly disclose financial statements'
                    }
                  ],
                  colSpan: true
                },
                {
                  type: inputType.WYSIWYG,
                  fieldName: CDP_SME_INTRO_FIELD_NAMES.SME_INTRO_Q6_2_VALUE,
                  fieldLabel:
                    'How do the entities included in your CDP response differ to those included in your financial statement, and why are they different?',
                  colSpan: true,
                  textLimit: 2500,
                  disabledOn: {
                    fieldName: CDP_SME_INTRO_FIELD_NAMES.SME_INTRO_Q6_1_VALUE,
                    condition: conditionType.EQUALS,
                    values: [
                      'Yes, the entities included in my CDP disclosure are the same as those included in my financial statements',
                      'Not applicable - we do not publicly disclose financial statements'
                    ]
                  }
                }
              ]
            }
          }
        ]
      },
      {
        field: [
          {
            fieldType: inputType.HEADING,
            heading:
              '14.6 Does your organization have an ISIN code or another unique identifier (e.g., Ticker, CUSIP, etc.)?'
          },
          {
            fieldType: inputType.ADD_NEW_TO_TABLE,
            fieldName: CDP_SME_INTRO_FIELD_NAMES.SME_INTRO_Q7_VALUE,
            formList: {
              formFields: [
                {
                  type: inputType.SELECT,
                  fieldName: CDP_SME_INTRO_FIELD_NAMES.SME_INTRO_Q7_1_VALUE,
                  fieldLabel: 'Unique Identifier',
                  options: [
                    {value: 'ISIN code – bond', label: 'ISIN code – bond'},
                    {value: 'ISIN code – equity', label: 'ISIN code – equity'},
                    {value: 'CUSIP number', label: 'CUSIP number'},
                    {value: 'Ticker symbol', label: 'Ticker symbol'},
                    {value: 'SEDOL code', label: 'SEDOL code'},
                    {value: 'LEI number', label: 'LEI number'},
                    {value: 'D-U-N-S number', label: 'D-U-N-S number'},
                    {
                      value: 'Other unique identifier',
                      label: 'Other unique identifier'
                    }
                  ],
                  colSpan: true
                },
                {
                  type: inputType.RADIOGROUP,
                  fieldName: CDP_SME_INTRO_FIELD_NAMES.SME_INTRO_Q7_2_VALUE,
                  fieldLabel:
                    'Does your organization use this unique identifier?',
                  options: ['Yes', 'No']
                },
                {
                  type: inputType.WYSIWYG,
                  fieldName: CDP_SME_INTRO_FIELD_NAMES.SME_INTRO_Q7_3_VALUE,
                  fieldLabel: 'Provide your Unique identifier',
                  colSpan: true,
                  disabledOn: {
                    fieldName: CDP_SME_INTRO_FIELD_NAMES.SME_INTRO_Q7_2_VALUE,
                    condition: conditionType.NOT,
                    values: ['Yes']
                  }
                }
              ]
            }
          }
        ]
      },
      {
        field: [
          {
            fieldType: inputType.HEADING,
            heading:
              '14.7 Select the countries/areas in which the entities reported in 14.5 are based and/or conduct business.'
          },
          {
            fieldType: inputType.MULTISELECT,
            fieldName: CDP_SME_INTRO_FIELD_NAMES.SME_INTRO_Q8_VALUE,
            options: COUNTRY_OPTIONS,
            colSpan: true
          }
        ]
      }
    ]
  }
];

export const smeManagementQuestions = [
  {
    key: '1',
    showIndex: false,
    items: [
      {
        field: [
          {
            fieldType: inputType.HEADING,
            heading:
              '15.1 Does your organization have a process for identifying, assessing, and managing environmental risks and opportunities?'
          },
          {
            fieldType: inputType.ADD_NEW_TO_TABLE,
            fieldName: CDP_SME_MANAGEMENT_FIELD_NAMES.SME_MANAGEMENT_Q1_VALUE,
            allowMultipleRows: false,
            formList: {
              formFields: [
                {
                  type: inputType.SELECT,
                  fieldName:
                    CDP_SME_MANAGEMENT_FIELD_NAMES.SME_MANAGEMENT_Q1_1_VALUE,
                  fieldLabel: 'Process in place',
                  options: [
                    {label: 'Yes', value: 'Yes'},
                    {
                      label: 'No, but we plan to within the next two years',
                      value: 'No, but we plan to within the next two years'
                    },
                    {
                      label:
                        'No, and we do not plan to within the next two years',
                      value:
                        'No, and we do not plan to within the next two years'
                    }
                  ],
                  colSpan: true
                },
                {
                  type: inputType.SELECT,
                  fieldName:
                    CDP_SME_MANAGEMENT_FIELD_NAMES.SME_MANAGEMENT_Q1_2_VALUE,
                  fieldLabel:
                    'Risks and/or opportunities evaluated in this process',
                  options: [
                    {label: 'Risk Only', value: 'Risk Only'},
                    {
                      label: 'Opportunities only',
                      value: 'Opportunities only'
                    },
                    {
                      label: 'Both risks and opportunities',
                      value: 'Both risks and opportunities'
                    }
                  ],
                  colSpan: true,
                  disabledOn: {
                    fieldName:
                      CDP_SME_MANAGEMENT_FIELD_NAMES.SME_MANAGEMENT_Q1_1_VALUE,
                    condition: conditionType.NOT,
                    values: ['Yes']
                  }
                },
                {
                  type: inputType.SELECT,
                  fieldName:
                    CDP_SME_MANAGEMENT_FIELD_NAMES.SME_MANAGEMENT_Q1_3_VALUE,
                  fieldLabel: 'Frequency of Assessment',
                  options: [
                    {
                      value: 'More than once a year',
                      label: 'More than once a year'
                    },
                    {value: 'Annually', label: 'Annually'},
                    {value: 'Every two years', label: 'Every two years'},
                    {
                      value: 'Every three years or more',
                      label: 'Every three years or more'
                    },
                    {
                      value: 'As important matters arise',
                      label: 'As important matters arise'
                    },
                    {value: 'Not defined', label: 'Not defined'}
                  ],
                  colSpan: true,
                  disabledOn: {
                    fieldName:
                      CDP_SME_MANAGEMENT_FIELD_NAMES.SME_MANAGEMENT_Q1_1_VALUE,
                    condition: conditionType.NOT,
                    values: ['Yes']
                  }
                },
                {
                  type: inputType.WYSIWYG,
                  fieldName:
                    CDP_SME_MANAGEMENT_FIELD_NAMES.SME_MANAGEMENT_Q1_4_VALUE,
                  fieldLabel: 'Please Explain the process',
                  textLimit: 3500,
                  colSpan: true,
                  disabledOn: {
                    fieldName:
                      CDP_SME_MANAGEMENT_FIELD_NAMES.SME_MANAGEMENT_Q1_1_VALUE,
                    condition: conditionType.NOT,
                    values: ['Yes']
                  }
                }
              ]
            }
          }
        ]
      }
    ]
  }
];

export const smeDisclosureQuestions = [
  {
    key: '1',
    showIndex: false,
    items: [
      {
        field: [
          {
            fieldType: inputType.HEADING,
            heading:
              '16.1 Are you aware of any risks created by environmental issues which have had a substantive effect on your organization in the reporting year or may in the future?'
          },
          {
            fieldType: inputType.ADD_NEW_TO_TABLE,
            fieldName: CDP_SME_DISCLOSURE_FIELD_NAMES.SME_DISCLOSURE_Q1_VALUE,
            allowMultipleRows: false,
            formList: {
              formFields: [
                {
                  type: inputType.SELECT,
                  fieldName:
                    CDP_SME_DISCLOSURE_FIELD_NAMES.SME_DISCLOSURE_Q1_1_VALUE,
                  fieldLabel: 'Environmental Issue',
                  options: ENVIRONMENTAL_ISSUE_OPTIONS,
                  colSpan: true
                },
                {
                  type: inputType.SELECT,
                  fieldName:
                    CDP_SME_DISCLOSURE_FIELD_NAMES.SME_DISCLOSURE_Q1_2_VALUE,
                  fieldLabel: 'Environmental Risk Identified',
                  options: [
                    {
                      label:
                        'Yes, both in direct operations (our own operations) and upstream/downstream value chain (our suppliers, distributors, and customers)',
                      value:
                        'Yes, both in direct operations (our own operations) and upstream/downstream value chain (our suppliers, distributors, and customers)'
                    },
                    {
                      label:
                        'Yes, only within our direct operations (our own operations)',
                      value:
                        'Yes, only within our direct operations (our own operations)'
                    },
                    {
                      label:
                        'Yes, only in our upstream/downstream value chain (our suppliers, distributors, and customers), excluding direct operations',
                      value:
                        'Yes, only in our upstream/downstream value chain (our suppliers, distributors, and customers), excluding direct operations'
                    },
                    {
                      label: 'No',
                      value: 'No'
                    }
                  ],
                  colSpan: true
                },
                {
                  type: inputType.SELECT_WITH_OTHER_TEXTBOX,
                  fieldName:
                    CDP_SME_DISCLOSURE_FIELD_NAMES.SME_DISCLOSURE_Q1_3_VALUE,
                  fieldLabel:
                    'Primary reason why your organization does not consider itself to have environmental risks in your direct operations and/or upstream/downstream value chain',
                  options: [
                    {
                      value:
                        'Environmental risks exist, but none with the potential to have a substantive effect on our organization',
                      label:
                        'Environmental risks exist, but none with the potential to have a substantive effect on our organization'
                    },
                    {
                      value: 'Evaluation in progress',
                      label: 'Evaluation in progress'
                    },
                    {
                      value:
                        'Lack of internal resources, capabilities, or expertise (e.g., due to organization size)',
                      label:
                        'Lack of internal resources, capabilities, or expertise (e.g., due to organization size)'
                    },
                    {
                      value: 'No standardized procedure',
                      label: 'No standardized procedure'
                    },
                    {
                      value: 'Not an immediate strategic priority',
                      label: 'Not an immediate strategic priority'
                    },
                    {value: 'Insufficient data', label: 'Insufficient data'},
                    {
                      value: 'Other, please specify',
                      label: 'Other, please specify'
                    }
                  ],
                  colSpan: true,
                  disabledOn: {
                    fieldName:
                      CDP_SME_DISCLOSURE_FIELD_NAMES.SME_DISCLOSURE_Q1_2_VALUE,
                    condition: conditionType.EQUALS,
                    values: ['No']
                  }
                }
              ]
            }
          }
        ]
      },
      {
        field: [
          {
            fieldType: inputType.HEADING,
            heading:
              '16.1.1 Provide details of the risks created by environmental issues which have had a substantive effect on your organization in the reporting year or may in the future.',
            conditionalVisibility: {
              dependsOn: CDP_SME_DISCLOSURE_FIELD_NAMES.SME_DISCLOSURE_Q1_VALUE,
              showWhen: [
                'Yes, only within our direct operations (our own operations)',
                'Yes, both in direct operations (our own operations) and upstream/downstream value chain (our suppliers, distributors, and customers)',
                'Yes, only in our upstream/downstream value chain (our suppliers, distributors, and customers), excluding direct operations'
              ],
              condition: conditionType.EQUALS,
              fieldName:
                CDP_SME_DISCLOSURE_FIELD_NAMES.SME_DISCLOSURE_Q1_2_VALUE
            }
          },
          {
            fieldType: inputType.ADD_NEW_TO_TABLE,
            fieldName: CDP_SME_DISCLOSURE_FIELD_NAMES.SME_DISCLOSURE_Q2_VALUE,
            //  conditionalVisibility: {
            dependsOn: CDP_SME_DISCLOSURE_FIELD_NAMES.SME_DISCLOSURE_Q1_2_VALUE,
            showWhen: [
              'Yes, only within our direct operations (our own operations)',
              'Yes, both in direct operations (our own operations) and upstream/downstream value chain (our suppliers, distributors, and customers)',
              'Yes, only in our upstream/downstream value chain (our suppliers, distributors, and customers), excluding direct operations'
            ],
            relatedTableKey:
              CDP_SME_DISCLOSURE_FIELD_NAMES.SME_DISCLOSURE_Q1_VALUE,
            //  },

            formList: {
              formFields: [
                {
                  type: inputType.SELECT,
                  fieldName:
                    CDP_SME_DISCLOSURE_FIELD_NAMES.SME_DISCLOSURE_Q2_1_VALUE,
                  fieldLabel: 'Environmental issue the risk relates to',
                  options: ENVIRONMENTAL_ISSUE_OPTIONS,
                  colSpan: true
                },
                {
                  type: inputType.SELECT,
                  fieldName:
                    CDP_SME_DISCLOSURE_FIELD_NAMES.SME_DISCLOSURE_Q2_2_VALUE,
                  fieldLabel: 'Risk identified',
                  options: [
                    {
                      label: 'Risk 1 ',
                      value: 'Risk 1'
                    },
                    {
                      label: 'Risk 2',
                      value: 'Risk 2'
                    },
                    {
                      label: 'Risk 3',
                      value: 'Risk 3'
                    },
                    {
                      label: 'Risk 4',
                      value: 'Risk 4'
                    },
                    {
                      label: 'Risk 5',
                      value: 'Risk 5'
                    }
                  ],
                  colSpan: true
                },
                {
                  type: inputType.SELECT,
                  fieldName:
                    CDP_SME_DISCLOSURE_FIELD_NAMES.SME_DISCLOSURE_Q2_3_VALUE,
                  fieldLabel: 'Commodity',
                  options: COMMODITY_OPTIONS,
                  colSpan: true
                },
                {
                  type: inputType.SELECT_WITH_OTHER_TEXTBOX,
                  fieldName:
                    CDP_SME_DISCLOSURE_FIELD_NAMES.SME_DISCLOSURE_Q2_4_VALUE,
                  fieldLabel:
                    'Risk type and primary source of the environmental risk',
                  options: [
                    {value: 'Policy', label: 'Policy'},
                    {
                      value: 'Carbon pricing mechanisms [C only]',
                      label: 'Carbon pricing mechanisms [C only]'
                    },
                    {
                      value:
                        'Changes to international law and bilateral agreements',
                      label:
                        'Changes to international law and bilateral agreements'
                    },
                    {
                      value: 'Changes to national legislation',
                      label: 'Changes to national legislation'
                    },
                    {
                      value:
                        'Changes to regulation of existing products and services',
                      label:
                        'Changes to regulation of existing products and services'
                    },
                    {
                      value: 'Higher water prices [W only]',
                      label: 'Higher water prices [W only]'
                    },
                    {
                      value:
                        'Increased difficulty in obtaining operations permits',
                      label:
                        'Increased difficulty in obtaining operations permits'
                    },
                    {
                      value:
                        'Increased difficulty in obtaining withdrawal permits [W only]',
                      label:
                        'Increased difficulty in obtaining withdrawal permits [W only]'
                    },
                    {
                      value:
                        'Introduction of regulatory standards for previously unregulated contaminants [W only]',
                      label:
                        'Introduction of regulatory standards for previously unregulated contaminants [W only]'
                    },
                    {
                      value:
                        'Lack of mature certification and sustainability standards',
                      label:
                        'Lack of mature certification and sustainability standards'
                    },
                    {
                      value:
                        'Limited or lack of river basin management [W only]',
                      label:
                        'Limited or lack of river basin management [W only]'
                    },
                    {
                      value:
                        'Limited or lack of transboundary water management [W only]',
                      label:
                        'Limited or lack of transboundary water management [W only]'
                    },
                    {
                      value:
                        'Mandatory water efficiency, conservation, recycling or process standards [W only]',
                      label:
                        'Mandatory water efficiency, conservation, recycling or process standards [W only]'
                    },
                    {
                      value: 'Non-compliance with legislation',
                      label: 'Non-compliance with legislation'
                    },
                    {
                      value: 'Poor enforcement of regulation',
                      label: 'Poor enforcement of regulation'
                    },
                    {
                      value: 'Poor coordination between regulatory bodies',
                      label: 'Poor coordination between regulatory bodies'
                    },
                    {
                      value: 'Regulation of discharge quality/volumes [W only]',
                      label: 'Regulation of discharge quality/volumes [W only]'
                    },
                    {
                      value:
                        'Statutory water withdrawal limits/changes to water allocation [W only]',
                      label:
                        'Statutory water withdrawal limits/changes to water allocation [W only]'
                    },
                    {
                      value:
                        'Uncertainty and/or conflicts involving land tenure rights and water rights [F, W only]',
                      label:
                        'Uncertainty and/or conflicts involving land tenure rights and water rights [F, W only]'
                    },
                    {
                      value: 'Other policy risk, please specify',
                      label: 'Other policy risk, please specify'
                    },

                    {
                      value: 'Liability (legal claims)',
                      label: 'Liability (legal claims)'
                    },
                    {
                      value: 'Exposure to sanctions and litigation',
                      label: 'Exposure to sanctions and litigation'
                    },
                    {
                      value: 'Moratoria and voluntary agreements [W, F only]',
                      label: 'Moratoria and voluntary agreements [W, F only]'
                    },
                    {
                      value: 'Other liability risk, please specify',
                      label: 'Other liability risk, please specify'
                    },

                    {value: 'Technology', label: 'Technology'},
                    {
                      value:
                        'Dependency on water intensive energy sources [C, W only]',
                      label:
                        'Dependency on water intensive energy sources [C, W only]'
                    },
                    {
                      value:
                        'Inability to increase yield of existing production areas [F only]',
                      label:
                        'Inability to increase yield of existing production areas [F only]'
                    },
                    {
                      value: 'Lack of access to data',
                      label: 'Lack of access to data'
                    },
                    {
                      value: 'Lack of monitoring systems',
                      label: 'Lack of monitoring systems'
                    },
                    {
                      value:
                        'Transition to water efficient and low water intensity technologies and products [W only]',
                      label:
                        'Transition to water efficient and low water intensity technologies and products [W only]'
                    },
                    {
                      value:
                        'Transition to water intensive, low carbon energy sources [CW]',
                      label:
                        'Transition to water intensive, low carbon energy sources [CW]'
                    },
                    {
                      value:
                        'Transitioning to lower emissions technology [C only]',
                      label:
                        'Transitioning to lower emissions technology [C only]'
                    },
                    {
                      value: 'Unsuccessful investment in new technologies',
                      label: 'Unsuccessful investment in new technologies'
                    },
                    {
                      value: 'Other technology risk, please specify',
                      label: 'Other technology risk, please specify'
                    },

                    {value: 'Market', label: 'Market'},
                    {
                      value: 'Changing customer behavior',
                      label: 'Changing customer behavior'
                    },
                    {
                      value: 'Other market risk, please specify',
                      label: 'Other market risk, please specify'
                    },

                    {value: 'Reputation', label: 'Reputation'},
                    {
                      value:
                        'Increased stakeholder concern or negative stakeholder feedback',
                      label:
                        'Increased stakeholder concern or negative stakeholder feedback'
                    },
                    {
                      value: 'Local community opposition',
                      label: 'Local community opposition'
                    },
                    {
                      value:
                        'Negative press coverage related to support of projects or activities with negative impacts on the environment (e.g. GHG emissions, deforestation & conversion, water stress)',
                      label:
                        'Negative press coverage related to support of projects or activities with negative impacts on the environment (e.g. GHG emissions, deforestation & conversion, water stress)'
                    },
                    {
                      value: 'Stigmatization of sector',
                      label: 'Stigmatization of sector'
                    },
                    {
                      value: 'Other reputation risk, please specify',
                      label: 'Other reputation risk, please specify'
                    },

                    {
                      value:
                        'Acute physical (short term, specific events that change the state of nature)',
                      label:
                        'Acute physical (short term, specific events that change the state of nature)'
                    },
                    {value: 'Avalanche', label: 'Avalanche'},
                    {value: 'Cold wave/frost', label: 'Cold wave/frost'},
                    {
                      value: 'Cyclone, hurricane, typhoon',
                      label: 'Cyclone, hurricane, typhoon'
                    },
                    {value: 'Drought', label: 'Drought'},
                    {
                      value: 'Flooding (coastal, fluvial pluvial, groundwater)',
                      label: 'Flooding (coastal, fluvial pluvial, groundwater)'
                    },
                    {
                      value: 'Glacial lake outburst',
                      label: 'Glacial lake outburst'
                    },
                    {value: 'Heat wave', label: 'Heat wave'},
                    {
                      value: 'Heavy precipitation (rail, hail, snow/ice)',
                      label: 'Heavy precipitation (rail, hail, snow/ice)'
                    },
                    {value: 'Landslide', label: 'Landslide'},
                    {
                      value: 'Pollution incident [W only]',
                      label: 'Pollution incident [W only]'
                    },
                    {
                      value: 'Storm (including blizzards, dust and sandstorm)',
                      label: 'Storm (including blizzards, dust and sandstorm)'
                    },
                    {value: 'Subsidence', label: 'Subsidence'},
                    {value: 'Tornado', label: 'Tornado'},
                    {
                      value: 'Toxic spills [W only]',
                      label: 'Toxic spills [W only]'
                    },
                    {value: 'Wildfires', label: 'Wildfires'},
                    {
                      value: 'Other acute physical risk, please specify',
                      label: 'Other acute physical risk, please specify'
                    },

                    {
                      value:
                        'Chronic physical (gradual changes to the state of nature)',
                      label:
                        'Chronic physical (gradual changes to the state of nature)'
                    },
                    {value: 'Change in land-use', label: 'Change in land-use'},
                    {
                      value:
                        'Changing precipitation patterns and types (rain, hail, snow/ice)',
                      label:
                        'Changing precipitation patterns and types (rain, hail, snow/ice)'
                    },
                    {
                      value:
                        'Changing temperature (air, freshwater, marine water)',
                      label:
                        'Changing temperature (air, freshwater, marine water)'
                    },
                    {
                      value: 'Changing wind patterns [C only]',
                      label: 'Changing wind patterns [C only]'
                    },
                    {value: 'Coastal erosion', label: 'Coastal erosion'},
                    {
                      value: 'Declining water quality [W only]',
                      label: 'Declining water quality [W only]'
                    },
                    {
                      value: 'Groundwater depletion [W only]',
                      label: 'Groundwater depletion [W only]'
                    },
                    {
                      value: 'Heat stress [C, F only]',
                      label: 'Heat stress [C, F only]'
                    },
                    {
                      value: 'Inadequate water-related infrastructure [W only]',
                      label: 'Inadequate water-related infrastructure [W only]'
                    },
                    {
                      value: 'Increased ecosystem vulnerability [F, W only]',
                      label: 'Increased ecosystem vulnerability [F, W only]'
                    },
                    {
                      value:
                        'Increased levels of environmental pollutants in freshwater bodies [W only]',
                      label:
                        'Increased levels of environmental pollutants in freshwater bodies [W only]'
                    },
                    {
                      value: 'Increased severity of extreme weather events',
                      label: 'Increased severity of extreme weather events'
                    },
                    {
                      value: 'Land loss to desertification [F only]',
                      label: 'Land loss to desertification [F only]'
                    },
                    {
                      value: 'Ocean acidification',
                      label: 'Ocean acidification'
                    },
                    {
                      value: 'Permafrost thawing [C, W only]',
                      label: 'Permafrost thawing [C, W only]'
                    },
                    {
                      value: 'Poorly managed sanitation [W only]',
                      label: 'Poorly managed sanitation [W only]'
                    },
                    {
                      value: 'Rationing of municipal water supply [W only]',
                      label: 'Rationing of municipal water supply [W only]'
                    },
                    {
                      value: 'Saline intrusion [F, W only]',
                      label: 'Saline intrusion [F, W only]'
                    },
                    {
                      value: 'Scarcity of land resources [F only]',
                      label: 'Scarcity of land resources [F only]'
                    },
                    {value: 'Sea level rise', label: 'Sea level rise'},
                    {
                      value: 'Seasonal supply variability [F, W only]',
                      label: 'Seasonal supply variability [F, W only]'
                    },
                    {value: 'Soil degradation', label: 'Soil degradation'},
                    {value: 'Soil erosion', label: 'Soil erosion'},
                    {value: 'Solifluction', label: 'Solifluction'},
                    {
                      value: 'Temperature variability',
                      label: 'Temperature variability'
                    },
                    {value: 'Water stress', label: 'Water stress'},
                    {
                      value: 'Other chronic physical risk, please specify',
                      label: 'Other chronic physical risk, please specify'
                    }
                  ],
                  colSpan: true
                },
                {
                  type: inputType.SELECT,
                  fieldName:
                    CDP_SME_DISCLOSURE_FIELD_NAMES.SME_DISCLOSURE_Q2_5_VALUE,
                  fieldLabel: 'Value chain stage where the risk occurs',
                  options: [
                    {
                      label: 'Direct  operations  (our own  operations)',
                      value: 'Direct  operations  (our own  operations)'
                    },
                    {
                      label: 'Upstream  value chain  (suppliers)',
                      value: 'Upstream  value chain  (suppliers)'
                    },
                    {
                      label:
                        'Downstream  value chain  (distributors  or  customers)',
                      value:
                        'Downstream  value chain  (distributors  or  customers)'
                    }
                  ],
                  colSpan: true
                },
                {
                  type: inputType.SELECT,
                  fieldName:
                    CDP_SME_DISCLOSURE_FIELD_NAMES.SME_DISCLOSURE_Q2_6_VALUE,
                  fieldLabel: 'Country/area where the risk occurs',
                  options: COUNTRY_OPTIONS,
                  colSpan: true
                },
                {
                  type: inputType.WYSIWYG,
                  fieldName:
                    CDP_SME_DISCLOSURE_FIELD_NAMES.SME_DISCLOSURE_Q2_7_VALUE,
                  fieldLabel: 'River basin where the risk occurs',
                  colSpan: true
                },
                {
                  type: inputType.WYSIWYG,
                  fieldName:
                    CDP_SME_DISCLOSURE_FIELD_NAMES.SME_DISCLOSURE_Q2_8_VALUE,
                  fieldLabel: 'Organization specific description of risk',
                  colSpan: true,
                  textLimit: 1500
                },
                {
                  type: inputType.SELECT_WITH_OTHER_TEXTBOX,
                  fieldName:
                    CDP_SME_DISCLOSURE_FIELD_NAMES.SME_DISCLOSURE_Q2_9_VALUE,
                  fieldLabel: 'Primary financial effect of the risk',
                  options: [
                    {value: 'Brand damage', label: 'Brand damage'},
                    {
                      value: 'Change in revenue mix and sources',
                      label: 'Change in revenue mix and sources'
                    },
                    {
                      value: 'Closure of operations',
                      label: 'Closure of operations'
                    },
                    {
                      value: 'Constraint to growth',
                      label: 'Constraint to growth'
                    },
                    {
                      value: 'Decrease in shareholder value',
                      label: 'Decrease in shareholder value'
                    },
                    {
                      value: 'Decreased access to capital',
                      label: 'Decreased access to capital'
                    },
                    {
                      value:
                        'Decreased asset value or asset useful life leading to writeoffs, asset impairment or early retirement of existing assets',
                      label:
                        'Decreased asset value or asset useful life leading to writeoffs, asset impairment or early retirement of existing assets'
                    },
                    {
                      value:
                        'Decreased revenues due to reduced demand for products and services',
                      label:
                        'Decreased revenues due to reduced demand for products and services'
                    },
                    {
                      value:
                        'Decreased revenues due to reduced production capacity',
                      label:
                        'Decreased revenues due to reduced production capacity'
                    },
                    {
                      value: 'Delays in securing operating licenses',
                      label: 'Delays in securing operating licenses'
                    },
                    {
                      value: 'Disruption in production capacity',
                      label: 'Disruption in production capacity'
                    },
                    {
                      value: 'Disruption to sales',
                      label: 'Disruption to sales'
                    },
                    {
                      value: 'Disruption in upstream supply chain (suppliers)',
                      label: 'Disruption in upstream supply chain (suppliers)'
                    },
                    {
                      value: 'Disruption to workforce management and planning',
                      label: 'Disruption to workforce management and planning'
                    },
                    {
                      value: 'Fines, penalties or enforcement orders',
                      label: 'Fines, penalties or enforcement orders'
                    },
                    {
                      value: 'Increased capital expenditures',
                      label: 'Increased capital expenditures'
                    },
                    {
                      value: 'Increased compliance costs',
                      label: 'Increased compliance costs'
                    },
                    {
                      value: 'Increased cost of capital',
                      label: 'Increased cost of capital'
                    },
                    {
                      value: 'Increased credit risk',
                      label: 'Increased credit risk'
                    },
                    {
                      value: 'Increased direct costs',
                      label: 'Increased direct costs'
                    },
                    {
                      value: 'Increased indirect [operating] costs',
                      label: 'Increased indirect [operating] costs'
                    },
                    {
                      value: 'Increased insurance premiums',
                      label: 'Increased insurance premiums'
                    },
                    {
                      value: 'Increased production costs',
                      label: 'Increased production costs'
                    },
                    {value: 'Litigation', label: 'Litigation'},
                    {
                      value: 'Loss of license to operate',
                      label: 'Loss of license to operate'
                    },
                    {
                      value:
                        'Reduced availability of insurance on assets in “high-risk” locations',
                      label:
                        'Reduced availability of insurance on assets in “high-risk” locations'
                    },
                    {
                      value:
                        'Upfront costs to adopt/deploy new practices and processes',
                      label:
                        'Upfront costs to adopt/deploy new practices and processes'
                    },
                    {
                      value: 'Other, please specify',
                      label: 'Other, please specify'
                    }
                  ],
                  colSpan: true
                },
                {
                  type: inputType.SELECT,
                  fieldName:
                    CDP_SME_DISCLOSURE_FIELD_NAMES.SME_DISCLOSURE_Q2_10_VALUE,
                  fieldLabel:
                    'Time horizon over which the risk is anticipated to have a substantive effect on the organization',
                  options: [
                    {label: 'Short-term', value: 'Short-term'},
                    {label: 'Medium-term', value: 'Medium-term'},
                    {label: 'Long-term', value: 'Long-term'},
                    {
                      label:
                        'The risk has already had a substantive effect on the organization in the reporting year',
                      value:
                        'The risk has already had a substantive effect on the organization in the reporting year'
                    }
                  ],
                  colSpan: true
                },
                {
                  type: inputType.SELECT,
                  fieldName:
                    CDP_SME_DISCLOSURE_FIELD_NAMES.SME_DISCLOSURE_Q2_11_VALUE,
                  fieldLabel:
                    'Likelihood of the risk having an effect within the anticipated time horizons',
                  options: [
                    {
                      value: 'Virtually certain (99–100%)',
                      label: 'Virtually certain (99–100%)'
                    },
                    {
                      value: 'Very likely (90–100%)',
                      label: 'Very likely (90–100%)'
                    },
                    {value: 'Likely (66–100%)', label: 'Likely (66–100%)'},
                    {
                      value: 'More likely than not (50–100%)',
                      label: 'More likely than not (50–100%)'
                    },
                    {
                      value: 'About as likely as not (33–66%)',
                      label: 'About as likely as not (33–66%)'
                    },
                    {value: 'Unlikely (0–33%)', label: 'Unlikely (0–33%)'},
                    {
                      value: 'Very unlikely (0–10%)',
                      label: 'Very unlikely (0–10%)'
                    },
                    {
                      value: 'Exceptionally unlikely (0–1%)',
                      label: 'Exceptionally unlikely (0–1%)'
                    },
                    {value: 'Unknown', label: 'Unknown'}
                  ],
                  colSpan: true
                },
                {
                  type: inputType.SELECT,
                  fieldName:
                    CDP_SME_DISCLOSURE_FIELD_NAMES.SME_DISCLOSURE_Q2_12_VALUE,
                  fieldLabel: 'Magnitude',
                  options: [
                    {value: 'High', label: 'High'},
                    {value: 'Medium-high', label: 'Medium-high'},
                    {value: 'Medium', label: 'Medium'},
                    {value: 'Medium-low', label: 'Medium-low'},
                    {value: 'Low', label: 'Low'},
                    {value: 'Unknown', label: 'Unknown'}
                  ],
                  colSpan: true
                },
                {
                  type: inputType.RADIOGROUP,
                  fieldName:
                    CDP_SME_DISCLOSURE_FIELD_NAMES.SME_DISCLOSURE_Q2_13_VALUE,
                  fieldLabel:
                    'Are you able to quantify the financial effect of the risk?',
                  options: ['Yes', 'No']
                },
                {
                  type: inputType.NUMBER,
                  fieldName:
                    CDP_SME_DISCLOSURE_FIELD_NAMES.SME_DISCLOSURE_Q2_14_VALUE,
                  fieldLabel:
                    'Potential financial effect figure - minimum (currency)',
                  disabledOn: {
                    fieldName:
                      CDP_SME_DISCLOSURE_FIELD_NAMES.SME_DISCLOSURE_Q2_13_VALUE,
                    condition: conditionType.NOT,
                    values: ['Yes']
                  }
                },
                {
                  type: inputType.NUMBER,
                  fieldName:
                    CDP_SME_DISCLOSURE_FIELD_NAMES.SME_DISCLOSURE_Q2_15_VALUE,
                  fieldLabel:
                    'Potential financial effect figure - maximum (currency)'
                },
                {
                  type: inputType.WYSIWYG,
                  fieldName:
                    CDP_SME_DISCLOSURE_FIELD_NAMES.SME_DISCLOSURE_Q2_16_VALUE,
                  fieldLabel: 'Explanation of financial effect figure',
                  colSpan: true,
                  textLimit: 2500,
                  disabledOn: {
                    fieldName:
                      CDP_SME_DISCLOSURE_FIELD_NAMES.SME_DISCLOSURE_Q2_13_VALUE,
                    condition: conditionType.NOT,
                    values: ['Yes']
                  }
                },
                {
                  type: inputType.SELECT_WITH_OTHER_TEXTBOX,
                  fieldName:
                    CDP_SME_DISCLOSURE_FIELD_NAMES.SME_DISCLOSURE_Q2_17_VALUE,
                  fieldLabel: 'Primary response to risk',
                  options: FINANCIAL_EFFECTS_OPTIONS,
                  colSpan: true
                },
                {
                  type: inputType.NUMBER,
                  fieldName:
                    CDP_SME_DISCLOSURE_FIELD_NAMES.SME_DISCLOSURE_Q2_18_VALUE,
                  fieldLabel: 'Cost of response to risk'
                },
                {
                  type: inputType.WYSIWYG,
                  fieldName:
                    CDP_SME_DISCLOSURE_FIELD_NAMES.SME_DISCLOSURE_Q2_19_VALUE,
                  fieldLabel: 'Explanation of cost calculation',
                  colSpan: true,
                  textLimit: 1000
                },
                {
                  type: inputType.WYSIWYG,
                  fieldName:
                    CDP_SME_DISCLOSURE_FIELD_NAMES.SME_DISCLOSURE_Q2_20_VALUE,
                  fieldLabel: 'Description of response',
                  colSpan: true,
                  textLimit: 2000
                }
              ]
            }
          }
        ]
      },
      {
        field: [
          {
            fieldType: inputType.HEADING,
            heading:
              '16.2 In the reporting year, was your organization subject to any fines, enforcement orders, and/or other penalties for water-related regulatory violations? (Water only)'
          },
          {
            fieldType: inputType.ADD_NEW_TO_TABLE,
            fieldName: CDP_SME_DISCLOSURE_FIELD_NAMES.SME_DISCLOSURE_Q3_VALUE,
            allowMultipleRows: false,
            formList: {
              formFields: [
                {
                  type: inputType.SELECT,
                  fieldName:
                    CDP_SME_DISCLOSURE_FIELD_NAMES.SME_DISCLOSURE_Q3_1_VALUE,
                  fieldLabel: 'Water-realated regulatory violations',
                  options: [
                    {label: 'Yes', value: 'Yes'},
                    {label: 'No', value: 'No'},
                    {label: 'Unknown', value: 'Unknown'}
                  ],
                  colSpan: true
                },
                {
                  type: inputType.MULTISELECT,
                  fieldName:
                    CDP_SME_DISCLOSURE_FIELD_NAMES.SME_DISCLOSURE_Q3_2_VALUE,
                  fieldLabel:
                    'Fines, enforcement orders, and/ or other penalties ',
                  options: [
                    {label: 'Fines', value: 'Fines'},
                    {
                      label: 'Enforcement orders or other penalties',
                      value: 'Enforcement orders or other penalties'
                    },
                    {
                      label: 'but none that are considered as significant',
                      value: 'but none that are considered as significant'
                    },
                    {
                      label:
                        'Enforcement orders or other penalties but none that are considered as significant',
                      value:
                        'Enforcement orders or other penalties but none that are considered as significant'
                    }
                  ],
                  colSpan: true,
                  disabledOn: {
                    fieldName:
                      CDP_SME_DISCLOSURE_FIELD_NAMES.SME_DISCLOSURE_Q3_1_VALUE,
                    condition: conditionType.EQUALS,
                    values: ['No', 'Unknown']
                  }
                },
                {
                  type: inputType.WYSIWYG,
                  fieldName:
                    CDP_SME_DISCLOSURE_FIELD_NAMES.SME_DISCLOSURE_Q3_3_VALUE,
                  fieldLabel: 'Comment',
                  colSpan: true,
                  textLimit: 1000
                }
              ]
            }
          }
        ]
      },
      {
        field: [
          {
            fieldType: inputType.HEADING,
            heading:
              '16.3 Are you aware of any opportunities created by environmental issues which have had a substantive effect on your organization in the reporting year or may in the future?'
          },
          {
            fieldType: inputType.ADD_NEW_TO_TABLE,
            fieldName: CDP_SME_DISCLOSURE_FIELD_NAMES.SME_DISCLOSURE_Q4_VALUE,
            allowMultipleRows: false,
            formList: {
              formFields: [
                {
                  type: inputType.SELECT,
                  fieldName:
                    CDP_SME_DISCLOSURE_FIELD_NAMES.SME_DISCLOSURE_Q4_1_VALUE,
                  fieldLabel: 'Environmental Issue',
                  options: ENVIRONMENTAL_ISSUE_OPTIONS,
                  colSpan: true
                },
                {
                  type: inputType.SELECT,
                  fieldName:
                    CDP_SME_DISCLOSURE_FIELD_NAMES.SME_DISCLOSURE_Q4_2_VALUE,
                  fieldLabel: 'Environmental opportunities Identified',
                  options: [
                    {
                      label:
                        'Yes, we have identified opportunities, and some/all are being realized',
                      value:
                        'Yes, we have identified opportunities, and some/all are being realized'
                    },
                    {
                      label:
                        'Yes, we have identified opportunities but are unable to realize them',
                      value:
                        'Yes, we have identified opportunities but are unable to realize them'
                    },
                    {label: 'No', value: 'No'}
                  ],
                  colSpan: true
                },
                {
                  type: inputType.SELECT_WITH_OTHER_TEXTBOX,
                  fieldName:
                    CDP_SME_DISCLOSURE_FIELD_NAMES.SME_DISCLOSURE_Q4_3_VALUE,
                  fieldLabel:
                    'Primary reason why your organization does not consider itself to have environmental opportunities',
                  options: [
                    {
                      value:
                        'Opportunities exist, but none anticipated to have a substantive effect on organization',
                      label:
                        'Opportunities exist, but none anticipated to have a substantive effect on organization'
                    },
                    {
                      value: 'Evaluation in progress',
                      label: 'Evaluation in progress'
                    },
                    {
                      value:
                        'Lack of internal resources, capabilities, or expertise (e.g., due to organization size)',
                      label:
                        'Lack of internal resources, capabilities, or expertise (e.g., due to organization size)'
                    },
                    {
                      value: 'No standardized procedure',
                      label: 'No standardized procedure'
                    },
                    {
                      value: 'Not an immediate strategic priority',
                      label: 'Not an immediate strategic priority'
                    },
                    {
                      value: 'Judged to be unimportant or not relevant',
                      label: 'Judged to be unimportant or not relevant'
                    },
                    {
                      value: 'Other, please specify',
                      label: 'Other, please specify'
                    }
                  ],
                  colSpan: true
                }
              ]
            }
          }
        ]
      },
      {
        field: [
          {
            fieldType: inputType.HEADING,
            heading:
              '16.3.1 Provide details of the opportunities created by environmental issues which have had a substantive effect on your organization in the reporting year or may in the future.',
            conditionalVisibility: {
              dependsOn: CDP_SME_DISCLOSURE_FIELD_NAMES.SME_DISCLOSURE_Q4_VALUE,
              showWhen: [
                'Yes, we have identified opportunities, and some/all are being realized',
                'Yes, we have identified opportunities but are unable to realize them'
              ],
              condition: conditionType.EQUALS,
              fieldName:
                CDP_SME_DISCLOSURE_FIELD_NAMES.SME_DISCLOSURE_Q4_2_VALUE
            }
          },
          {
            fieldType: inputType.ADD_NEW_TO_TABLE,
            fieldName: CDP_SME_DISCLOSURE_FIELD_NAMES.SME_DISCLOSURE_Q5_VALUE,
            //  conditionalVisibility: {
            dependsOn: CDP_SME_DISCLOSURE_FIELD_NAMES.SME_DISCLOSURE_Q4_2_VALUE,
            showWhen: [
              'Yes, we have identified opportunities, and some/all are being realized',
              'Yes, we have identified opportunities but are unable to realize them'
            ],
            relatedTableKey:
              CDP_SME_DISCLOSURE_FIELD_NAMES.SME_DISCLOSURE_Q4_VALUE,
            //  },
            formList: {
              formFields: [
                {
                  type: inputType.SELECT,
                  fieldName:
                    CDP_SME_DISCLOSURE_FIELD_NAMES.SME_DISCLOSURE_Q5_1_VALUE,
                  fieldLabel: 'Environmental issue the opportunity relates to',
                  options: ENVIRONMENTAL_ISSUE_OPTIONS,
                  colSpan: true
                },
                {
                  type: inputType.SELECT,
                  fieldName:
                    CDP_SME_DISCLOSURE_FIELD_NAMES.SME_DISCLOSURE_Q5_2_VALUE,
                  fieldLabel: 'Opportunity identifier',
                  options: OPPORTUNITY_OPTIONS,
                  colSpan: true
                },
                {
                  type: inputType.SELECT,
                  fieldName:
                    CDP_SME_DISCLOSURE_FIELD_NAMES.SME_DISCLOSURE_Q5_3_VALUE,
                  fieldLabel: 'Commodity',
                  options: COMMODITY_OPTIONS,
                  colSpan: true,
                  disabledOn: {
                    fieldName:
                      CDP_SME_DISCLOSURE_FIELD_NAMES.SME_DISCLOSURE_Q5_1_VALUE,
                    condition: conditionType.EQUALS,
                    values: ['Climate change', 'Water']
                  }
                },
                {
                  type: inputType.SELECT_WITH_OTHER_TEXTBOX,
                  fieldName:
                    CDP_SME_DISCLOSURE_FIELD_NAMES.SME_DISCLOSURE_Q5_4_VALUE,
                  fieldLabel: 'Opportunity Type and primary source',
                  options: [
                    {
                      value: 'Capital flow and financing',
                      label: 'Capital flow and financing'
                    },
                    {
                      value: 'Access to new financing options',
                      label: 'Access to new financing options'
                    },
                    {
                      value: 'Access to sustainability linked loans',
                      label: 'Access to sustainability linked loans'
                    },
                    {
                      value: 'Financial reward from buyers',
                      label: 'Financial reward from buyers'
                    },
                    {
                      value:
                        'Payment for ecosystem services [other than REDD+]',
                      label: 'Payment for ecosystem services [other than REDD+]'
                    },
                    {value: 'REDD+', label: 'REDD+'},
                    {
                      value:
                        'Other capital flow and financing opportunity, please specify',
                      label:
                        'Other capital flow and financing opportunity, please specify'
                    },
                    {value: 'Energy source', label: 'Energy source'},
                    {
                      value: 'Participation in carbon market',
                      label: 'Participation in carbon market'
                    },
                    {
                      value: 'Shift toward decentralized energy generation',
                      label: 'Shift toward decentralized energy generation'
                    },
                    {
                      value: 'Use of carbon capture and storage',
                      label: 'Use of carbon capture and storage'
                    },
                    {
                      value: 'Use of low-carbon energy sources',
                      label: 'Use of low-carbon energy sources'
                    },
                    {
                      value: 'Use of renewable energy sources',
                      label: 'Use of renewable energy sources'
                    },
                    {
                      value: 'Other energy source opportunity, please specify',
                      label: 'Other energy source opportunity, please specify'
                    },
                    {value: 'Markets', label: 'Markets'},
                    {
                      value:
                        'Easier access to cheaper and/or more available credit',
                      label:
                        'Easier access to cheaper and/or more available credit'
                    },
                    {
                      value: 'Expansion into new markets',
                      label: 'Expansion into new markets'
                    },
                    {
                      value: 'Increased brand value',
                      label: 'Increased brand value'
                    },
                    {
                      value: 'Improved supply chain engagement',
                      label: 'Improved supply chain engagement'
                    },
                    {
                      value:
                        'Increased availability of products with reduced environmental impact [other than certified products]',
                      label:
                        'Increased availability of products with reduced environmental impact [other than certified products]'
                    },
                    {
                      value:
                        'Increased demand for certified and sustainable materials',
                      label:
                        'Increased demand for certified and sustainable materials'
                    },
                    {
                      value: 'Stronger competitive advantage',
                      label: 'Stronger competitive advantage'
                    },
                    {
                      value: 'Use of public sector incentives',
                      label: 'Use of public sector incentives'
                    },
                    {
                      value: 'Other markets opportunity, please specify',
                      label: 'Other markets opportunity, please specify'
                    },
                    {
                      value: 'Products & services',
                      label: 'Products & services'
                    },
                    {
                      value: 'Ability to diversify business activities',
                      label: 'Ability to diversify business activities'
                    },
                    {
                      value:
                        'Development of new products or services through R&D and innovation',
                      label:
                        'Development of new products or services through R&D and innovation'
                    },
                    {
                      value:
                        'Increased sales of existing products and services',
                      label: 'Increased sales of existing products and services'
                    },
                    {
                      value: 'Increased value chain transparency',
                      label: 'Increased value chain transparency'
                    },
                    {
                      value: 'Shift in consumer preferences',
                      label: 'Shift in consumer preferences'
                    },
                    {
                      value:
                        'Other products and services opportunity, please specify',
                      label:
                        'Other products and services opportunity, please specify'
                    },
                    {
                      value: 'Reputational capital',
                      label: 'Reputational capital'
                    },
                    {
                      value: 'Improved community relations',
                      label: 'Improved community relations'
                    },
                    {
                      value: 'Improved ratings by sustainability/ESG indexes',
                      label: 'Improved ratings by sustainability/ESG indexes'
                    },
                    {
                      value:
                        'Reputational benefits resulting in increased demand for products/services',
                      label:
                        'Reputational benefits resulting in increased demand for products/services'
                    },
                    {
                      value: 'Strengthened social license to operate',
                      label: 'Strengthened social license to operate'
                    },
                    {
                      value:
                        'Other reputational capital opportunity, please specify',
                      label:
                        'Other reputational capital opportunity, please specify'
                    },
                    {value: 'Resilience', label: 'Resilience'},
                    {
                      value: 'Improved resilience to future regulatory changes',
                      label: 'Improved resilience to future regulatory changes'
                    },
                    {
                      value: 'Improved staff retention',
                      label: 'Improved staff retention'
                    },
                    {
                      value:
                        'Increased resilience to impacts of climate change',
                      label: 'Increased resilience to impacts of climate change'
                    },
                    {
                      value: 'Increased upstream value chain resilience',
                      label: 'Increased upstream value chain resilience'
                    },
                    {
                      value:
                        'Participation in environmental collaborative industry frameworks, initiatives and/or commitments',
                      label:
                        'Participation in environmental collaborative industry frameworks, initiatives and/or commitments'
                    },
                    {
                      value: 'Shift in business model',
                      label: 'Shift in business model'
                    },
                    {
                      value: 'Other resilience opportunity, please specify',
                      label: 'Other resilience opportunity, please specify'
                    },
                    {
                      value: 'Resource efficiency',
                      label: 'Resource efficiency'
                    },
                    {value: 'Cost savings', label: 'Cost savings'},
                    {
                      value:
                        'Increased efficiency of production and/or distribution processes',
                      label:
                        'Increased efficiency of production and/or distribution processes'
                    },
                    {
                      value: 'Move to more energy/resource efficient buildings',
                      label: 'Move to more energy/resource efficient buildings'
                    },
                    {
                      value: 'Reduced water usage and consumption',
                      label: 'Reduced water usage and consumption'
                    },
                    {
                      value: 'Use of more efficient modes of transport',
                      label: 'Use of more efficient modes of transport'
                    },
                    {value: 'Use of recycling', label: 'Use of recycling'},
                    {
                      value: 'Use of new technologies',
                      label: 'Use of new technologies'
                    },
                    {
                      value:
                        'Other resource efficiency opportunity, please specify',
                      label:
                        'Other resource efficiency opportunity, please specify'
                    },
                    {
                      value: 'Other, please specify',
                      label: 'Other, please specify'
                    },
                    {
                      value: 'Other opportunity, please specify',
                      label: 'Other opportunity, please specify'
                    }
                  ],
                  colSpan: true
                },
                {
                  type: inputType.SELECT,
                  fieldName:
                    CDP_SME_DISCLOSURE_FIELD_NAMES.SME_DISCLOSURE_Q5_5_VALUE,
                  fieldLabel: 'Value chain Stage where the opportunity occurs',
                  options: [
                    {
                      label: 'Direct operations (our own operations)',
                      value: 'Direct operations (our own operations)'
                    },
                    {
                      label:
                        'Downstream value chain (distributors or customers)',
                      value:
                        'Downstream value chain (distributors or customers)'
                    },
                    {
                      label: 'Upstream value chain (suppliers)',
                      value: 'Upstream value chain (suppliers)'
                    }
                  ],
                  colSpan: true
                },
                {
                  type: inputType.SELECT,
                  fieldName:
                    CDP_SME_DISCLOSURE_FIELD_NAMES.SME_DISCLOSURE_Q5_6_VALUE,
                  fieldLabel: 'Country/Area where the opportunity occurs',
                  options: COUNTRY_OPTIONS,
                  colSpan: true
                },
                {
                  type: inputType.SELECT,
                  fieldName:
                    CDP_SME_DISCLOSURE_FIELD_NAMES.SME_DISCLOSURE_Q5_7_VALUE,
                  fieldLabel: 'River basin where the opportunity occurs',
                  options: [
                    {label: '1', value: '1'},
                    {label: '2', value: '2'},
                    {label: '3', value: '3'},
                    {label: '4', value: '4'},
                    {label: '5', value: '5'}
                  ],
                  colSpan: true
                },
                {
                  type: inputType.WYSIWYG,
                  fieldName:
                    CDP_SME_DISCLOSURE_FIELD_NAMES.SME_DISCLOSURE_Q5_8_VALUE,
                  fieldLabel: 'Organization specific description',
                  colSpan: true,
                  textLimit: 1500
                },
                {
                  type: inputType.SELECT_WITH_OTHER_TEXTBOX,
                  fieldName:
                    CDP_SME_DISCLOSURE_FIELD_NAMES.SME_DISCLOSURE_Q5_9_VALUE,
                  fieldLabel:
                    'Primary financial effect of the opportunity (10)',
                  options: [
                    {
                      value: 'Reduced direct costs',
                      label: 'Reduced direct costs'
                    },
                    {
                      value: 'Reduced indirect (operating) costs',
                      label: 'Reduced indirect (operating) costs'
                    },
                    {
                      value:
                        'Increased revenues resulting from increased demand for products and services',
                      label:
                        'Increased revenues resulting from increased demand for products and services'
                    },
                    {
                      value:
                        'Increased revenues through access to new and emerging markets',
                      label:
                        'Increased revenues through access to new and emerging markets'
                    },
                    {
                      value:
                        'Increased revenues resulting from increased production capacity',
                      label:
                        'Increased revenues resulting from increased production capacity'
                    },
                    {
                      value: 'Increased revenue resulting from price premiums',
                      label: 'Increased revenue resulting from price premiums'
                    },
                    {
                      value:
                        'Increased revenue resulting from direct payments from downstream companies',
                      label:
                        'Increased revenue resulting from direct payments from downstream companies'
                    },
                    {
                      value: 'Increased access to capital',
                      label: 'Increased access to capital'
                    },
                    {
                      value:
                        'Increased access to capital at lower/more favorable rates',
                      label:
                        'Increased access to capital at lower/more favorable rates'
                    },
                    {
                      value: 'Increased value of fixed assets',
                      label: 'Increased value of fixed assets'
                    },
                    {
                      value: 'Increased diversification of financial assets',
                      label: 'Increased diversification of financial assets'
                    },
                    {
                      value: 'Returns on investment in low-emission technology',
                      label: 'Returns on investment in low-emission technology'
                    },
                    {
                      value: 'Other, please specify',
                      label: 'Other, please specify'
                    }
                  ],
                  colSpan: true
                },
                {
                  type: inputType.SELECT,
                  fieldName:
                    CDP_SME_DISCLOSURE_FIELD_NAMES.SME_DISCLOSURE_Q5_10_VALUE,
                  fieldLabel:
                    'Time horizon over which the opportunity is anticipated to have a substantive effect on the organization',
                  options: [
                    {label: 'Short-term', value: 'Short-term'},
                    {label: 'Medium-term', value: 'Medium-term'},
                    {label: 'Long-term', value: 'Long-term'},
                    {
                      label:
                        'The opportunity has already had a substantive effect on our organization in the reporting year',
                      value:
                        'The opportunity has already had a substantive effect on our organization in the reporting year'
                    }
                  ],
                  colSpan: true
                },
                {
                  type: inputType.SELECT,
                  fieldName:
                    CDP_SME_DISCLOSURE_FIELD_NAMES.SME_DISCLOSURE_Q5_11_VALUE,
                  fieldLabel:
                    'Likelihood of the opportunity having an effect within the anticipated time horizon',
                  options: [
                    {
                      value: 'Virtually certain (99-100%)',
                      label: 'Virtually certain (99-100%)'
                    },
                    {
                      value: 'Very likely (90-100%)',
                      label: 'Very likely (90-100%)'
                    },
                    {value: 'Likely (66-100%)', label: 'Likely (66-100%)'},
                    {
                      value: 'More likely than not (50-100%)',
                      label: 'More likely than not (50-100%)'
                    },
                    {
                      value: 'About as likely as not (33-66%)',
                      label: 'About as likely as not (33-66%)'
                    },
                    {value: 'Unlikely (0-33%)', label: 'Unlikely (0-33%)'},
                    {
                      value: 'Very unlikely (0-10%)',
                      label: 'Very unlikely (0-10%)'
                    },
                    {
                      value: 'Exceptionally unlikely (0-1%)',
                      label: 'Exceptionally unlikely (0-1%)'
                    },
                    {value: 'Unknown', label: 'Unknown'}
                  ],
                  colSpan: true
                },
                {
                  type: inputType.SELECT,
                  fieldName:
                    CDP_SME_DISCLOSURE_FIELD_NAMES.SME_DISCLOSURE_Q5_12_VALUE,
                  fieldLabel: 'Magnitude',
                  options: [
                    {value: 'High', label: 'High'},
                    {value: 'Medium-high', label: 'Medium-high'},
                    {value: 'Medium', label: 'Medium'},
                    {value: 'Medium-low', label: 'Medium-low'},
                    {value: 'Low', label: 'Low'},
                    {value: 'Unknown', label: 'Unknown'}
                  ],
                  colSpan: true
                }
              ]
            }
          }
        ]
      }
    ]
  }
];

export const smeGovernanceQuestions = [
  {
    key: '1',
    showIndex: false,
    items: [
      {
        field: [
          {
            fieldType: inputType.HEADING,
            heading:
              '17.1 Is there responsibility for environmental issues within your organization?'
          },
          {
            fieldType: inputType.ADD_NEW_TO_TABLE,
            fieldName: CDP_SME_GOVERNANCE_FIELD_NAMES.SME_GOVERNANCE_Q1_VALUE,
            allowMultipleRows: false,
            formList: {
              formFields: [
                {
                  type: inputType.SELECT,
                  fieldName:
                    CDP_SME_GOVERNANCE_FIELD_NAMES.SME_GOVERNANCE_Q1_1_VALUE,
                  fieldLabel: 'Environmental issue',
                  options: ENVIRONMENTAL_ISSUE_OPTIONS,
                  colSpan: true
                },
                {
                  type: inputType.SELECT,
                  fieldName:
                    CDP_SME_GOVERNANCE_FIELD_NAMES.SME_GOVERNANCE_Q1_2_VALUE,
                  fieldLabel: 'Responsibility for this environmental issue',
                  options: [
                    {label: 'Yes', value: 'Yes'},
                    {
                      label: 'No but we plan to within the next two years',
                      value: 'No but we plan to within the next two years'
                    },
                    {
                      label:
                        'No, and we do not plan to within the next two years',
                      value:
                        'No, and we do not plan to within the next two years'
                    }
                  ],
                  colSpan: true
                }
              ]
            }
          }
        ]
      },
      {
        field: [
          {
            fieldType: inputType.HEADING,
            heading:
              '17.1.1 Provide the highest positions or committees with responsibility for environmental issues (do not include names of individuals).',
            conditionalVisibility: {
              dependsOn: CDP_SME_GOVERNANCE_FIELD_NAMES.SME_GOVERNANCE_Q1_VALUE,
              showWhen: 'Yes',
              condition: conditionType.EQUALS,
              fieldName:
                CDP_SME_GOVERNANCE_FIELD_NAMES.SME_GOVERNANCE_Q1_2_VALUE
            }
          },
          {
            fieldType: inputType.ADD_NEW_TO_TABLE,
            fieldName: CDP_SME_GOVERNANCE_FIELD_NAMES.SME_GOVERNANCE_Q2_VALUE,
            //  conditionalVisibility: {
            dependsOn: CDP_SME_GOVERNANCE_FIELD_NAMES.SME_GOVERNANCE_Q1_2_VALUE,
            showWhen: ['Yes'],
            relatedTableKey:
              CDP_SME_GOVERNANCE_FIELD_NAMES.SME_GOVERNANCE_Q1_VALUE,
            //  },
            formList: {
              formFields: [
                {
                  type: inputType.SELECT,
                  fieldName:
                    CDP_SME_GOVERNANCE_FIELD_NAMES.SME_GOVERNANCE_Q2_1_VALUE,
                  fieldLabel: 'Environmental Issue',
                  options: ENVIRONMENTAL_ISSUE_OPTIONS,
                  colSpan: true
                },
                {
                  type: inputType.SELECT_WITH_OTHER_TEXTBOX,
                  fieldName:
                    CDP_SME_GOVERNANCE_FIELD_NAMES.SME_GOVERNANCE_Q2_2_VALUE,
                  fieldLabel:
                    'Position of individual or committee with responsibility',
                  options: [
                    {value: 'Executive level', label: 'Executive level'},
                    {
                      value: 'Corporate executive team',
                      label: 'Corporate executive team'
                    },
                    {
                      value: 'Chief Executive Officer (CEO)',
                      label: 'Chief Executive Officer (CEO)'
                    },
                    {
                      value: 'Chief Financial Officer (CFO)',
                      label: 'Chief Financial Officer (CFO)'
                    },
                    {
                      value: 'Chief Operating Officer (COO)',
                      label: 'Chief Operating Officer (COO)'
                    },
                    {
                      value: 'Chief Procurement Officer (CPO)',
                      label: 'Chief Procurement Officer (CPO)'
                    },
                    {
                      value: 'Chief Risks Officer (CRO)',
                      label: 'Chief Risks Officer (CRO)'
                    },
                    {
                      value: 'Chief Sustainability Officer (CSO)',
                      label: 'Chief Sustainability Officer (CSO)'
                    },
                    {
                      value: 'Chief Government Relations Officer (CGRO)',
                      label: 'Chief Government Relations Officer (CGRO)'
                    },
                    {
                      value: 'Chief Technology Officer (CTO)',
                      label: 'Chief Technology Officer (CTO)'
                    },
                    {
                      value: 'Chief Compliance Officer (CCO)',
                      label: 'Chief Compliance Officer (CCO)'
                    },
                    {
                      value: 'Other C-Suite Officer',
                      label: 'Other C-Suite Officer'
                    },
                    {value: 'President', label: 'President'},
                    {value: 'General Counsel', label: 'General Counsel'},
                    {value: 'Committee', label: 'Committee'},
                    {value: 'Risk committee', label: 'Risk committee'},
                    {
                      value: 'Sustainability committee',
                      label: 'Sustainability committee'
                    },
                    {
                      value: 'Environmental, Social, Governance committee',
                      label: 'Environmental, Social, Governance committee'
                    },
                    {
                      value:
                        'Safety, Health, Environment and Quality committee',
                      label: 'Safety, Health, Environment and Quality committee'
                    },
                    {
                      value: 'Corporate responsibility committee',
                      label: 'Corporate responsibility committee'
                    },
                    {
                      value: 'Other committee, please specify',
                      label: 'Other committee, please specify'
                    },
                    {value: 'Management level', label: 'Management level'},
                    {
                      value: 'Business unit manager',
                      label: 'Business unit manager'
                    },
                    {value: 'Energy manager', label: 'Energy manager'},
                    {
                      value: 'Environmental, Health, and Safety manager',
                      label: 'Environmental, Health, and Safety manager'
                    },
                    {
                      value: 'Environment/Sustainability manager',
                      label: 'Environment/Sustainability manager'
                    },
                    {value: 'Facility manager', label: 'Facility manager'},
                    {
                      value: 'Process operation manager',
                      label: 'Process operation manager'
                    },
                    {
                      value: 'Procurement manager',
                      label: 'Procurement manager'
                    },
                    {
                      value: 'Public affairs manager',
                      label: 'Public affairs manager'
                    },
                    {value: 'Risk manager', label: 'Risk manager'},
                    {value: 'Other', label: 'Other'},
                    {
                      value: 'Other position, please specify',
                      label: 'Other position, please specify'
                    }
                  ],
                  colSpan: true
                },
                {
                  type: inputType.SELECT,
                  fieldName:
                    CDP_SME_GOVERNANCE_FIELD_NAMES.SME_GOVERNANCE_Q2_3_VALUE,
                  fieldLabel: 'Environmental responsibilities of this position',
                  options: [
                    {
                      value: 'Risks and opportunities',
                      label: 'Risks and opportunities'
                    },
                    {
                      value:
                        'Assessing future trends in environmental risks and opportunities',
                      label:
                        'Assessing future trends in environmental risks and opportunities'
                    },
                    {
                      value: 'Assessing environmental risks and opportunities',
                      label: 'Assessing environmental risks and opportunities'
                    },
                    {
                      value: 'Managing environmental risks and opportunities',
                      label: 'Managing environmental risks and opportunities'
                    },
                    {
                      value: 'Policies, commitments, and targets',
                      label: 'Policies, commitments, and targets'
                    },
                    {
                      value:
                        'Setting corporate environmental policies and/or commitments',
                      label:
                        'Setting corporate environmental policies and/or commitments'
                    },
                    {
                      value:
                        'Monitoring compliance with corporate environmental policies and/or commitments',
                      label:
                        'Monitoring compliance with corporate environmental policies and/or commitments'
                    },
                    {
                      value: 'Setting corporate environmental targets',
                      label: 'Setting corporate environmental targets'
                    },
                    {
                      value:
                        'Measuring progress towards environmental corporate targets',
                      label:
                        'Measuring progress towards environmental corporate targets'
                    },
                    {
                      value:
                        'Measuring progress towards environmental science-based targets',
                      label:
                        'Measuring progress towards environmental science-based targets'
                    },
                    {value: 'Engagement', label: 'Engagement'},
                    {
                      value:
                        'Managing public policy engagement related to environmental issues',
                      label:
                        'Managing public policy engagement related to environmental issues'
                    },
                    {
                      value:
                        'Managing value chain engagement related to environmental issues',
                      label:
                        'Managing value chain engagement related to environmental issues'
                    },
                    {
                      value:
                        'Managing engagement in landscapes and/or jurisdictions',
                      label:
                        'Managing engagement in landscapes and/or jurisdictions'
                    },
                    {
                      value:
                        'Managing supplier compliance with environmental requirements',
                      label:
                        'Managing supplier compliance with environmental requirements'
                    },
                    {
                      value: 'Strategy and financial planning',
                      label: 'Strategy and financial planning'
                    },
                    {
                      value: 'Conducting environmental scenario analysis',
                      label: 'Conducting environmental scenario analysis'
                    },
                    {
                      value: 'Developing a climate transition plan',
                      label: 'Developing a climate transition plan'
                    },
                    {
                      value: 'Implementing a climate transition plan',
                      label: 'Implementing a climate transition plan'
                    },
                    {
                      value:
                        'Developing a business strategy which considers environmental issues',
                      label:
                        'Developing a business strategy which considers environmental issues'
                    },
                    {
                      value:
                        'Implementing the business strategy related to environmental issues',
                      label:
                        'Implementing the business strategy related to environmental issues'
                    },
                    {
                      value:
                        'Managing acquisitions, mergers, and divestitures related to environmental issues',
                      label:
                        'Managing acquisitions, mergers, and divestitures related to environmental issues'
                    },
                    {
                      value:
                        'Managing major capital and/or operational expenditures relating to environmental issues',
                      label:
                        'Managing major capital and/or operational expenditures relating to environmental issues'
                    },
                    {
                      value:
                        'Managing annual budgets related to environmental issues',
                      label:
                        'Managing annual budgets related to environmental issues'
                    },
                    {
                      value:
                        'Managing priorities related to innovation/low-environmental impact products or services (including R&D)',
                      label:
                        'Managing priorities related to innovation/low-environmental impact products or services (including R&D)'
                    },
                    {
                      value:
                        'Managing environmental reporting, audit, and verification processes',
                      label:
                        'Managing environmental reporting, audit, and verification processes'
                    },
                    {value: 'Other', label: 'Other'},
                    {
                      value:
                        'Providing employee incentives related to environmental performance',
                      label:
                        'Providing employee incentives related to environmental performance'
                    },
                    {
                      value: 'Other, please specify',
                      label: 'Other, please specify'
                    }
                  ],
                  colSpan: true
                },
                {
                  type: inputType.SELECT,
                  fieldName:
                    CDP_SME_GOVERNANCE_FIELD_NAMES.SME_GOVERNANCE_Q2_4_VALUE,
                  fieldLabel:
                    'Who in the organization does this position report to',
                  options: [
                    {
                      label: 'Reports to the board directly',
                      value: 'Reports to the board directly'
                    },
                    {
                      label:
                        'Reports to executive leadership (CEO, CRO, CFO, COO, CSO, or equivalent)',
                      value:
                        'Reports to executive leadership (CEO, CRO, CFO, COO, CSO, or equivalent)'
                    },
                    {
                      label: 'Other, please specify',
                      value: 'Other, please specify'
                    }
                  ],
                  colSpan: true
                },
                {
                  type: inputType.SELECT,
                  fieldName:
                    CDP_SME_GOVERNANCE_FIELD_NAMES.SME_GOVERNANCE_Q2_5_VALUE,
                  fieldLabel:
                    'Frequency of reporting on environmental issues via this reporting line',
                  options: [
                    {
                      value: 'More frequently than quarterly',
                      label: 'More frequently than quarterly'
                    },
                    {value: 'Quarterly', label: 'Quarterly'},
                    {value: 'Half-yearly', label: 'Half-yearly'},
                    {value: 'Annually', label: 'Annually'},
                    {
                      value: 'Less frequently than annually',
                      label: 'Less frequently than annually'
                    },
                    {
                      value: 'As important matters arise',
                      label: 'As important matters arise'
                    }
                  ],
                  colSpan: true
                },
                {
                  type: inputType.WYSIWYG,
                  fieldName:
                    CDP_SME_GOVERNANCE_FIELD_NAMES.SME_GOVERNANCE_Q2_6_VALUE,
                  fieldLabel: 'Please explain',
                  colSpan: true,
                  textLimit: 2000
                }
              ]
            }
          }
        ]
      },
      {
        field: [
          {
            fieldType: inputType.HEADING,
            heading:
              '17.2 Does your organization have an environmental policy that addresses environmental issues?'
          },
          {
            fieldType: inputType.ADD_NEW_TO_TABLE,
            fieldName: CDP_SME_GOVERNANCE_FIELD_NAMES.SME_GOVERNANCE_Q3_VALUE,
            allowMultipleRows: false,
            formList: {
              formFields: [
                {
                  type: inputType.SELECT,
                  fieldName:
                    CDP_SME_GOVERNANCE_FIELD_NAMES.SME_GOVERNANCE_Q3_1_VALUE,
                  fieldLabel:
                    'Does your organization have any environmental policies?',
                  options: [
                    {label: 'Yes', value: 'Yes'},
                    {
                      label: 'No, but we plan to within the next two years',
                      value: 'No, but we plan to within the next two years'
                    },
                    {
                      label:
                        'No, and we do not plan to within the next two years',
                      value:
                        'No, and we do not plan to within the next two years'
                    }
                  ],
                  colSpan: true
                },
                {
                  type: inputType.SELECT_WITH_OTHER_TEXTBOX,
                  fieldName:
                    CDP_SME_GOVERNANCE_FIELD_NAMES.SME_GOVERNANCE_Q3_2_VALUE,
                  fieldLabel:
                    'Primary reason for not having a environmental policy',
                  options: [
                    {
                      label:
                        'Lack of internal resources, capabilities, or expertise (e.g., due to organization size)',
                      value:
                        'Lack of internal resources, capabilities, or expertise (e.g., due to organization size)'
                    },
                    {
                      label: 'No standardized procedure',
                      value: 'No standardized procedure'
                    },
                    {
                      label: 'Not an immediate strategic priority',
                      value: 'Not an immediate strategic priority'
                    },
                    {
                      label: 'Judged to be unimportant or not relevant',
                      value: 'Judged to be unimportant or not relevant'
                    },
                    {
                      label: 'Other, please specify',
                      value: 'Other, please specify'
                    }
                  ],
                  colSpan: true,
                  disabledOn: {
                    fieldName:
                      CDP_SME_GOVERNANCE_FIELD_NAMES.SME_GOVERNANCE_Q3_1_VALUE,
                    condition: conditionType.INCLUDES,
                    values: ['Yes']
                  }
                }
              ]
            }
          }
        ]
      },
      {
        field: [
          {
            fieldType: inputType.HEADING,
            heading: '17.2.1 Provide details of your environmental policies.',
            conditionalVisibility: {
              dependsOn: CDP_SME_GOVERNANCE_FIELD_NAMES.SME_GOVERNANCE_Q3_VALUE,
              showWhen: 'Yes',
              condition: conditionType.EQUALS,
              fieldName:
                CDP_SME_GOVERNANCE_FIELD_NAMES.SME_GOVERNANCE_Q3_1_VALUE
            }
          },
          {
            fieldType: inputType.ADD_NEW_TO_TABLE,
            fieldName: CDP_SME_GOVERNANCE_FIELD_NAMES.SME_GOVERNANCE_Q4_VALUE,
            //  conditionalVisibility: {
            dependsOn: CDP_SME_GOVERNANCE_FIELD_NAMES.SME_GOVERNANCE_Q3_1_VALUE,
            showWhen: ['Yes'],
            relatedTableKey:
              CDP_SME_GOVERNANCE_FIELD_NAMES.SME_GOVERNANCE_Q3_VALUE,
            //   },
            formList: {
              formFields: [
                {
                  type: inputType.SELECT,
                  fieldName:
                    CDP_SME_GOVERNANCE_FIELD_NAMES.SME_GOVERNANCE_Q4_1_VALUE,
                  fieldLabel: 'Environmental issues covered',
                  options: ENVIRONMENTAL_ISSUE_OPTIONS,
                  colSpan: true
                },
                {
                  type: inputType.SELECT,
                  fieldName:
                    CDP_SME_GOVERNANCE_FIELD_NAMES.SME_GOVERNANCE_Q4_2_VALUE,
                  fieldLabel: 'Level of coverage',
                  options: [
                    {label: 'Organization-wide', value: 'Organization-wide'},
                    {
                      label:
                        'Selected facilities, businesses or geographies only',
                      value:
                        'Selected facilities, businesses or geographies only'
                    },
                    {
                      label: 'Selected products only',
                      value: 'Selected products only'
                    },
                    {
                      label: 'Selected commodities only',
                      value: 'Selected commodities only'
                    }
                  ],
                  colSpan: true
                },
                {
                  type: inputType.SELECT,
                  fieldName:
                    CDP_SME_GOVERNANCE_FIELD_NAMES.SME_GOVERNANCE_Q4_3_VALUE,
                  fieldLabel: 'Value chain stages covered',
                  options: [
                    {
                      label: 'Direct operations (our own organization)',
                      value: 'Direct operations (our own organization)'
                    },
                    {
                      label: 'Upstream activities (suppliers)',
                      value: 'Upstream activities (suppliers)'
                    },
                    {
                      label:
                        'Downstream activities (distributors or customers)',
                      value: 'Downstream activities (distributors or customers)'
                    }
                  ],
                  colSpan: true
                },
                {
                  type: inputType.WYSIWYG,
                  fieldName:
                    CDP_SME_GOVERNANCE_FIELD_NAMES.SME_GOVERNANCE_Q4_4_VALUE,
                  fieldLabel: 'Explain the coverage',
                  colSpan: true,
                  textLimit: 1500
                },
                {
                  type: inputType.SELECT_WITH_OTHER_TEXTBOX,
                  fieldName:
                    CDP_SME_GOVERNANCE_FIELD_NAMES.SME_GOVERNANCE_Q4_5_VALUE,
                  fieldLabel: 'Environmental Policy Content',
                  options: [
                    {
                      value: 'Environmental policy content',
                      label: 'Environmental policy content'
                    },
                    {
                      value: 'Environmental commitments',
                      label: 'Environmental commitments'
                    },
                    {
                      value:
                        'Commitment to comply with regulations and mandatory standards',
                      label:
                        'Commitment to comply with regulations and mandatory standards'
                    },
                    {
                      value:
                        'Commitment to take environmental action beyond regulatory compliance',
                      label:
                        'Commitment to take environmental action beyond regulatory compliance'
                    },
                    {
                      value:
                        'Commitment to engage in integrated, multi-stakeholder landscape (including river basin) initiatives to promote shared sustainability goals',
                      label:
                        'Commitment to engage in integrated, multi-stakeholder landscape (including river basin) initiatives to promote shared sustainability goals'
                    },
                    {
                      value:
                        'Commitment to stakeholder engagement and capacity building on environmental issues',
                      label:
                        'Commitment to stakeholder engagement and capacity building on environmental issues'
                    },
                    {
                      value: 'Other environmental commitment, please specify',
                      label: 'Other environmental commitment, please specify'
                    },
                    {
                      value: 'Climate-specific commitments',
                      label: 'Climate-specific commitments'
                    },
                    {
                      value: 'Commitment to 100% renewable energy',
                      label: 'Commitment to 100% renewable energy'
                    },
                    {
                      value: 'Commitment to net-zero emissions',
                      label: 'Commitment to net-zero emissions'
                    },
                    {
                      value:
                        'Commitment to not invest in fossil-fuel expansion',
                      label: 'Commitment to not invest in fossil-fuel expansion'
                    },
                    {
                      value: 'Other climate-related commitment, please specify',
                      label: 'Other climate-related commitment, please specify'
                    },
                    {
                      value: 'Forests-specific commitments',
                      label: 'Forests-specific commitments'
                    },
                    {
                      value:
                        'Commitment to best management practices for soils and peat',
                      label:
                        'Commitment to best management practices for soils and peat'
                    },
                    {
                      value:
                        'Commitment to no-conversion of natural ecosystems by target date, please specify',
                      label:
                        'Commitment to no-conversion of natural ecosystems by target date, please specify'
                    },
                    {
                      value:
                        'Commitment to no-deforestation by target date, please specify',
                      label:
                        'Commitment to no-deforestation by target date, please specify'
                    },
                    {
                      value: 'Other forests-related commitment, please specify',
                      label: 'Other forests-related commitment, please specify'
                    },
                    {
                      value: 'Water-specific commitments',
                      label: 'Water-specific commitments'
                    },
                    {
                      value:
                        'Commitment to reduce or phase out hazardous substances',
                      label:
                        'Commitment to reduce or phase out hazardous substances'
                    },
                    {
                      value:
                        'Commitment to control/reduce/eliminate water pollution',
                      label:
                        'Commitment to control/reduce/eliminate water pollution'
                    },
                    {
                      value: 'Commitment to reduce water consumption volumes',
                      label: 'Commitment to reduce water consumption volumes'
                    },
                    {
                      value: 'Commitment to reduce water withdrawal volumes',
                      label: 'Commitment to reduce water withdrawal volumes'
                    },
                    {
                      value:
                        'Commitment to safely managed WASH in local communities',
                      label:
                        'Commitment to safely managed WASH in local communities'
                    },
                    {
                      value:
                        'Commitment to water stewardship and/or collective action',
                      label:
                        'Commitment to water stewardship and/or collective action'
                    },
                    {
                      value: 'Other water-related commitment, please specify',
                      label: 'Other water-related commitment, please specify'
                    },
                    {value: 'Social commitments', label: 'Social commitments'},
                    {
                      value:
                        'Adoption of the UN International Labour Organization principles',
                      label:
                        'Adoption of the UN International Labour Organization principles'
                    },
                    {
                      value:
                        'Commitment to promote gender equality and women’s empowerment',
                      label:
                        'Commitment to promote gender equality and women’s empowerment'
                    },
                    {
                      value:
                        'Commitment to respect and protect the customary rights to land, resources, and territory of Indigenous Peoples and Local Communities',
                      label:
                        'Commitment to respect and protect the customary rights to land, resources, and territory of Indigenous Peoples and Local Communities'
                    },
                    {
                      value:
                        'Commitment to respect internationally recognized human rights',
                      label:
                        'Commitment to respect internationally recognized human rights'
                    },
                    {
                      value:
                        'Commitment to secure Free, Prior, and Informed Consent (FPIC) of indigenous people and local communities',
                      label:
                        'Commitment to secure Free, Prior, and Informed Consent (FPIC) of indigenous people and local communities'
                    },
                    {
                      value: 'Other social commitment, please specify',
                      label: 'Other social commitment, please specify'
                    },
                    {
                      value: 'Additional references/Descriptions',
                      label: 'Additional references/Descriptions'
                    },
                    {
                      value: 'Description of commodities covered by the policy',
                      label: 'Description of commodities covered by the policy'
                    },
                    {
                      value:
                        'Description of environmental requirements for procurement',
                      label:
                        'Description of environmental requirements for procurement'
                    },
                    {
                      value:
                        'Description of grievance/whistleblower mechanism to monitor non-compliance with the environmental policy and raise/address/escalate any other greenwashing concerns',
                      label:
                        'Description of grievance/whistleblower mechanism to monitor non-compliance with the environmental policy and raise/address/escalate any other greenwashing concerns'
                    },
                    {
                      value:
                        'Description of renewable electricity procurement practices',
                      label:
                        'Description of renewable electricity procurement practices'
                    },
                    {
                      value:
                        'Reference to time bound environmental milestones and targets',
                      label:
                        'Reference to time bound environmental milestones and targets'
                    },
                    {
                      value:
                        'Other, additional references/descriptions please specify',
                      label:
                        'Other, additional references/descriptions please specify'
                    }
                  ],
                  colSpan: true
                }
              ]
            }
          }
        ]
      }
    ]
  }
];

export const smeBusinessStrategyQuestions = [
  {
    key: '1',
    showIndex: false,
    items: [
      {
        field: [
          {
            fieldType: inputType.HEADING,
            heading:
              '18.1 Have risks and opportunities created by environmental issues influenced your strategy and/or financial planning?'
          },
          {
            fieldType: inputType.ADD_NEW_TO_TABLE,
            fieldName:
              CDP_SME_BUSINESS_STRATEGY_FIELD_NAMES.SME_BUSINESS_STRATEGY_Q1_VALUE,
            allowMultipleRows: false,
            formList: {
              formFields: [
                {
                  type: inputType.SELECT,
                  fieldName:
                    CDP_SME_BUSINESS_STRATEGY_FIELD_NAMES.SME_BUSINESS_STRATEGY_Q1_1_VALUE,
                  fieldLabel:
                    'Environmental risks and/or opportunities have affected your strategy and/or financial planning',
                  options: [
                    {label: 'Yes, strategy only', value: 'Yes, strategy only'},
                    {
                      label: 'Yes, financial planning only',
                      value: 'Yes, financial planning only'
                    },
                    {
                      label: 'Yes, both strategy and financial planning',
                      value: 'Yes, both strategy and financial planning'
                    },
                    {
                      label:
                        'We plan to evaluate the potential effect of environmental risks and opportunities on our strategy and financial planning within the next two years',
                      value:
                        'We plan to evaluate the potential effect of environmental risks and opportunities on our strategy and financial planning within the next two years'
                    },
                    {
                      label:
                        'We do not plan to evaluate the potential effect of risk and opportunities on our strategy and financial planning within the next two years',
                      value:
                        'We do not plan to evaluate the potential effect of risk and opportunities on our strategy and financial planning within the next two years'
                    },
                    {
                      label: 'No',
                      value: 'No'
                    }
                  ],
                  colSpan: true
                },
                {
                  type: inputType.SELECT_WITH_OTHER_TEXTBOX,
                  fieldName:
                    CDP_SME_BUSINESS_STRATEGY_FIELD_NAMES.SME_BUSINESS_STRATEGY_Q1_2_VALUE,
                  fieldLabel:
                    'Primary reason why environmental risks and opportunities have not affected your strategy and/or financial planning',
                  options: [
                    {
                      label:
                        'Lack of internal resources, capabilities, or expertise (e.g., due to organization size)',
                      value:
                        'Lack of internal resources, capabilities, or expertise (e.g., due to organization size)'
                    },
                    {
                      label: 'No standardized procedure',
                      value: 'No standardized procedure'
                    },
                    {
                      label: 'Not an immediate strategic priority',
                      value: 'Not an immediate strategic priority'
                    },
                    {
                      label: 'Judged to be unimportant or not relevant',
                      value: 'Judged to be unimportant or not relevant'
                    },
                    {
                      label: 'Other, please specify',
                      value: 'Other, please specify'
                    }
                  ],
                  colSpan: true,
                  disabledOn: {
                    fieldName:
                      CDP_SME_BUSINESS_STRATEGY_FIELD_NAMES.SME_BUSINESS_STRATEGY_Q1_1_VALUE,
                    condition: conditionType.INCLUDES,
                    values: [
                      'Yes, strategy only',
                      'Yes, financial planning only',
                      'Yes, both strategy and financial planning'
                    ]
                  }
                },
                {
                  type: inputType.WYSIWYG,
                  fieldName:
                    CDP_SME_BUSINESS_STRATEGY_FIELD_NAMES.SME_BUSINESS_STRATEGY_Q1_3_VALUE,
                  fieldLabel:
                    'Explain why environmental risks and/or opportunities have not affected your strategy and/or financial planning',
                  colSpan: true,
                  textLimit: 2500,
                  disabledOn: {
                    fieldName:
                      CDP_SME_BUSINESS_STRATEGY_FIELD_NAMES.SME_BUSINESS_STRATEGY_Q1_1_VALUE,
                    condition: conditionType.INCLUDES,
                    values: [
                      'Yes, strategy only',
                      'Yes, financial planning only',
                      'Yes, both strategy and financial planning'
                    ]
                  }
                }
              ]
            }
          }
        ]
      },
      {
        field: [
          {
            fieldType: inputType.HEADING,
            heading:
              '18.1.1 Describe where and how risks and opportunities created by environmental issues have influenced your strategy and/or financial planning.',
            conditionalVisibility: {
              dependsOn:
                CDP_SME_BUSINESS_STRATEGY_FIELD_NAMES.SME_BUSINESS_STRATEGY_Q1_VALUE,
              showWhen: [
                'Yes, strategy only',
                'Yes, financial planning only',
                'Yes, both strategy and financial planning'
              ],
              condition: conditionType.EQUALS,
              fieldName:
                CDP_SME_BUSINESS_STRATEGY_FIELD_NAMES.SME_BUSINESS_STRATEGY_Q1_1_VALUE
            }
          },
          {
            fieldType: inputType.ADD_NEW_TO_TABLE,
            fieldName:
              CDP_SME_BUSINESS_STRATEGY_FIELD_NAMES.SME_BUSINESS_STRATEGY_Q2_VALUE,
            //  conditionalVisibility: {
            dependsOn:
              CDP_SME_BUSINESS_STRATEGY_FIELD_NAMES.SME_BUSINESS_STRATEGY_Q1_1_VALUE,
            showWhen: [
              'Yes, strategy only',
              'Yes, financial planning only',
              'Yes, both strategy and financial planning'
            ],
            relatedTableKey:
              CDP_SME_BUSINESS_STRATEGY_FIELD_NAMES.SME_BUSINESS_STRATEGY_Q1_VALUE,
            //   },
            formList: {
              formFields: [
                {
                  type: inputType.SELECT,
                  fieldName:
                    CDP_SME_BUSINESS_STRATEGY_FIELD_NAMES.SME_BUSINESS_STRATEGY_Q2_1_VALUE,
                  fieldLabel:
                    'Area influenced by environmental risks and/or opportunities',
                  options: [
                    {label: 'Strategy', value: 'Strategy'},
                    {label: 'Financial Planning', value: 'Financial Planning'}
                  ],
                  colSpan: true
                },
                {
                  type: inputType.SELECT,
                  fieldName:
                    CDP_SME_BUSINESS_STRATEGY_FIELD_NAMES.SME_BUSINESS_STRATEGY_Q2_2_VALUE,
                  fieldLabel: 'Business areas that have been affected',
                  options: [
                    {
                      label: 'Products and services',
                      value: 'Products and services'
                    },
                    {
                      label: 'Upstream/downstream value chain',
                      value: 'Upstream/downstream value chain'
                    },
                    {label: 'Investment in R&D', value: 'Investment in R&D'},
                    {label: 'Operations', value: 'Operations'}
                  ],
                  colSpan: true,
                  disabledOn: {
                    fieldName:
                      CDP_SME_BUSINESS_STRATEGY_FIELD_NAMES.SME_BUSINESS_STRATEGY_Q2_1_VALUE,
                    condition: conditionType.EQUALS,
                    values: ['Financial Planning']
                  }
                },
                {
                  type: inputType.SELECT,
                  fieldName:
                    CDP_SME_BUSINESS_STRATEGY_FIELD_NAMES.SME_BUSINESS_STRATEGY_Q2_3_VALUE,
                  fieldLabel:
                    'Financial planning elements that have been affected',
                  options: [
                    {value: 'Revenues', label: 'Revenues'},
                    {value: 'Direct costs', label: 'Direct costs'},
                    {value: 'Indirect costs', label: 'Indirect costs'},
                    {
                      value: 'Capital expenditures',
                      label: 'Capital expenditures'
                    },
                    {value: 'Capital allocation', label: 'Capital allocation'},
                    {
                      value: 'Acquisitions and divestments',
                      label: 'Acquisitions and divestments'
                    },
                    {value: 'Access to capital', label: 'Access to capital'},
                    {value: 'Assets', label: 'Assets'},
                    {value: 'Liabilities', label: 'Liabilities'},
                    {
                      value: 'Other, please specify',
                      label: 'Other, please specify'
                    }
                  ],
                  colSpan: true,
                  disabledOn: {
                    fieldName:
                      CDP_SME_BUSINESS_STRATEGY_FIELD_NAMES.SME_BUSINESS_STRATEGY_Q2_1_VALUE,
                    condition: conditionType.EQUALS,
                    values: ['Strategy']
                  }
                },
                {
                  type: inputType.SELECT,
                  fieldName:
                    CDP_SME_BUSINESS_STRATEGY_FIELD_NAMES.SME_BUSINESS_STRATEGY_Q2_4_VALUE,
                  fieldLabel: 'Effect type',
                  options: [
                    {label: 'Risks', value: 'Risks'},
                    {label: 'Opportunities', value: 'Opportunities'}
                  ],
                  colSpan: true
                },
                {
                  type: inputType.SELECT,
                  fieldName:
                    CDP_SME_BUSINESS_STRATEGY_FIELD_NAMES.SME_BUSINESS_STRATEGY_Q2_5_VALUE,
                  fieldLabel:
                    'Environmental issues relevant to the risks and/or opportunities that have affected your strategy and/or financial planning in this area',
                  options: ENVIRONMENTAL_ISSUE_OPTIONS,
                  colSpan: true,
                  disabledOn: {
                    fieldName:
                      CDP_SME_BUSINESS_STRATEGY_FIELD_NAMES.SME_BUSINESS_STRATEGY_Q2_4_VALUE,
                    condition: conditionType.NOT,
                    values: ['Risks', 'Opportunities']
                  }
                },
                {
                  type: inputType.WYSIWYG,
                  fieldName:
                    CDP_SME_BUSINESS_STRATEGY_FIELD_NAMES.SME_BUSINESS_STRATEGY_Q2_6_VALUE,
                  fieldLabel:
                    'Describe how environmental risks and/or opportunities have affected your strategy and/or financial planning in this area',
                  colSpan: true,
                  textLimit: 2500,
                  disabledOn: {
                    fieldName:
                      CDP_SME_BUSINESS_STRATEGY_FIELD_NAMES.SME_BUSINESS_STRATEGY_Q2_1_VALUE,
                    condition: conditionType.EMPTY,
                    values: []
                  }
                }
              ]
            }
          }
        ]
      },
      {
        field: [
          {
            fieldType: inputType.HEADING,
            heading:
              '18.2 Does your organization’s strategy include a climate transition plan?'
          },
          {
            fieldType: inputType.ADD_NEW_TO_TABLE,
            fieldName:
              CDP_SME_BUSINESS_STRATEGY_FIELD_NAMES.SME_BUSINESS_STRATEGY_Q3_VALUE,
            allowMultipleRows: false,
            formList: {
              formFields: [
                {
                  type: inputType.SELECT,
                  fieldName:
                    CDP_SME_BUSINESS_STRATEGY_FIELD_NAMES.SME_BUSINESS_STRATEGY_Q3_1_VALUE,
                  fieldLabel: 'Transition plan',
                  options: [
                    {
                      label: 'Yes, we have a climate transition plan',
                      value: 'Yes, we have a climate transition plan'
                    },
                    {
                      label:
                        'No, but we are developing a climate transition plan within two years',
                      value:
                        'No, but we are developing a climate transition plan within two years'
                    },
                    {
                      label:
                        'No, and we do not plan to develop a climate transition plan within the next two years',
                      value:
                        'No, and we do not plan to develop a climate transition plan within the next two years'
                    }
                  ],
                  colSpan: true
                },
                {
                  type: inputType.SELECT_WITH_OTHER_TEXTBOX,
                  fieldName:
                    CDP_SME_BUSINESS_STRATEGY_FIELD_NAMES.SME_BUSINESS_STRATEGY_Q3_2_VALUE,
                  fieldLabel: 'Temperature alignment of transition plan',
                  options: [
                    {label: '1.5°C', value: '1.5°C'},
                    {
                      label: 'Well-below 2°C aligned',
                      value: 'Well-below 2°C aligned'
                    },
                    {label: '2°C aligned', value: '2°C aligned'},
                    {label: 'Unspecified', value: 'Unspecified'},
                    {
                      label: 'Other, please specify',
                      value: 'Other, please specify'
                    }
                  ],
                  colSpan: true,
                  disabledOn: {
                    fieldName:
                      CDP_SME_BUSINESS_STRATEGY_FIELD_NAMES.SME_BUSINESS_STRATEGY_Q3_1_VALUE,
                    condition: conditionType.EQUALS,
                    values: [
                      'No, but we are developing a climate transition plan within two years',
                      'No, and we do not plan to develop a climate transition plan within the next two years'
                    ]
                  }
                },
                {
                  type: inputType.RADIOGROUP,
                  fieldName:
                    CDP_SME_BUSINESS_STRATEGY_FIELD_NAMES.SME_BUSINESS_STRATEGY_Q3_3_VALUE,
                  fieldLabel: 'Publicly available climate transition plan',
                  options: ['Yes', 'No']
                },
                {
                  type: inputType.SELECT,
                  fieldName:
                    CDP_SME_BUSINESS_STRATEGY_FIELD_NAMES.SME_BUSINESS_STRATEGY_Q3_4_VALUE,
                  fieldLabel:
                    'Mechanism by which feedback is collected from stakeholders on your climate transition plan',
                  options: [
                    {
                      label:
                        'We have a feedback mechanism in place, please specify',
                      value:
                        'We have a feedback mechanism in place, please specify'
                    },
                    {
                      label:
                        'We do not have a feedback mechanism in place, but we plan to introduce one within the next two years',
                      value:
                        'We do not have a feedback mechanism in place, but we plan to introduce one within the next two years'
                    },
                    {
                      label:
                        'We do not have a feedback mechanism in place, and we do not plan to introduce one within the next two years',
                      value:
                        'We do not have a feedback mechanism in place, and we do not plan to introduce one within the next two years'
                    }
                  ],
                  colSpan: true
                },
                {
                  type: inputType.SELECT,
                  fieldName:
                    CDP_SME_BUSINESS_STRATEGY_FIELD_NAMES.SME_BUSINESS_STRATEGY_Q3_5_VALUE,
                  fieldLabel: 'Frequency of feedback collection',
                  options: [
                    {
                      label: 'More frequently than annually',
                      value: 'More frequently than annually'
                    },
                    {label: 'Annually', value: 'Annually'},
                    {
                      label: 'Less frequently than annually',
                      value: 'Less frequently than annually'
                    }
                  ],
                  colSpan: true,
                  disabledOn: {
                    fieldName:
                      CDP_SME_BUSINESS_STRATEGY_FIELD_NAMES.SME_BUSINESS_STRATEGY_Q3_4_VALUE,
                    condition: conditionType.EQUALS,
                    values: [
                      'We have a feedback mechanism in place, please specify',
                      'We do not have a feedback mechanism in place, and we do not plan to introduce one within the next two years'
                    ]
                  }
                },
                {
                  type: inputType.FILEUPLOAD,
                  fieldName:
                    CDP_SME_BUSINESS_STRATEGY_FIELD_NAMES.SME_BUSINESS_STRATEGY_Q3_6_VALUE,
                  fieldLabel:
                    'Attach any relevant documents which detail your climate transition plan (optional)',
                  colSpan: true
                },
                {
                  type: inputType.SELECT,
                  fieldName:
                    CDP_SME_BUSINESS_STRATEGY_FIELD_NAMES.SME_BUSINESS_STRATEGY_Q3_7_VALUE,
                  fieldLabel:
                    'Other environmental issues that your climate transition plan considers',
                  options: [
                    {label: 'Forests', value: 'Forests'},
                    {label: 'Water', value: 'Water'},
                    {
                      label: 'Other, please specify',
                      value: 'Other, please specify'
                    },
                    {
                      label: 'No other environmental issue considered',
                      value: 'No other environmental issue considered'
                    }
                  ],
                  colSpan: true
                },
                {
                  type: inputType.WYSIWYG,
                  fieldName:
                    CDP_SME_BUSINESS_STRATEGY_FIELD_NAMES.SME_BUSINESS_STRATEGY_Q3_8_VALUE,
                  fieldLabel:
                    'Explain how the other environmental issues are considered in your climate transition plan',
                  colSpan: true,
                  textLimit: 2500,
                  disabledOn: {
                    fieldName:
                      CDP_SME_BUSINESS_STRATEGY_FIELD_NAMES.SME_BUSINESS_STRATEGY_Q3_1_VALUE,
                    condition: conditionType.EQUALS,
                    values: [
                      'No, but we are developing a climate transition plan within two years',
                      'No, and we do not plan to develop a climate transition plan within the next two years'
                    ]
                  }
                }
              ]
            }
          }
        ]
      },
      {
        field: [
          {
            fieldType: inputType.HEADING,
            heading:
              '18.3 Do you engage with suppliers, customers, and other stakeholders within your value chain on environmental issues?'
          },
          {
            fieldType: inputType.ADD_NEW_TO_TABLE,
            fieldName:
              CDP_SME_BUSINESS_STRATEGY_FIELD_NAMES.SME_BUSINESS_STRATEGY_Q4_VALUE,
            allowMultipleRows: false,
            formList: {
              formFields: [
                {
                  type: inputType.SELECT,
                  fieldName:
                    CDP_SME_BUSINESS_STRATEGY_FIELD_NAMES.SME_BUSINESS_STRATEGY_Q4_1_VALUE,
                  fieldLabel: 'Value chain stakeholder',
                  options: [
                    {label: 'Suppliers', value: 'Suppliers'},
                    {label: 'Customers', value: 'Customers'},
                    {
                      label: 'Investors and shareholders',
                      value: 'Investors and shareholders'
                    },
                    {
                      label: 'Other value chain stakeholders, please specify',
                      value: 'Other value chain stakeholders, please specify'
                    }
                  ],
                  colSpan: true,
                  disabledOn: {
                    fieldName:
                      CDP_SME_BUSINESS_STRATEGY_FIELD_NAMES.SME_BUSINESS_STRATEGY_Q4_2_VALUE,
                    condition: conditionType.EQUALS,
                    values:
                      'No, and we do not plan to within the next two years'
                  }
                },
                {
                  type: inputType.SELECT,
                  fieldName:
                    CDP_SME_BUSINESS_STRATEGY_FIELD_NAMES.SME_BUSINESS_STRATEGY_Q4_2_VALUE,
                  fieldLabel:
                    'Engaging with this stakeholder on environmental issues',
                  options: [
                    {label: 'Yes', value: 'Yes'},
                    {
                      label: 'No, but we plan to within the next two years',
                      value: 'No, but we plan to within the next two years'
                    },
                    {
                      label:
                        'No, and we do not plan to within the next two years',
                      value:
                        'No, and we do not plan to within the next two years'
                    }
                  ],
                  colSpan: true
                },
                {
                  type: inputType.SELECT,
                  fieldName:
                    CDP_SME_BUSINESS_STRATEGY_FIELD_NAMES.SME_BUSINESS_STRATEGY_Q4_3_VALUE,
                  fieldLabel: 'Environmental issues covered',
                  options: ENVIRONMENTAL_ISSUE_OPTIONS,
                  colSpan: true,
                  disabledOn: {
                    fieldName:
                      CDP_SME_BUSINESS_STRATEGY_FIELD_NAMES.SME_BUSINESS_STRATEGY_Q4_2_VALUE,
                    condition: conditionType.EQUALS,
                    values:
                      'No, and we do not plan to within the next two years'
                  }
                },
                {
                  type: inputType.SELECT_WITH_OTHER_TEXTBOX,
                  fieldName:
                    CDP_SME_BUSINESS_STRATEGY_FIELD_NAMES.SME_BUSINESS_STRATEGY_Q4_4_VALUE,
                  fieldLabel: 'Primary reason for no engagement',
                  options: [
                    {
                      value:
                        'Lack of internal resources, capabilities, or expertise (e.g., due to organization size)',
                      label:
                        'Lack of internal resources, capabilities, or expertise (e.g., due to organization size)'
                    },
                    {
                      value: 'No standardized procedure',
                      label: 'No standardized procedure'
                    },
                    {
                      value: 'Not an immediate strategic priority',
                      label: 'Not an immediate strategic priority'
                    },
                    {
                      value: 'Judged to be unimportant or not relevant',
                      label: 'Judged to be unimportant or not relevant'
                    },
                    {
                      value: 'Other, please specify',
                      label: 'Other, please specify'
                    }
                  ],
                  colSpan: true
                },
                {
                  type: inputType.SELECT_WITH_OTHER_TEXTBOX,
                  fieldName:
                    CDP_SME_BUSINESS_STRATEGY_FIELD_NAMES.SME_BUSINESS_STRATEGY_Q4_5_VALUE,
                  fieldLabel: 'Type of engagement',
                  options: [
                    {value: 'Capacity building', label: 'Capacity building'},
                    {
                      value: 'Financial incentives',
                      label: 'Financial incentives'
                    },
                    {
                      value: 'Information collection',
                      label: 'Information collection'
                    },
                    {
                      value: 'Innovation and collaboration',
                      label: 'Innovation and collaboration'
                    },
                    {
                      value: 'Education/ Information sharing',
                      label: 'Education/ Information sharing'
                    },
                    {value: 'Other', label: 'Other'}
                  ],
                  colSpan: true,
                  disabledOn: {
                    fieldName:
                      CDP_SME_BUSINESS_STRATEGY_FIELD_NAMES.SME_BUSINESS_STRATEGY_Q4_2_VALUE,
                    condition: conditionType.EQUALS,
                    values:
                      'No, and we do not plan to within the next two years'
                  }
                },
                {
                  type: inputType.WYSIWYG,
                  fieldName:
                    CDP_SME_BUSINESS_STRATEGY_FIELD_NAMES.SME_BUSINESS_STRATEGY_Q4_6_VALUE,
                  fieldLabel: 'Details of engagement',
                  colSpan: true,
                  textLimit: 2500,
                  disabledOn: {
                    fieldName:
                      CDP_SME_BUSINESS_STRATEGY_FIELD_NAMES.SME_BUSINESS_STRATEGY_Q4_2_VALUE,
                    condition: conditionType.EQUALS,
                    values:
                      'No, and we do not plan to within the next two years'
                  }
                }
              ]
            }
          }
        ]
      },
      {
        field: [
          {
            fieldType: inputType.HEADING,
            heading: `18.4 Indicate any mutually beneficial environmental initiatives you could 
                          collaborate on with specific CDP Supply Chain members.`
          },
          {
            fieldType: inputType.ADD_NEW_TO_TABLE,
            fieldName:
              CDP_SME_BUSINESS_STRATEGY_FIELD_NAMES.SME_BUSINESS_STRATEGY_Q5_VALUE,
            formList: {
              formFields: [
                {
                  type: inputType.WYSIWYG,
                  fieldName:
                    CDP_SME_BUSINESS_STRATEGY_FIELD_NAMES.SME_BUSINESS_STRATEGY_Q5_1_VALUE,
                  fieldLabel: 'Requesting member',
                  colSpan: true
                },
                {
                  type: inputType.SELECT,
                  fieldName:
                    CDP_SME_BUSINESS_STRATEGY_FIELD_NAMES.SME_BUSINESS_STRATEGY_Q5_2_VALUE,
                  fieldLabel: 'Environmental issues the initiative relates to',
                  options: ENVIRONMENTAL_ISSUE_OPTIONS,
                  colSpan: true
                },
                {
                  type: inputType.SELECT,
                  fieldName:
                    CDP_SME_BUSINESS_STRATEGY_FIELD_NAMES.SME_BUSINESS_STRATEGY_Q5_3_VALUE,
                  fieldLabel: 'Commodities the initiative relates to',
                  options: COMMODITY_OPTIONS,
                  colSpan: true,
                  disabledOn: {
                    fieldName:
                      CDP_SME_BUSINESS_STRATEGY_FIELD_NAMES.SME_BUSINESS_STRATEGY_Q5_1_VALUE,
                    condition: conditionType.NOT_EMPTY
                  }
                },
                {
                  type: inputType.SELECT_WITH_OTHER_TEXTBOX,
                  fieldName:
                    CDP_SME_BUSINESS_STRATEGY_FIELD_NAMES.SME_BUSINESS_STRATEGY_Q5_4_VALUE,
                  fieldLabel: 'Initiative category and type',
                  options: [
                    {value: 'Certification', label: 'Certification'},
                    {
                      value: 'Increase coverage of commodity certified',
                      label: 'Increase coverage of commodity certified'
                    },
                    {
                      value: 'Other certification, please specify',
                      label: 'Other certification, please specify'
                    },
                    {
                      value: 'Change to provision of goods and services',
                      label: 'Change to provision of goods and services'
                    },
                    {
                      value: 'More online/virtual provision of services',
                      label: 'More online/virtual provision of services'
                    },
                    {
                      value: 'Reduce packaging weight',
                      label: 'Reduce packaging weight'
                    },
                    {
                      value: 'Reduce water-related impacts',
                      label: 'Reduce water-related impacts'
                    },
                    {
                      value:
                        'Other change to provision of goods and services, please specify',
                      label:
                        'Other change to provision of goods and services, please specify'
                    },
                    {
                      value: 'Change to supplier operations',
                      label: 'Change to supplier operations'
                    },
                    {
                      value:
                        'Assess life-cycle impact of products or services to identify efficiencies',
                      label:
                        'Assess life-cycle impact of products or services to identify efficiencies'
                    },
                    {
                      value: 'Implement energy reduction projects',
                      label: 'Implement energy reduction projects'
                    },
                    {
                      value:
                        'Increase proportion of renewable energy purchased',
                      label: 'Increase proportion of renewable energy purchased'
                    },
                    {
                      value: 'Increase water efficiency in operations',
                      label: 'Increase water efficiency in operations'
                    },
                    {
                      value:
                        'Other change to supplier operations, please specify',
                      label:
                        'Other change to supplier operations, please specify'
                    },
                    {value: 'Communications', label: 'Communications'},
                    {
                      value: 'Awards – apply for external awards together',
                      label: 'Awards – apply for external awards together'
                    },
                    {
                      value: 'Joint case studies or marketing campaign',
                      label: 'Joint case studies or marketing campaign'
                    },
                    {
                      value: 'Other communications, please specify',
                      label: 'Other communications, please specify'
                    },
                    {value: 'Innovation', label: 'Innovation'},
                    {
                      value:
                        'Implement new techniques/technologies to ensure sustainable production',
                      label:
                        'Implement new techniques/technologies to ensure sustainable production'
                    },
                    {
                      value:
                        'New product or service that has a lower upstream emissions footprint',
                      label:
                        'New product or service that has a lower upstream emissions footprint'
                    },
                    {
                      value:
                        'New product or service that has a lower upstream impact on forests',
                      label:
                        'New product or service that has a lower upstream impact on forests'
                    },
                    {
                      value:
                        'New product or service that has a lower upstream water impacts',
                      label:
                        'New product or service that has a lower upstream water impacts'
                    },
                    {
                      value:
                        'New product or service that reduces customers’ operational emissions',
                      label:
                        'New product or service that reduces customers’ operational emissions'
                    },
                    {
                      value:
                        'New product or service that reduces customers operational water consumption',
                      label:
                        'New product or service that reduces customers operational water consumption'
                    },
                    {
                      value:
                        'New product or service that reduces customers’ products/services commodity consumption',
                      label:
                        'New product or service that reduces customers’ products/services commodity consumption'
                    },
                    {
                      value:
                        'New product or service that reduces customers’ products/services operational emissions',
                      label:
                        'New product or service that reduces customers’ products/services operational emissions'
                    },
                    {value: 'Reduce packaging', label: 'Reduce packaging'},
                    {
                      value: 'Other innovation, please specify',
                      label: 'Other innovation, please specify'
                    },
                    {value: 'Logistical change', label: 'Logistical change'},
                    {
                      value: 'Change timing of logistics',
                      label: 'Change timing of logistics'
                    },
                    {
                      value:
                        'Change transportation mode (e.g., switch from aviation to rail)',
                      label:
                        'Change transportation mode (e.g., switch from aviation to rail)'
                    },
                    {
                      value: 'Consolidate logistics',
                      label: 'Consolidate logistics'
                    },
                    {value: 'Route optimization', label: 'Route optimization'},
                    {
                      value: 'Other logistical change, please specify',
                      label: 'Other logistical change, please specify'
                    },
                    {
                      value: 'Promote collective action',
                      label: 'Promote collective action'
                    },
                    {
                      value:
                        'Invite customer to collaborate with other users in their river basins to reduce impact',
                      label:
                        'Invite customer to collaborate with other users in their river basins to reduce impact'
                    },
                    {
                      value:
                        'Invite customer to collaborate in landscape or jurisdictional initiatives',
                      label:
                        'Invite customer to collaborate in landscape or jurisdictional initiatives'
                    },
                    {
                      value: 'Other collective action, please specify',
                      label: 'Other collective action, please specify'
                    },
                    {
                      value: 'Relationship sustainability assessment',
                      label: 'Relationship sustainability assessment'
                    },
                    {
                      value:
                        'Align goals to feed into customers targets and ambitions',
                      label:
                        'Align goals to feed into customers targets and ambitions'
                    },
                    {
                      value: 'Sustainability audit of existing relationship',
                      label: 'Sustainability audit of existing relationship'
                    },
                    {
                      value: 'Other assessment, please specify',
                      label: 'Other assessment, please specify'
                    },
                    {
                      value: 'Traceability and transparency',
                      label: 'Traceability and transparency'
                    },
                    {
                      value: 'Improve existing traceability system',
                      label: 'Improve existing traceability system'
                    },
                    {
                      value: 'New traceability system',
                      label: 'New traceability system'
                    },
                    {
                      value: 'Other traceability system, please specify',
                      label: 'Other traceability system, please specify'
                    },
                    {value: 'Other', label: 'Other'},
                    {
                      value: 'Other initiative type, please specify',
                      label: 'Other initiative type, please specify'
                    }
                  ],
                  colSpan: true,
                  disabledOn: {
                    fieldName:
                      CDP_SME_BUSINESS_STRATEGY_FIELD_NAMES.SME_BUSINESS_STRATEGY_Q5_1_VALUE,
                    condition: conditionType.NOT_EMPTY
                  }
                },
                {
                  type: inputType.WYSIWYG,
                  fieldName:
                    CDP_SME_BUSINESS_STRATEGY_FIELD_NAMES.SME_BUSINESS_STRATEGY_Q5_5_VALUE,
                  fieldLabel: 'Details of initiative',
                  colSpan: true,
                  textLimit: 2500,
                  disabledOn: {
                    fieldName:
                      CDP_SME_BUSINESS_STRATEGY_FIELD_NAMES.SME_BUSINESS_STRATEGY_Q5_1_VALUE,
                    condition: conditionType.NOT_EMPTY
                  }
                },
                {
                  type: inputType.SELECT_WITH_OTHER_TEXTBOX,
                  fieldName:
                    CDP_SME_BUSINESS_STRATEGY_FIELD_NAMES.SME_BUSINESS_STRATEGY_Q5_6_VALUE,
                  fieldLabel: 'Expected benefits',
                  options: [
                    {
                      value: 'Higher incomes due to increased productivity',
                      label: 'Higher incomes due to increased productivity'
                    },
                    {
                      value: 'Improved resource use and efficiency',
                      label: 'Improved resource use and efficiency'
                    },
                    {
                      value: 'Improved water quality',
                      label: 'Improved water quality'
                    },
                    {
                      value: 'Improved water stewardship',
                      label: 'Improved water stewardship'
                    },
                    {
                      value: 'Increase in use of certified materials',
                      label: 'Increase in use of certified materials'
                    },
                    {
                      value:
                        'Increased transparency of upstream/downstream value chain',
                      label:
                        'Increased transparency of upstream/downstream value chain'
                    },
                    {
                      value: 'Lower price per unit',
                      label: 'Lower price per unit'
                    },
                    {
                      value:
                        'Price premiums for deforestation and conversion-free materials',
                      label:
                        'Price premiums for deforestation and conversion-free materials'
                    },
                    {
                      value:
                        'Reduction of customers’ operational emissions (customer scope 1 & 2)',
                      label:
                        'Reduction of customers’ operational emissions (customer scope 1 & 2)'
                    },
                    {
                      value:
                        'Reduction of own operational emissions (own scope 1 & 2)',
                      label:
                        'Reduction of own operational emissions (own scope 1 & 2)'
                    },
                    {
                      value:
                        'Reduction of downstream value chain emissions (own scope 3)',
                      label:
                        'Reduction of downstream value chain emissions (own scope 3)'
                    },
                    {
                      value:
                        'Reduction of customers’ operational water withdrawals and/or consumption',
                      label:
                        'Reduction of customers’ operational water withdrawals and/or consumption'
                    },
                    {
                      value:
                        'Reduction of own operational water withdrawals and/or consumption',
                      label:
                        'Reduction of own operational water withdrawals and/or consumption'
                    },
                    {
                      value:
                        'Reduction of downstream value chain water withdrawals and/or consumption',
                      label:
                        'Reduction of downstream value chain water withdrawals and/or consumption'
                    },
                    {
                      value: 'Other, please specify',
                      label: 'Other, please specify'
                    }
                  ],
                  colSpan: true,
                  disabledOn: {
                    fieldName:
                      CDP_SME_BUSINESS_STRATEGY_FIELD_NAMES.SME_BUSINESS_STRATEGY_Q5_1_VALUE,
                    condition: conditionType.NOT_EMPTY
                  }
                },
                {
                  type: inputType.SELECT_WITH_OTHER_TEXTBOX,
                  fieldName:
                    CDP_SME_BUSINESS_STRATEGY_FIELD_NAMES.SME_BUSINESS_STRATEGY_Q5_7_VALUE,
                  fieldLabel: 'Estimated timeframe for realization of benefits',
                  options: [
                    {label: '0-1 year', value: '0-1 year'},
                    {label: '1-3 years', value: '1-3 years'},
                    {label: '3-5 years', value: '3-5 years'},
                    {label: '5 years', value: '5 years'},
                    {
                      label: 'Other, please specify',
                      value: 'Other, please specify'
                    }
                  ],
                  colSpan: true,
                  disabledOn: {
                    fieldName:
                      CDP_SME_BUSINESS_STRATEGY_FIELD_NAMES.SME_BUSINESS_STRATEGY_Q5_1_VALUE,
                    condition: conditionType.NOT_EMPTY
                  }
                },
                {
                  type: inputType.SELECT,
                  fieldName:
                    CDP_SME_BUSINESS_STRATEGY_FIELD_NAMES.SME_BUSINESS_STRATEGY_Q5_8_VALUE,
                  fieldLabel:
                    'Are you able to estimate the lifetime CO2e and/or water savings of this initiative?',
                  options: [
                    {
                      label:
                        'Yes, both lifetime CO2e and lifetime water savings',
                      value:
                        'Yes, both lifetime CO2e and lifetime water savings'
                    },
                    {
                      label: 'Yes, lifetime CO2e savings only',
                      value: 'Yes, lifetime CO2e savings only'
                    },
                    {
                      label: 'Yes, lifetime water savings only',
                      value: 'Yes, lifetime water savings only'
                    },
                    {label: 'No', value: 'No'}
                  ],
                  colSpan: true,
                  disabledOn: {
                    fieldName:
                      CDP_SME_BUSINESS_STRATEGY_FIELD_NAMES.SME_BUSINESS_STRATEGY_Q5_1_VALUE,
                    condition: conditionType.NOT_EMPTY
                  }
                },
                {
                  type: inputType.NUMBER,
                  fieldName:
                    CDP_SME_BUSINESS_STRATEGY_FIELD_NAMES.SME_BUSINESS_STRATEGY_Q5_9_VALUE,
                  fieldLabel: 'Estimated lifetime CO2e savings',
                  disabledOn: {
                    fieldName:
                      CDP_SME_BUSINESS_STRATEGY_FIELD_NAMES.SME_BUSINESS_STRATEGY_Q5_1_VALUE,
                    condition: conditionType.NOT_EMPTY
                  }
                },
                {
                  type: inputType.NUMBER,
                  fieldName:
                    CDP_SME_BUSINESS_STRATEGY_FIELD_NAMES.SME_BUSINESS_STRATEGY_Q5_10_VALUE,
                  fieldLabel: 'Estimated lifetime water savings (megaliters)',
                  disabledOn: {
                    fieldName:
                      CDP_SME_BUSINESS_STRATEGY_FIELD_NAMES.SME_BUSINESS_STRATEGY_Q5_1_VALUE,
                    condition: conditionType.NOT_EMPTY
                  }
                },
                {
                  type: inputType.WYSIWYG,
                  fieldName:
                    CDP_SME_BUSINESS_STRATEGY_FIELD_NAMES.SME_BUSINESS_STRATEGY_Q5_11_VALUE,
                  fieldLabel: 'Please explain',
                  textLimit: 1000,
                  colSpan: true
                }
              ]
            }
          }
        ]
      },
      {
        field: [
          {
            fieldType: inputType.HEADING,
            heading: `18.5 Has your organization already implemented any mutually beneficial environmental 
                           initiatives due to CDP Supply Chain member engagement?`
          },
          {
            fieldType: inputType.ADD_NEW_TO_TABLE,
            fieldName:
              CDP_SME_BUSINESS_STRATEGY_FIELD_NAMES.SME_BUSINESS_STRATEGY_Q6_VALUE,
            allowMultipleRows: false,
            formList: {
              formFields: [
                {
                  type: inputType.SELECT,
                  fieldName:
                    CDP_SME_BUSINESS_STRATEGY_FIELD_NAMES.SME_BUSINESS_STRATEGY_Q6_1_VALUE,
                  fieldLabel:
                    'Environmental initiatives implemented due to CDP Supply Chain member engagement',
                  options: [
                    {label: 'Yes', value: 'Yes'},
                    {
                      label: 'No, but we plan to within the next two years',
                      value: 'No, but we plan to within the next two years'
                    },
                    {
                      label:
                        'No, and we do not plan to within the next two years',
                      value:
                        'No, and we do not plan to within the next two years'
                    }
                  ],
                  colSpan: true
                },
                {
                  type: inputType.SELECT_WITH_OTHER_TEXTBOX,
                  fieldName:
                    CDP_SME_BUSINESS_STRATEGY_FIELD_NAMES.SME_BUSINESS_STRATEGY_Q6_2_VALUE,
                  fieldLabel:
                    'Primary reason for not implementing environmental initiatives',
                  options: [
                    {
                      label:
                        'Lack of internal resources, capabilities, or expertise (e.g., due to organization size)',
                      value:
                        'Lack of internal resources, capabilities, or expertise (e.g., due to organization size)'
                    },
                    {
                      label: 'No standardized procedure',
                      value: 'No standardized procedure'
                    },
                    {
                      label: 'Not an immediate strategic priority',
                      value: 'Not an immediate strategic priority'
                    },
                    {
                      label: 'Judged to be unimportant or not relevant',
                      value: 'Judged to be unimportant or not relevant'
                    },
                    {
                      label: 'Other, please specify',
                      value: 'Other, please specify'
                    }
                  ],
                  colSpan: true,
                  conditionalVisibility: {
                    dependsOn:
                      CDP_SME_BUSINESS_STRATEGY_FIELD_NAMES.SME_BUSINESS_STRATEGY_Q6_1_VALUE,
                    showWhen: 'Yes',
                    condition: conditionType.NOT
                  }
                },
                {
                  type: inputType.WYSIWYG,
                  fieldName:
                    CDP_SME_BUSINESS_STRATEGY_FIELD_NAMES.SME_BUSINESS_STRATEGY_Q6_3_VALUE,
                  fieldLabel:
                    'Explain why your organization has not implemented any environmental initiatives',
                  textLimit: 2500,
                  colSpan: true,
                  conditionalVisibility: {
                    dependsOn:
                      CDP_SME_BUSINESS_STRATEGY_FIELD_NAMES.SME_BUSINESS_STRATEGY_Q6_1_VALUE,
                    showWhen: 'Yes',
                    condition: conditionType.NOT
                  }
                }
              ]
            }
          }
        ]
      },
      {
        field: [
          {
            fieldType: inputType.HEADING,
            heading: `18.5.1 Specify the CDP Supply Chain members that have prompted your implementation of mutually
                             beneficial environmental initiatives and provide information on the initiatives.`,
            conditionalVisibility: {
              dependsOn:
                CDP_SME_BUSINESS_STRATEGY_FIELD_NAMES.SME_BUSINESS_STRATEGY_Q6_VALUE,
              showWhen: 'Yes',
              condition: conditionType.EQUALS,
              fieldName:
                CDP_SME_BUSINESS_STRATEGY_FIELD_NAMES.SME_BUSINESS_STRATEGY_Q6_1_VALUE
            }
          },
          {
            fieldType: inputType.ADD_NEW_TO_TABLE,
            fieldName:
              CDP_SME_BUSINESS_STRATEGY_FIELD_NAMES.SME_BUSINESS_STRATEGY_Q7_VALUE,
            // conditionalVisibility: {
            dependsOn:
              CDP_SME_BUSINESS_STRATEGY_FIELD_NAMES.SME_BUSINESS_STRATEGY_Q6_1_VALUE,
            showWhen: ['Yes'],
            relatedTableKey:
              CDP_SME_BUSINESS_STRATEGY_FIELD_NAMES.SME_BUSINESS_STRATEGY_Q6_VALUE,
            //  },
            formList: {
              formFields: [
                {
                  type: inputType.WYSIWYG,
                  fieldName:
                    CDP_SME_BUSINESS_STRATEGY_FIELD_NAMES.SME_BUSINESS_STRATEGY_Q7_1_VALUE,
                  fieldLabel: 'Requesting member',
                  colSpan: true
                },
                {
                  type: inputType.SELECT,
                  fieldName:
                    CDP_SME_BUSINESS_STRATEGY_FIELD_NAMES.SME_BUSINESS_STRATEGY_Q7_2_VALUE,
                  fieldLabel: 'Environmental issues the initiative relates to',
                  options: ENVIRONMENTAL_ISSUE_OPTIONS,
                  colSpan: true
                },
                {
                  type: inputType.SELECT,
                  fieldName:
                    CDP_SME_BUSINESS_STRATEGY_FIELD_NAMES.SME_BUSINESS_STRATEGY_Q7_3_VALUE,
                  fieldLabel: 'Commodities the initiative relates to',
                  options: COMMODITY_OPTIONS,
                  colSpan: true,
                  disabledOn: {
                    fieldName:
                      CDP_SME_BUSINESS_STRATEGY_FIELD_NAMES.SME_BUSINESS_STRATEGY_Q7_2_VALUE,
                    condition: conditionType.EQUALS,
                    values: ['Climate change', 'Water']
                  }
                },
                {
                  type: inputType.SELECT,
                  fieldName:
                    CDP_SME_BUSINESS_STRATEGY_FIELD_NAMES.SME_BUSINESS_STRATEGY_Q7_4_VALUE,
                  fieldLabel: 'Initiative ID',
                  options: INITIATIVE_ID_OPTIONS,
                  colSpan: true
                },
                {
                  type: inputType.SELECT_WITH_OTHER_TEXTBOX,
                  fieldName:
                    CDP_SME_BUSINESS_STRATEGY_FIELD_NAMES.SME_BUSINESS_STRATEGY_Q7_5_VALUE,
                  fieldLabel: 'Initiative category and type',
                  options: [
                    {value: 'Certification', label: 'Certification'},
                    {
                      value: 'Increase coverage of commodity certified',
                      label: 'Increase coverage of commodity certified'
                    },
                    {
                      value: 'Other certification, please specify',
                      label: 'Other certification, please specify'
                    },
                    {
                      value: 'Change to provision of goods and services',
                      label: 'Change to provision of goods and services'
                    },
                    {
                      value: 'More online/virtual provision of services',
                      label: 'More online/virtual provision of services'
                    },
                    {
                      value: 'Reduce packaging weight',
                      label: 'Reduce packaging weight'
                    },
                    {
                      value: 'Reduce water-related impacts',
                      label: 'Reduce water-related impacts'
                    },
                    {
                      value:
                        'Other change to provision of goods and services, please specify',
                      label:
                        'Other change to provision of goods and services, please specify'
                    },
                    {
                      value: 'Change to supplier operations',
                      label: 'Change to supplier operations'
                    },
                    {
                      value:
                        'Assess life-cycle impact of products or services to identify efficiencies',
                      label:
                        'Assess life-cycle impact of products or services to identify efficiencies'
                    },
                    {
                      value: 'Implement energy reduction projects',
                      label: 'Implement energy reduction projects'
                    },
                    {
                      value:
                        'Increase proportion of renewable energy purchased',
                      label: 'Increase proportion of renewable energy purchased'
                    },
                    {
                      value: 'Increase water efficiency in operations',
                      label: 'Increase water efficiency in operations'
                    },
                    {
                      value:
                        'Other change to supplier operations, please specify',
                      label:
                        'Other change to supplier operations, please specify'
                    },
                    {value: 'Communications', label: 'Communications'},
                    {
                      value: 'Awards – apply for external awards together',
                      label: 'Awards – apply for external awards together'
                    },
                    {
                      value: 'Joint case studies or marketing campaign',
                      label: 'Joint case studies or marketing campaign'
                    },
                    {
                      value: 'Other communications, please specify',
                      label: 'Other communications, please specify'
                    },
                    {value: 'Innovation', label: 'Innovation'},
                    {
                      value:
                        'Implement new techniques/technologies to ensure sustainable production',
                      label:
                        'Implement new techniques/technologies to ensure sustainable production'
                    },
                    {
                      value:
                        'New product or service that has a lower upstream emissions footprint',
                      label:
                        'New product or service that has a lower upstream emissions footprint'
                    },
                    {
                      value:
                        'New product or service that has a lower upstream impact on forests',
                      label:
                        'New product or service that has a lower upstream impact on forests'
                    },
                    {
                      value:
                        'New product or service that has a lower upstream water impacts',
                      label:
                        'New product or service that has a lower upstream water impacts'
                    },
                    {
                      value:
                        'New product or service that reduces customers’ operational emissions',
                      label:
                        'New product or service that reduces customers’ operational emissions'
                    },
                    {
                      value:
                        'New product or service that reduces customers operational water consumption',
                      label:
                        'New product or service that reduces customers operational water consumption'
                    },
                    {
                      value:
                        'New product or service that reduces customers’ products/services commodity consumption',
                      label:
                        'New product or service that reduces customers’ products/services commodity consumption'
                    },
                    {
                      value:
                        'New product or service that reduces customers’ products/services operational emissions',
                      label:
                        'New product or service that reduces customers’ products/services operational emissions'
                    },
                    {value: 'Reduce packaging', label: 'Reduce packaging'},
                    {
                      value: 'Other innovation, please specify',
                      label: 'Other innovation, please specify'
                    },
                    {value: 'Logistical change', label: 'Logistical change'},
                    {
                      value: 'Change timing of logistics',
                      label: 'Change timing of logistics'
                    },
                    {
                      value:
                        'Change transportation mode (e.g., switch from aviation to rail)',
                      label:
                        'Change transportation mode (e.g., switch from aviation to rail)'
                    },
                    {
                      value: 'Consolidate logistics',
                      label: 'Consolidate logistics'
                    },
                    {value: 'Route optimization', label: 'Route optimization'},
                    {
                      value: 'Other logistical change, please specify',
                      label: 'Other logistical change, please specify'
                    },
                    {
                      value: 'Promote collective action',
                      label: 'Promote collective action'
                    },
                    {
                      value:
                        'Invite customer to collaborate with other users in their river basins to reduce impact',
                      label:
                        'Invite customer to collaborate with other users in their river basins to reduce impact'
                    },
                    {
                      value:
                        'Invite customer to collaborate in landscape or jurisdictional initiatives',
                      label:
                        'Invite customer to collaborate in landscape or jurisdictional initiatives'
                    },
                    {
                      value: 'Other collective action, please specify',
                      label: 'Other collective action, please specify'
                    },
                    {
                      value: 'Relationship sustainability assessment',
                      label: 'Relationship sustainability assessment'
                    },
                    {
                      value:
                        'Align goals to feed into customers targets and ambitions',
                      label:
                        'Align goals to feed into customers targets and ambitions'
                    },
                    {
                      value: 'Sustainability audit of existing relationship',
                      label: 'Sustainability audit of existing relationship'
                    },
                    {
                      value: 'Other assessment, please specify',
                      label: 'Other assessment, please specify'
                    },
                    {
                      value: 'Traceability and transparency',
                      label: 'Traceability and transparency'
                    },
                    {
                      value: 'Improve existing traceability system',
                      label: 'Improve existing traceability system'
                    },
                    {
                      value: 'New traceability system',
                      label: 'New traceability system'
                    },
                    {
                      value: 'Other traceability system, please specify',
                      label: 'Other traceability system, please specify'
                    },
                    {value: 'Other', label: 'Other'},
                    {
                      value: 'Other initiative type, please specify',
                      label: 'Other initiative type, please specify'
                    }
                  ],
                  colSpan: true
                },
                {
                  type: inputType.WYSIWYG,
                  fieldName:
                    CDP_SME_BUSINESS_STRATEGY_FIELD_NAMES.SME_BUSINESS_STRATEGY_Q7_6_VALUE,
                  fieldLabel: 'Details of initiative',
                  textLimit: 2500,
                  colSpan: true
                },
                {
                  type: inputType.SELECT_WITH_OTHER_TEXTBOX,
                  fieldName:
                    CDP_SME_BUSINESS_STRATEGY_FIELD_NAMES.SME_BUSINESS_STRATEGY_Q7_7_VALUE,
                  fieldLabel: 'Benefits achieved',
                  options: [
                    {
                      value: 'Higher incomes due to increased productivity',
                      label: 'Higher incomes due to increased productivity'
                    },
                    {
                      value: 'Improved resource use and efficiency',
                      label: 'Improved resource use and efficiency'
                    },
                    {
                      value: 'Improved water quality',
                      label: 'Improved water quality'
                    },
                    {
                      value: 'Improved water stewardship',
                      label: 'Improved water stewardship'
                    },
                    {
                      value: 'Increase in use of certified materials',
                      label: 'Increase in use of certified materials'
                    },
                    {
                      value:
                        'Increased transparency of upstream/downstream value chain',
                      label:
                        'Increased transparency of upstream/downstream value chain'
                    },
                    {
                      value: 'Lower price per unit',
                      label: 'Lower price per unit'
                    },
                    {
                      value:
                        'Price premiums for deforestation and conversion-free materials',
                      label:
                        'Price premiums for deforestation and conversion-free materials'
                    },
                    {
                      value:
                        'Reduction of customers’ operational emissions (customer scope 1 & 2)',
                      label:
                        'Reduction of customers’ operational emissions (customer scope 1 & 2)'
                    },
                    {
                      value:
                        'Reduction of own operational emissions (own scope 1 & 2)',
                      label:
                        'Reduction of own operational emissions (own scope 1 & 2)'
                    },
                    {
                      value:
                        'Reduction of downstream value chain emissions (own scope 3)',
                      label:
                        'Reduction of downstream value chain emissions (own scope 3)'
                    },
                    {
                      value:
                        'Reduction of customers’ operational water withdrawals and/or consumption',
                      label:
                        'Reduction of customers’ operational water withdrawals and/or consumption'
                    },
                    {
                      value:
                        'Reduction of own operational water withdrawals and/or consumption',
                      label:
                        'Reduction of own operational water withdrawals and/or consumption'
                    },
                    {
                      value:
                        'Reduction of downstream value chain water withdrawals and/or consumption',
                      label:
                        'Reduction of downstream value chain water withdrawals and/or consumption'
                    },
                    {
                      value: 'Other, please specify',
                      label: 'Other, please specify'
                    }
                  ],
                  colSpan: true
                },
                {
                  type: inputType.SELECT,
                  fieldName:
                    CDP_SME_BUSINESS_STRATEGY_FIELD_NAMES.SME_BUSINESS_STRATEGY_Q7_8_VALUE,
                  fieldLabel:
                    'Are you able to provide figures for emissions savings or water savings in the reporting year?',
                  options: [
                    {
                      label: 'Yes, emissions savings and water savings',
                      value: 'Yes, emissions savings and water savings'
                    },
                    {
                      label: 'Yes, emissions savings only',
                      value: 'Yes, emissions savings only'
                    },
                    {
                      label: 'Yes, water savings only',
                      value: 'Yes, water savings only'
                    },
                    {label: 'No', value: 'No'}
                  ],
                  colSpan: true
                },
                {
                  type: inputType.NUMBER,
                  fieldName:
                    CDP_SME_BUSINESS_STRATEGY_FIELD_NAMES.SME_BUSINESS_STRATEGY_Q7_9_VALUE,
                  fieldLabel:
                    'Estimated savings in the reporting year in metric tons of CO2e',
                  disabledOn: {
                    fieldName:
                      CDP_SME_BUSINESS_STRATEGY_FIELD_NAMES.SME_BUSINESS_STRATEGY_Q7_8_VALUE,
                    condition: conditionType.EQUALS,
                    values: ['No']
                  }
                },
                {
                  type: inputType.NUMBER,
                  fieldName:
                    CDP_SME_BUSINESS_STRATEGY_FIELD_NAMES.SME_BUSINESS_STRATEGY_Q7_10_VALUE,
                  fieldLabel:
                    'Estimated water savings in the reporting year in megaliters',
                  disabledOn: {
                    fieldName:
                      CDP_SME_BUSINESS_STRATEGY_FIELD_NAMES.SME_BUSINESS_STRATEGY_Q7_8_VALUE,
                    condition: conditionType.EQUALS,
                    values: ['No']
                  }
                },
                {
                  type: inputType.WYSIWYG,
                  fieldName:
                    CDP_SME_BUSINESS_STRATEGY_FIELD_NAMES.SME_BUSINESS_STRATEGY_Q7_11_VALUE,
                  fieldLabel:
                    'Please explain how success for this initiative is measured',
                  textLimit: 1500,
                  colSpan: true
                },
                {
                  type: inputType.RADIOGROUP,
                  fieldName:
                    CDP_SME_BUSINESS_STRATEGY_FIELD_NAMES.SME_BUSINESS_STRATEGY_Q7_12_VALUE,
                  fieldLabel: `Would you be happy for CDP Supply Chain members to highlight 
                               this work in their external communication?`,
                  options: ['Yes', 'No']
                }
              ]
            }
          }
        ]
      }
    ]
  }
];

export const smePerformanceConsolidationApproachQuestions = [
  {
    key: '1',
    showIndex: false,
    items: [
      {
        field: [
          {
            fieldType: inputType.HEADING,
            heading: `19.1 Select the consolidation approach used by your organization to determine 
                      the climate-related impacts that are reported on throughout your response.
                       Note that this option should align with your chosen approach for consolidating 
                       your GHG inventory.`
          },
          {
            fieldType: inputType.ADD_NEW_TO_TABLE,
            fieldName:
              CDP_SME_PER_APPROACH_FIELD_NAMES.SME_PER_APPROACH_Q1_VALUE,
            allowMultipleRows: false,
            formList: {
              formFields: [
                {
                  type: inputType.SELECT_WITH_OTHER_TEXTBOX,
                  fieldName:
                    CDP_SME_PER_APPROACH_FIELD_NAMES.SME_PER_APPROACH_Q1_1_VALUE,
                  fieldLabel: 'Consolidation approach used',
                  options: [
                    {
                      label: 'Operational control',
                      value: 'Operational control'
                    },
                    {label: 'Financial control', value: 'Financial control'},
                    {label: 'Equity share', value: 'Equity share'},
                    {
                      label: 'Approach is unknown used',
                      value: 'Approach is unknown used'
                    },
                    {
                      label: 'Other, please specify',
                      value: 'Other, please specify'
                    }
                  ],
                  colSpan: true,
                  showOtherTextBox: true,
                  otherFieldName:
                    CDP_SME_PER_APPROACH_FIELD_NAMES.SME_PER_APPROACH_Q1_1_VALUE
                },
                {
                  type: inputType.WYSIWYG,
                  fieldName:
                    CDP_SME_PER_APPROACH_FIELD_NAMES.SME_PER_APPROACH_Q1_2_VALUE,
                  fieldLabel:
                    'Provide the rationale for the choice of consolidation approach',
                  textLimit: 2500,
                  colSpan: true
                }
              ]
            }
          }
        ]
      }
    ]
  }
];

export const smePerformanceClimateChangeQuestions = [
  {
    key: '1',
    showIndex: false,
    items: [
      {
        field: [
          {
            fieldType: inputType.HEADING,
            heading: `20.1 Do you evaluate your organization’s greenhouse gas (GHG) emissions? 
                           (You can measure or estimate using a carbon accounting tool.)`
          },
          {
            fieldType: inputType.ADD_FIXED_ROW_TO_TABLE,
            fieldName:
              CDP_SME_PER_CLIMATE_CHANGE_FIELD_NAMES.SME_PER_CLIMATE_CHANGE_Q1_VALUE,
            fixedRows: [
              {
                id: 'Scope1',
                label:
                  'Scope 1 (direct emissions from owned or controlled activities)'
              },
              {
                id: 'Scope2',
                label:
                  'Scope 2 (indirect emissions from purchased electricity, heat, steam or cooling)'
              },
              {
                id: 'Scope3',
                label:
                  'Scope 3 (indirect emissions in upstream/downstream value chain)'
              }
            ],
            formList: {
              formFields: [
                {
                  type: inputType.SELECT,
                  fieldName:
                    CDP_SME_PER_CLIMATE_CHANGE_FIELD_NAMES.SME_PER_CLIMATE_CHANGE_Q1_1_VALUE,
                  fieldLabel: 'Emissions evaluated',
                  options: EMISSION_EVALUATION_OPTIONS,
                  colSpan: true
                },
                {
                  type: inputType.SELECT,
                  fieldName:
                    CDP_SME_PER_CLIMATE_CHANGE_FIELD_NAMES.SME_PER_CLIMATE_CHANGE_Q1_2_VALUE,
                  fieldLabel: 'Scope 2 approach',
                  options: SCOPE_2_APPROACH_OPTIONS,
                  colSpan: true
                },
                {
                  type: inputType.SELECT,
                  fieldName:
                    CDP_SME_PER_CLIMATE_CHANGE_FIELD_NAMES.SME_PER_CLIMATE_CHANGE_Q1_3_VALUE,
                  fieldLabel:
                    'Primary reason for not reporting a market-based figure',
                  options:
                    PRIMARY_REASON_FOR_NOT_REPORTING_A_MARKET_BASED_FIGURE_OPTIONS,
                  colSpan: true
                },
                {
                  type: inputType.RADIOGROUP,
                  fieldName:
                    CDP_SME_PER_CLIMATE_CHANGE_FIELD_NAMES.SME_PER_CLIMATE_CHANGE_Q1_4_VALUE,
                  fieldLabel: `Indicate whether you had any major barriers or challenges evaluating 
                  your emissions in the reporting year`,
                  options: ['Yes', 'No']
                },
                {
                  type: inputType.WYSIWYG,
                  fieldName:
                    CDP_SME_PER_CLIMATE_CHANGE_FIELD_NAMES.SME_PER_CLIMATE_CHANGE_Q1_5_VALUE,
                  fieldLabel:
                    'Please explain the major barriers or challenges in evaluating your emissions',
                  colSpan: true,
                  textLimit: 2500,
                  disabledOn: {
                    fieldName:
                      CDP_SME_PER_CLIMATE_CHANGE_FIELD_NAMES.SME_PER_CLIMATE_CHANGE_Q1_4_VALUE,
                    condition: conditionType.EQUALS,
                    values: ['No']
                  }
                },
                {
                  type: inputType.SELECT_WITH_OTHER_TEXTBOX,
                  fieldName:
                    CDP_SME_PER_CLIMATE_CHANGE_FIELD_NAMES.SME_PER_CLIMATE_CHANGE_Q1_6_VALUE,
                  fieldLabel:
                    'Main measures which have helped, or would help, to manage or resolve the challenges',
                  options:
                    MAIN_MEASURES_WHICH_HAVE_HELPED_OR_WOULD_HELP_TO_MANAGE_OR_RESOLVE_THE_CHALLENGES_OPTIONS,
                  colSpan: true,
                  disabledOn: {
                    fieldName:
                      CDP_SME_PER_CLIMATE_CHANGE_FIELD_NAMES.SME_PER_CLIMATE_CHANGE_Q1_4_VALUE,
                    condition: conditionType.EQUALS,
                    values: ['No']
                  }
                },
                {
                  type: inputType.SELECT_WITH_OTHER_TEXTBOX,
                  fieldName:
                    CDP_SME_PER_CLIMATE_CHANGE_FIELD_NAMES.SME_PER_CLIMATE_CHANGE_Q1_7_VALUE,
                  fieldLabel: 'Primary reason for not evaluating emissions',
                  options: PRIMARY_REASON_FOR_NOT_EVALUATING_EMISSIONS_OPTIONS,
                  colSpan: true
                },
                {
                  type: inputType.RADIOGROUP,
                  fieldName:
                    CDP_SME_PER_CLIMATE_CHANGE_FIELD_NAMES.SME_PER_CLIMATE_CHANGE_Q1_8_VALUE,
                  fieldLabel: `Indicate if you are providing emissions 
                               data for past reporting years`,
                  options: ['Yes', 'No']
                },
                {
                  type: inputType.SELECT,
                  fieldName:
                    CDP_SME_PER_CLIMATE_CHANGE_FIELD_NAMES.SME_PER_CLIMATE_CHANGE_Q1_9_VALUE,
                  fieldLabel:
                    'Number of past reporting years you will be providing emissions data for',
                  options: [
                    {label: 'year 1', value: 'year 1'},
                    {label: 'years 2', value: 'years 2'},
                    {label: 'years 3', value: 'years 3'},
                    {label: 'years 4', value: 'years 4'},
                    {label: 'years 5', value: 'years 5'}
                  ],
                  colSpan: true,
                  conditionalVisibility: {
                    dependsOn:
                      CDP_SME_PER_CLIMATE_CHANGE_FIELD_NAMES.SME_PER_CLIMATE_CHANGE_Q1_8_VALUE,
                    showWhen: 'No',
                    condition: conditionType.NOT
                  }
                }
              ]
            }
          }
        ]
      },
      {
        field: [
          {
            fieldType: inputType.HEADING,
            heading: `20.2 Select the standard, protocol,
                      or methodology used to collect activity data and calculate emissions.`,
            dependsOn:
              SCOPE_FIELD_NAMES.SME_PER_CLIMATE_CHANGE_Q1_1_VALUE_SCOPE1,
            showWhen: [
              'Yes, we use tailored in-house or paid-for resources to calculate them',
              'Yes, we use a generic tool to estimate them, please specify'
            ],
            relatedTableKey:
              CDP_SME_PER_CLIMATE_CHANGE_FIELD_NAMES.SME_PER_CLIMATE_CHANGE_Q1_VALUE
          },
          {
            fieldType: inputType.MULTISELECT,
            fieldName:
              CDP_SME_PER_CLIMATE_CHANGE_FIELD_NAMES.SME_PER_CLIMATE_CHANGE_Q2_1_VALUE,
            //  conditionalVisibility: {
            dependsOn:
              SCOPE_FIELD_NAMES.SME_PER_CLIMATE_CHANGE_Q1_1_VALUE_SCOPE1,
            showWhen: [
              'Yes, we use tailored in-house or paid-for resources to calculate them',
              'Yes, we use a generic tool to estimate them, please specify'
            ],
            relatedTableKey:
              CDP_SME_PER_CLIMATE_CHANGE_FIELD_NAMES.SME_PER_CLIMATE_CHANGE_Q1_VALUE,
            //       },
            options: PROTOCOL_OPTIONS
          }
        ]
      },
      {
        field: [
          {
            fieldType: inputType.HEADING,
            heading: `20.3 Are there any sources of Scope 1, Scope 2 or Scope 3 emissions 
                      attributed to the entities in scope but not included in your disclosure?`
          },
          {
            fieldType: inputType.RADIOGROUP,
            fieldName:
              CDP_SME_PER_CLIMATE_CHANGE_FIELD_NAMES.SME_PER_CLIMATE_CHANGE_Q3_1_VALUE,
            options: ['Yes', 'No']
          }
        ]
      },
      {
        field: [
          {
            fieldType: inputType.HEADING,
            heading: `20.3.1 Provide details of the sources of Scope 1, Scope 2
             or Scope 3 emissions in scope that are not included in your disclosure.`,
            conditionalVisibility: {
              dependsOn:
                CDP_SME_PER_CLIMATE_CHANGE_FIELD_NAMES.SME_PER_CLIMATE_CHANGE_Q3_1_VALUE,
              showWhen: 'Yes',
              condition: conditionType.EQUALS,
              fieldName:
                CDP_SME_PER_CLIMATE_CHANGE_FIELD_NAMES.SME_PER_CLIMATE_CHANGE_Q3_1_VALUE
            }
          },
          {
            fieldType: inputType.ADD_NEW_TO_TABLE,
            fieldName:
              CDP_SME_PER_CLIMATE_CHANGE_FIELD_NAMES.SME_PER_CLIMATE_CHANGE_Q4_VALUE,
            //   conditionalVisibility: {
            dependsOn:
              CDP_SME_PER_CLIMATE_CHANGE_FIELD_NAMES.SME_PER_CLIMATE_CHANGE_Q3_1_VALUE,
            showWhen: ['Yes'],
            relatedTableKey:
              CDP_SME_PER_CLIMATE_CHANGE_FIELD_NAMES.SME_PER_CLIMATE_CHANGE_Q3_1_VALUE,
            //  },
            formList: {
              formFields: [
                {
                  type: inputType.WYSIWYG,
                  fieldName:
                    CDP_SME_PER_CLIMATE_CHANGE_FIELD_NAMES.SME_PER_CLIMATE_CHANGE_Q4_1_VALUE,
                  fieldLabel: 'Source of excluded emissions',
                  textLimit: 2500,
                  colSpan: true
                },
                {
                  type: inputType.SELECT,
                  fieldName:
                    CDP_SME_PER_CLIMATE_CHANGE_FIELD_NAMES.SME_PER_CLIMATE_CHANGE_Q4_2_VALUE,
                  fieldLabel: 'Scope(s) or Scope 3 category(ies)',
                  options: [
                    {value: 'Scope 1', label: 'Scope 1'},
                    {
                      value: 'Scope 2 (location-based)',
                      label: 'Scope 2 (location-based)'
                    },
                    {
                      value: 'Scope 2 (market-based)',
                      label: 'Scope 2 (market-based)'
                    },
                    {
                      value: 'Scope 2 (approach unknown)',
                      label: 'Scope 2 (approach unknown)'
                    },
                    {
                      value: 'Scope 3: Purchased goods and services',
                      label: 'Scope 3: Purchased goods and services'
                    },
                    {
                      value: 'Scope 3: Capital goods',
                      label: 'Scope 3: Capital goods'
                    },
                    {
                      value:
                        'Scope 3: Fuel and energy-related activities (not included in Scopes 1 or 2)',
                      label:
                        'Scope 3: Fuel and energy-related activities (not included in Scopes 1 or 2)'
                    },
                    {
                      value:
                        'Scope 3: Upstream transportation and distribution',
                      label: 'Scope 3: Upstream transportation and distribution'
                    },
                    {
                      value: 'Scope 3: Waste generated in operations',
                      label: 'Scope 3: Waste generated in operations'
                    },
                    {
                      value: 'Scope 3: Business travel',
                      label: 'Scope 3: Business travel'
                    },
                    {
                      value: 'Scope 3: Employee commuting',
                      label: 'Scope 3: Employee commuting'
                    },
                    {
                      value: 'Scope 3: Upstream leased assets',
                      label: 'Scope 3: Upstream leased assets'
                    },
                    {
                      value:
                        'Scope 3: Downstream transportation and distribution',
                      label:
                        'Scope 3: Downstream transportation and distribution'
                    },
                    {
                      value: 'Scope 3: Processing of sold products',
                      label: 'Scope 3: Processing of sold products'
                    },
                    {
                      value: 'Scope 3: Use of sold products',
                      label: 'Scope 3: Use of sold products'
                    },
                    {
                      value: 'Scope 3: End-of-life treatment of sold products',
                      label: 'Scope 3: End-of-life treatment of sold products'
                    },
                    {
                      value: 'Scope 3: Downstream leased assets',
                      label: 'Scope 3: Downstream leased assets'
                    },
                    {
                      value: 'Scope 3: Franchises',
                      label: 'Scope 3: Franchises'
                    },
                    {
                      value: 'Scope 3: Investments',
                      label: 'Scope 3: Investments'
                    },
                    {
                      value: 'Scope 3: Other (upstream)',
                      label: 'Scope 3: Other (upstream)'
                    },
                    {
                      value: 'Scope 3: Other (downstream)',
                      label: 'Scope 3: Other (downstream)'
                    }
                  ],
                  colSpan: true
                },
                {
                  type: inputType.SELECT,
                  fieldName:
                    CDP_SME_PER_CLIMATE_CHANGE_FIELD_NAMES.SME_PER_CLIMATE_CHANGE_Q4_3_VALUE,
                  fieldLabel: 'Relevance of Scope 1 emissions from this source',
                  options: RELEVANCE_OF_SCOPE_OPTIONS,
                  colSpan: true,
                  disabledOn: {
                    fieldName:
                      CDP_SME_PER_CLIMATE_CHANGE_FIELD_NAMES.SME_PER_CLIMATE_CHANGE_Q4_2_VALUE,
                    condition: conditionType.NOT,
                    values: ['Scope 1']
                  }
                },
                {
                  type: inputType.SELECT,
                  fieldName:
                    CDP_SME_PER_CLIMATE_CHANGE_FIELD_NAMES.SME_PER_CLIMATE_CHANGE_Q4_4_VALUE,
                  fieldLabel:
                    'Relevance of location-based Scope 2 emissions from this source',
                  options: RELEVANCE_OF_SCOPE_OPTIONS,
                  colSpan: true,
                  disabledOn: {
                    fieldName:
                      CDP_SME_PER_CLIMATE_CHANGE_FIELD_NAMES.SME_PER_CLIMATE_CHANGE_Q4_2_VALUE,
                    condition: conditionType.NOT,
                    values: ['Scope 2 (location-based)']
                  }
                },
                {
                  type: inputType.SELECT,
                  fieldName:
                    CDP_SME_PER_CLIMATE_CHANGE_FIELD_NAMES.SME_PER_CLIMATE_CHANGE_Q4_5_VALUE,
                  fieldLabel:
                    'Relevance of market-based Scope 2 emissions from this source',
                  options: RELEVANCE_OF_SCOPE_OPTIONS,
                  colSpan: true,
                  disabledOn: {
                    fieldName:
                      CDP_SME_PER_CLIMATE_CHANGE_FIELD_NAMES.SME_PER_CLIMATE_CHANGE_Q4_2_VALUE,
                    condition: conditionType.NOT,
                    values: ['Scope 2 (market-based)']
                  }
                },
                {
                  type: inputType.SELECT,
                  fieldName:
                    CDP_SME_PER_CLIMATE_CHANGE_FIELD_NAMES.SME_PER_CLIMATE_CHANGE_Q4_6_VALUE,
                  fieldLabel:
                    'Relevance of Scope 2 (approach unknown) emissions from this source',
                  options: RELEVANCE_OF_SCOPE_OPTIONS,
                  colSpan: true,
                  disabledOn: {
                    fieldName:
                      CDP_SME_PER_CLIMATE_CHANGE_FIELD_NAMES.SME_PER_CLIMATE_CHANGE_Q4_2_VALUE,
                    condition: conditionType.NOT,
                    values: ['Scope 2 (approach unknown)']
                  }
                },
                {
                  type: inputType.SELECT,
                  fieldName:
                    CDP_SME_PER_CLIMATE_CHANGE_FIELD_NAMES.SME_PER_CLIMATE_CHANGE_Q4_7_VALUE,
                  fieldLabel: 'Relevance of Scope 3 emissions from this source',
                  options: RELEVANCE_OF_SCOPE_OPTIONS,
                  colSpan: true,
                  disabledOn: {
                    fieldName:
                      CDP_SME_PER_CLIMATE_CHANGE_FIELD_NAMES.SME_PER_CLIMATE_CHANGE_Q4_2_VALUE,
                    condition: conditionType.NOT,
                    values: [
                      'Scope 3: Purchased goods and services',
                      'Scope 3: Capital goods',
                      'Scope 3: Fuel and energy-related activities (not included in Scopes 1 or 2)',
                      'Scope 3: Upstream transportation and distribution',
                      'Scope 3: Waste generated in operations',
                      'Scope 3: Business travel',
                      'Scope 3: Employee commuting',
                      'Scope 3: Upstream leased assets',
                      'Scope 3: Downstream transportation and distribution',
                      'Scope 3: Processing of sold products',
                      'Scope 3: Use of sold products',
                      'Scope 3: End-of-life treatment of sold products',
                      'Scope 3: Downstream leased assets',
                      'Scope 3: Franchises',
                      'Scope 3: Investments',
                      'Scope 3: Other (upstream)',
                      'Scope 3: Other (downstream)'
                    ]
                  }
                },
                {
                  type: inputType.DATEPICKER,
                  fieldName:
                    CDP_SME_PER_CLIMATE_CHANGE_FIELD_NAMES.SME_PER_CLIMATE_CHANGE_Q4_8_VALUE,
                  fieldLabel: 'Date of completion of acquisition or merger',
                  dateFormat: 'DD-MM-YYYY',
                  disabledOn: {
                    fieldName:
                      CDP_SME_PER_CLIMATE_CHANGE_FIELD_NAMES.SME_PER_CLIMATE_CHANGE_Q4_3_VALUE,
                    condition: conditionType.NOT,
                    values: [
                      'Emissions excluded due to a recent acquisition or merger'
                    ]
                  }
                },
                {
                  type: inputType.NUMBER,
                  fieldName:
                    CDP_SME_PER_CLIMATE_CHANGE_FIELD_NAMES.SME_PER_CLIMATE_CHANGE_Q4_9_VALUE,
                  fieldLabel:
                    'Estimated percentage of total Scope 1+2 emissions this excluded source represents',
                  disabledOn: {
                    fieldName:
                      CDP_SME_PER_CLIMATE_CHANGE_FIELD_NAMES.SME_PER_CLIMATE_CHANGE_Q4_3_VALUE,
                    condition: conditionType.NOT,
                    values: [
                      'Emissions excluded due to a recent acquisition or merger',
                      'Emissions are not evaluated'
                    ]
                  }
                },
                {
                  type: inputType.NUMBER,
                  fieldName:
                    CDP_SME_PER_CLIMATE_CHANGE_FIELD_NAMES.SME_PER_CLIMATE_CHANGE_Q4_10_VALUE,
                  fieldLabel:
                    'Estimated percentage of total Scope 3 emissions this excluded source represents',
                  disabledOn: {
                    fieldName:
                      CDP_SME_PER_CLIMATE_CHANGE_FIELD_NAMES.SME_PER_CLIMATE_CHANGE_Q4_7_VALUE,
                    condition: conditionType.NOT,
                    values: [
                      'Emissions excluded due to a recent acquisition or merger',
                      'Emissions are not evaluated'
                    ]
                  }
                },
                {
                  type: inputType.WYSIWYG,
                  fieldName:
                    CDP_SME_PER_CLIMATE_CHANGE_FIELD_NAMES.SME_PER_CLIMATE_CHANGE_Q4_11_VALUE,
                  fieldLabel: 'Explain why this source is excluded',
                  textLimit: 2500,
                  colSpan: true
                },
                {
                  type: inputType.WYSIWYG,
                  fieldName:
                    CDP_SME_PER_CLIMATE_CHANGE_FIELD_NAMES.SME_PER_CLIMATE_CHANGE_Q4_12_VALUE,
                  fieldLabel:
                    'Explain how you estimated the percentage of emissions this excluded source represents',
                  colSpan: true,
                  textLimit: 2500,
                  disabledOn: {
                    fieldName:
                      CDP_SME_PER_CLIMATE_CHANGE_FIELD_NAMES.SME_PER_CLIMATE_CHANGE_Q4_9_VALUE,
                    condition: conditionType.NOT_EMPTY
                  }
                }
              ]
            }
          }
        ]
      },
      {
        field: [
          {
            fieldType: inputType.HEADING,
            heading:
              '20.4 What were your organization’s gross global Scope 1 emissions (tCO2e)?',
            conditionalVisibility: {
              dependsOn:
                CDP_SME_PER_CLIMATE_CHANGE_FIELD_NAMES.SME_PER_CLIMATE_CHANGE_Q1_VALUE,
              showWhen: [
                'Yes, we use tailored in-house or paid-for resources to calculate them',
                'Yes, we use a generic tool to estimate them, please specify'
              ],
              condition: conditionType.EQUALS,
              fieldName:
                SCOPE_FIELD_NAMES.SME_PER_CLIMATE_CHANGE_Q1_1_VALUE_SCOPE1
            }
          },
          {
            fieldType: inputType.ADD_NEW_TO_TABLE,
            fieldName:
              CDP_SME_PER_CLIMATE_CHANGE_FIELD_NAMES.SME_PER_CLIMATE_CHANGE_Q5_VALUE,
            allowMultipleRows: false,
            // conditionalVisibility: {
            dependsOn:
              SCOPE_FIELD_NAMES.SME_PER_CLIMATE_CHANGE_Q1_1_VALUE_SCOPE1,
            showWhen: [
              'Yes, we use tailored in-house or paid-for resources to calculate them',
              'Yes, we use a generic tool to estimate them, please specify'
            ],
            relatedTableKey:
              CDP_SME_PER_CLIMATE_CHANGE_FIELD_NAMES.SME_PER_CLIMATE_CHANGE_Q1_VALUE,
            //  },
            formList: {
              formFields: [
                {
                  type: inputType.SELECT,
                  fieldName:
                    CDP_SME_PER_CLIMATE_CHANGE_FIELD_NAMES.SME_PER_CLIMATE_CHANGE_Q5_1_VALUE,
                  fieldLabel: 'Year',
                  options: [
                    {label: 'Reporting year', value: 'Reporting year'},
                    {label: 'Past year 1', value: 'Past year 1'},
                    {label: 'Past year 2', value: 'Past year 2'},
                    {label: 'Past year 3', value: 'Past year 3'},
                    {label: 'Past year 4', value: 'Past year 4'},
                    {label: 'Past year 5', value: 'Past year 5'}
                  ],
                  colSpan: true
                },
                {
                  type: inputType.NUMBER,
                  fieldName:
                    CDP_SME_PER_CLIMATE_CHANGE_FIELD_NAMES.SME_PER_CLIMATE_CHANGE_Q5_2_VALUE,
                  fieldLabel:
                    'Gross global Scope 1 emissions (metric tons CO2e)'
                },
                {
                  type: inputType.DATEPICKER,
                  fieldName:
                    CDP_SME_PER_CLIMATE_CHANGE_FIELD_NAMES.SME_PER_CLIMATE_CHANGE_Q5_3_VALUE,
                  fieldLabel: 'End date',
                  dateFormat: 'DD-MM-YYYY'
                },
                {
                  type: inputType.WYSIWYG,
                  fieldName:
                    CDP_SME_PER_CLIMATE_CHANGE_FIELD_NAMES.SME_PER_CLIMATE_CHANGE_Q5_4_VALUE,
                  fieldLabel: 'Methodological details',
                  textLimit: 2500,
                  colSpan: true
                }
              ]
            }
          }
        ]
      },
      {
        field: [
          {
            fieldType: inputType.HEADING,
            heading:
              '20.5 What were your organization’s gross global Scope 2 emissions (tCO2e)?',
            conditionalVisibility: {
              dependsOn:
                CDP_SME_PER_CLIMATE_CHANGE_FIELD_NAMES.SME_PER_CLIMATE_CHANGE_Q1_VALUE,
              showWhen: [
                'Yes, we use tailored in-house or paid-for resources to calculate them',
                'Yes, we use a generic tool to estimate them, please specify'
              ],
              condition: conditionType.EQUALS,
              fieldName:
                SCOPE_FIELD_NAMES.SME_PER_CLIMATE_CHANGE_Q1_1_VALUE_SCOPE2
            }
          },
          {
            fieldType: inputType.ADD_NEW_TO_TABLE,
            fieldName:
              CDP_SME_PER_CLIMATE_CHANGE_FIELD_NAMES.SME_PER_CLIMATE_CHANGE_Q6_VALUE,
            allowMultipleRows: false,
            //    conditionalVisibility: {
            dependsOn:
              SCOPE_FIELD_NAMES.SME_PER_CLIMATE_CHANGE_Q1_1_VALUE_SCOPE2,
            showWhen: [
              'Yes, we use tailored in-house or paid-for resources to calculate them',
              'Yes, we use a generic tool to estimate them, please specify'
            ],
            relatedTableKey:
              CDP_SME_PER_CLIMATE_CHANGE_FIELD_NAMES.SME_PER_CLIMATE_CHANGE_Q1_VALUE,
            //   },
            formList: {
              formFields: [
                {
                  type: inputType.SELECT,
                  fieldName:
                    CDP_SME_PER_CLIMATE_CHANGE_FIELD_NAMES.SME_PER_CLIMATE_CHANGE_Q6_1_VALUE,
                  fieldLabel: 'Year',
                  options: [
                    {label: 'Reporting year', value: 'Reporting year'},
                    {label: 'Past year 1', value: 'Past year 1'},
                    {label: 'Past year 2', value: 'Past year 2'},
                    {label: 'Past year 3', value: 'Past year 3'},
                    {label: 'Past year 4', value: 'Past year 4'},
                    {label: 'Past year 5', value: 'Past year 5'}
                  ],
                  colSpan: true
                },
                {
                  type: inputType.NUMBER,
                  fieldName:
                    CDP_SME_PER_CLIMATE_CHANGE_FIELD_NAMES.SME_PER_CLIMATE_CHANGE_Q6_2_VALUE,
                  fieldLabel:
                    'Gross global Scope 2, location-based emissions (metric tons CO2e)'
                },
                {
                  type: inputType.NUMBER,
                  fieldName:
                    CDP_SME_PER_CLIMATE_CHANGE_FIELD_NAMES.SME_PER_CLIMATE_CHANGE_Q6_3_VALUE,
                  fieldLabel:
                    'Gross global Scope 2, market-based emissions (metric tons CO2e)'
                },
                {
                  type: inputType.NUMBER,
                  fieldName:
                    CDP_SME_PER_CLIMATE_CHANGE_FIELD_NAMES.SME_PER_CLIMATE_CHANGE_Q6_4_VALUE,
                  fieldLabel:
                    'Gross global Scope 2 emissions, approach unknown (metric tons CO2e)'
                },
                {
                  type: inputType.DATEPICKER,
                  fieldName:
                    CDP_SME_PER_CLIMATE_CHANGE_FIELD_NAMES.SME_PER_CLIMATE_CHANGE_Q6_5_VALUE,
                  fieldLabel: 'End date',
                  dateFormat: 'DD-MM-YYYY'
                },
                {
                  type: inputType.WYSIWYG,
                  fieldName:
                    CDP_SME_PER_CLIMATE_CHANGE_FIELD_NAMES.SME_PER_CLIMATE_CHANGE_Q6_6_VALUE,
                  fieldLabel: 'Methodological details',
                  textLimit: 2500,
                  colSpan: true
                }
              ]
            }
          }
        ]
      },
      {
        field: [
          {
            fieldType: inputType.HEADING,
            heading:
              '20.6 What was the % of revenue produced in the countries/areas reported in 14.7?',
            conditionalVisibility: {
              dependsOn:
                CDP_SME_PER_CLIMATE_CHANGE_FIELD_NAMES.SME_PER_CLIMATE_CHANGE_Q1_VALUE,
              showWhen: [
                'No, but we plan to within the next two years',
                'No, and do not plan to in the next two years'
              ],
              condition: conditionType.EQUALS,
              fieldName:
                SCOPE_FIELD_NAMES.SME_PER_CLIMATE_CHANGE_Q1_1_VALUE_SCOPE1
            }
          },
          {
            fieldType: inputType.ADD_NEW_TO_TABLE,
            fieldName:
              CDP_SME_PER_CLIMATE_CHANGE_FIELD_NAMES.SME_PER_CLIMATE_CHANGE_Q7_VALUE,
            allowMultipleRows: false,
            //    conditionalVisibility: {
            dependsOn:
              SCOPE_FIELD_NAMES.SME_PER_CLIMATE_CHANGE_Q1_1_VALUE_SCOPE1,
            showWhen: [
              'No, but we plan to within the next two years',
              'No, and do not plan to in the next two years'
            ],
            relatedTableKey:
              CDP_SME_PER_CLIMATE_CHANGE_FIELD_NAMES.SME_PER_CLIMATE_CHANGE_Q1_VALUE,
            //   },
            formList: {
              formFields: [
                {
                  type: inputType.SELECT,
                  fieldName:
                    CDP_SME_PER_CLIMATE_CHANGE_FIELD_NAMES.SME_PER_CLIMATE_CHANGE_Q7_1_VALUE,
                  fieldLabel: 'Country/area',
                  options: COUNTRY_OPTIONS,
                  colSpan: true
                },
                {
                  type: inputType.NUMBER,
                  fieldName:
                    CDP_SME_PER_CLIMATE_CHANGE_FIELD_NAMES.SME_PER_CLIMATE_CHANGE_Q7_2_VALUE,
                  fieldLabel: '% of total revenue produced in country/area'
                }
              ]
            }
          }
        ]
      },
      {
        field: [
          {
            fieldType: inputType.HEADING,
            heading: `20.7 Account for your organization’s gross global 
                      Scope 3 emissions, disclosing and explaining any exclusions.`,
            conditionalVisibility: {
              dependsOn:
                CDP_SME_PER_CLIMATE_CHANGE_FIELD_NAMES.SME_PER_CLIMATE_CHANGE_Q1_VALUE,
              showWhen: [
                'Yes, we use tailored in-house or paid-for resources to calculate them',
                'Yes, we use a generic tool to estimate them, please specify'
              ],
              condition: conditionType.EQUALS,
              fieldName:
                SCOPE_FIELD_NAMES.SME_PER_CLIMATE_CHANGE_Q1_1_VALUE_SCOPE3
            }
          },
          {
            fieldType: inputType.ADD_NEW_TO_TABLE,
            fieldName:
              CDP_SME_PER_CLIMATE_CHANGE_FIELD_NAMES.SME_PER_CLIMATE_CHANGE_Q8_VALUE,
            allowMultipleRows: false,
            //  conditionalVisibility: {
            dependsOn:
              SCOPE_FIELD_NAMES.SME_PER_CLIMATE_CHANGE_Q1_1_VALUE_SCOPE3,
            showWhen: [
              'Yes, we use tailored in-house or paid-for resources to calculate them',
              'Yes, we use a generic tool to estimate them, please specify'
            ],
            relatedTableKey:
              CDP_SME_PER_CLIMATE_CHANGE_FIELD_NAMES.SME_PER_CLIMATE_CHANGE_Q1_VALUE,
            //   },
            formList: {
              formFields: [
                {
                  type: inputType.SELECT,
                  fieldName:
                    CDP_SME_PER_CLIMATE_CHANGE_FIELD_NAMES.SME_PER_CLIMATE_CHANGE_Q8_1_VALUE,
                  fieldLabel: 'Scope 3 category',
                  options: [
                    {
                      value: 'Purchased goods and services',
                      label: 'Purchased goods and services'
                    },
                    {value: 'Capital goods', label: 'Capital goods'},
                    {
                      value:
                        'Fuel-and-energy-related activities (not included in Scope 1 or 2)',
                      label:
                        'Fuel-and-energy-related activities (not included in Scope 1 or 2)'
                    },
                    {
                      value: 'Upstream transportation and distribution',
                      label: 'Upstream transportation and distribution'
                    },
                    {
                      value: 'Waste generated in operations',
                      label: 'Waste generated in operations'
                    },
                    {value: 'Business travel', label: 'Business travel'},
                    {value: 'Employee commuting', label: 'Employee commuting'},
                    {
                      value: 'Upstream leased assets',
                      label: 'Upstream leased assets'
                    },
                    {
                      value: 'Downstream transportation and distribution',
                      label: 'Downstream transportation and distribution'
                    },
                    {
                      value: 'Processing of sold products',
                      label: 'Processing of sold products'
                    },
                    {
                      value: 'Use of sold products',
                      label: 'Use of sold products'
                    },
                    {
                      value: 'End of life treatment of sold products',
                      label: 'End of life treatment of sold products'
                    },
                    {
                      value: 'Downstream leased assets',
                      label: 'Downstream leased assets'
                    },
                    {value: 'Franchises', label: 'Franchises'},
                    {value: 'Investments', label: 'Investments'},
                    {value: 'Other (upstream)', label: 'Other (upstream)'},
                    {value: 'Other (downstream)', label: 'Other (downstream)'}
                  ],
                  colSpan: true
                },
                {
                  type: inputType.SELECT,
                  fieldName:
                    CDP_SME_PER_CLIMATE_CHANGE_FIELD_NAMES.SME_PER_CLIMATE_CHANGE_Q8_2_VALUE,
                  fieldLabel: 'Evaluation status',
                  options: [
                    {
                      label: 'Relevant, calculated',
                      value: 'Relevant, calculated'
                    },
                    {
                      label: 'Relevant, not yet calculated',
                      value: 'Relevant, not yet calculated'
                    },
                    {
                      label: 'Not relevant, calculated',
                      value: 'Not relevant, calculated'
                    },
                    {
                      label: 'Not relevant, explanation provided',
                      value: 'Not relevant, explanation provided'
                    },
                    {label: 'Not evaluated', value: 'Not evaluated'}
                  ],
                  colSpan: true
                },
                {
                  type: inputType.NUMBER,
                  fieldName:
                    CDP_SME_PER_CLIMATE_CHANGE_FIELD_NAMES.SME_PER_CLIMATE_CHANGE_Q8_3_VALUE,
                  fieldLabel: 'Emissions in reporting year (metric tons CO2e)'
                },
                {
                  type: inputType.WYSIWYG,
                  fieldName:
                    CDP_SME_PER_CLIMATE_CHANGE_FIELD_NAMES.SME_PER_CLIMATE_CHANGE_Q8_4_VALUE,
                  fieldLabel: 'Please explain',
                  textLimit: 2400,
                  colSpan: true
                }
              ]
            }
          }
        ]
      },
      {
        field: [
          {
            fieldType: inputType.HEADING,
            heading:
              '20.7.1 Disclose or restate your Scope 3 emissions data for previous years.',
            conditionalVisibility: {
              dependsOn:
                CDP_SME_PER_CLIMATE_CHANGE_FIELD_NAMES.SME_PER_CLIMATE_CHANGE_Q1_VALUE,
              showWhen: 'Yes',
              condition: conditionType.EQUALS,
              fieldName:
                SCOPE_FIELD_NAMES.SME_PER_CLIMATE_CHANGE_Q1_8_VALUE_SCOPE3
            }
          },
          {
            fieldType: inputType.ADD_NEW_TO_TABLE,
            fieldName:
              CDP_SME_PER_CLIMATE_CHANGE_FIELD_NAMES.SME_PER_CLIMATE_CHANGE_Q9_VALUE,
            allowMultipleRows: false,
            //  conditionalVisibility: {
            dependsOn:
              SCOPE_FIELD_NAMES.SME_PER_CLIMATE_CHANGE_Q1_8_VALUE_SCOPE3,
            showWhen: ['Yes'],
            relatedTableKey:
              CDP_SME_PER_CLIMATE_CHANGE_FIELD_NAMES.SME_PER_CLIMATE_CHANGE_Q1_VALUE,
            //   },
            formList: {
              formFields: [
                {
                  type: inputType.SELECT,
                  fieldName:
                    CDP_SME_PER_CLIMATE_CHANGE_FIELD_NAMES.SME_PER_CLIMATE_CHANGE_Q9_1_VALUE,
                  fieldLabel: 'Year',
                  options: [
                    {label: 'Past year 1', value: 'Past year 1'},
                    {label: 'Past year 2', value: 'Past year 2'},
                    {label: 'Past year 3', value: 'Past year 3'},
                    {label: 'Past year 4', value: 'Past year 4'},
                    {label: 'Past year 5', value: 'Past year 5'}
                  ],
                  colSpan: true
                },
                {
                  type: inputType.DATEPICKER,
                  fieldName:
                    CDP_SME_PER_CLIMATE_CHANGE_FIELD_NAMES.SME_PER_CLIMATE_CHANGE_Q9_2_VALUE,
                  fieldLabel: 'End date',
                  dateFormat: 'DD-MM-YYYY'
                },
                {
                  type: inputType.NUMBER,
                  fieldName:
                    CDP_SME_PER_CLIMATE_CHANGE_FIELD_NAMES.SME_PER_CLIMATE_CHANGE_Q9_3_VALUE,
                  fieldLabel:
                    'Scope 3: Purchased goods and services (metric tons CO2e)'
                },
                {
                  type: inputType.NUMBER,
                  fieldName:
                    CDP_SME_PER_CLIMATE_CHANGE_FIELD_NAMES.SME_PER_CLIMATE_CHANGE_Q9_4_VALUE,
                  fieldLabel: 'Scope 3: Capital goods (metric tons CO2e)'
                },
                {
                  type: inputType.NUMBER,
                  fieldName:
                    CDP_SME_PER_CLIMATE_CHANGE_FIELD_NAMES.SME_PER_CLIMATE_CHANGE_Q9_5_VALUE,
                  fieldLabel:
                    'Scope 3: Fuel and energy-related activities (not included in Scopes 1 or 2) (metric tons CO2e)'
                },
                {
                  type: inputType.NUMBER,
                  fieldName:
                    CDP_SME_PER_CLIMATE_CHANGE_FIELD_NAMES.SME_PER_CLIMATE_CHANGE_Q9_6_VALUE,
                  fieldLabel:
                    'Scope 3: Upstream transportation and distribution (metric tons CO2e)'
                },
                {
                  type: inputType.NUMBER,
                  fieldName:
                    CDP_SME_PER_CLIMATE_CHANGE_FIELD_NAMES.SME_PER_CLIMATE_CHANGE_Q9_7_VALUE,
                  fieldLabel:
                    'Scope 3: Waste generated in operations (metric tons CO2e)'
                },
                {
                  type: inputType.NUMBER,
                  fieldName:
                    CDP_SME_PER_CLIMATE_CHANGE_FIELD_NAMES.SME_PER_CLIMATE_CHANGE_Q9_8_VALUE,
                  fieldLabel: 'Scope 3: Business travel (metric tons CO2e)'
                },
                {
                  type: inputType.NUMBER,
                  fieldName:
                    CDP_SME_PER_CLIMATE_CHANGE_FIELD_NAMES.SME_PER_CLIMATE_CHANGE_Q9_9_VALUE,
                  fieldLabel: 'Scope 3: Employee commuting (metric tons CO2e)'
                },
                {
                  type: inputType.NUMBER,
                  fieldName:
                    CDP_SME_PER_CLIMATE_CHANGE_FIELD_NAMES.SME_PER_CLIMATE_CHANGE_Q9_10_VALUE,
                  fieldLabel:
                    'Scope 3: Upstream leased assets (metric tons CO2e)'
                },
                {
                  type: inputType.NUMBER,
                  fieldName:
                    CDP_SME_PER_CLIMATE_CHANGE_FIELD_NAMES.SME_PER_CLIMATE_CHANGE_Q9_11_VALUE,
                  fieldLabel:
                    'Scope 3: Downstream transportation and distribution (metric tons CO2e)'
                },
                {
                  type: inputType.NUMBER,
                  fieldName:
                    CDP_SME_PER_CLIMATE_CHANGE_FIELD_NAMES.SME_PER_CLIMATE_CHANGE_Q9_12_VALUE,
                  fieldLabel:
                    'Scope 3: Processing of sold products (metric tons CO2e)'
                },
                {
                  type: inputType.NUMBER,
                  fieldName:
                    CDP_SME_PER_CLIMATE_CHANGE_FIELD_NAMES.SME_PER_CLIMATE_CHANGE_Q9_13_VALUE,
                  fieldLabel: 'Scope 3: Use of sold products (metric tons CO2e)'
                },
                {
                  type: inputType.NUMBER,
                  fieldName:
                    CDP_SME_PER_CLIMATE_CHANGE_FIELD_NAMES.SME_PER_CLIMATE_CHANGE_Q9_14_VALUE,
                  fieldLabel:
                    'Scope 3: End of life treatment of sold products (metric tons CO2e)'
                },
                {
                  type: inputType.NUMBER,
                  fieldName:
                    CDP_SME_PER_CLIMATE_CHANGE_FIELD_NAMES.SME_PER_CLIMATE_CHANGE_Q9_15_VALUE,
                  fieldLabel:
                    'Scope 3: Downstream leased assets (metric tons CO2e)'
                },
                {
                  type: inputType.NUMBER,
                  fieldName:
                    CDP_SME_PER_CLIMATE_CHANGE_FIELD_NAMES.SME_PER_CLIMATE_CHANGE_Q9_16_VALUE,
                  fieldLabel: 'Scope 3: Franchises (metric tons CO2e)'
                },
                {
                  type: inputType.NUMBER,
                  fieldName:
                    CDP_SME_PER_CLIMATE_CHANGE_FIELD_NAMES.SME_PER_CLIMATE_CHANGE_Q9_17_VALUE,
                  fieldLabel: 'Scope 3: Investments (metric tons CO2e)'
                },
                {
                  type: inputType.NUMBER,
                  fieldName:
                    CDP_SME_PER_CLIMATE_CHANGE_FIELD_NAMES.SME_PER_CLIMATE_CHANGE_Q9_18_VALUE,
                  fieldLabel: 'Scope 3: Other (upstream) (metric tons CO2e)'
                },
                {
                  type: inputType.NUMBER,
                  fieldName:
                    CDP_SME_PER_CLIMATE_CHANGE_FIELD_NAMES.SME_PER_CLIMATE_CHANGE_Q9_19_VALUE,
                  fieldLabel: 'Scope 3: Other (downstream) (metric tons CO2e)'
                },
                {
                  type: inputType.WYSIWYG,
                  fieldName:
                    CDP_SME_PER_CLIMATE_CHANGE_FIELD_NAMES.SME_PER_CLIMATE_CHANGE_Q9_20_VALUE,
                  fieldLabel: 'Comment',
                  textLimit: 2400,
                  colSpan: true
                }
              ]
            }
          }
        ]
      },
      {
        field: [
          {
            fieldType: inputType.HEADING,
            heading:
              '20.8 Indicate the verification/assurance status that applies to your reported emissions.',
            conditionalVisibility: {
              dependsOn:
                CDP_SME_PER_CLIMATE_CHANGE_FIELD_NAMES.SME_PER_CLIMATE_CHANGE_Q1_VALUE,
              showWhen:
                'Yes, we use tailored in-house or paid-for resources to calculate them',
              condition: conditionType.EQUALS,
              fieldName:
                SCOPE_FIELD_NAMES.SME_PER_CLIMATE_CHANGE_Q1_1_VALUE_SCOPE1
            }
          },
          {
            fieldType: inputType.ADD_FIXED_ROW_TO_TABLE,
            fieldName:
              CDP_SME_PER_CLIMATE_CHANGE_FIELD_NAMES.SME_PER_CLIMATE_CHANGE_Q10_VALUE,
            scopeColumnTitle: 'Scope',
            fixedRows: [
              {
                id: 'Scope1',
                label:
                  'Scope 1 (direct emissions from owned or controlled activities)'
              },
              {
                id: 'Scope2',
                label:
                  'Scope 2 (indirect emissions from purchased electricity, heat, steam or cooling)'
              },
              {
                id: 'Scope3',
                label:
                  'Scope 3 (indirect emissions in upstream/downstream value chain)'
              }
            ],
            //    conditionalVisibility: {
            dependsOn:
              SCOPE_FIELD_NAMES.SME_PER_CLIMATE_CHANGE_Q1_1_VALUE_SCOPE1,
            showWhen: [
              'Yes, we use tailored in-house or paid-for resources to calculate them'
            ],
            relatedTableKey:
              CDP_SME_PER_CLIMATE_CHANGE_FIELD_NAMES.SME_PER_CLIMATE_CHANGE_Q1_VALUE,
            //     },
            formList: {
              formFields: [
                {
                  type: inputType.SELECT,
                  fieldName:
                    CDP_SME_PER_CLIMATE_CHANGE_FIELD_NAMES.SME_PER_CLIMATE_CHANGE_Q10_1_VALUE,
                  fieldLabel: 'Verification/assurance status',
                  options: [
                    {
                      label: 'No third-party verification or assurance',
                      value: 'No third-party verification or assurance'
                    },
                    {
                      label:
                        'Third-party verification or assurance process in place',
                      value:
                        'Third-party verification or assurance process in place'
                    }
                  ],
                  colSpan: true
                },
                {
                  type: inputType.FILEUPLOAD,
                  fieldName:
                    CDP_SME_PER_CLIMATE_CHANGE_FIELD_NAMES.SME_PER_CLIMATE_CHANGE_Q10_2_VALUE,
                  fieldLabel: 'Attach verification evidence/report (optional)',
                  disabledOn: {
                    fieldName:
                      CDP_SME_PER_CLIMATE_CHANGE_FIELD_NAMES.SME_PER_CLIMATE_CHANGE_Q10_1_VALUE,
                    condition: conditionType.EQUALS,
                    values: 'No third-party verification or assurance'
                  }
                }
              ]
            }
          }
        ]
      },
      {
        field: [
          {
            fieldType: inputType.HEADING,
            heading: `20.9 How do your gross global emissions (Scope 1 and 2 combined) 
                      for the reporting year compare to the previous reporting year?`,
            conditionalVisibility: {
              dependsOn:
                CDP_SME_PER_CLIMATE_CHANGE_FIELD_NAMES.SME_PER_CLIMATE_CHANGE_Q1_VALUE,
              showWhen: [
                'Yes, we use tailored in-house or paid-for resources to calculate them',
                'Yes, we use a generic tool to estimate them, please specify'
              ],
              condition: conditionType.EQUALS,
              fieldName:
                SCOPE_FIELD_NAMES.SME_PER_CLIMATE_CHANGE_Q1_1_VALUE_SCOPE1
            }
          },
          {
            fieldType: inputType.ADD_NEW_TO_TABLE,
            fieldName:
              CDP_SME_PER_CLIMATE_CHANGE_FIELD_NAMES.SME_PER_CLIMATE_CHANGE_Q11_VALUE,
            allowMultipleRows: false,
            //  conditionalVisibility: {
            dependsOn:
              SCOPE_FIELD_NAMES.SME_PER_CLIMATE_CHANGE_Q1_1_VALUE_SCOPE1,
            showWhen: [
              'Yes, we use tailored in-house or paid-for resources to calculate them',
              'Yes, we use a generic tool to estimate them, please specify'
            ],
            relatedTableKey:
              CDP_SME_PER_CLIMATE_CHANGE_FIELD_NAMES.SME_PER_CLIMATE_CHANGE_Q1_VALUE,
            //   },
            formList: {
              formFields: [
                {
                  type: inputType.SELECT,
                  fieldName:
                    CDP_SME_PER_CLIMATE_CHANGE_FIELD_NAMES.SME_PER_CLIMATE_CHANGE_Q11_1_VALUE,
                  fieldLabel: `How do your gross global emissions (Scope 1 and 2 combined) for the reporting year 
                               compare to those of the previous reporting year?`,
                  options: [
                    {label: 'Increased', value: 'Increased'},
                    {label: 'Decreased', value: 'Decreased'},
                    {
                      label: 'Remained the same overall',
                      value: 'Remained the same overall'
                    },
                    {
                      label:
                        'This is our first year of reporting, so we cannot compare to last year',
                      value:
                        'This is our first year of reporting, so we cannot compare to last year'
                    }
                  ],
                  colSpan: true
                },
                {
                  type: inputType.SELECT_WITH_OTHER_TEXTBOX,
                  fieldName:
                    CDP_SME_PER_CLIMATE_CHANGE_FIELD_NAMES.SME_PER_CLIMATE_CHANGE_Q11_2_VALUE,
                  fieldLabel: 'Reason',
                  options: [
                    {
                      value: 'Change in renewable energy consumption',
                      label: 'Change in renewable energy consumption'
                    },
                    {
                      value: 'Other emissions reduction activities',
                      label: 'Other emissions reduction activities'
                    },
                    {value: 'Divestment', label: 'Divestment'},
                    {value: 'Acquisitions', label: 'Acquisitions'},
                    {value: 'Mergers', label: 'Mergers'},
                    {value: 'Change in output', label: 'Change in output'},
                    {
                      value: 'Change in methodology',
                      label: 'Change in methodology'
                    },
                    {value: 'Change in boundary', label: 'Change in boundary'},
                    {
                      value: 'Change in physical operating conditions',
                      label: 'Change in physical operating conditions'
                    },
                    {value: 'Unidentified', label: 'Unidentified'},
                    {value: 'Other', label: 'Other'}
                  ],
                  colSpan: true,
                  disabledOn: {
                    fieldName:
                      CDP_SME_PER_CLIMATE_CHANGE_FIELD_NAMES.SME_PER_CLIMATE_CHANGE_Q11_1_VALUE,
                    condition: conditionType.EQUALS,
                    values:
                      'This is our first year of reporting, so we cannot compare to last year'
                  }
                },
                {
                  type: inputType.WYSIWYG,
                  fieldName:
                    CDP_SME_PER_CLIMATE_CHANGE_FIELD_NAMES.SME_PER_CLIMATE_CHANGE_Q11_3_VALUE,
                  fieldLabel: 'Please explain',
                  colSpan: true,
                  textLimit: 2000,
                  disabledOn: {
                    fieldName:
                      CDP_SME_PER_CLIMATE_CHANGE_FIELD_NAMES.SME_PER_CLIMATE_CHANGE_Q11_1_VALUE,
                    condition: conditionType.EQUALS,
                    values:
                      'This is our first year of reporting, so we cannot compare to last year'
                  }
                }
              ]
            }
          }
        ]
      },
      {
        field: [
          {
            fieldType: inputType.HEADING,
            heading:
              '20.10 Break down your total gross global Scope 1 emissions by business activity.',
            conditionalVisibility: {
              dependsOn:
                CDP_SME_PER_CLIMATE_CHANGE_FIELD_NAMES.SME_PER_CLIMATE_CHANGE_Q1_VALUE,
              showWhen: [
                'Yes, we use tailored in-house or paid-for resources to calculate them'
              ],
              condition: conditionType.EQUALS,
              fieldName:
                SCOPE_FIELD_NAMES.SME_PER_CLIMATE_CHANGE_Q1_1_VALUE_SCOPE1
            }
          },
          {
            fieldType: inputType.ADD_NEW_TO_TABLE,
            fieldName:
              CDP_SME_PER_CLIMATE_CHANGE_FIELD_NAMES.SME_PER_CLIMATE_CHANGE_Q12_VALUE,
            //  conditionalVisibility: {
            dependsOn:
              SCOPE_FIELD_NAMES.SME_PER_CLIMATE_CHANGE_Q1_1_VALUE_SCOPE1,
            showWhen: [
              'Yes, we use tailored in-house or paid-for resources to calculate them'
            ],
            relatedTableKey:
              CDP_SME_PER_CLIMATE_CHANGE_FIELD_NAMES.SME_PER_CLIMATE_CHANGE_Q1_VALUE,
            //  },
            formList: {
              formFields: [
                {
                  type: inputType.WYSIWYG,
                  fieldName:
                    CDP_SME_PER_CLIMATE_CHANGE_FIELD_NAMES.SME_PER_CLIMATE_CHANGE_Q12_1_VALUE,
                  fieldLabel: 'Activity',
                  textLimit: 500,
                  colSpan: true
                },
                {
                  type: inputType.NUMBER,
                  fieldName:
                    CDP_SME_PER_CLIMATE_CHANGE_FIELD_NAMES.SME_PER_CLIMATE_CHANGE_Q12_2_VALUE,
                  fieldLabel: 'Scope 1 Emission (metric ton co2e)'
                }
              ]
            }
          }
        ]
      },
      {
        field: [
          {
            fieldType: inputType.HEADING,
            heading:
              '20.11 Break down your total gross global Scope 2 emissions by business activity.',
            conditionalVisibility: {
              dependsOn:
                CDP_SME_PER_CLIMATE_CHANGE_FIELD_NAMES.SME_PER_CLIMATE_CHANGE_Q1_VALUE,
              showWhen: [
                'Yes, we use tailored in-house or paid-for resources to calculate them'
              ],
              condition: conditionType.EQUALS,
              fieldName:
                SCOPE_FIELD_NAMES.SME_PER_CLIMATE_CHANGE_Q1_1_VALUE_SCOPE2
            }
          },
          {
            fieldType: inputType.ADD_NEW_TO_TABLE,
            fieldName:
              CDP_SME_PER_CLIMATE_CHANGE_FIELD_NAMES.SME_PER_CLIMATE_CHANGE_Q13_VALUE,
            // conditionalVisibility: {
            dependsOn:
              SCOPE_FIELD_NAMES.SME_PER_CLIMATE_CHANGE_Q1_1_VALUE_SCOPE2,
            showWhen: [
              'Yes, we use tailored in-house or paid-for resources to calculate them'
            ],
            relatedTableKey:
              CDP_SME_PER_CLIMATE_CHANGE_FIELD_NAMES.SME_PER_CLIMATE_CHANGE_Q1_VALUE,
            //   },
            formList: {
              formFields: [
                {
                  type: inputType.WYSIWYG,
                  fieldName:
                    CDP_SME_PER_CLIMATE_CHANGE_FIELD_NAMES.SME_PER_CLIMATE_CHANGE_Q13_1_VALUE,
                  fieldLabel: 'Activity',
                  textLimit: 500,
                  colSpan: true
                },
                {
                  type: inputType.NUMBER,
                  fieldName:
                    CDP_SME_PER_CLIMATE_CHANGE_FIELD_NAMES.SME_PER_CLIMATE_CHANGE_Q13_2_VALUE,
                  fieldLabel: 'Scope 2, location-based (metric tons CO2e)'
                },
                {
                  type: inputType.NUMBER,
                  fieldName:
                    CDP_SME_PER_CLIMATE_CHANGE_FIELD_NAMES.SME_PER_CLIMATE_CHANGE_Q13_3_VALUE,
                  fieldLabel: 'Scope 2, market-based (metric tons CO2e)'
                }
              ]
            }
          }
        ]
      },
      {
        field: [
          {
            fieldType: inputType.HEADING,
            heading: `20.12 Allocate your emissions to listed customers according to 
                      the goods or services sold in this reporting period.`
          },
          {
            fieldType: inputType.ADD_NEW_TO_TABLE,
            fieldName:
              CDP_SME_PER_CLIMATE_CHANGE_FIELD_NAMES.SME_PER_CLIMATE_CHANGE_Q14_VALUE,
            formList: {
              formFields: [
                {
                  type: inputType.WYSIWYG,
                  fieldName:
                    CDP_SME_PER_CLIMATE_CHANGE_FIELD_NAMES.SME_PER_CLIMATE_CHANGE_Q14_1_VALUE,
                  fieldLabel: 'Requesting member',
                  colSpan: true
                },
                {
                  type: inputType.SELECT,
                  fieldName:
                    CDP_SME_PER_CLIMATE_CHANGE_FIELD_NAMES.SME_PER_CLIMATE_CHANGE_Q14_2_VALUE,
                  fieldLabel: 'Scope of emissions',
                  options: [
                    {label: 'Scope 1', value: 'Scope 1'},
                    {
                      label: 'Scope 2: location- based',
                      value: 'Scope 2: location- based'
                    },
                    {
                      label: 'Scope 2: market- based',
                      value: 'Scope 2: market- based'
                    },
                    {
                      label: 'Scope 2: approach unknown',
                      value: 'Scope 2: approach unknown'
                    },
                    {
                      label: 'Scope 3',
                      value: 'Scope 3'
                    }
                  ],
                  colSpan: true
                },
                {
                  type: inputType.SELECT,
                  fieldName:
                    CDP_SME_PER_CLIMATE_CHANGE_FIELD_NAMES.SME_PER_CLIMATE_CHANGE_Q14_3_VALUE,
                  fieldLabel: 'Scope 3 category(ies)',
                  options: [
                    {
                      value:
                        'Scope 3, Category 1 - Purchased goods and services',
                      label:
                        'Scope 3, Category 1 - Purchased goods and services'
                    },
                    {
                      value: 'Scope 3, Category 2 - Capital goods',
                      label: 'Scope 3, Category 2 - Capital goods'
                    },
                    {
                      value:
                        'Scope 3, Category 3 - Fuel- and energy- related activities (not included in Scope 1 or 2)',
                      label:
                        'Scope 3, Category 3 - Fuel- and energy- related activities (not included in Scope 1 or 2)'
                    },
                    {
                      value:
                        'Scope 3, Category 4 - Upstream transportation and distribution',
                      label:
                        'Scope 3, Category 4 - Upstream transportation and distribution'
                    },
                    {
                      value:
                        'Scope 3, Category 5 - Waste generated in operations',
                      label:
                        'Scope 3, Category 5 - Waste generated in operations'
                    },
                    {
                      value: 'Scope 3, Category 6 - Business travel',
                      label: 'Scope 3, Category 6 - Business travel'
                    },
                    {
                      value: 'Scope 3, Category 7 - Employee commuting',
                      label: 'Scope 3, Category 7 - Employee commuting'
                    },
                    {
                      value: 'Scope 3, Category 8 - Upstream leased assets',
                      label: 'Scope 3, Category 8 - Upstream leased assets'
                    },
                    {
                      value:
                        'Scope 3, Category 9 - Downstream transportation and distribution',
                      label:
                        'Scope 3, Category 9 - Downstream transportation and distribution'
                    },
                    {
                      value:
                        'Scope 3, Category 10 - Processing of sold products',
                      label:
                        'Scope 3, Category 10 - Processing of sold products'
                    },
                    {
                      value: 'Scope 3, Category 11 - Use of sold products',
                      label: 'Scope 3, Category 11 - Use of sold products'
                    },
                    {
                      value:
                        'Scope 3, Category 12 - End-of-life treatment of sold products',
                      label:
                        'Scope 3, Category 12 - End-of-life treatment of sold products'
                    },
                    {
                      value: 'Scope 3, Category 13 - Downstream leased assets',
                      label: 'Scope 3, Category 13 - Downstream leased assets'
                    },
                    {
                      value: 'Scope 3, Category 14 - Franchises',
                      label: 'Scope 3, Category 14 - Franchises'
                    },
                    {
                      value: 'Scope 3, Category 15 - Investments',
                      label: 'Scope 3, Category 15 - Investments'
                    },
                    {value: 'Other (upstream)', label: 'Other (upstream)'},
                    {value: 'Other (downstream)', label: 'Other (downstream)'}
                  ],
                  colSpan: true,
                  disabledOn: {
                    fieldName:
                      CDP_SME_PER_CLIMATE_CHANGE_FIELD_NAMES.SME_PER_CLIMATE_CHANGE_Q14_2_VALUE,
                    condition: conditionType.NOT,
                    values: ['Scope 3']
                  }
                },
                {
                  type: inputType.SELECT,
                  fieldName:
                    CDP_SME_PER_CLIMATE_CHANGE_FIELD_NAMES.SME_PER_CLIMATE_CHANGE_Q14_4_VALUE,
                  fieldLabel: 'Allocation level',
                  options: [
                    {label: 'Company wide', value: 'Company wide'},
                    {
                      label: 'Business unit (subsidiary company)',
                      value: 'Business unit (subsidiary company)'
                    },
                    {label: 'Facility', value: 'Facility'},
                    {label: 'Commodity', value: 'Commodity'}
                  ],
                  colSpan: true
                },
                {
                  type: inputType.WYSIWYG,
                  fieldName:
                    CDP_SME_PER_CLIMATE_CHANGE_FIELD_NAMES.SME_PER_CLIMATE_CHANGE_Q14_5_VALUE,
                  fieldLabel: 'Allocation level detail',
                  textLimit: 500,
                  colSpan: true,
                  disabledOn: {
                    fieldName:
                      CDP_SME_PER_CLIMATE_CHANGE_FIELD_NAMES.SME_PER_CLIMATE_CHANGE_Q14_4_VALUE,
                    condition: conditionType.EQUALS,
                    values: ['Company wide', 'Commodity']
                  }
                },
                {
                  type: inputType.SELECT,
                  fieldName:
                    CDP_SME_PER_CLIMATE_CHANGE_FIELD_NAMES.SME_PER_CLIMATE_CHANGE_Q14_6_VALUE,
                  fieldLabel: 'Allocation method',
                  options: [
                    {
                      value:
                        'Allocation not necessary due to type of primary data available',
                      label:
                        'Allocation not necessary due to type of primary data available'
                    },
                    {
                      value: 'Allocation not necessary as secondary data used',
                      label: 'Allocation not necessary as secondary data used'
                    },
                    {
                      value: 'Allocation based on mass of products purchased',
                      label: 'Allocation based on mass of products purchased'
                    },
                    {
                      value:
                        'Allocation based on the volume of products purchased',
                      label:
                        'Allocation based on the volume of products purchased'
                    },
                    {
                      value:
                        'Allocation based on the energy content of products purchased',
                      label:
                        'Allocation based on the energy content of products purchased'
                    },
                    {
                      value:
                        'Allocation based on the chemical content of products purchased',
                      label:
                        'Allocation based on the chemical content of products purchased'
                    },
                    {
                      value:
                        'Allocation based on the number of units purchased',
                      label: 'Allocation based on the number of units purchased'
                    },
                    {
                      value: 'Allocation based on area',
                      label: 'Allocation based on area'
                    },
                    {
                      value: 'Allocation based on another physical factor',
                      label: 'Allocation based on another physical factor'
                    },
                    {
                      value:
                        'Allocation based on the market value of products purchased',
                      label:
                        'Allocation based on the market value of products purchased'
                    },
                    {
                      value: 'Other allocation method, please specify',
                      label: 'Other allocation method, please specify'
                    }
                  ],
                  colSpan: true
                },
                {
                  type: inputType.SELECT,
                  fieldName:
                    CDP_SME_PER_CLIMATE_CHANGE_FIELD_NAMES.SME_PER_CLIMATE_CHANGE_Q14_7_VALUE,
                  fieldLabel:
                    'Unit for market value or quantity of goods/services supplied',
                  options: [
                    {value: 'Currency', label: 'Currency'},
                    {value: 'Kilograms', label: 'Kilograms'},
                    {value: 'Pounds (lb)', label: 'Pounds (lb)'},
                    {value: 'Metric tons', label: 'Metric tons'},
                    {value: 'Gallons', label: 'Gallons'},
                    {value: 'Liters', label: 'Liters'},
                    {value: 'Cubic feet', label: 'Cubic feet'},
                    {value: 'Cubic meters', label: 'Cubic meters'},
                    {value: 'Square meters', label: 'Square meters'},
                    {value: 'Hectares', label: 'Hectares'},
                    {
                      value: 'Full time equivalents (FTE)',
                      label: 'Full time equivalents (FTE)'
                    },
                    {value: 'Kilometers', label: 'Kilometers'},
                    {
                      value: 'Other unit, please specify',
                      label: 'Other unit, please specify'
                    }
                  ],
                  colSpan: true,
                  disabledOn: {
                    fieldName:
                      CDP_SME_PER_CLIMATE_CHANGE_FIELD_NAMES.SME_PER_CLIMATE_CHANGE_Q14_6_VALUE,
                    condition: conditionType.EQUALS,
                    values: [
                      'Allocation not necessary due to type of primary data available',
                      'Allocation not necessary as secondary data used'
                    ]
                  }
                },
                {
                  type: inputType.NUMBER,
                  fieldName:
                    CDP_SME_PER_CLIMATE_CHANGE_FIELD_NAMES.SME_PER_CLIMATE_CHANGE_Q14_8_VALUE,
                  fieldLabel:
                    'Market value or quantity of goods/services supplied to the requesting member (numerator)',
                  disabledOn: {
                    fieldName:
                      CDP_SME_PER_CLIMATE_CHANGE_FIELD_NAMES.SME_PER_CLIMATE_CHANGE_Q14_6_VALUE,
                    condition: conditionType.EQUALS,
                    values: [
                      'Allocation not necessary due to type of primary data available',
                      'Allocation not necessary as secondary data used'
                    ]
                  }
                },
                {
                  type: inputType.NUMBER,
                  fieldName:
                    CDP_SME_PER_CLIMATE_CHANGE_FIELD_NAMES.SME_PER_CLIMATE_CHANGE_Q14_9_VALUE,
                  fieldLabel: 'Emissions in metric tons of CO2e',
                  disabledOn: {
                    fieldName:
                      CDP_SME_PER_CLIMATE_CHANGE_FIELD_NAMES.SME_PER_CLIMATE_CHANGE_Q14_6_VALUE,
                    condition: conditionType.EQUALS,
                    values: [
                      'Allocation not necessary due to type of primary data available',
                      'Allocation not necessary as secondary data used'
                    ]
                  }
                },
                {
                  type: inputType.NUMBER,
                  fieldName:
                    CDP_SME_PER_CLIMATE_CHANGE_FIELD_NAMES.SME_PER_CLIMATE_CHANGE_Q14_10_VALUE,
                  fieldLabel: 'Uncertainty (± %)',
                  disabledOn: {
                    fieldName:
                      CDP_SME_PER_CLIMATE_CHANGE_FIELD_NAMES.SME_PER_CLIMATE_CHANGE_Q14_6_VALUE,
                    condition: conditionType.EQUALS,
                    values: [
                      'Allocation not necessary due to type of primary data available',
                      'Allocation not necessary as secondary data used'
                    ]
                  }
                },
                {
                  type: inputType.WYSIWYG,
                  fieldName:
                    CDP_SME_PER_CLIMATE_CHANGE_FIELD_NAMES.SME_PER_CLIMATE_CHANGE_Q14_11_VALUE,
                  fieldLabel: 'Major sources of emissions',
                  textLimit: 2500,
                  colSpan: true
                },
                {
                  type: inputType.SELECT,
                  fieldName:
                    CDP_SME_PER_CLIMATE_CHANGE_FIELD_NAMES.SME_PER_CLIMATE_CHANGE_Q14_12_VALUE,
                  fieldLabel: 'Allocation verified by a third party?',
                  options: [{label: 'Yes', value: 'Yes'}],
                  colSpan: true
                },
                {
                  type: inputType.WYSIWYG,
                  fieldName:
                    CDP_SME_PER_CLIMATE_CHANGE_FIELD_NAMES.SME_PER_CLIMATE_CHANGE_Q14_13_VALUE,
                  fieldLabel:
                    'Please explain how you have identified the GHG source, including major limitations to this process and assumptions made',
                  colSpan: true,
                  textLimit: 2500,
                  disabledOn: {
                    fieldName:
                      CDP_SME_PER_CLIMATE_CHANGE_FIELD_NAMES.SME_PER_CLIMATE_CHANGE_Q14_9_VALUE,
                    condition: conditionType.GREATER_THAN,
                    numericValue: 0
                  }
                },
                {
                  type: inputType.WYSIWYG,
                  fieldName:
                    CDP_SME_PER_CLIMATE_CHANGE_FIELD_NAMES.SME_PER_CLIMATE_CHANGE_Q14_14_VALUE,
                  fieldLabel:
                    'Where published information has been used, please provide a reference.',
                  textLimit: 2500,
                  colSpan: true
                }
              ]
            }
          }
        ]
      },
      {
        field: [
          {
            fieldType: inputType.HEADING,
            heading: `20.13 What are the challenges in allocating emissions to different customers, 
                     and what would help you to overcome these challenges?`
          },
          {
            fieldType: inputType.ADD_NEW_TO_TABLE,
            fieldName:
              CDP_SME_PER_CLIMATE_CHANGE_FIELD_NAMES.SME_PER_CLIMATE_CHANGE_Q15_VALUE,
            formList: {
              formFields: [
                {
                  type: inputType.SELECT,
                  fieldName:
                    CDP_SME_PER_CLIMATE_CHANGE_FIELD_NAMES.SME_PER_CLIMATE_CHANGE_Q15_1_VALUE,
                  fieldLabel: 'Allocation challenges',
                  options: [
                    {
                      label: `Diversity of product lines makes accurately 
                      accounting for each product/product line cost ineffective`,
                      value: `Diversity of product lines makes accurately 
                      accounting for each product/product line cost ineffective`
                    },
                    {
                      value:
                        'Customer base is too large and diverse to accurately track emissions to the customer level',
                      label:
                        'Customer base is too large and diverse to accurately track emissions to the customer level'
                    },
                    {
                      value: `Managing the different emission factors of diverse and numerous geographies
                             makes calculating total footprint difficult`,
                      label: `Managing the different emission factors of diverse and numerous geographies
                             makes calculating total footprint difficult`
                    },
                    {
                      value:
                        'Doing so would require we disclose business sensitive/proprietary information',
                      label:
                        'Doing so would require we disclose business sensitive/proprietary information'
                    },
                    {
                      value: 'We face no challenges',
                      label: 'We face no challenges'
                    },
                    {
                      value: 'Other, please specify',
                      label: 'Other, please specify'
                    }
                  ],

                  colSpan: true
                },
                {
                  type: inputType.WYSIWYG,
                  fieldName:
                    CDP_SME_PER_CLIMATE_CHANGE_FIELD_NAMES.SME_PER_CLIMATE_CHANGE_Q15_2_VALUE,
                  fieldLabel:
                    'Please explain what would help you overcome these challenges',
                  colSpan: true,
                  textLimit: 2500,
                  disabledOn: {
                    fieldName:
                      CDP_SME_PER_CLIMATE_CHANGE_FIELD_NAMES.SME_PER_CLIMATE_CHANGE_Q15_1_VALUE,
                    condition: conditionType.EQUALS,
                    values: ['We face no challenges']
                  }
                }
              ]
            }
          }
        ]
      },
      {
        field: [
          {
            fieldType: inputType.HEADING,
            heading:
              '20.14 Do you plan to develop capabilities to allocate emissions to your customers in the future?'
          },
          {
            fieldType: inputType.ADD_NEW_TO_TABLE,
            fieldName:
              CDP_SME_PER_CLIMATE_CHANGE_FIELD_NAMES.SME_PER_CLIMATE_CHANGE_Q16_VALUE,
            allowMultipleRows: false,
            formList: {
              formFields: [
                {
                  type: inputType.RADIOGROUP,
                  fieldName:
                    CDP_SME_PER_CLIMATE_CHANGE_FIELD_NAMES.SME_PER_CLIMATE_CHANGE_Q16_1_VALUE,
                  fieldLabel:
                    'Do you plan to develop your capabilities to allocate emissions to your customers in the future?',
                  options: ['Yes', 'No']
                },
                {
                  type: inputType.WYSIWYG,
                  fieldName:
                    CDP_SME_PER_CLIMATE_CHANGE_FIELD_NAMES.SME_PER_CLIMATE_CHANGE_Q16_2_VALUE,
                  fieldLabel:
                    'Describe how you plan to develop your capabilities',
                  colSpan: true,
                  textLimit: 5000,
                  disabledOn: {
                    fieldName:
                      CDP_SME_PER_CLIMATE_CHANGE_FIELD_NAMES.SME_PER_CLIMATE_CHANGE_Q16_1_VALUE,
                    condition: conditionType.EQUALS,
                    values: ['No']
                  }
                },
                {
                  type: inputType.SELECT,
                  fieldName:
                    CDP_SME_PER_CLIMATE_CHANGE_FIELD_NAMES.SME_PER_CLIMATE_CHANGE_Q16_3_VALUE,
                  fieldLabel:
                    'Primary reason for no plans to develop your capabilities to allocate emissions to your customers',
                  options: [
                    {
                      value:
                        'Lack of internal resources, capabilities, or expertise (e.g., due to organization size)',
                      label:
                        'Lack of internal resources, capabilities, or expertise (e.g., due to organization size)'
                    },
                    {
                      value: 'No standardized procedure',
                      label: 'No standardized procedure'
                    },
                    {
                      value: 'Not an immediate strategic priority',
                      label: 'Not an immediate strategic priority'
                    },
                    {
                      value: 'Judged to be unimportant or not relevant',
                      label: 'Judged to be unimportant or not relevant'
                    },
                    {
                      value:
                        'Capabilities to allocate emissions to customers already maximized',
                      label:
                        'Capabilities to allocate emissions to customers already maximized'
                    },
                    {
                      value: 'Other, please specify',
                      label: 'Other, please specify'
                    }
                  ],
                  colSpan: true,
                  disabledOn: {
                    fieldName:
                      CDP_SME_PER_CLIMATE_CHANGE_FIELD_NAMES.SME_PER_CLIMATE_CHANGE_Q16_1_VALUE,
                    condition: conditionType.EQUALS,
                    values: ['Yes']
                  }
                },
                {
                  type: inputType.WYSIWYG,
                  fieldName:
                    CDP_SME_PER_CLIMATE_CHANGE_FIELD_NAMES.SME_PER_CLIMATE_CHANGE_Q16_4_VALUE,
                  fieldLabel:
                    'Explain why you do not plan to develop capabilities to allocate emissions to your customers',
                  colSpan: true,
                  textLimit: 5000,
                  disabledOn: {
                    fieldName:
                      CDP_SME_PER_CLIMATE_CHANGE_FIELD_NAMES.SME_PER_CLIMATE_CHANGE_Q16_1_VALUE,
                    condition: conditionType.EQUALS,
                    values: ['Yes']
                  }
                }
              ]
            }
          }
        ]
      },
      {
        field: [
          {
            fieldType: inputType.HEADING,
            heading:
              '20.15 Does your organization break down its electricity consumption by country/area?'
          },
          {
            fieldType: inputType.RADIOGROUP,
            fieldName:
              CDP_SME_PER_CLIMATE_CHANGE_FIELD_NAMES.SME_PER_CLIMATE_CHANGE_Q17_VALUE,
            options: ['Yes', 'No']
          }
        ]
      },
      {
        field: [
          {
            fieldType: inputType.HEADING,
            heading:
              '20.15.1 Provide a breakdown by country/area of purchased/acquired electricity consumption (MWh).',
            conditionalVisibility: {
              dependsOn:
                CDP_SME_PER_CLIMATE_CHANGE_FIELD_NAMES.SME_PER_CLIMATE_CHANGE_Q17_VALUE,
              showWhen: 'Yes',
              condition: conditionType.EQUALS,
              fieldName:
                CDP_SME_PER_CLIMATE_CHANGE_FIELD_NAMES.SME_PER_CLIMATE_CHANGE_Q17_VALUE
            }
          },
          {
            fieldType: inputType.ADD_NEW_TO_TABLE,
            fieldName:
              CDP_SME_PER_CLIMATE_CHANGE_FIELD_NAMES.SME_PER_CLIMATE_CHANGE_Q18_VALUE,
            //   conditionalVisibility: {
            dependsOn:
              CDP_SME_PER_CLIMATE_CHANGE_FIELD_NAMES.SME_PER_CLIMATE_CHANGE_Q17_VALUE,
            showWhen: ['Yes'],
            relatedTableKey:
              CDP_SME_PER_CLIMATE_CHANGE_FIELD_NAMES.SME_PER_CLIMATE_CHANGE_Q17_VALUE,
            //   },
            formList: {
              formFields: [
                {
                  type: inputType.SELECT,
                  fieldName:
                    CDP_SME_PER_CLIMATE_CHANGE_FIELD_NAMES.SME_PER_CLIMATE_CHANGE_Q18_1_VALUE,
                  fieldLabel: 'Country/area',
                  options: COUNTRY_OPTIONS,
                  colSpan: true
                },
                {
                  type: inputType.NUMBER,
                  fieldName:
                    CDP_SME_PER_CLIMATE_CHANGE_FIELD_NAMES.SME_PER_CLIMATE_CHANGE_Q18_2_VALUE,
                  fieldLabel: 'MWh from renewable sources'
                },
                {
                  type: inputType.NUMBER,
                  fieldName:
                    CDP_SME_PER_CLIMATE_CHANGE_FIELD_NAMES.SME_PER_CLIMATE_CHANGE_Q18_3_VALUE,
                  fieldLabel: 'MWh from non-renewable sources'
                },
                {
                  type: inputType.DISPLAY_CALCULATION_IN_TABLE,
                  fieldName:
                    CDP_SME_PER_CLIMATE_CHANGE_FIELD_NAMES.SME_PER_CLIMATE_CHANGE_Q18_4_VALUE,
                  fieldLabel: 'Total (renewable + non-renewable) MWh',
                  relatedKey: [
                    CDP_SME_PER_CLIMATE_CHANGE_FIELD_NAMES.SME_PER_CLIMATE_CHANGE_Q18_2_VALUE,
                    CDP_SME_PER_CLIMATE_CHANGE_FIELD_NAMES.SME_PER_CLIMATE_CHANGE_Q18_3_VALUE
                  ],
                  formula: calculateSum
                },
                {
                  type: inputType.WYSIWYG,
                  fieldName:
                    CDP_SME_PER_CLIMATE_CHANGE_FIELD_NAMES.SME_PER_CLIMATE_CHANGE_Q18_5_VALUE,
                  fieldLabel: 'Comment',
                  textLimit: 2500,
                  colSpan: true
                }
              ]
            }
          }
        ]
      },
      {
        field: [
          {
            fieldType: inputType.HEADING,
            heading:
              '20.15.2 Report your organization’s consumption of purchased/acquired electricity (MWh).',
            conditionalVisibility: {
              dependsOn:
                CDP_SME_PER_CLIMATE_CHANGE_FIELD_NAMES.SME_PER_CLIMATE_CHANGE_Q17_VALUE,
              showWhen: 'No',
              condition: conditionType.EQUALS,
              fieldName:
                CDP_SME_PER_CLIMATE_CHANGE_FIELD_NAMES.SME_PER_CLIMATE_CHANGE_Q17_VALUE
            }
          },
          {
            fieldType: inputType.ADD_NEW_TO_TABLE,
            fieldName:
              CDP_SME_PER_CLIMATE_CHANGE_FIELD_NAMES.SME_PER_CLIMATE_CHANGE_Q19_VALUE,
            allowMultipleRows: false,
            //    conditionalVisibility: {
            dependsOn:
              CDP_SME_PER_CLIMATE_CHANGE_FIELD_NAMES.SME_PER_CLIMATE_CHANGE_Q17_VALUE,
            showWhen: ['No'],
            relatedTableKey:
              CDP_SME_PER_CLIMATE_CHANGE_FIELD_NAMES.SME_PER_CLIMATE_CHANGE_Q17_VALUE,
            // },
            formList: {
              formFields: [
                {
                  type: inputType.NUMBER,
                  fieldName:
                    CDP_SME_PER_CLIMATE_CHANGE_FIELD_NAMES.SME_PER_CLIMATE_CHANGE_Q19_1_VALUE,
                  fieldLabel: 'MWh from renewable sources'
                },
                {
                  type: inputType.NUMBER,
                  fieldName:
                    CDP_SME_PER_CLIMATE_CHANGE_FIELD_NAMES.SME_PER_CLIMATE_CHANGE_Q19_2_VALUE,
                  fieldLabel: 'MWh from non-renewable sources'
                },
                {
                  type: inputType.DISPLAY_CALCULATION_IN_TABLE,
                  fieldName:
                    CDP_SME_PER_CLIMATE_CHANGE_FIELD_NAMES.SME_PER_CLIMATE_CHANGE_Q19_3_VALUE,
                  fieldLabel: 'Total (renewable + nonrenewable) MWh',
                  relatedKey: [
                    CDP_SME_PER_CLIMATE_CHANGE_FIELD_NAMES.SME_PER_CLIMATE_CHANGE_Q19_1_VALUE,
                    CDP_SME_PER_CLIMATE_CHANGE_FIELD_NAMES.SME_PER_CLIMATE_CHANGE_Q19_2_VALUE
                  ],
                  formula: calculateSum
                },
                {
                  type: inputType.WYSIWYG,
                  fieldName:
                    CDP_SME_PER_CLIMATE_CHANGE_FIELD_NAMES.SME_PER_CLIMATE_CHANGE_Q19_4_VALUE,
                  fieldLabel: 'Comment',
                  textLimit: 2500,
                  colSpan: true
                }
              ]
            }
          }
        ]
      },
      {
        field: [
          {
            fieldType: inputType.HEADING,
            heading:
              '20.16 Did you have an emissions or other climate-related target active in the reporting year?',
            conditionalVisibility: {
              dependsOn:
                CDP_SME_PER_CLIMATE_CHANGE_FIELD_NAMES.SME_PER_CLIMATE_CHANGE_Q1_VALUE,
              showWhen: [
                'Yes, we use tailored in-house or paid-for resources to calculate them',
                'Yes, we use a generic tool to estimate them, please specify'
              ],
              condition: conditionType.EQUALS,
              fieldName:
                SCOPE_FIELD_NAMES.SME_PER_CLIMATE_CHANGE_Q1_1_VALUE_SCOPE1
            }
          },
          {
            fieldType: inputType.ADD_NEW_TO_TABLE,
            fieldName:
              CDP_SME_PER_CLIMATE_CHANGE_FIELD_NAMES.SME_PER_CLIMATE_CHANGE_Q20_VALUE,
            allowMultipleRows: false,
            //   conditionalVisibility: {
            dependsOn:
              SCOPE_FIELD_NAMES.SME_PER_CLIMATE_CHANGE_Q1_1_VALUE_SCOPE1,
            showWhen: [
              'Yes, we use tailored in-house or paid-for resources to calculate them',
              'Yes, we use a generic tool to estimate them, please specify'
            ],
            relatedTableKey:
              CDP_SME_PER_CLIMATE_CHANGE_FIELD_NAMES.SME_PER_CLIMATE_CHANGE_Q1_VALUE,
            // },
            formList: {
              formFields: [
                {
                  type: inputType.SELECT,
                  fieldName:
                    CDP_SME_PER_CLIMATE_CHANGE_FIELD_NAMES.SME_PER_CLIMATE_CHANGE_Q20_1_VALUE,
                  fieldLabel: 'Emissions or other climate-related target',
                  options: [
                    {
                      value: 'Absolute emissions target',
                      label: 'Absolute emissions target'
                    },
                    {
                      value: 'Emissions intensity target',
                      label: 'Emissions intensity target'
                    },
                    {
                      value:
                        'Target to increase or maintain low-carbon energy consumption or production',
                      label:
                        'Target to increase or maintain low-carbon energy consumption or production'
                    },
                    {
                      value: 'Target to reduce methane emissions',
                      label: 'Target to reduce methane emissions'
                    },
                    {value: 'Net-zero target', label: 'Net-zero target'},
                    {
                      value: 'Other climate-related target',
                      label: 'Other climate-related target'
                    },
                    {value: 'No target', label: 'No target'}
                  ],
                  colSpan: true
                },
                {
                  type: inputType.SELECT,
                  fieldName:
                    CDP_SME_PER_CLIMATE_CHANGE_FIELD_NAMES.SME_PER_CLIMATE_CHANGE_Q20_2_VALUE,
                  fieldLabel:
                    'Primary reason for not having an emissions or other climate-related target',
                  options: [
                    {
                      value:
                        'We are planning to introduce a target in the next two years',
                      label:
                        'We are planning to introduce a target in the next two years'
                    },
                    {
                      value: 'Important but not an immediate business priority',
                      label: 'Important but not an immediate business priority'
                    },
                    {
                      value: 'Judged to be unimportant, explanation provided',
                      label: 'Judged to be unimportant, explanation provided'
                    },
                    {
                      value: 'Lack of internal resources',
                      label: 'Lack of internal resources'
                    },
                    {
                      value: 'Insufficient data on operations',
                      label: 'Insufficient data on operations'
                    },
                    {
                      value: 'No instruction from management',
                      label: 'No instruction from management'
                    },
                    {
                      value: 'Other, please specify',
                      label: 'Other, please specify'
                    }
                  ],
                  colSpan: true,
                  disabledOn: {
                    fieldName:
                      CDP_SME_PER_CLIMATE_CHANGE_FIELD_NAMES.SME_PER_CLIMATE_CHANGE_Q20_1_VALUE,
                    condition: conditionType.NOT,
                    values: ['No target'],
                    required: true
                  }
                },
                {
                  type: inputType.WYSIWYG,
                  fieldName:
                    CDP_SME_PER_CLIMATE_CHANGE_FIELD_NAMES.SME_PER_CLIMATE_CHANGE_Q20_3_VALUE,
                  fieldLabel: 'Please explain',
                  textLimit: 2400,
                  colSpan: true,
                  disabledOn: {
                    fieldName:
                      CDP_SME_PER_CLIMATE_CHANGE_FIELD_NAMES.SME_PER_CLIMATE_CHANGE_Q20_1_VALUE,
                    condition: conditionType.NOT,
                    values: ['No target'],
                    required: true
                  }
                }
              ]
            }
          }
        ]
      },
      {
        field: [
          {
            fieldType: inputType.HEADING,
            heading:
              '20.16.1 Provide details of your absolute emissions targets and progress against those targets.',
            conditionalVisibility: {
              dependsOn:
                CDP_SME_PER_CLIMATE_CHANGE_FIELD_NAMES.SME_PER_CLIMATE_CHANGE_Q20_VALUE,
              showWhen: ['Absolute emissions target'],
              condition: conditionType.EQUALS,
              fieldName:
                CDP_SME_PER_CLIMATE_CHANGE_FIELD_NAMES.SME_PER_CLIMATE_CHANGE_Q20_1_VALUE
            }
          },
          {
            fieldType: inputType.ADD_NEW_TO_TABLE,
            fieldName:
              CDP_SME_PER_CLIMATE_CHANGE_FIELD_NAMES.SME_PER_CLIMATE_CHANGE_Q21_VALUE,
            //   conditionalVisibility: {
            dependsOn:
              CDP_SME_PER_CLIMATE_CHANGE_FIELD_NAMES.SME_PER_CLIMATE_CHANGE_Q20_1_VALUE,
            showWhen: ['Absolute emissions target'],
            relatedTableKey:
              CDP_SME_PER_CLIMATE_CHANGE_FIELD_NAMES.SME_PER_CLIMATE_CHANGE_Q20_VALUE,
            //   },
            formList: {
              formFields: [
                {
                  type: inputType.SELECT,
                  fieldName:
                    CDP_SME_PER_CLIMATE_CHANGE_FIELD_NAMES.SME_PER_CLIMATE_CHANGE_Q21_1_VALUE,
                  fieldLabel: 'Target reference number',
                  options: ABS_OPTIONS,
                  colSpan: true
                },
                {
                  type: inputType.DATEPICKER,
                  fieldName:
                    CDP_SME_PER_CLIMATE_CHANGE_FIELD_NAMES.SME_PER_CLIMATE_CHANGE_Q21_2_VALUE,
                  fieldLabel: 'Date target was set',
                  dateFormat: 'DD-MM-YYYY'
                },
                {
                  type: inputType.SELECT,
                  fieldName:
                    CDP_SME_PER_CLIMATE_CHANGE_FIELD_NAMES.SME_PER_CLIMATE_CHANGE_Q21_3_VALUE,
                  fieldLabel: 'Target coverage',
                  options: [
                    {value: 'Organization-wide', label: 'Organization-wide'},
                    {value: 'Business division', label: 'Business division'},
                    {value: 'Business activity', label: 'Business activity'},
                    {value: 'Site/facility', label: 'Site/facility'},
                    {
                      value: 'Country/area/region',
                      label: 'Country/area/region'
                    },
                    {value: 'Product-level', label: 'Product-level'},
                    {
                      value: 'Other, please specify',
                      label: 'Other, please specify'
                    }
                  ],
                  colSpan: true
                },
                {
                  type: inputType.SELECT,
                  fieldName:
                    CDP_SME_PER_CLIMATE_CHANGE_FIELD_NAMES.SME_PER_CLIMATE_CHANGE_Q21_4_VALUE,
                  fieldLabel: 'Scopes covered by target',
                  options: [
                    {
                      value:
                        'Scope 1 (direct emissions from owned or controlled activities)',
                      label:
                        'Scope 1 (direct emissions from owned or controlled activities)'
                    },
                    {
                      value:
                        'Scope 2 (indirect emissions from purchased electricity, heat, steam or cooling)',
                      label:
                        'Scope 2 (indirect emissions from purchased electricity, heat, steam or cooling)'
                    },
                    {
                      value:
                        'Scope 3 (indirect emissions in upstream/downstream value chain)',
                      label:
                        'Scope 3 (indirect emissions in upstream/downstream value chain)'
                    }
                  ],
                  colSpan: true
                },
                {
                  type: inputType.SELECT,
                  fieldName:
                    CDP_SME_PER_CLIMATE_CHANGE_FIELD_NAMES.SME_PER_CLIMATE_CHANGE_Q21_5_VALUE,
                  fieldLabel: 'Scope 2 accounting method ',
                  options: [
                    {label: 'Location-based', value: 'Location-based'},
                    {label: 'Market-based', value: 'Market-based'},
                    {label: 'Approach unknown', value: 'Approach unknown'}
                  ],
                  colSpan: true,
                  disabledOn: {
                    fieldName:
                      CDP_SME_PER_CLIMATE_CHANGE_FIELD_NAMES.SME_PER_CLIMATE_CHANGE_Q21_4_VALUE,
                    condition: conditionType.NOT,
                    values: [
                      'Scope 2 (indirect emissions from purchased electricity, heat, steam or cooling)'
                    ]
                  }
                },
                {
                  type: inputType.SELECT,
                  fieldName:
                    CDP_SME_PER_CLIMATE_CHANGE_FIELD_NAMES.SME_PER_CLIMATE_CHANGE_Q21_6_VALUE,
                  fieldLabel: 'Scope 3 categories ',
                  options: [
                    {
                      value:
                        'Scope 3, Category 1 – Purchased goods and services',
                      label:
                        'Scope 3, Category 1 – Purchased goods and services'
                    },
                    {
                      value: 'Scope 3, Category 2 – Capital goods',
                      label: 'Scope 3, Category 2 – Capital goods'
                    },
                    {
                      value:
                        'Scope 3, Category 3 – Fuel- and energy- related activities (not included in Scope 1 or 2)',
                      label:
                        'Scope 3, Category 3 – Fuel- and energy- related activities (not included in Scope 1 or 2)'
                    },
                    {
                      value:
                        'Scope 3, Category 4 – Upstream transportation and distribution',
                      label:
                        'Scope 3, Category 4 – Upstream transportation and distribution'
                    },
                    {
                      value:
                        'Scope 3, Category 5 – Waste generated in operations',
                      label:
                        'Scope 3, Category 5 – Waste generated in operations'
                    },
                    {
                      value: 'Scope 3, Category 6 – Business travel',
                      label: 'Scope 3, Category 6 – Business travel'
                    },
                    {
                      value: 'Scope 3, Category 7 – Employee commuting',
                      label: 'Scope 3, Category 7 – Employee commuting'
                    },
                    {
                      value: 'Scope 3, Category 8 - Upstream leased assets',
                      label: 'Scope 3, Category 8 - Upstream leased assets'
                    },
                    {
                      value:
                        'Scope 3, Category 9 – Downstream transportation and distribution',
                      label:
                        'Scope 3, Category 9 – Downstream transportation and distribution'
                    },
                    {
                      value:
                        'Scope 3, Category 10 – Processing of sold products',
                      label:
                        'Scope 3, Category 10 – Processing of sold products'
                    },
                    {
                      value: 'Scope 3, Category 11 – Use of sold products',
                      label: 'Scope 3, Category 11 – Use of sold products'
                    },
                    {
                      value:
                        'Scope 3, Category 12 – End-of-life treatment of sold products',
                      label:
                        'Scope 3, Category 12 – End-of-life treatment of sold products'
                    },
                    {
                      value: 'Scope 3, Category 13 – Downstream leased assets',
                      label: 'Scope 3, Category 13 – Downstream leased assets'
                    },
                    {
                      value: 'Scope 3, Category 14 – Franchises',
                      label: 'Scope 3, Category 14 – Franchises'
                    },
                    {
                      value: 'Scope 3, Category 15 – Investments',
                      label: 'Scope 3, Category 15 – Investments'
                    },
                    {value: 'Other (upstream)', label: 'Other (upstream)'},
                    {value: 'Other (downstream)', label: 'Other (downstream)'}
                  ],
                  colSpan: true,
                  disabledOn: {
                    fieldName:
                      CDP_SME_PER_CLIMATE_CHANGE_FIELD_NAMES.SME_PER_CLIMATE_CHANGE_Q21_4_VALUE,
                    condition: conditionType.NOT,
                    values: [
                      'Scope 3 (indirect emissions in upstream/downstream value chain)'
                    ]
                  }
                },
                {
                  type: inputType.DATEPICKER,
                  fieldName:
                    CDP_SME_PER_CLIMATE_CHANGE_FIELD_NAMES.SME_PER_CLIMATE_CHANGE_Q21_7_VALUE,
                  fieldLabel: 'End date of base year ',
                  dateFormat: 'DD-MM-YYYY'
                },
                {
                  type: inputType.NUMBER,
                  fieldName:
                    CDP_SME_PER_CLIMATE_CHANGE_FIELD_NAMES.SME_PER_CLIMATE_CHANGE_Q21_8_VALUE,
                  fieldLabel:
                    'Total base year emissions covered by target in all selected Scopes (metric tons CO2e)'
                },
                {
                  type: inputType.DATEPICKER,
                  fieldName:
                    CDP_SME_PER_CLIMATE_CHANGE_FIELD_NAMES.SME_PER_CLIMATE_CHANGE_Q21_9_VALUE,
                  fieldLabel: 'End date of target',
                  dateFormat: 'DD-MM-YYYY'
                },
                {
                  type: inputType.NUMBER,
                  fieldName:
                    CDP_SME_PER_CLIMATE_CHANGE_FIELD_NAMES.SME_PER_CLIMATE_CHANGE_Q21_10_VALUE,
                  fieldLabel: 'Targeted reduction from base year (%)'
                },
                {
                  type: inputType.DISPLAY_CALCULATION_IN_TABLE,
                  fieldName:
                    CDP_SME_PER_CLIMATE_CHANGE_FIELD_NAMES.SME_PER_CLIMATE_CHANGE_Q21_11_VALUE,
                  fieldLabel: `Total emissions at end date of target covered by target in all selected Scopes 
                  (metric tons CO2e)`,
                  relatedKey: [
                    CDP_SME_PER_CLIMATE_CHANGE_FIELD_NAMES.SME_PER_CLIMATE_CHANGE_Q21_8_VALUE,
                    CDP_SME_PER_CLIMATE_CHANGE_FIELD_NAMES.SME_PER_CLIMATE_CHANGE_Q21_10_VALUE
                  ],
                  formula: ([coveredByTarget, targetReduction]: any[]):
                    | number
                    | string => {
                    const emission = 100 - targetReduction;
                    const percentage = emission / 100;
                    const totalEmissions = coveredByTarget * percentage;

                    return totalEmissions;
                  }
                },
                {
                  type: inputType.NUMBER,
                  fieldName:
                    CDP_SME_PER_CLIMATE_CHANGE_FIELD_NAMES.SME_PER_CLIMATE_CHANGE_Q21_12_VALUE,
                  fieldLabel: `Total emissions in reporting year covered by target 
                               in all selected scopes (metric tons CO2e)`
                },
                {
                  type: inputType.DISPLAY_CALCULATION_IN_TABLE,
                  fieldName:
                    CDP_SME_PER_CLIMATE_CHANGE_FIELD_NAMES.SME_PER_CLIMATE_CHANGE_Q21_13_VALUE,
                  fieldLabel: '% of target achieved relative to base year',
                  relatedKey: [
                    CDP_SME_PER_CLIMATE_CHANGE_FIELD_NAMES.SME_PER_CLIMATE_CHANGE_Q21_8_VALUE,
                    CDP_SME_PER_CLIMATE_CHANGE_FIELD_NAMES.SME_PER_CLIMATE_CHANGE_Q21_10_VALUE,
                    CDP_SME_PER_CLIMATE_CHANGE_FIELD_NAMES.SME_PER_CLIMATE_CHANGE_Q21_12_VALUE
                  ],
                  formula: ([
                    coveredByTarget,
                    targetReduction,
                    totalEmissionsInReportingYear
                  ]: any[]): number | string => {
                    const emission =
                      coveredByTarget - totalEmissionsInReportingYear;

                    const percentage = targetReduction / 100;
                    const targetAchieved =
                      (emission / (percentage * coveredByTarget)) * 100;

                    return targetAchieved;
                  }
                },
                {
                  type: inputType.SELECT,
                  fieldName:
                    CDP_SME_PER_CLIMATE_CHANGE_FIELD_NAMES.SME_PER_CLIMATE_CHANGE_Q21_14_VALUE,
                  fieldLabel: 'Target status in reporting year',
                  options: [
                    {label: 'New', value: 'New'},
                    {label: 'Underway', value: 'Underway'},
                    {label: 'Achieved', value: 'Achieved'},
                    {
                      label: 'Achieved and maintained',
                      value: 'Achieved and maintained'
                    },
                    {label: 'Expired', value: 'Expired'},
                    {label: 'Revised', value: 'Revised'},
                    {label: 'Replaced', value: 'Replaced'},
                    {label: 'Retired', value: 'Retired'}
                  ],
                  colSpan: true
                },
                {
                  type: inputType.SELECT,
                  fieldName:
                    CDP_SME_PER_CLIMATE_CHANGE_FIELD_NAMES.SME_PER_CLIMATE_CHANGE_Q21_15_VALUE,
                  fieldLabel: 'Is this a science-based target?',
                  options: [
                    {
                      label:
                        'Yes, and this target has been approved by the Science Based Targets initiative',
                      value:
                        'Yes, and this target has been approved by the Science Based Targets initiative'
                    },
                    {
                      label: `Yes, we consider this a science-based target, and the target is currently
                       being reviewed by the Science Based Targets initiative`,
                      value: `Yes, we consider this a science-based target, and the target is currently
                       being reviewed by the Science Based Targets initiative`
                    },
                    {
                      value: `Yes, we consider this a science-based target, but we have not committed to seek validation
                              of this target by the Science Based Targets initiative within the next two years`,
                      label: `Yes, we consider this a science-based target, but we have not committed to seek validation
                              of this target by the Science Based Targets initiative within the next two years`
                    },
                    {
                      label:
                        'No, but we are reporting another target that is science-based',
                      value:
                        'No, but we are reporting another target that is science-based'
                    },
                    {
                      value:
                        'No, but we anticipate setting one in the next two years',
                      label:
                        'No, but we anticipate setting one in the next two years'
                    },
                    {
                      value:
                        'No, and we do not anticipate setting one in the next two years',
                      label:
                        'No, and we do not anticipate setting one in the next two years'
                    }
                  ],
                  colSpan: true
                },
                {
                  type: inputType.FILEUPLOAD,
                  fieldName:
                    CDP_SME_PER_CLIMATE_CHANGE_FIELD_NAMES.SME_PER_CLIMATE_CHANGE_Q21_16_VALUE,
                  fieldLabel:
                    'Science Based Targets initiative official validation letter',
                  disabledOn: {
                    fieldName:
                      CDP_SME_PER_CLIMATE_CHANGE_FIELD_NAMES.SME_PER_CLIMATE_CHANGE_Q21_15_VALUE,
                    condition: conditionType.NOT,
                    values: [
                      'Yes, and this target has been approved by the Science Based Targets initiative'
                    ]
                  }
                },
                {
                  type: inputType.WYSIWYG,
                  fieldName:
                    CDP_SME_PER_CLIMATE_CHANGE_FIELD_NAMES.SME_PER_CLIMATE_CHANGE_Q21_17_VALUE,
                  fieldLabel:
                    'Explain target coverage and identify any exclusions',
                  colSpan: true,
                  textLimit: 2500,
                  requiredOn: {
                    fieldName:
                      CDP_SME_PER_CLIMATE_CHANGE_FIELD_NAMES.SME_PER_CLIMATE_CHANGE_Q21_14_VALUE,
                    condition: conditionType.EQUALS,
                    values: ['Expired', 'Retired'],
                    required: true,
                    dependentValue:
                      CDP_SME_PER_CLIMATE_CHANGE_FIELD_NAMES.SME_PER_CLIMATE_CHANGE_Q21_14_VALUE
                  }
                }
              ]
            }
          }
        ]
      },
      {
        field: [
          {
            fieldType: inputType.HEADING,
            heading:
              '20.16.2 Provide details of your emissions intensity targets and progress against those targets.',
            conditionalVisibility: {
              dependsOn:
                CDP_SME_PER_CLIMATE_CHANGE_FIELD_NAMES.SME_PER_CLIMATE_CHANGE_Q20_VALUE,
              showWhen: ['Emissions intensity target'],
              condition: conditionType.EQUALS,
              fieldName:
                CDP_SME_PER_CLIMATE_CHANGE_FIELD_NAMES.SME_PER_CLIMATE_CHANGE_Q20_1_VALUE
            }
          },
          {
            fieldType: inputType.ADD_NEW_TO_TABLE,
            fieldName:
              CDP_SME_PER_CLIMATE_CHANGE_FIELD_NAMES.SME_PER_CLIMATE_CHANGE_Q22_VALUE,
            //        conditionalVisibility: {
            dependsOn:
              CDP_SME_PER_CLIMATE_CHANGE_FIELD_NAMES.SME_PER_CLIMATE_CHANGE_Q20_1_VALUE,
            showWhen: ['Emissions intensity target'],
            relatedTableKey:
              CDP_SME_PER_CLIMATE_CHANGE_FIELD_NAMES.SME_PER_CLIMATE_CHANGE_Q20_VALUE,
            //   },
            formList: {
              formFields: [
                {
                  type: inputType.SELECT,
                  fieldName:
                    CDP_SME_PER_CLIMATE_CHANGE_FIELD_NAMES.SME_PER_CLIMATE_CHANGE_Q22_1_VALUE,
                  fieldLabel: 'Target reference number ',
                  options: INT_OPTIONS,
                  colSpan: true
                },
                {
                  type: inputType.DATEPICKER,
                  fieldName:
                    CDP_SME_PER_CLIMATE_CHANGE_FIELD_NAMES.SME_PER_CLIMATE_CHANGE_Q22_2_VALUE,
                  fieldLabel: 'Date target was set',
                  dateFormat: 'DD-MM-YYYY'
                },
                {
                  type: inputType.SELECT,
                  fieldName:
                    CDP_SME_PER_CLIMATE_CHANGE_FIELD_NAMES.SME_PER_CLIMATE_CHANGE_Q22_3_VALUE,
                  fieldLabel: 'Target coverage',
                  options: [
                    {value: 'Organization-wide', label: 'Organization-wide'},
                    {value: 'Business division', label: 'Business division'},
                    {value: 'Business activity', label: 'Business activity'},
                    {value: 'Site/facility', label: 'Site/facility'},
                    {
                      value: 'Country/area/region',
                      label: 'Country/area/region'
                    },
                    {value: 'Product-level', label: 'Product-level'},
                    {
                      value: 'Other, please specify',
                      label: 'Other, please specify'
                    }
                  ],
                  colSpan: true
                },
                {
                  type: inputType.SELECT,
                  fieldName:
                    CDP_SME_PER_CLIMATE_CHANGE_FIELD_NAMES.SME_PER_CLIMATE_CHANGE_Q22_4_VALUE,
                  fieldLabel: 'Scopes covered by target',
                  options: [
                    {
                      value:
                        'Scope 1 (direct emissions from owned or controlled activities)',
                      label:
                        'Scope 1 (direct emissions from owned or controlled activities)'
                    },
                    {
                      value:
                        'Scope 2 (indirect emissions from purchased electricity, heat, steam or cooling)',
                      label:
                        'Scope 2 (indirect emissions from purchased electricity, heat, steam or cooling)'
                    },
                    {
                      value:
                        'Scope 3 (indirect emissions in upstream/downstream value chain)',
                      label:
                        'Scope 3 (indirect emissions in upstream/downstream value chain)'
                    }
                  ],
                  colSpan: true
                },
                {
                  type: inputType.SELECT,
                  fieldName:
                    CDP_SME_PER_CLIMATE_CHANGE_FIELD_NAMES.SME_PER_CLIMATE_CHANGE_Q22_5_VALUE,
                  fieldLabel: 'Scope 2 accounting method ',
                  options: [
                    {label: 'Location-based', value: 'Location-based'},
                    {label: 'Market-based', value: 'Market-based'},
                    {label: 'Approach unknown', value: 'Approach unknown'}
                  ],
                  colSpan: true,
                  disabledOn: {
                    fieldName:
                      CDP_SME_PER_CLIMATE_CHANGE_FIELD_NAMES.SME_PER_CLIMATE_CHANGE_Q22_4_VALUE,
                    condition: conditionType.NOT,
                    values: [
                      'Scope 2 (indirect emissions from purchased electricity, heat, steam or cooling)'
                    ]
                  }
                },
                {
                  type: inputType.SELECT,
                  fieldName:
                    CDP_SME_PER_CLIMATE_CHANGE_FIELD_NAMES.SME_PER_CLIMATE_CHANGE_Q22_6_VALUE,
                  fieldLabel: 'Scope 3 categories ',
                  options: [
                    {
                      value:
                        'Scope 3, Category 1 – Purchased goods and services',
                      label:
                        'Scope 3, Category 1 – Purchased goods and services'
                    },
                    {
                      value: 'Scope 3, Category 2 – Capital goods',
                      label: 'Scope 3, Category 2 – Capital goods'
                    },
                    {
                      value:
                        'Scope 3, Category 3 – Fuel- and energy- related activities (not included in Scope 1 or 2)',
                      label:
                        'Scope 3, Category 3 – Fuel- and energy- related activities (not included in Scope 1 or 2)'
                    },
                    {
                      value:
                        'Scope 3, Category 4 – Upstream transportation and distribution',
                      label:
                        'Scope 3, Category 4 – Upstream transportation and distribution'
                    },
                    {
                      value:
                        'Scope 3, Category 5 – Waste generated in operations',
                      label:
                        'Scope 3, Category 5 – Waste generated in operations'
                    },
                    {
                      value: 'Scope 3, Category 6 – Business travel',
                      label: 'Scope 3, Category 6 – Business travel'
                    },
                    {
                      value: 'Scope 3, Category 7 – Employee commuting',
                      label: 'Scope 3, Category 7 – Employee commuting'
                    },
                    {
                      value: 'Scope 3, Category 8 - Upstream leased assets',
                      label: 'Scope 3, Category 8 - Upstream leased assets'
                    },
                    {
                      value:
                        'Scope 3, Category 9 – Downstream transportation and distribution',
                      label:
                        'Scope 3, Category 9 – Downstream transportation and distribution'
                    },
                    {
                      value:
                        'Scope 3, Category 10 – Processing of sold products',
                      label:
                        'Scope 3, Category 10 – Processing of sold products'
                    },
                    {
                      value: 'Scope 3, Category 11 – Use of sold products',
                      label: 'Scope 3, Category 11 – Use of sold products'
                    },
                    {
                      value:
                        'Scope 3, Category 12 – End-of-life treatment of sold products',
                      label:
                        'Scope 3, Category 12 – End-of-life treatment of sold products'
                    },
                    {
                      value: 'Scope 3, Category 13 – Downstream leased assets',
                      label: 'Scope 3, Category 13 – Downstream leased assets'
                    },
                    {
                      value: 'Scope 3, Category 14 – Franchises',
                      label: 'Scope 3, Category 14 – Franchises'
                    },
                    {
                      value: 'Scope 3, Category 15 – Investments',
                      label: 'Scope 3, Category 15 – Investments'
                    },
                    {value: 'Other (upstream)', label: 'Other (upstream)'},
                    {value: 'Other (downstream)', label: 'Other (downstream)'}
                  ],
                  colSpan: true,
                  disabledOn: {
                    fieldName:
                      CDP_SME_PER_CLIMATE_CHANGE_FIELD_NAMES.SME_PER_CLIMATE_CHANGE_Q22_4_VALUE,
                    condition: conditionType.NOT,
                    values: [
                      'Scope 3 (indirect emissions in upstream/downstream value chain)'
                    ]
                  }
                },
                {
                  type: inputType.SELECT,
                  fieldName:
                    CDP_SME_PER_CLIMATE_CHANGE_FIELD_NAMES.SME_PER_CLIMATE_CHANGE_Q22_7_VALUE,
                  fieldLabel: 'Intensity metric (7)',
                  options: [
                    {
                      label: 'Grams CO2e per revenue passenger kilometer',
                      value: 'Grams CO2e per revenue passenger kilometer'
                    },
                    {
                      label: 'Metric tons CO2e per USD($) value-added',
                      value: 'Metric tons CO2e per USD($) value-added'
                    },
                    {
                      label: 'Metric tons CO2e per square meter',
                      value: 'Metric tons CO2e per square meter'
                    },
                    {
                      label: 'Metric tons CO2e per metric ton of aluminum',
                      value: 'Metric tons CO2e per metric ton of aluminum'
                    },
                    {
                      label: 'Metric tons CO2e per metric ton of steel',
                      value: 'Metric tons CO2e per metric ton of steel'
                    },
                    {
                      label: 'Metric tons CO2e per metric ton of cement',
                      value: 'Metric tons CO2e per metric ton of cement'
                    },
                    {
                      label: 'Metric tons CO2e per metric ton of cardboard',
                      value: 'Metric tons CO2e per metric ton of cardboard'
                    },
                    {
                      label: 'Grams CO2e per kilometer',
                      value: 'Grams CO2e per kilometer'
                    },
                    {
                      label: 'Metric tons CO2e per unit revenue',
                      value: 'Metric tons CO2e per unit revenue'
                    },
                    {
                      label: 'Metric tons CO2e per unit FTE employee',
                      value: 'Metric tons CO2e per unit FTE employee'
                    },
                    {
                      label: 'Metric tons CO2e per unit hour worked',
                      value: 'Metric tons CO2e per unit hour worked'
                    },
                    {
                      label: 'Metric tons CO2e per metric ton of product',
                      value: 'Metric tons CO2e per metric ton of product'
                    },
                    {
                      label: 'Metric tons of CO2e per liter of product',
                      value: 'Metric tons of CO2e per liter of product'
                    },
                    {
                      label: 'Metric tons CO2e per unit of production',
                      value: 'Metric tons CO2e per unit of production'
                    },
                    {
                      label: 'Metric tons CO2e per unit of service provided',
                      value: 'Metric tons CO2e per unit of service provided'
                    },
                    {
                      label: 'Metric tons CO2e per square foot',
                      value: 'Metric tons CO2e per square foot'
                    },
                    {
                      label: 'Metric tons CO2e per kilometer',
                      value: 'Metric tons CO2e per kilometer'
                    },
                    {
                      label: 'Metric tons CO2e per passenger kilometer',
                      value: 'Metric tons CO2e per passenger kilometer'
                    },
                    {
                      label: 'Metric tons CO2e per megawatt hour (MWh)',
                      value: 'Metric tons CO2e per megawatt hour (MWh)'
                    },
                    {
                      label:
                        'Metric tons CO2e per barrel of oil equivalent (BOE)',
                      value:
                        'Metric tons CO2e per barrel of oil equivalent (BOE)'
                    },
                    {
                      label: 'Metric tons CO2e per vehicle produced',
                      value: 'Metric tons CO2e per vehicle produced'
                    },
                    {
                      label: 'Metric tons CO2e per metric ton of ore processed',
                      value: 'Metric tons CO2e per metric ton of ore processed'
                    },
                    {
                      label: 'Metric tons CO2e per ounce of gold',
                      value: 'Metric tons CO2e per ounce of gold'
                    },
                    {
                      label: 'Metric tons CO2e per ounce of platinum',
                      value: 'Metric tons CO2e per ounce of platinum'
                    },
                    {
                      label: 'Metric tons of CO2e per metric ton of aggregate',
                      value: 'Metric tons of CO2e per metric ton of aggregate'
                    },
                    {
                      label:
                        'Metric tons of CO2e per billion (currency) funds under management',
                      value:
                        'Metric tons of CO2e per billion (currency) funds under management'
                    },
                    {
                      label: 'Other, please specify',
                      value: 'Other, please specify'
                    }
                  ],
                  colSpan: true
                },
                {
                  type: inputType.DATEPICKER,
                  fieldName:
                    CDP_SME_PER_CLIMATE_CHANGE_FIELD_NAMES.SME_PER_CLIMATE_CHANGE_Q22_8_VALUE,
                  fieldLabel: 'End date of base year',
                  dateFormat: 'DD-MM-YYYY'
                },
                {
                  type: inputType.NUMBER,
                  fieldName:
                    CDP_SME_PER_CLIMATE_CHANGE_FIELD_NAMES.SME_PER_CLIMATE_CHANGE_Q22_9_VALUE,
                  fieldLabel:
                    'Intensity figure in base year for all selected Scopes ',
                  disabledOn: {
                    fieldName:
                      CDP_SME_PER_CLIMATE_CHANGE_FIELD_NAMES.SME_PER_CLIMATE_CHANGE_Q22_8_VALUE,
                    condition: conditionType.EMPTY,
                    values: []
                  }
                },
                {
                  type: inputType.DATEPICKER,
                  fieldName:
                    CDP_SME_PER_CLIMATE_CHANGE_FIELD_NAMES.SME_PER_CLIMATE_CHANGE_Q22_10_VALUE,
                  fieldLabel: 'End date of target',
                  disabledOn: {
                    fieldName:
                      CDP_SME_PER_CLIMATE_CHANGE_FIELD_NAMES.SME_PER_CLIMATE_CHANGE_Q22_8_VALUE,
                    condition: conditionType.EMPTY,
                    values: []
                  }
                },
                {
                  type: inputType.NUMBER,
                  fieldName:
                    CDP_SME_PER_CLIMATE_CHANGE_FIELD_NAMES.SME_PER_CLIMATE_CHANGE_Q22_11_VALUE,
                  fieldLabel: 'Targeted reduction from base year (%)'
                },
                {
                  type: inputType.DISPLAY_CALCULATION_IN_TABLE,
                  fieldName:
                    CDP_SME_PER_CLIMATE_CHANGE_FIELD_NAMES.SME_PER_CLIMATE_CHANGE_Q22_12_VALUE,
                  fieldLabel:
                    'Intensity figure at end date of target for all selected Scopes',
                  disabledOn: {
                    fieldName:
                      CDP_SME_PER_CLIMATE_CHANGE_FIELD_NAMES.SME_PER_CLIMATE_CHANGE_Q22_9_VALUE,
                    condition: conditionType.EMPTY,
                    values: []
                  },
                  relatedKey: [
                    CDP_SME_PER_CLIMATE_CHANGE_FIELD_NAMES.SME_PER_CLIMATE_CHANGE_Q22_9_VALUE,
                    CDP_SME_PER_CLIMATE_CHANGE_FIELD_NAMES.SME_PER_CLIMATE_CHANGE_Q22_11_VALUE
                  ],
                  formula: ([baseYearIntensity, targetReduction]: any[]):
                    | number
                    | string => {
                    const result =
                      (baseYearIntensity * (100 - targetReduction)) / 100;

                    return result;
                  }
                },
                {
                  type: inputType.NUMBER,
                  fieldName:
                    CDP_SME_PER_CLIMATE_CHANGE_FIELD_NAMES.SME_PER_CLIMATE_CHANGE_Q22_13_VALUE,
                  fieldLabel:
                    'Intensity figure in reporting year for all selected Scopes '
                },
                {
                  type: inputType.DISPLAY_CALCULATION_IN_TABLE,
                  fieldName:
                    CDP_SME_PER_CLIMATE_CHANGE_FIELD_NAMES.SME_PER_CLIMATE_CHANGE_Q22_14_VALUE,
                  fieldLabel: '% of target achieved relative to base year',
                  relatedKey: [
                    CDP_SME_PER_CLIMATE_CHANGE_FIELD_NAMES.SME_PER_CLIMATE_CHANGE_Q22_9_VALUE,
                    CDP_SME_PER_CLIMATE_CHANGE_FIELD_NAMES.SME_PER_CLIMATE_CHANGE_Q22_11_VALUE,
                    CDP_SME_PER_CLIMATE_CHANGE_FIELD_NAMES.SME_PER_CLIMATE_CHANGE_Q22_13_VALUE
                  ],
                  formula: ([
                    coveredByTarget,
                    targetReduction,
                    totalEmissionsInReportingYear
                  ]: any[]): number | string => {
                    const emission =
                      coveredByTarget - totalEmissionsInReportingYear;

                    const percentage = targetReduction / 100;
                    const targetAchieved =
                      (emission / (percentage * coveredByTarget)) * 100;

                    return targetAchieved;
                  }
                },
                {
                  type: inputType.SELECT,
                  fieldName:
                    CDP_SME_PER_CLIMATE_CHANGE_FIELD_NAMES.SME_PER_CLIMATE_CHANGE_Q22_15_VALUE,
                  fieldLabel: 'Target status in reporting year',
                  options: [
                    {label: 'New', value: 'New'},
                    {label: 'Underway', value: 'Underway'},
                    {label: 'Achieved', value: 'Achieved'},
                    {
                      label: 'Achieved and maintained',
                      value: 'Achieved and maintained'
                    },
                    {label: 'Expired', value: 'Expired'},
                    {label: 'Revised', value: 'Revised'},
                    {label: 'Replaced', value: 'Replaced'},
                    {label: 'Retired', value: 'Retired'}
                  ],
                  colSpan: true
                },
                {
                  type: inputType.SELECT,
                  fieldName:
                    CDP_SME_PER_CLIMATE_CHANGE_FIELD_NAMES.SME_PER_CLIMATE_CHANGE_Q22_16_VALUE,
                  fieldLabel: 'Is this a science-based target?',
                  options: [
                    {
                      label:
                        'Yes, and this target has been approved by the Science Based Targets initiative',
                      value:
                        'Yes, and this target has been approved by the Science Based Targets initiative'
                    },
                    {
                      label: `Yes, we consider this a science-based target, and the target is currently 
                      being reviewed by the Science Based Targets initiative`,
                      value: `Yes, we consider this a science-based target, and the target is currently 
                      being reviewed by the Science Based Targets initiative`
                    },
                    {
                      label: `Yes, we consider this a science-based target, and we have committed to seek 
                        validation of this target by the Science Based Targets initiative in the next two years`,
                      value: `Yes, we consider this a science-based target, and we have committed to seek validation 
                        of this target by the Science Based Targets initiative in the next two years`
                    },
                    {
                      label: `Yes, we consider this a science-based target, but we have not committed to seek 
                        validation of this target by the Science Based Targets initiative within the next two years`,
                      value: `Yes, we consider this a science-based target, but we have not committed to seek
                            validation of this target by the Science Based Targets initiative within the next two years`
                    },
                    {
                      label:
                        'No, but we are reporting another target that is science-based',
                      value:
                        'No, but we are reporting another target that is science-based'
                    },
                    {
                      label:
                        'No, but we anticipate setting one in the next two years',
                      value:
                        'No, but we anticipate setting one in the next two years'
                    },
                    {
                      label:
                        'No, and we do not anticipate setting one in the next two years',
                      value:
                        'No, and we do not anticipate setting one in the next two years'
                    }
                  ],
                  colSpan: true
                },
                {
                  type: inputType.FILEUPLOAD,
                  fieldName:
                    CDP_SME_PER_CLIMATE_CHANGE_FIELD_NAMES.SME_PER_CLIMATE_CHANGE_Q22_17_VALUE,
                  fieldLabel:
                    'Science Based Targets initiative official validation letter',
                  disabledOn: {
                    fieldName:
                      CDP_SME_PER_CLIMATE_CHANGE_FIELD_NAMES.SME_PER_CLIMATE_CHANGE_Q22_16_VALUE,
                    condition: conditionType.NOT,
                    values: [
                      'Yes, and this target has been approved by the Science Based Targets initiative'
                    ]
                  }
                },
                {
                  type: inputType.WYSIWYG,
                  fieldName:
                    CDP_SME_PER_CLIMATE_CHANGE_FIELD_NAMES.SME_PER_CLIMATE_CHANGE_Q22_18_VALUE,
                  fieldLabel:
                    'Explain target coverage and identify any exclusions',
                  colSpan: true,
                  textLimit: 5000,
                  requiredOn: {
                    fieldName:
                      CDP_SME_PER_CLIMATE_CHANGE_FIELD_NAMES.SME_PER_CLIMATE_CHANGE_Q22_15_VALUE,
                    condition: conditionType.EQUALS,
                    values: ['Expired', 'Retired'],
                    required: true,
                    dependentValue:
                      CDP_SME_PER_CLIMATE_CHANGE_FIELD_NAMES.SME_PER_CLIMATE_CHANGE_Q22_15_VALUE
                  }
                }
              ]
            }
          }
        ]
      },
      {
        field: [
          {
            fieldType: inputType.HEADING,
            heading:
              '20.16.3 Provide details of any other climate-related targets active in the reporting year.',
            conditionalVisibility: {
              dependsOn:
                CDP_SME_PER_CLIMATE_CHANGE_FIELD_NAMES.SME_PER_CLIMATE_CHANGE_Q20_VALUE,
              showWhen: [
                'Target to increase or maintain low-carbon energy consumption or production',
                'Target to reduce methane emissions',
                'Net-zero target'
              ],
              condition: conditionType.EQUALS,
              fieldName:
                CDP_SME_PER_CLIMATE_CHANGE_FIELD_NAMES.SME_PER_CLIMATE_CHANGE_Q20_1_VALUE
            }
          },
          {
            fieldType: inputType.ADD_NEW_TO_TABLE,
            fieldName:
              CDP_SME_PER_CLIMATE_CHANGE_FIELD_NAMES.SME_PER_CLIMATE_CHANGE_Q23_VALUE,
            //   conditionalVisibility: {
            dependsOn:
              CDP_SME_PER_CLIMATE_CHANGE_FIELD_NAMES.SME_PER_CLIMATE_CHANGE_Q20_1_VALUE,
            showWhen: [
              'Target to increase or maintain low-carbon energy consumption or production',
              'Target to reduce methane emissions',
              'Net-zero target'
            ],
            relatedTableKey:
              CDP_SME_PER_CLIMATE_CHANGE_FIELD_NAMES.SME_PER_CLIMATE_CHANGE_Q20_VALUE,
            //  },
            formList: {
              formFields: [
                {
                  type: inputType.SELECT,
                  fieldName:
                    CDP_SME_PER_CLIMATE_CHANGE_FIELD_NAMES.SME_PER_CLIMATE_CHANGE_Q23_1_VALUE,
                  fieldLabel: 'Active climate-related target',
                  options: [
                    {
                      label: 'Target to reduce methane emissions',
                      value: 'Target to reduce methane emissions'
                    },
                    {
                      label:
                        'Target to increase or maintain lowcarbon energy consumption or production',
                      value:
                        'Target to increase or maintain lowcarbon energy consumption or production'
                    },
                    {
                      label: ' Net-zero target',
                      value: 'Net-zero target'
                    },
                    {
                      label: 'Other climaterelated target',
                      value: 'Other climaterelated target'
                    }
                  ],
                  colSpan: true
                },
                {
                  type: inputType.SELECT,
                  fieldName:
                    CDP_SME_PER_CLIMATE_CHANGE_FIELD_NAMES.SME_PER_CLIMATE_CHANGE_Q23_2_VALUE,
                  fieldLabel: 'Target reference number ',
                  options: OTH_OPTIONS,
                  colSpan: true
                },
                {
                  type: inputType.DATEPICKER,
                  fieldName:
                    CDP_SME_PER_CLIMATE_CHANGE_FIELD_NAMES.SME_PER_CLIMATE_CHANGE_Q23_3_VALUE,
                  fieldLabel: 'Date target was set',
                  dateFormat: 'DD-MM-YYYY'
                },
                {
                  type: inputType.SELECT_WITH_OTHER_TEXTBOX,
                  fieldName:
                    CDP_SME_PER_CLIMATE_CHANGE_FIELD_NAMES.SME_PER_CLIMATE_CHANGE_Q23_4_VALUE,
                  fieldLabel: 'Target coverage',
                  options: [
                    {value: 'Organization-wide', label: 'Organization-wide'},
                    {value: 'Business division', label: 'Business division'},
                    {value: 'Business activity', label: 'Business activity'},
                    {value: 'Site/facility', label: 'Site/facility'},
                    {
                      value: 'Country/area/region',
                      label: 'Country/area/region'
                    },
                    {value: 'Product-level', label: 'Product-level'},
                    {
                      value: 'Other, please specify',
                      label: 'Other, please specify'
                    }
                  ],
                  colSpan: true
                },
                {
                  type: inputType.SELECT,
                  fieldName:
                    CDP_SME_PER_CLIMATE_CHANGE_FIELD_NAMES.SME_PER_CLIMATE_CHANGE_Q23_5_VALUE,
                  fieldLabel: 'Targets linked to this net zero target',
                  options: [
                    {label: 'Abs1-Abs50', value: 'Abs1-Abs50'},
                    {label: 'Int1-Int50', value: 'Int1-Int50'},
                    {label: 'Not applicable', value: 'Not applicable'}
                  ],
                  colSpan: true
                },
                {
                  type: inputType.DATEPICKER,
                  fieldName:
                    CDP_SME_PER_CLIMATE_CHANGE_FIELD_NAMES.SME_PER_CLIMATE_CHANGE_Q23_6_VALUE,
                  fieldLabel: 'End date of base year',
                  dateFormat: 'DD-MM-YYYY'
                },
                {
                  type: inputType.DATEPICKER,
                  fieldName:
                    CDP_SME_PER_CLIMATE_CHANGE_FIELD_NAMES.SME_PER_CLIMATE_CHANGE_Q23_7_VALUE,
                  fieldLabel: 'End date of target',
                  dateFormat: 'DD-MM-YYYY'
                },
                {
                  type: inputType.WYSIWYG,
                  fieldName:
                    CDP_SME_PER_CLIMATE_CHANGE_FIELD_NAMES.SME_PER_CLIMATE_CHANGE_Q23_8_VALUE,
                  fieldLabel: 'Description of target',
                  textLimit: 2500,
                  colSpan: true
                },
                {
                  type: inputType.SELECT,
                  fieldName:
                    CDP_SME_PER_CLIMATE_CHANGE_FIELD_NAMES.SME_PER_CLIMATE_CHANGE_Q23_9_VALUE,
                  fieldLabel: 'Target status in reporting year',
                  options: [
                    {label: 'New', value: 'New'},
                    {label: 'Underway', value: 'Underway'},
                    {label: 'Achieved', value: 'Achieved'},
                    {
                      label: 'Achieved and maintained',
                      value: 'Achieved and maintained'
                    },
                    {label: 'Expired', value: 'Expired'},
                    {label: 'Revised', value: 'Revised'},
                    {label: 'Replaced', value: 'Replaced'},
                    {label: 'Retired', value: 'Retired'}
                  ],
                  colSpan: true
                },
                {
                  type: inputType.SELECT,
                  fieldName:
                    CDP_SME_PER_CLIMATE_CHANGE_FIELD_NAMES.SME_PER_CLIMATE_CHANGE_Q23_10_VALUE,
                  fieldLabel:
                    'Is this target part of an overarching initiative?',
                  options: [
                    {label: 'RE100', value: 'RE100'},
                    {
                      label: 'Science Based Targets initiative – SME target',
                      value: 'Science Based Targets initiative – SME target'
                    },
                    {
                      label:
                        'Science Based Targets initiative – non-SME target',
                      value: 'Science Based Targets initiative – non-SME target'
                    },
                    {
                      label: 'SME Climate Hub or UN Race to Zero campaign',
                      value: 'SME Climate Hub or UN Race to Zero campaign'
                    },
                    {
                      label: 'No, it’s not part of an overarching initiative',
                      value: 'No, it’s not part of an overarching initiative'
                    },
                    {
                      label: 'Other, please specify',
                      value: 'Other, please specify'
                    }
                  ],
                  colSpan: true
                },
                {
                  type: inputType.WYSIWYG,
                  fieldName:
                    CDP_SME_PER_CLIMATE_CHANGE_FIELD_NAMES.SME_PER_CLIMATE_CHANGE_Q23_11_VALUE,
                  fieldLabel:
                    'Explain target coverage and identify any exclusions',
                  textLimit: 2400,
                  colSpan: true,
                  requiredOn: {
                    fieldName:
                      CDP_SME_PER_CLIMATE_CHANGE_FIELD_NAMES.SME_PER_CLIMATE_CHANGE_Q23_9_VALUE,
                    condition: conditionType.EQUALS,
                    values: ['Expired', 'Retired'],
                    required: true,
                    dependentValue:
                      CDP_SME_PER_CLIMATE_CHANGE_FIELD_NAMES.SME_PER_CLIMATE_CHANGE_Q23_9_VALUE
                  }
                }
              ]
            }
          }
        ]
      },
      {
        field: [
          {
            fieldType: inputType.HEADING,
            heading: `20.17 Did you have emissions reduction initiatives that were active within the reporting year? 
                      (Includes those in planning/implementation).`,
            conditionalVisibility: {
              dependsOn:
                CDP_SME_PER_CLIMATE_CHANGE_FIELD_NAMES.SME_PER_CLIMATE_CHANGE_Q1_VALUE,
              showWhen: [
                'Yes, we use tailored in-house or paid-for resources to calculate them',
                'Yes, we use a generic tool to estimate them, please specify'
              ],
              condition: conditionType.EQUALS,
              fieldName:
                SCOPE_FIELD_NAMES.SME_PER_CLIMATE_CHANGE_Q1_1_VALUE_SCOPE1
            }
          },
          {
            fieldType: inputType.ADD_NEW_TO_TABLE,
            fieldName:
              CDP_SME_PER_CLIMATE_CHANGE_FIELD_NAMES.SME_PER_CLIMATE_CHANGE_Q24_VALUE,
            allowMultipleRows: false,
            // conditionalVisibility: {
            dependsOn:
              SCOPE_FIELD_NAMES.SME_PER_CLIMATE_CHANGE_Q1_1_VALUE_SCOPE1,
            showWhen: [
              'Yes, we use tailored in-house or paid-for resources to calculate them',
              'Yes, we use a generic tool to estimate them, please specify'
            ],
            relatedTableKey:
              CDP_SME_PER_CLIMATE_CHANGE_FIELD_NAMES.SME_PER_CLIMATE_CHANGE_Q1_VALUE,
            //   },
            formList: {
              formFields: [
                {
                  type: inputType.SELECT,
                  fieldName:
                    CDP_SME_PER_CLIMATE_CHANGE_FIELD_NAMES.SME_PER_CLIMATE_CHANGE_Q24_1_VALUE,
                  fieldLabel: 'Emissions reduction initiative',
                  options: [
                    {label: 'Yes', value: 'Yes'},
                    {
                      label: 'No, but we plan to within the next two years',
                      value: 'No, but we plan to within the next two years'
                    },
                    {
                      label:
                        'No, and we do not plan to within the next two years',
                      value:
                        'No, and we do not plan to within the next two years'
                    }
                  ],
                  colSpan: true
                },
                {
                  type: inputType.SELECT,
                  fieldName:
                    CDP_SME_PER_CLIMATE_CHANGE_FIELD_NAMES.SME_PER_CLIMATE_CHANGE_Q24_2_VALUE,
                  fieldLabel:
                    'Primary reason for not having an emissions reduction initiative',
                  options: [
                    {
                      label: 'Important but not an immediate business priority',
                      value: 'Important but not an immediate business priority'
                    },
                    {
                      label: 'Judged to be unimportant',
                      value: 'Judged to be unimportant'
                    },
                    {
                      label: 'Insufficient data on operations',
                      value: 'Insufficient data on operations'
                    },
                    {
                      label: 'No instruction from management',
                      value: 'No instruction from management'
                    },
                    {
                      label: 'Other, please specify',
                      value: 'Other, please specify'
                    }
                  ],
                  colSpan: true,
                  disabledOn: {
                    fieldName:
                      CDP_SME_PER_CLIMATE_CHANGE_FIELD_NAMES.SME_PER_CLIMATE_CHANGE_Q24_1_VALUE,
                    condition: conditionType.EQUALS,
                    values: ['Yes']
                  }
                }
              ]
            }
          }
        ]
      },
      {
        field: [
          {
            fieldType: inputType.HEADING,
            heading:
              '20.17.1 Provide details on the emissions reduction initiatives implemented in the reporting year.',
            conditionalVisibility: {
              dependsOn:
                CDP_SME_PER_CLIMATE_CHANGE_FIELD_NAMES.SME_PER_CLIMATE_CHANGE_Q24_VALUE,
              showWhen: ['Yes'],
              condition: conditionType.EQUALS,
              fieldName:
                CDP_SME_PER_CLIMATE_CHANGE_FIELD_NAMES.SME_PER_CLIMATE_CHANGE_Q24_1_VALUE
            }
          },
          {
            fieldType: inputType.ADD_NEW_TO_TABLE,
            fieldName:
              CDP_SME_PER_CLIMATE_CHANGE_FIELD_NAMES.SME_PER_CLIMATE_CHANGE_Q25_VALUE,
            // conditionalVisibility: {
            dependsOn:
              CDP_SME_PER_CLIMATE_CHANGE_FIELD_NAMES.SME_PER_CLIMATE_CHANGE_Q24_1_VALUE,
            showWhen: ['Yes'],
            relatedTableKey:
              CDP_SME_PER_CLIMATE_CHANGE_FIELD_NAMES.SME_PER_CLIMATE_CHANGE_Q24_VALUE,
            //  },
            formList: {
              formFields: [
                {
                  type: inputType.SELECT,
                  fieldName:
                    CDP_SME_PER_CLIMATE_CHANGE_FIELD_NAMES.SME_PER_CLIMATE_CHANGE_Q25_1_VALUE,
                  fieldLabel: 'Initiative type',
                  options: INITIATIVE_TYPE_OPTIONS,
                  colSpan: true
                },
                {
                  type: inputType.MULTISELECT,
                  fieldName:
                    CDP_SME_PER_CLIMATE_CHANGE_FIELD_NAMES.SME_PER_CLIMATE_CHANGE_Q25_2_VALUE,
                  fieldLabel:
                    'Scope(s) or Scope 3 category(ies) where emissions savings occur',
                  options: [
                    {value: 'Scope 1', label: 'Scope 1'},
                    {
                      value: 'Scope 2 (location-based)',
                      label: 'Scope 2 (location-based)'
                    },
                    {
                      value: 'Scope 2 (market-based)',
                      label: 'Scope 2 (market-based)'
                    },
                    {
                      value: 'Scope 2 (approach unknown)',
                      label: 'Scope 2 (approach unknown)'
                    },
                    {
                      value: 'Scope 3: Purchased goods and services',
                      label: 'Scope 3: Purchased goods and services'
                    },
                    {
                      value: 'Scope 3: Capital goods',
                      label: 'Scope 3: Capital goods'
                    },
                    {
                      value:
                        'Scope 3: Fuel and energy-related activities (not included in Scopes 1 or 2)',
                      label:
                        'Scope 3: Fuel and energy-related activities (not included in Scopes 1 or 2)'
                    },
                    {
                      value:
                        'Scope 3: Upstream transportation and distribution',
                      label: 'Scope 3: Upstream transportation and distribution'
                    },
                    {
                      value: 'Scope 3: Waste generated in operations',
                      label: 'Scope 3: Waste generated in operations'
                    },
                    {
                      value: 'Scope 3: Business travel',
                      label: 'Scope 3: Business travel'
                    },
                    {
                      value: 'Scope 3: Employee commuting',
                      label: 'Scope 3: Employee commuting'
                    },
                    {
                      value: 'Scope 3: Upstream leased assets',
                      label: 'Scope 3: Upstream leased assets'
                    },
                    {
                      value:
                        'Scope 3: Downstream transportation and distribution',
                      label:
                        'Scope 3: Downstream transportation and distribution'
                    },
                    {
                      value: 'Scope 3: Processing of sold products',
                      label: 'Scope 3: Processing of sold products'
                    },
                    {
                      value: 'Scope 3: Use of sold products',
                      label: 'Scope 3: Use of sold products'
                    },
                    {
                      value: 'Scope 3: End-of-life treatment of sold products',
                      label: 'Scope 3: End-of-life treatment of sold products'
                    },
                    {
                      value: 'Scope 3: Downstream leased assets',
                      label: 'Scope 3: Downstream leased assets'
                    },
                    {
                      value: 'Scope 3: Franchises',
                      label: 'Scope 3: Franchises'
                    },
                    {
                      value: 'Scope 3: Investments',
                      label: 'Scope 3: Investments'
                    },
                    {
                      value: 'Scope 3: Other (upstream)',
                      label: 'Scope 3: Other (upstream)'
                    },
                    {
                      value: 'Scope 3: Other (downstream)',
                      label: 'Scope 3: Other (downstream)'
                    }
                  ],
                  colSpan: true
                },
                {
                  type: inputType.SELECT,
                  fieldName:
                    CDP_SME_PER_CLIMATE_CHANGE_FIELD_NAMES.SME_PER_CLIMATE_CHANGE_Q25_3_VALUE,
                  fieldLabel: 'Voluntary/ Mandatory',
                  options: [
                    {label: 'Voluntary', value: 'Voluntary'},
                    {label: 'Mandatory', value: 'Mandatory'}
                  ],
                  colSpan: true
                },
                {
                  type: inputType.RADIOGROUP,
                  fieldName:
                    CDP_SME_PER_CLIMATE_CHANGE_FIELD_NAMES.SME_PER_CLIMATE_CHANGE_Q25_4_VALUE,
                  fieldLabel:
                    'Are you able to estimate CO2e savings and financial impacts?',
                  options: ['Yes', 'No'],
                  colSpan: true
                },
                {
                  type: inputType.NUMBER,
                  fieldName:
                    CDP_SME_PER_CLIMATE_CHANGE_FIELD_NAMES.SME_PER_CLIMATE_CHANGE_Q25_5_VALUE,
                  fieldLabel:
                    'Estimated annual CO2e savings (metric tons CO2e)',
                  disabledOn: {
                    fieldName:
                      CDP_SME_PER_CLIMATE_CHANGE_FIELD_NAMES.SME_PER_CLIMATE_CHANGE_Q25_4_VALUE,
                    condition: conditionType.EQUALS,
                    values: ['No']
                  }
                },
                {
                  type: inputType.NUMBER,
                  fieldName:
                    CDP_SME_PER_CLIMATE_CHANGE_FIELD_NAMES.SME_PER_CLIMATE_CHANGE_Q25_6_VALUE,
                  fieldLabel:
                    'Investment required (unit currency – as specified in 14.2)'
                },
                {
                  type: inputType.NUMBER,
                  fieldName:
                    CDP_SME_PER_CLIMATE_CHANGE_FIELD_NAMES.SME_PER_CLIMATE_CHANGE_Q25_7_VALUE,
                  fieldLabel:
                    'Annual monetary savings (unit currency – as specified in 14.2)'
                },
                {
                  type: inputType.SELECT,
                  fieldName:
                    CDP_SME_PER_CLIMATE_CHANGE_FIELD_NAMES.SME_PER_CLIMATE_CHANGE_Q25_8_VALUE,
                  fieldLabel: 'Payback period',
                  options: [
                    {label: '<1 year', value: '<1 year'},
                    {label: '1-3 years', value: '1-3 years'},
                    {label: '4-10 years', value: '4-10 years'},
                    {label: '11-15 years', value: '11-15 years'},
                    {label: '16-20 years', value: '16-20 years'},
                    {label: '21-25 years', value: '21-25 years'},
                    {label: '>25 years', value: '>25 years'},
                    {label: 'No payback', value: 'No payback'}
                  ],
                  colSpan: true
                },
                {
                  type: inputType.SELECT,
                  fieldName:
                    CDP_SME_PER_CLIMATE_CHANGE_FIELD_NAMES.SME_PER_CLIMATE_CHANGE_Q25_9_VALUE,
                  fieldLabel: 'Estimated lifetime of the initiative',
                  options: [
                    {label: '<1 year', value: '<1 year'},
                    {label: '1-2 years', value: '1-2 years'},
                    {label: '3-5 years', value: '3-5 years'},
                    {label: '6-10 years', value: '6-10 years'},
                    {label: '11-15 years', value: '11-15 years'},
                    {label: '16-20 years', value: '16-20 years'},
                    {label: '21-30 years', value: '21-30 years'},
                    {label: '>30 years', value: '>30 years'},
                    {label: 'Ongoing', value: 'Ongoing'}
                  ],
                  colSpan: true,
                  disabledOn: {
                    fieldName:
                      CDP_SME_PER_CLIMATE_CHANGE_FIELD_NAMES.SME_PER_CLIMATE_CHANGE_Q25_4_VALUE,
                    condition: conditionType.EQUALS,
                    values: ['No']
                  }
                },
                {
                  type: inputType.WYSIWYG,
                  fieldName:
                    CDP_SME_PER_CLIMATE_CHANGE_FIELD_NAMES.SME_PER_CLIMATE_CHANGE_Q25_10_VALUE,
                  fieldLabel: 'Comment',
                  textLimit: 1500,
                  colSpan: true
                }
              ]
            }
          }
        ]
      }
    ]
  }
];

export const smeSignOffQuestions = [
  {
    key: '1',
    showIndex: false,
    items: [
      {
        field: [
          {
            fieldType: inputType.HEADING,
            heading: `21.1 Is any environmental information included in your CDP response 
                     (not already reported in 20.8) verified and/or assured by a third party?`
          },
          {
            fieldType: inputType.SELECT,
            fieldName: CDP_SME_SIGN_OFF_FIELD_NAMES.SME_SIGN_OFF_Q1_1_VALUE,
            options: [
              {label: 'Yes', value: 'Yes'},
              {
                label:
                  'Third-party verification/assurance is currently in progress',
                value:
                  'Third-party verification/assurance is currently in progress'
              },
              {
                label: `No, but we plan to obtain third-party
                             verification/assurance of other environmental
                             information in our CDP response within the next two years`,
                value: `No, but we plan to obtain third-party
                             verification/assurance of other environmental
                             information in our CDP response within the next two years`
              },
              {
                label: `No, and we do not plan to obtain third-party verification/assurance of other
                              environmental information in our CDP response within the next two years`,
                value: `No, and we do not plan to obtain third-party verification/assurance of other
                              environmental information in our CDP response within the next two years`
              }
            ]
          }
        ]
      },
      {
        field: [
          {
            fieldType: inputType.HEADING,
            heading: `21.1.1 Which data points within your CDP response are verified and/or assured by a third party,
                      and which standard/provider was used?`,
            conditionalVisibility: {
              dependsOn: CDP_SME_SIGN_OFF_FIELD_NAMES.SME_SIGN_OFF_Q1_1_VALUE,
              showWhen: [
                'Yes',
                'Third-party verification/assurance is currently in progress'
              ],
              condition: conditionType.EQUALS,
              fieldName: CDP_SME_SIGN_OFF_FIELD_NAMES.SME_SIGN_OFF_Q1_1_VALUE
            }
          },
          {
            fieldType: inputType.ADD_NEW_TO_TABLE,
            fieldName: CDP_SME_SIGN_OFF_FIELD_NAMES.SME_SIGN_OFF_Q2_VALUE,
            //   conditionalVisibility: {
            dependsOn: CDP_SME_SIGN_OFF_FIELD_NAMES.SME_SIGN_OFF_Q1_1_VALUE,
            showWhen: [
              'Yes',
              'Third-party verification/assurance is currently in progress'
            ],
            relatedTableKey:
              CDP_SME_SIGN_OFF_FIELD_NAMES.SME_SIGN_OFF_Q1_1_VALUE,
            // },
            formList: {
              formFields: [
                {
                  type: inputType.SELECT,
                  fieldName:
                    CDP_SME_SIGN_OFF_FIELD_NAMES.SME_SIGN_OFF_Q2_1_VALUE,
                  fieldLabel:
                    'Environmental issue for which data has been verified and/or  assured',
                  options: ENVIRONMENTAL_ISSUE_OPTIONS,
                  colSpan: true
                },
                {
                  type: inputType.SELECT_WITH_OTHER_TEXTBOX,
                  fieldName:
                    CDP_SME_SIGN_OFF_FIELD_NAMES.SME_SIGN_OFF_Q2_2_VALUE,
                  fieldLabel:
                    'Disclosure module and data verified and/or assured',
                  options: DISCLOSURE_MODULE_OPTIONS,
                  colSpan: true,
                  disabledOn: {
                    fieldName:
                      CDP_SME_SIGN_OFF_FIELD_NAMES.SME_SIGN_OFF_Q2_1_VALUE,
                    condition: conditionType.EMPTY,
                    values: []
                  }
                },
                {
                  type: inputType.SELECT,
                  fieldName:
                    CDP_SME_SIGN_OFF_FIELD_NAMES.SME_SIGN_OFF_Q2_3_VALUE,
                  fieldLabel: 'Verification/assurance standard',
                  options: VERIFICATION_STANDARD_OPTIONS,
                  colSpan: true
                },
                {
                  type: inputType.WYSIWYG,
                  fieldName:
                    CDP_SME_SIGN_OFF_FIELD_NAMES.SME_SIGN_OFF_Q2_4_VALUE,
                  fieldLabel:
                    'Further details of the thirdparty verification/assurance process',
                  textLimit: 2500,
                  colSpan: true
                },
                {
                  type: inputType.FILEUPLOAD,
                  fieldName:
                    CDP_SME_SIGN_OFF_FIELD_NAMES.SME_SIGN_OFF_Q2_5_VALUE,
                  fieldLabel:
                    'Attach verification/assurance evidence/report (optional)',
                  colSpan: true
                }
              ]
            }
          }
        ]
      },
      {
        field: [
          {
            fieldType: inputType.HEADING,
            heading: `21.2 Provide the following information 
                      for the person that has signed off (approved) your CDP response.`
          },
          {
            fieldType: inputType.ADD_NEW_TO_TABLE,
            fieldName: CDP_SME_SIGN_OFF_FIELD_NAMES.SME_SIGN_OFF_Q3_VALUE,
            allowMultipleRows: false,
            formList: {
              formFields: [
                {
                  type: inputType.WYSIWYG,
                  fieldName:
                    CDP_SME_SIGN_OFF_FIELD_NAMES.SME_SIGN_OFF_Q3_1_VALUE,
                  fieldLabel: 'Job title',
                  textLimit: 200,
                  colSpan: true
                },
                {
                  type: inputType.SELECT_WITH_OTHER_TEXTBOX,
                  fieldName:
                    CDP_SME_SIGN_OFF_FIELD_NAMES.SME_SIGN_OFF_Q3_2_VALUE,
                  fieldLabel: 'Corresponding job category',
                  options: [
                    {value: 'Board chair', label: 'Board chair'},
                    {value: 'Director on board', label: 'Director on board'},
                    {
                      value: 'Chief Executive Officer (CEO)',
                      label: 'Chief Executive Officer (CEO)'
                    },
                    {
                      value: 'Chief Financial Officer (CFO)',
                      label: 'Chief Financial Officer (CFO)'
                    },
                    {
                      value: 'Chief Operating Officer (COO)',
                      label: 'Chief Operating Officer (COO)'
                    },
                    {
                      value: 'Chief Procurement Officer (CPO)',
                      label: 'Chief Procurement Officer (CPO)'
                    },
                    {
                      value: 'Chief Risk Officer (CRO)',
                      label: 'Chief Risk Officer (CRO)'
                    },
                    {
                      value: 'Chief Sustainability Officer (CSO)',
                      label: 'Chief Sustainability Officer (CSO)'
                    },
                    {
                      value: 'Other C-Suite Officer',
                      label: 'Other C-Suite Officer'
                    },
                    {value: 'President', label: 'President'},
                    {value: 'General Counsel', label: 'General Counsel'},
                    {
                      value: 'Business unit manager',
                      label: 'Business unit manager'
                    },
                    {value: 'Energy manager', label: 'Energy manager'},
                    {
                      value: 'Environmental, health and safety manager',
                      label: 'Environmental, health and safety manager'
                    },
                    {
                      value: 'Environment/Sustainability manager',
                      label: 'Environment/Sustainability manager'
                    },
                    {value: 'Facilities manager', label: 'Facilities manager'},
                    {
                      value: 'Process operation manager',
                      label: 'Process operation manager'
                    },
                    {
                      value: 'Procurement manager',
                      label: 'Procurement manager'
                    },
                    {
                      value: 'Public affairs manager',
                      label: 'Public affairs manager'
                    },
                    {value: 'Risk manager', label: 'Risk manager'},
                    {
                      value: 'Other, please specify',
                      label: 'Other, please specify'
                    }
                  ],
                  colSpan: true,
                  disabledOn: {
                    fieldName:
                      CDP_SME_SIGN_OFF_FIELD_NAMES.SME_SIGN_OFF_Q3_1_VALUE,
                    condition: conditionType.EMPTY,
                    values: []
                  }
                }
              ]
            }
          }
        ]
      },
      {
        field: [
          {
            fieldType: inputType.HEADING,
            heading: `21.3 Please indicate your consent for CDP to share contact details with the
                           Pacific Institute to support content for its Water Action Hub website.`
          },
          {
            fieldType: inputType.SELECT,
            fieldName: CDP_SME_SIGN_OFF_FIELD_NAMES.SME_SIGN_OFF_Q4_1_VALUE,
            options: [
              {
                label:
                  'Yes CDP may share our Disclosure Submission Lead contact details with the Pacific Institute',
                value:
                  'Yes CDP may share our Disclosure Submission Lead contact details with the Pacific Institute'
              },
              {label: 'No', value: 'No'}
            ]
          }
        ]
      }
    ]
  }
];
